webpackJsonp([16],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(928);
var ITERATOR = __webpack_require__(866)('iterator');
var Iterators = __webpack_require__(882);
module.exports = __webpack_require__(864).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1002);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListWithLoadMore.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListWithLoadMore.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".InfiniteScroll-ListWithLoadMore-Button__primary{background-color:#022140;color:#fff}.InfiniteScroll-ListWithLoadMore-Button__primary:focus,.InfiniteScroll-ListWithLoadMore-Button__primary:hover{background-color:rgba(2,33,64,.7)}.InfiniteScroll-ListWithLoadMore-u_spaceTop{margin-top:15px!important;margin-top:.9375rem!important}.InfiniteScroll-ListWithLoadMore-showMoreIcon{clear:both;text-align:center;width:100%;margin:0 auto}", ""]);

// exports
exports.locals = {
	"Button__primary": "InfiniteScroll-ListWithLoadMore-Button__primary",
	"u_spaceTop": "InfiniteScroll-ListWithLoadMore-u_spaceTop",
	"showMoreIcon": "InfiniteScroll-ListWithLoadMore-showMoreIcon"
};

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1004);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Button.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Button.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Button-Button-Button{border:none;font-size:14px;font-size:.875rem;-webkit-transition:background-color #0376a3,opacity #0376a3;-o-transition:background-color #0376a3,opacity #0376a3;transition:background-color #0376a3,opacity #0376a3;padding:5.2px 16px;padding:.325rem 1rem;margin-bottom:10px;margin-bottom:.625rem;text-transform:uppercase;display:inline-block;text-align:center;cursor:pointer}.Button-Button-Button[disabled]{opacity:.25}.Button-Button-Button.Button-Button-light{background-color:#0376a3}.Button-Button-Button.Button-Button-medium{background-color:#005d82}.Button-Button-Button.Button-Button-dark{background-color:#033f57}.Button-Button-Button.Button-Button-light_spirotech,.Button-Button-Button.Button-Button-medium_spirotech{background-color:#fae04e}.Button-Button-Button.Button-Button-dark_spirotech{background-color:#fae03a}.Button-Button-Button.Button-Button-search,.Button-Button-Button.Button-Button-transparent{background-color:transparent;cursor:pointer}.Button-Button-Button.Button-Button-search{padding:0}.Button-Button-Button.Button-Button-main{margin:0;display:block;cursor:pointer;max-width:100px;height:85px}@media (min-width:721px){.Button-Button-Button.Button-Button-main{margin:10px 3px;display:inline-block}}.Button-Button-Button.Button-Button-mainPdf{margin:0 6px;height:128px;height:8rem;max-width:110px;cursor:pointer}@media (min-width:721px){.Button-Button-Button.Button-Button-mainPdf{display:inline-block}}.Button-Button-Button.Button-Button-mainFull{display:none;cursor:pointer;max-width:100px;height:85px}@media (min-width:721px){.Button-Button-Button.Button-Button-mainFull{margin:10px 3px;display:inline-block}}.Button-Button-Button.Button-Button-level{margin:0;display:inline-block;min-width:90px;cursor:pointer}@media (min-width:721px){.Button-Button-Button.Button-Button-level{margin:5px}}@media (min-width:480px){.Button-Button-Button.Button-Button-level{min-width:120px}}.Button-Button-Button.Button-Button-Button__primary{background-color:#022140;color:#fff;cursor:pointer}.Button-Button-Button.Button-Button-Button__primary:focus,.Button-Button-Button.Button-Button-Button__primary:hover{background-color:rgba(2,33,64,.7)}.Button-Button-Button a{text-decoration:none}", ""]);

// exports
exports.locals = {
	"Button": "Button-Button-Button",
	"light": "Button-Button-light",
	"medium": "Button-Button-medium",
	"dark": "Button-Button-dark",
	"light_spirotech": "Button-Button-light_spirotech",
	"medium_spirotech": "Button-Button-medium_spirotech",
	"dark_spirotech": "Button-Button-dark_spirotech",
	"transparent": "Button-Button-transparent",
	"search": "Button-Button-search",
	"main": "Button-Button-main",
	"mainPdf": "Button-Button-mainPdf",
	"mainFull": "Button-Button-mainFull",
	"level": "Button-Button-level",
	"Button__primary": "Button-Button-Button__primary"
};

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "610318c4.svg";

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1007);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loader.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Loader-Loader-Loader{display:inline-block;width:16px;width:1rem;height:16px;height:1rem;margin:-2px 8px 0;margin:-2px .5rem 0;vertical-align:middle}.Loader-Loader-Loader__block{display:block;margin:48px auto;margin:3rem auto}.Loader-Loader-Loader_svg{height:100%;width:100%;-webkit-animation:Loader-Loader-spin .6s linear infinite;animation:Loader-Loader-spin .6s linear infinite}@-webkit-keyframes Loader-Loader-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes Loader-Loader-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"Loader": "Loader-Loader-Loader",
	"Loader__block": "Loader-Loader-Loader__block",
	"Loader_svg": "Loader-Loader-Loader_svg",
	"spin": "Loader-Loader-spin"
};

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1009);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Icon.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Icon.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(889);
exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Icon-Icon-Icon{display:inline-block;vertical-align:middle;-webkit-transform:translateY(-5%);-ms-transform:translateY(-5%);transform:translateY(-5%);background-size:100%;background-repeat:no-repeat;background-position:50%;margin:5px 15px}.Icon-Icon-Icon.Icon-Icon-block{display:inline-block;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.Icon-Icon-Icon.Icon-Icon-small{margin:0!important}.Icon-Icon-Icon.Icon-Icon-devices{background-image:url(" + escape(__webpack_require__(1010)) + ")}.Icon-Icon-Icon.Icon-Icon-devices_white{background-image:url(" + escape(__webpack_require__(1011)) + ")}.Icon-Icon-Icon.Icon-Icon-add{background-image:url(" + escape(__webpack_require__(1012)) + ")}.Icon-Icon-Icon.Icon-Icon-add_white{background-image:url(" + escape(__webpack_require__(1013)) + ")}.Icon-Icon-Icon.Icon-Icon-odrzuc{background-image:url(" + escape(__webpack_require__(929)) + ");margin:0}.Icon-Icon-Icon.Icon-Icon-odrzuc_margin{background-image:url(" + escape(__webpack_require__(929)) + ")}.Icon-Icon-Icon.Icon-Icon-odrzuc_white{background-image:url(" + escape(__webpack_require__(1014)) + ")}.Icon-Icon-Icon.Icon-Icon-settings{background-image:url(" + escape(__webpack_require__(1015)) + ")}.Icon-Icon-Icon.Icon-Icon-settings_white{background-image:url(" + escape(__webpack_require__(1016)) + ")}.Icon-Icon-Icon.Icon-Icon-settings_key_white{background-image:url(" + escape(__webpack_require__(1017)) + ")}.Icon-Icon-Icon.Icon-Icon-messages{background-image:url(" + escape(__webpack_require__(1018)) + ")}.Icon-Icon-Icon.Icon-Icon-messages_white{background-image:url(" + escape(__webpack_require__(1019)) + ")}.Icon-Icon-Icon.Icon-Icon-notifications{background-image:url(" + escape(__webpack_require__(1020)) + ")}.Icon-Icon-Icon.Icon-Icon-notifications_white{background-image:url(" + escape(__webpack_require__(1021)) + ")}.Icon-Icon-Icon.Icon-Icon-logout{background-image:url(" + escape(__webpack_require__(1022)) + ")}.Icon-Icon-Icon.Icon-Icon-logout_white{background-image:url(" + escape(__webpack_require__(1023)) + ")}.Icon-Icon-Icon.Icon-Icon-historia{background-image:url(" + escape(__webpack_require__(1024)) + ")}.Icon-Icon-Icon.Icon-Icon-historia_black{background-image:url(" + escape(__webpack_require__(1025)) + ")}.Icon-Icon-Icon.Icon-Icon-edytuj{background-image:url(" + escape(__webpack_require__(1026)) + ")}.Icon-Icon-Icon.Icon-Icon-edytuj_black{background-image:url(" + escape(__webpack_require__(1027)) + ")}.Icon-Icon-Icon.Icon-Icon-edytuj2{background-image:url(" + escape(__webpack_require__(1028)) + ")}.Icon-Icon-Icon.Icon-Icon-polacz{background-image:url(" + escape(__webpack_require__(1029)) + ")}.Icon-Icon-Icon.Icon-Icon-polacz_black{background-image:url(" + escape(__webpack_require__(1030)) + ")}.Icon-Icon-Icon.Icon-Icon-cofnij{background-image:url(" + escape(__webpack_require__(1031)) + ")}.Icon-Icon-Icon.Icon-Icon-cofnij_black{background-image:url(" + escape(__webpack_require__(1032)) + ")}.Icon-Icon-Icon.Icon-Icon-dalej{background-image:url(" + escape(__webpack_require__(1033)) + ")}.Icon-Icon-Icon.Icon-Icon-dalej_black{background-image:url(" + escape(__webpack_require__(1034)) + ")}.Icon-Icon-Icon.Icon-Icon-kosz{background-image:url(" + escape(__webpack_require__(1035)) + ")}.Icon-Icon-Icon.Icon-Icon-pobierz{background-image:url(" + escape(__webpack_require__(1036)) + ")}.Icon-Icon-Icon.Icon-Icon-pobierz_white{background-image:url(" + escape(__webpack_require__(1037)) + ")}.Icon-Icon-Icon.Icon-Icon-lupka{background-image:url(" + escape(__webpack_require__(1038)) + ")}.Icon-Icon-Icon.Icon-Icon-lupka_white{background-image:url(" + escape(__webpack_require__(1039)) + ")}", ""]);

// exports
exports.locals = {
	"Icon": "Icon-Icon-Icon",
	"block": "Icon-Icon-block",
	"small": "Icon-Icon-small",
	"devices": "Icon-Icon-devices",
	"devices_white": "Icon-Icon-devices_white",
	"add": "Icon-Icon-add",
	"add_white": "Icon-Icon-add_white",
	"odrzuc": "Icon-Icon-odrzuc",
	"odrzuc_margin": "Icon-Icon-odrzuc_margin",
	"odrzuc_white": "Icon-Icon-odrzuc_white",
	"settings": "Icon-Icon-settings",
	"settings_white": "Icon-Icon-settings_white",
	"settings_key_white": "Icon-Icon-settings_key_white",
	"messages": "Icon-Icon-messages",
	"messages_white": "Icon-Icon-messages_white",
	"notifications": "Icon-Icon-notifications",
	"notifications_white": "Icon-Icon-notifications_white",
	"logout": "Icon-Icon-logout",
	"logout_white": "Icon-Icon-logout_white",
	"historia": "Icon-Icon-historia",
	"historia_black": "Icon-Icon-historia_black",
	"edytuj": "Icon-Icon-edytuj",
	"edytuj_black": "Icon-Icon-edytuj_black",
	"edytuj2": "Icon-Icon-edytuj2",
	"polacz": "Icon-Icon-polacz",
	"polacz_black": "Icon-Icon-polacz_black",
	"cofnij": "Icon-Icon-cofnij",
	"cofnij_black": "Icon-Icon-cofnij_black",
	"dalej": "Icon-Icon-dalej",
	"dalej_black": "Icon-Icon-dalej_black",
	"kosz": "Icon-Icon-kosz",
	"pobierz": "Icon-Icon-pobierz",
	"pobierz_white": "Icon-Icon-pobierz_white",
	"lupka": "Icon-Icon-lupka",
	"lupka_white": "Icon-Icon-lupka_white"
};

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.884,1.605c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.746,3.901-3.9,3.901c-2.154,0-3.901-1.747-3.901-3.901 C0.983,3.351,2.73,1.605,4.884,1.605L4.884,1.605z M4.884,17.206c2.154,0,3.9,1.747,3.9,3.9c0,2.154-1.746,3.901-3.9,3.901 c-2.154,0-3.901-1.747-3.901-3.901C0.983,18.953,2.73,17.206,4.884,17.206L4.884,17.206z M4.884,32.808 c2.154,0,3.9,1.746,3.9,3.901c0,2.153-1.746,3.899-3.9,3.899c-2.154,0-3.901-1.746-3.901-3.899 C0.983,34.554,2.73,32.808,4.884,32.808L4.884,32.808z M12.685,5.505h27.303 M12.685,21.106h27.303 M12.685,36.709h27.303'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.884,1.605c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.746,3.901-3.9,3.901c-2.154,0-3.901-1.747-3.901-3.901 C0.983,3.351,2.73,1.605,4.884,1.605L4.884,1.605z M4.884,17.206c2.154,0,3.9,1.747,3.9,3.9c0,2.154-1.746,3.901-3.9,3.901 c-2.154,0-3.901-1.747-3.901-3.901C0.983,18.953,2.73,17.206,4.884,17.206L4.884,17.206z M4.884,32.808 c2.154,0,3.9,1.746,3.9,3.901c0,2.153-1.746,3.899-3.9,3.899c-2.154,0-3.901-1.746-3.901-3.899 C0.983,34.554,2.73,32.808,4.884,32.808L4.884,32.808z M12.685,5.505h27.303 M12.685,21.106h27.303 M12.685,36.709h27.303'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.523,1.317c10.771,0,19.502,8.731,19.502,19.502s-8.731,19.502-19.502,19.502S1.021,31.59,1.021,20.819 S9.752,1.317,20.523,1.317L20.523,1.317z'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='4.922' y1='20.819' x2='36.125' y2='20.819'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.523' y1='36.421' x2='20.523' y2='5.218'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.523,1.317c10.771,0,19.502,8.731,19.502,19.502s-8.731,19.502-19.502,19.502S1.021,31.59,1.021,20.819 S9.752,1.317,20.523,1.317L20.523,1.317z'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='4.922' y1='20.819' x2='36.125' y2='20.819'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.523' y1='36.421' x2='20.523' y2='5.218'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.707,1.317c10.771,0,19.503,8.731,19.503,19.502s-8.731,19.502-19.503,19.502c-10.77,0-19.501-8.731-19.501-19.502 S9.937,1.317,20.707,1.317L20.707,1.317z'/%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M9.006,9.118l23.401,23.402 M9.006,32.521L32.408,9.118'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4999' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.892,40.608v-7.801 M4.892,25.007V1.605 M20.493,40.608V17.206 M20.493,9.406V1.605 M36.095,40.608v-7.801 M36.095,25.007V1.605' /%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.892,25.007c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.747,3.9-3.9,3.9c-2.154,0-3.9-1.746-3.9-3.9 C0.991,26.753,2.737,25.007,4.892,25.007L4.892,25.007z M36.095,25.007c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.746,3.9-3.9,3.9 s-3.9-1.746-3.9-3.9C32.194,26.753,33.94,25.007,36.095,25.007L36.095,25.007z M20.493,9.406c2.154,0,3.9,1.746,3.9,3.9 c0,2.154-1.746,3.9-3.9,3.9s-3.9-1.746-3.9-3.9C16.593,11.152,18.339,9.406,20.493,9.406L20.493,9.406z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4999' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.892,40.608v-7.801 M4.892,25.007V1.605 M20.493,40.608V17.206 M20.493,9.406V1.605 M36.095,40.608v-7.801 M36.095,25.007V1.605' /%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M4.892,25.007c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.747,3.9-3.9,3.9c-2.154,0-3.9-1.746-3.9-3.9 C0.991,26.753,2.737,25.007,4.892,25.007L4.892,25.007z M36.095,25.007c2.154,0,3.9,1.746,3.9,3.9c0,2.154-1.746,3.9-3.9,3.9 s-3.9-1.746-3.9-3.9C32.194,26.753,33.94,25.007,36.095,25.007L36.095,25.007z M20.493,9.406c2.154,0,3.9,1.746,3.9,3.9 c0,2.154-1.746,3.9-3.9,3.9s-3.9-1.746-3.9-3.9C16.593,11.152,18.339,9.406,20.493,9.406L20.493,9.406z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='41px' viewBox='0 0 41 41' enable-background='new 0 0 41 41' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M7.678,38.949c-0.708,0.724-1.695,1.172-2.787,1.172c-2.154,0-3.9-1.746-3.9-3.9c0-1.05,0.415-2.003,1.091-2.704v-0.001 c7.554-7.553,15.107-15.107,22.661-22.661C24.584,10.236,24.5,9.587,24.5,8.919c0-4.309,3.492-7.801,7.801-7.801 c0.79,0,1.553,0.118,2.271,0.336c-1.315,0.626-2.225,1.968-2.225,3.522c0,2.154,1.746,3.9,3.9,3.9c1.552,0,2.892-0.906,3.521-2.219 c0.216,0.715,0.332,1.474,0.332,2.26c0,4.308-3.492,7.8-7.8,7.8c-0.723,0-1.422-0.098-2.085-0.282L7.678,38.949L7.678,38.949z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M0.985,7.332h39.003v27.303H0.985V7.332L0.985,7.332z M0.985,7.332l19.502,19.502L39.988,7.332 M0.985,34.635l13.651-13.651'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='39.988' y1='34.635' x2='26.337' y2='20.983'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M0.985,7.332h39.003v27.303H0.985V7.332L0.985,7.332z M0.985,7.332l19.502,19.502L39.988,7.332 M0.985,34.635l13.651-13.651'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='39.988' y1='34.635' x2='26.337' y2='20.983'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M24.394,36.491c0,2.154-1.746,3.9-3.9,3.9s-3.9-1.746-3.9-3.9H24.394L24.394,36.491z M36.094,17.029L36.094,17.029l0.001,8.784 c0,1.982,0.4,3.679,1.287,5.451l2.613,5.228H0.992l2.614-5.228c0.886-1.771,1.286-3.469,1.286-5.45v-8.82v-0.004l0,0 C4.893,8.373,11.877,1.388,20.494,1.388s15.602,6.985,15.602,15.601C36.095,17.002,36.094,17.016,36.094,17.029L36.094,17.029z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M24.394,36.491c0,2.154-1.746,3.9-3.9,3.9s-3.9-1.746-3.9-3.9H24.394L24.394,36.491z M36.094,17.029L36.094,17.029l0.001,8.784 c0,1.982,0.4,3.679,1.287,5.451l2.613,5.228H0.992l2.614-5.228c0.886-1.771,1.286-3.469,1.286-5.45v-8.82v-0.004l0,0 C4.893,8.373,11.877,1.388,20.494,1.388s15.602,6.985,15.602,15.601C36.095,17.002,36.094,17.016,36.094,17.029L36.094,17.029z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M32.237,5.289c0.725,0.546,1.411,1.143,2.054,1.785c7.616,7.616,7.616,19.964,0,27.58c-7.616,7.616-19.964,7.616-27.58,0 c-7.616-7.616-7.616-19.964,0-27.58c0.642-0.642,1.328-1.239,2.053-1.785'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.501' y1='1.361' x2='20.501' y2='21.19'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M32.237,5.289c0.725,0.546,1.411,1.143,2.054,1.785c7.616,7.616,7.616,19.964,0,27.58c-7.616,7.616-19.964,7.616-27.58,0 c-7.616-7.616-7.616-19.964,0-27.58c0.642-0.642,1.328-1.239,2.053-1.785'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.501' y1='1.361' x2='20.501' y2='21.19'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.49,5.505l0.092,15.602 M20.582,21.106l11.609,7.801'/%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M1.08,21.106c0-10.771,8.731-19.501,19.502-19.501c10.771,0,19.501,8.731,19.501,19.501s-8.73,19.502-19.501,19.502 c-6.158,0-11.954-2.908-15.635-7.845'/%3E %3Cpolyline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.689,32.808 4.888,32.808 4.888,40.608 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.49,5.505l0.092,15.602 M20.582,21.106l11.609,7.801'/%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M1.08,21.106c0-10.771,8.731-19.501,19.502-19.501c10.771,0,19.501,8.731,19.501,19.501s-8.73,19.502-19.501,19.502 c-6.158,0-11.954-2.908-15.635-7.845'/%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.689,32.808 4.888,32.808 4.888,40.608 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M1.006,5.488h7.801v27.303H1.006V5.488L1.006,5.488z M1.006,5.488h7.801v-3.9H1.006V5.488L1.006,5.488z M8.807,32.791l-3.9,7.801 l-3.9-7.801'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='4.907' y1='40.592' x2='40.01' y2='40.592'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M1.006,5.488h7.801v27.303H1.006V5.488L1.006,5.488z M1.006,5.488h7.801v-3.9H1.006V5.488L1.006,5.488z M8.807,32.791l-3.9,7.801 l-3.9-7.801'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='4.907' y1='40.592' x2='40.01' y2='40.592'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M15.615,5.488h7.8v27.303h-7.8V5.488L15.615,5.488z M15.615,5.488h7.8v-3.9h-7.8V5.488L15.615,5.488z M23.415,32.791l-3.9,7.801 l-3.899-7.801'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4999' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M0.984,40.448l15.364-15.365 M28.766,12.677L39.987,1.444'/%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-miterlimit='22.9256' d='M20.485,15.096 c3.231,0,5.851,2.619,5.851,5.851c0,3.231-2.619,5.851-5.851,5.851c-3.23,0-5.851-2.62-5.851-5.851 C14.634,17.715,17.254,15.096,20.485,15.096L20.485,15.096z'/%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M12.211,12.672c4.569-4.57,11.979-4.57,16.548,0s4.569,11.978,0,16.548'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4999' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M0.984,40.448l15.364-15.365 M28.766,12.677L39.987,1.444'/%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-miterlimit='22.9256' d='M20.485,15.096 c3.231,0,5.851,2.619,5.851,5.851c0,3.231-2.619,5.851-5.851,5.851c-3.23,0-5.851-2.62-5.851-5.851 C14.634,17.715,17.254,15.096,20.485,15.096L20.485,15.096z'/%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M12.211,12.672c4.569-4.57,11.979-4.57,16.548,0s4.569,11.978,0,16.548'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.508,1.65c10.771,0,19.502,8.731,19.502,19.502s-8.731,19.502-19.502,19.502c-10.771,0-19.502-8.731-19.502-19.502 S9.737,1.65,20.508,1.65L20.508,1.65z'/%3E %3Cpolyline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 28.309,9.451 8.807,21.152 28.309,32.854 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.508,1.65c10.771,0,19.502,8.731,19.502,19.502s-8.731,19.502-19.502,19.502c-10.771,0-19.502-8.731-19.502-19.502 S9.737,1.65,20.508,1.65L20.508,1.65z'/%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 28.309,9.451 8.807,21.152 28.309,32.854 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.492,1.65C9.722,1.65,0.99,10.382,0.99,21.152s8.731,19.502,19.502,19.502c10.771,0,19.502-8.731,19.502-19.502 S31.264,1.65,20.492,1.65L20.492,1.65z'/%3E %3Cpolyline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.691,9.451 32.193,21.152 12.691,32.854 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.492,1.65C9.722,1.65,0.99,10.382,0.99,21.152s8.731,19.502,19.502,19.502c10.771,0,19.502-8.731,19.502-19.502 S31.264,1.65,20.492,1.65L20.492,1.65z'/%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.691,9.451 32.193,21.152 12.691,32.854 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 28.324,5.292 24.423,1.391 16.623,1.391 12.722,5.292 '/%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 36.125,5.292 32.224,40.395 8.822,40.395 5.034,5.292 '/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='1.021' y1='5.292' x2='40.025' y2='5.292'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpolyline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.882,24.813 20.682,36.514 28.482,24.813 '/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.682' y1='36.514' x2='20.682' y2='1.41'/%3E %3Cpolygon fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 1.181,40.412 40.184,40.412 1.181,40.412 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpolyline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 12.882,24.813 20.682,36.514 28.482,24.813 '/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='20.682' y1='36.514' x2='20.682' y2='1.41'/%3E %3Cpolygon fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' points=' 1.181,40.412 40.184,40.412 1.181,40.412 '/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M26.352,1.375c7.539,0,13.651,6.112,13.651,13.651s-6.112,13.652-13.651,13.652s-13.651-6.112-13.651-13.652 S18.813,1.375,26.352,1.375L26.352,1.375z'/%3E %3Cline fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='1' y1='40.379' x2='16.601' y2='24.777'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M26.352,1.375c7.539,0,13.651,6.112,13.651,13.651s-6.112,13.652-13.651,13.652s-13.651-6.112-13.651-13.652 S18.813,1.375,26.352,1.375L26.352,1.375z'/%3E %3Cline fill='none' stroke='%23ffffff' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' x1='1' y1='40.379' x2='16.601' y2='24.777'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(104);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(1042);
var reduce = __webpack_require__(1043);

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  root = this;
}

/**
 * Noop.
 */

function noop(){};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  return false;
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return obj === Object(obj);
}

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    if (null != obj[key]) {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(obj[key]));
    }
  }
  return pairs.join('&');
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var parts;
  var pair;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    parts = pair.split('=');
    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return reduce(str.split(/ *; */), function(obj, str){
    var parts = str.split(/ *= */)
      , key = parts.shift()
      , val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this.setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this.setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this.parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype.setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Force given parser
 * 
 * Sets the body parser no matter type.
 * 
 * @param {Function}
 * @api public
 */

Response.prototype.parse = function(fn){
  this.parser = fn;
  return this;
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype.parseBody = function(str){
  var parse = this.parser || request.parse[this.type];
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype.setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  Emitter.call(this);
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {};
  this._header = {};
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      return self.callback(err);
    }

    self.emit('response', res);

    if (err) {
      return self.callback(err, res);
    }

    if (res.status >= 200 && res.status < 300) {
      return self.callback(err, res);
    }

    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
    new_err.original = err;
    new_err.response = res;
    new_err.status = res.status;

    self.callback(new_err, res);
  });
}

/**
 * Mixin `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Allow for extension
 */

Request.prototype.use = function(fn) {
  fn(this);
  return this;
}

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.timeout = function(ms){
  this._timeout = ms;
  return this;
};

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.clearTimeout = function(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */

Request.prototype.abort = function(){
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Set header `field` to `val`, or multiple fields with one object.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Get case-insensitive header `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api private
 */

Request.prototype.getHeader = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass){
  var str = btoa(user + ':' + pass);
  this.set('Authorization', 'Basic ' + str);
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Write the field `name` and `val` for "multipart/form-data"
 * request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 * ```
 *
 * @param {String} name
 * @param {String|Blob|File} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.field = function(name, val){
  if (!this._formData) this._formData = new root.FormData();
  this._formData.append(name, val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  if (!this._formData) this._formData = new root.FormData();
  this._formData.append(field, file, filename);
  return this;
};

/**
 * Send `data`, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // querystring
 *       request.get('/search')
 *         .end(callback)
 *
 *       // multiple data "writes"
 *       request.get('/search')
 *         .send({ search: 'query' })
 *         .send({ range: '1..5' })
 *         .send({ order: 'desc' })
 *         .end(callback)
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"})
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
  *      request.post('/user')
  *        .send('name=tobi')
  *        .send('species=ferret')
  *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.send = function(data){
  var obj = isObject(data);
  var type = this.getHeader('Content-Type');

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    if (!type) this.type('form');
    type = this.getHeader('Content-Type');
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || isHost(data)) return this;
  if (!type) this.type('json');
  return this;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
  err.crossDomain = true;
  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype.timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

Request.prototype.withCredentials = function(){
  this._withCredentials = true;
  return this;
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var query = this._query.join('&');
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self.timeoutError();
      if (self.aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(e){
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    xhr.onprogress = handleProgress;
  }
  try {
    if (xhr.upload && this.hasListeners('progress')) {
      xhr.upload.onprogress = handleProgress;
    }
  } catch(e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  if (query) {
    query = request.serializeObject(query);
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }

  // initiate request
  xhr.open(this.method, this.url, true);

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
    // serialize stuff
    var contentType = this.getHeader('Content-Type');
    var serialize = request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  // send stuff
  this.emit('request', this);
  xhr.send(data);
  return this;
};

/**
 * Faux promise support
 *
 * @param {Function} fulfill
 * @param {Function} reject
 * @return {Request}
 */

Request.prototype.then = function (fulfill, reject) {
  return this.end(function(err, res) {
    err ? reject(err) : fulfill(res);
  });
}

/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(method, url) {
  // callback
  if ('function' == typeof url) {
    return new Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new Request('GET', method);
  }

  return new Request(method, url);
}

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.del = function(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * Expose `request`.
 */

module.exports = request;


/***/ }),

/***/ 1042:
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 1043:
/***/ (function(module, exports) {


/**
 * Reduce `arr` with `fn`.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Mixed} initial
 *
 * TODO: combatible error handling?
 */

module.exports = function(arr, fn, initial){  
  var idx = 0;
  var len = arr.length;
  var curr = arguments.length == 3
    ? initial
    : arr[idx++];

  while (idx < len) {
    curr = fn.call(null, curr, arr[idx], ++idx, arr);
  }
  
  return curr;
};

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

module.exports = function(data, filename, mime) {
    var blob = new Blob([data], {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were 
        // revoked by closing the blob for which they were created. 
        // These URLs will no longer resolve as the data backing 
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename); 
        
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking 
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }
        
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }
}


/***/ }),

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mandatoryServerSide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);

function mandatoryServerSide(path) {
  if (!__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
    throw new Error('Missing parameter for path ' + path);
  }
}

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1047);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Badge.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Badge.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Badge-Badge-Badge{background-color:#f00540;color:#fff;padding:3.2px 3px;padding:.2rem .1875rem;border-radius:50%;font-size:10px;font-size:.625rem;line-height:1;position:absolute;right:-12px;right:-.75rem;top:16px;top:1rem;min-width:16px;min-width:1rem;text-align:center}.Badge-Badge-Badge:empty{display:none}@media (min-width:920px){.Badge-Badge-Badge{top:2rem}}.Badge-Badge-Badge__history{right:8px;right:.5rem;top:24px;top:1.5rem}.Badge-Badge-Badge__history:empty{display:none}.Badge-Badge-Badge__inline{position:static;display:inline-block;padding:4.8px 3.2px 3.2px;padding:.3rem .2rem .2rem;font-size:12px;font-size:.75rem;margin-right:5.6px;margin-right:.35rem;min-width:21.6px;min-width:1.35rem;-ms-flex-negative:0;flex-shrink:0}.Badge-Badge-Badge__inline:empty{display:inherit;padding:0;width:21.6px;width:1.35rem;height:21.6px;height:1.35rem;background-color:transparent;border:1px solid #f00540;opacity:.3}", ""]);

// exports
exports.locals = {
	"Badge": "Badge-Badge-Badge",
	"Badge__history": "Badge-Badge-Badge__history",
	"Badge__inline": "Badge-Badge-Badge__inline"
};

/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1049);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Section.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Section.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Section-Section-Section{margin:0 auto;max-width:768px;max-width:48rem}.Section-Section-Section__container{padding-top:15px;padding-top:.9375rem}@media (min-width:1280px){.Section-Section-Section__container{max-width:none}}.Section-Section-Section__sidebar:empty{padding:0}@media (min-width:721px){.Section-Section-Section__sidebar{width:100%;float:left}.Section-Section-Section__sidebar+.Section-Section-Section__sidebar{float:right}}@media (min-width:1280px){.Section-Section-Section__sidebar{width:10rem}}.Section-Section-Section__main{clear:both}@media (min-width:1280px){.Section-Section-Section__main{width:calc(100% - 20rem);clear:none}.Section-Section-Section--sidebar:not(:empty)+.Section-Section-Section__main{float:left}.Section-Section-Section__sidebar+.Section-Section-Section__sidebar+.Section-Section-Section__main{float:none}}.Section-Section-Section_info{font-size:13.6px;font-size:.85rem;margin:16px 0;margin:1rem 0}@media (min-width:1280px){.Section-Section-Section_info{max-width:75%;margin:1.5rem auto 0 1rem}.Section-Section-Section--sidebar+.Section-Section-Section--sidebar .Section-Section-Section_info{margin-left:auto;margin-right:1rem}}.Section-Section-Section_info__highlight{background-color:#f3f5f7;padding:8px 16px;padding:.5rem 1rem;margin:0 0 16px;margin:0 0 1rem}@media (min-width:1280px){.Section-Section-Section_info__highlight{max-width:none}}", ""]);

// exports
exports.locals = {
	"Section": "Section-Section-Section",
	"Section__container": "Section-Section-Section__container",
	"Section__sidebar": "Section-Section-Section__sidebar",
	"Section__main": "Section-Section-Section__main",
	"Section--sidebar": "Section-Section-Section--sidebar",
	"Section_info": "Section-Section-Section_info",
	"Section_info__highlight": "Section-Section-Section_info__highlight"
};

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1051);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SortInput.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SortInput.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".SortInput-SortInput-listBordered{padding:8px;padding:.5rem}.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item,.SortInput-SortInput-listBordered>li{padding:10px 0;padding:.625rem 0;font-size:13.6px;font-size:.85rem;display:block;border-bottom:1px solid #e9edf0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item:last-child,.SortInput-SortInput-listBordered>li:last-child{border-bottom:0}.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted,.SortInput-SortInput-listBordered>li.SortInput-SortInput-is_highlighted{background-color:#f3f5f7;position:relative}.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted:before,.SortInput-SortInput-listBordered>li.SortInput-SortInput-is_highlighted:before{content:\"\";position:absolute;top:-1px;left:0;right:0;height:1px;background-color:#e9edf0}.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted,.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted+.SortInput-SortInput-listBordered_item:not(.SortInput-SortInput-is_highlighted),.SortInput-SortInput-listBordered .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted+li,.SortInput-SortInput-listBordered>li.SortInput-SortInput-is_highlighted,.SortInput-SortInput-listBordered>li.SortInput-SortInput-is_highlighted+.SortInput-SortInput-listBordered_item:not(.SortInput-SortInput-is_highlighted),.SortInput-SortInput-listBordered>li.SortInput-SortInput-is_highlighted+li{margin:0 -8px;margin:0 -.5rem;padding:10px 8px;padding:.625rem .5rem}.SortInput-SortInput-listBordered__large{padding:15px;padding:.9375rem}.SortInput-SortInput-listBordered__large .SortInput-SortInput-listBordered-item,.SortInput-SortInput-listBordered__large li{padding:15px 0;padding:.9375rem 0;font-size:15.2px;font-size:.95rem}.SortInput-SortInput-listBordered__large .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted,.SortInput-SortInput-listBordered__large .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted+.SortInput-SortInput-listBordered-item:not(.SortInput-SortInput-is-highlighted),.SortInput-SortInput-listBordered__large .SortInput-SortInput-listBordered_item.SortInput-SortInput-is_highlighted+li,.SortInput-SortInput-listBordered__large li.SortInput-SortInput-is_highlighted,.SortInput-SortInput-listBordered__large li.SortInput-SortInput-is_highlighted+.SortInput-SortInput-listBordered-item:not(.SortInput-SortInput-is-highlighted),.SortInput-SortInput-listBordered__large li.SortInput-SortInput-is_highlighted+li{margin:0 -var(--base-gutter);padding:15px;padding:.9375rem}.SortInput-SortInput-listBordered__flat{padding-top:0;padding-bottom:0}.SortInput-SortInput-Sort{font-size:13.6px;font-size:.85rem;text-align:right;margin:8px 0;margin:.5rem 0}@media (min-width:721px){.SortInput-SortInput-Sort{margin:0}}.SortInput-SortInput-SortInput{display:inline-block;white-space:nowrap;margin:8px 0 8px 8px;margin:.5rem 0 .5rem .5rem;color:#646669;position:relative}.SortInput-SortInput-is_active{color:#022140}.SortInput-SortInput-SortInput_label{display:inline-block;margin-right:10px}.SortInput-SortInput-SortInput_field{color:#000;font-size:14px;font-size:.875rem;line-height:24px;line-height:1.5rem;height:24px;height:1.5rem;padding:0 6.4px;padding:0 .4rem;width:256px;width:16rem;display:inline-block;position:relative}.SortInput-SortInput-SortInput__light .SortInput-SortInput-SortInput_field,.SortInput-SortInput-SortInput__search .SortInput-SortInput-SortInput_field{padding-right:25.6px;padding-right:1.6rem}.SortInput-SortInput-SortInput__search .SortInput-SortInput-SortInput_field{border:1px solid #054c94;border-radius:2px;background-color:transparent;font-size:12.8px;font-size:.8rem;line-height:21.6px;line-height:1.35rem;height:21.6px;height:1.35rem}.SortInput-SortInput-SortInput__light .SortInput-SortInput-SortInput_field{background-color:hsla(0,0%,100%,.7)}.SortInput-SortInput-SortInput_field:-moz-read-only{background-color:hsla(0,0%,86%,.7)}.SortInput-SortInput-SortInput_field:read-only{background-color:hsla(0,0%,86%,.7)}.SortInput-SortInput-SortInput_icon{position:absolute;right:3.2px;right:.2rem;top:2.8px;top:.175rem}.SortInput-SortInput-Sort .SortInput-SortInput-SortInput_icon{display:none}.SortInput-SortInput-SortInput__search .SortInput-SortInput-SortInput_icon{display:block}.SortInput-SortInput-SortInput__light .SortInput-SortInput-SortInput_icon{opacity:.4;display:block}", ""]);

// exports
exports.locals = {
	"listBordered": "SortInput-SortInput-listBordered",
	"listBordered_item": "SortInput-SortInput-listBordered_item",
	"is_highlighted": "SortInput-SortInput-is_highlighted",
	"listBordered__large": "SortInput-SortInput-listBordered__large",
	"listBordered-item": "SortInput-SortInput-listBordered-item",
	"is-highlighted": "SortInput-SortInput-is-highlighted",
	"listBordered__flat": "SortInput-SortInput-listBordered__flat",
	"Sort": "SortInput-SortInput-Sort",
	"SortInput": "SortInput-SortInput-SortInput",
	"is_active": "SortInput-SortInput-is_active",
	"SortInput_label": "SortInput-SortInput-SortInput_label",
	"SortInput_field": "SortInput-SortInput-SortInput_field",
	"SortInput__search": "SortInput-SortInput-SortInput__search",
	"SortInput__light": "SortInput-SortInput-SortInput__light",
	"SortInput_icon": "SortInput-SortInput-SortInput_icon"
};

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1053);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Sort.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Sort.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Sort-Sort-Sort{font-size:13.6px;font-size:.85rem;margin:8px 0;margin:.5rem 0;width:100%}@media (min-width:721px){.Sort-Sort-Sort{margin:0;text-align:right}}", ""]);

// exports
exports.locals = {
	"Sort": "Sort-Sort-Sort"
};

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

function toObj(source) {
  return Object.keys(source).reduce(function (output, key) {
    var parentKey = key.match(/[^\[]*/i);
    var paths = key.match(/\[.*?\]/g) || [];
    paths = [parentKey[0]].concat(paths).map(function (key) {
      return key.replace(/\[|\]/g, '');
    });
    var currentPath = output;
    while (paths.length) {
      var pathKey = paths.shift();

      if (pathKey in currentPath) {
        currentPath = currentPath[pathKey];
      } else {
        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
        currentPath = currentPath[pathKey];
      }
    }

    return output;
  }, {});
}

function fromObj(obj) {
  function recur(newObj, propName, currVal) {
    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
      Object.keys(currVal).forEach(function(v) {
        recur(newObj, propName + "[" + v + "]", currVal[v]);
      });
      return newObj;
    }

    newObj[propName] = currVal;
    return newObj;
  }

  var keys = Object.keys(obj);
  return keys.reduce(function(newObj, propName) {
    return recur(newObj, propName, obj[propName]);
  }, {});
}

module.exports = {
  fromObj: fromObj,
  toObj: toObj
}

/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isExisty = function _isExisty(value) {
  return value !== null && value !== undefined;
};
var isEmpty = function isEmpty(value) {
  return value === '';
};

var validations = {
  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
    return value === undefined || value === '';
  },
  isExisty: function isExisty(values, value) {
    return _isExisty(value);
  },
  matchRegexp: function matchRegexp(values, value, regexp) {
    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
  },
  isUndefined: function isUndefined(values, value) {
    return value === undefined;
  },
  isEmptyString: function isEmptyString(values, value) {
    return isEmpty(value);
  },
  isEmail: function isEmail(values, value) {
    // Regex from http://emailregex.com/
    return validations.matchRegexp(values, value, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
  },
  isUrl: function isUrl(values, value) {
    return validations.matchRegexp(values, value, /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/i);
  },
  isTrue: function isTrue(values, value) {
    return value === true;
  },
  isFalse: function isFalse(values, value) {
    return value === false;
  },
  isNumeric: function isNumeric(values, value) {
    if (typeof value === 'number') {
      return true;
    }
    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
  },
  isAlpha: function isAlpha(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
  },
  isAlphanumeric: function isAlphanumeric(values, value) {
    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
  },
  isInt: function isInt(values, value) {
    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
  },
  isFloat: function isFloat(values, value) {
    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][+-]?(?:\d+))?$/);
  },
  isWords: function isWords(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
  },
  isSpecialWords: function isSpecialWords(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
  },
  isLength: function isLength(values, value, length) {
    return !_isExisty(value) || isEmpty(value) || value.length === length;
  },
  equals: function equals(values, value, eql) {
    return !_isExisty(value) || isEmpty(value) || value === eql;
  },
  equalsField: function equalsField(values, value, field) {
    return value === values[field];
  },
  maxLength: function maxLength(values, value, length) {
    return !_isExisty(value) || value.length <= length;
  },
  minLength: function minLength(values, value, length) {
    return !_isExisty(value) || isEmpty(value) || value.length >= length;
  }
};

exports.default = validations;

/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(79);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(70);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(930);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/default-props-match-prop-types */

var convertValidationsToObject = function convertValidationsToObject(validations) {
  if (typeof validations === 'string') {
    return validations.split(/,(?![^{[]*[}\]])/g).reduce(function (validationsAccumulator, validation) {
      var args = validation.split(':');
      var validateMethod = args.shift();

      args = args.map(function (arg) {
        try {
          return JSON.parse(arg);
        } catch (e) {
          return arg; // It is a string if it can not parse it
        }
      });

      if (args.length > 1) {
        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
      }

      // Avoid parameter reassignment
      var validationsAccumulatorCopy = Object.assign({}, validationsAccumulator);
      validationsAccumulatorCopy[validateMethod] = args.length ? args[0] : true;
      return validationsAccumulatorCopy;
    }, {});
  }

  return validations || {};
};

var propTypes = {
  innerRef: _propTypes2.default.func,
  name: _propTypes2.default.string.isRequired,
  required: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.string]),
  validations: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  value: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types
};

exports.propTypes = propTypes;

exports.default = function (Component) {
  var WrappedComponent = function (_React$Component) {
    _inherits(WrappedComponent, _React$Component);

    function WrappedComponent(props) {
      _classCallCheck(this, WrappedComponent);

      var _this = _possibleConstructorReturn(this, (WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call(this, props));

      _this.getErrorMessage = function () {
        var messages = _this.getErrorMessages();
        return messages.length ? messages[0] : null;
      };

      _this.getErrorMessages = function () {
        if (!_this.isValid() || _this.showRequired()) {
          return _this.state.externalError || _this.state.validationError || [];
        }
        return [];
      };

      _this.getValue = function () {
        return _this.state.value;
      };

      _this.setValidations = function (validations, required) {
        // Add validations to the store itself as the props object can not be modified
        _this.validations = convertValidationsToObject(validations) || {};
        _this.requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
      };

      _this.setValue = function (value) {
        var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (!validate) {
          _this.setState({
            value: value
          });
        } else {
          _this.setState({
            value: value,
            isPristine: false
          }, function () {
            _this.context.formsy.validate(_this);
          });
        }
      };

      _this.hasValue = function () {
        return _this.state.value !== '';
      };

      _this.isFormDisabled = function () {
        return _this.context.formsy.isFormDisabled();
      };

      _this.isFormSubmitted = function () {
        return _this.state.formSubmitted;
      };

      _this.isPristine = function () {
        return _this.state.isPristine;
      };

      _this.isRequired = function () {
        return !!_this.props.required;
      };

      _this.isValid = function () {
        return _this.state.isValid;
      };

      _this.isValidValue = function (value) {
        return _this.context.formsy.isValidValue.call(null, _this, value);
      };

      _this.resetValue = function () {
        _this.setState({
          value: _this.state.pristineValue,
          isPristine: true
        }, function () {
          _this.context.formsy.validate(_this);
        });
      };

      _this.showError = function () {
        return !_this.showRequired() && !_this.isValid();
      };

      _this.showRequired = function () {
        return _this.state.isRequired;
      };

      _this.state = {
        value: props.value,
        isRequired: false,
        isValid: true,
        isPristine: true,
        pristineValue: props.value,
        validationError: [],
        externalError: null,
        formSubmitted: false
      };
      return _this;
    }

    _createClass(WrappedComponent, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        var configure = function configure() {
          _this2.setValidations(_this2.props.validations, _this2.props.required);

          // Pass a function instead?
          _this2.context.formsy.attachToForm(_this2);
        };

        if (!this.props.name) {
          throw new Error('Form Input requires a name property when used');
        }

        configure();
      }

      // We have to make sure the validate method is kept when new props are added

    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setValidations(nextProps.validations, nextProps.required);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        // If the value passed has changed, set it. If value is not passed it will
        // internally update, and this will never run
        if (!_utils2.default.isSame(this.props.value, prevProps.value)) {
          this.setValue(this.props.value);
        }

        // If validations or required is changed, run a new validation
        if (!_utils2.default.isSame(this.props.validations, prevProps.validations) || !_utils2.default.isSame(this.props.required, prevProps.required)) {
          this.context.formsy.validate(this);
        }
      }

      // Detach it when component unmounts

    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context.formsy.detachFromForm(this);
      }

      // By default, we validate after the value has been set.
      // A user can override this and pass a second parameter of `false` to skip validation.

    }, {
      key: 'render',
      value: function render() {
        var innerRef = this.props.innerRef;

        var propsForElement = _extends({
          getErrorMessage: this.getErrorMessage,
          getErrorMessages: this.getErrorMessages,
          getValue: this.getValue,
          hasValue: this.hasValue,
          isFormDisabled: this.isFormDisabled,
          isValid: this.isValid,
          isPristine: this.isPristine,
          isFormSubmitted: this.isFormSubmitted,
          isRequired: this.isRequired,
          isValidValue: this.isValidValue,
          resetValue: this.resetValue,
          setValidations: this.setValidations,
          setValue: this.setValue,
          showRequired: this.showRequired,
          showError: this.showError
        }, this.props);

        if (innerRef) {
          propsForElement.ref = innerRef;
        }

        return _react2.default.createElement(Component, propsForElement);
      }
    }]);

    return WrappedComponent;
  }(_react2.default.Component);

  function getDisplayName(component) {
    return component.displayName || component.name || (typeof component === 'string' ? component : 'Component');
  }

  WrappedComponent.displayName = 'Formsy(' + getDisplayName(Component) + ')';

  WrappedComponent.contextTypes = {
    formsy: _propTypes2.default.object // What about required?
  };

  WrappedComponent.defaultProps = {
    innerRef: function innerRef() {},
    required: false,
    validationError: '',
    validationErrors: {},
    validations: null,
    value: Component.defaultValue
  };

  WrappedComponent.propTypes = propTypes;

  return WrappedComponent;
};

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1058);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Select.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(889);
exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Select-Select-u_hidden{display:none!important}.Select-Select-big{height:128px!important;height:8rem!important}.Select-Select-Form_field{-webkit-appearance:none!important;-moz-appearance:none!important;background:#fff url(" + escape(__webpack_require__(1059)) + ") no-repeat 100%;color:#000;font-size:14px;font-size:.875rem;line-height:24px;line-height:1.5rem;height:32px;height:2rem;margin:0 0 10px;margin:0 0 .625rem;padding:4.8px 8.4px;padding:.3rem .525rem;width:100%;display:block;position:relative}.Select-Select-Form_field:focus{border-color:rgba(2,33,64,.4)}.Select-Select-Form_field:disabled{background-color:transparent;opacity:.75}.Select-Select-Form_field a{color:#022140}.Select-Select-Form__secondary .Select-Select-Form_field{background-color:transparent;border-color:rgba(2,33,64,.4)}.Select-Select-Form__static .Select-Select-Form_field{border-color:#022140}.Select-Select-Form_group .Select-Select-Form_field{margin-bottom:0}.Select-Select-Form_addon .Select-Select-Form_field{background-color:rgba(2,33,64,.35);border:1px solid rgba(2,33,64,.4);border-right:0;border-radius:2px 0 0 2px}.Select-Select-Form_afterAddon .Select-Select-Form_field{border-left:0;border-radius:0 2px 2px 0}.Select-Select-Form_buttonLike .Select-Select-Form_field{background-color:#f3f5f7}.Select-Select-FormSelect{position:relative}.Select-Select-FormSelect__static{max-width:80%;margin:0 auto 40px;margin:0 auto 2.5rem}.Select-Select-FormSelect__label{display:block}.Select-Select-FormSelect__static .Select-Select-FormSelect__label{margin-bottom:8px;margin-bottom:.5rem;text-align:center}.Select-Select-FormSelect_value{position:absolute;top:0;bottom:0;right:0;left:0;margin:0;padding-right:22.4px;padding-right:1.4rem;white-space:nowrap;overflow:hidden;width:100%;-o-text-overflow:ellipsis;text-overflow:ellipsis}.Select-Select-FormSelect_value.Select-Select-is-default{color:rgba(0,0,0,.55)}.Select-Select-FormSelect_value:after{content:\"\";border:3px solid transparent;border-top:5px solid #022140;position:absolute;right:12.8px;right:.8rem;top:calc(50% - 3px)}.Select-Select-FormSelect_field:focus+.Select-Select-FormSelect_value{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;border-color:rgba(2,33,64,.4)}.Select-Select-FormSelect_field:disabled+.Select-Select-FormSelect_value,.Select-Select-FormSelect_field:disabled+.Select-Select-FormSelect_value:after{opacity:.75}.Select-Select-FormSelect__static .Select-Select-FormSelect_value{background-color:#fff;border-color:#022140;text-align:center}.Select-Select-FormSelect__static .Select-Select-FormSelect_value:after{border-width:6px;border-top-width:9px}.Select-Select-FormSelect_value.Select-Select-Form_field__large{line-height:1.2}", ""]);

// exports
exports.locals = {
	"u_hidden": "Select-Select-u_hidden",
	"big": "Select-Select-big",
	"Form_field": "Select-Select-Form_field",
	"Form__secondary": "Select-Select-Form__secondary",
	"Form__static": "Select-Select-Form__static",
	"Form_group": "Select-Select-Form_group",
	"Form_addon": "Select-Select-Form_addon",
	"Form_afterAddon": "Select-Select-Form_afterAddon",
	"Form_buttonLike": "Select-Select-Form_buttonLike",
	"FormSelect": "Select-Select-FormSelect",
	"FormSelect__static": "Select-Select-FormSelect__static",
	"FormSelect__label": "Select-Select-FormSelect__label",
	"FormSelect_value": "Select-Select-FormSelect_value",
	"is-default": "Select-Select-is-default",
	"FormSelect_field": "Select-Select-FormSelect_field",
	"Form_field__large": "Select-Select-Form_field__large"
};

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpERUVGMjAzMkUzN0FFMjExQTE5N0UzMjI4RjgyN0E1QyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMEQ2QjBGODgzOTExMUUyODEyREIxMkY3REFGN0VBMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMEQ2QjBGNzgzOTExMUUyODEyREIxMkY3REFGN0VBMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjdCODBGQzg4N0Q4M0UyMTE5MTk5QTc5M0NFNzA2REQ3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkRFRUYyMDMyRTM3QUUyMTFBMTk3RTMyMjhGODI3QTVDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dvvVVgAAAK5JREFUeNpi/P//PwM1ACNNDKqsrGwGUrVE6Gtub29HUceEpqAGiNsJGNIOVceAzyAQqADiLhyGdEHlGYgxCARKgbgP5HVYEED5pbiciW7QKyR2IRBPhKqZCOVjU4fVIEcgfonEzwXii1AaBl5C1eE16BoQOwDxcyQxHST2c6j8NWLC6AbUxqdo4k+hhtwgJbBvQjU9hvIfQ/m3iA1sZHAHqvkQlL5D/yxCCQAIMAAeiDEIpiCuCgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1061);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Form.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Form.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Form-Form-Form__separated{background-color:#fbfbfb;padding:8px 15px;padding:.5rem .9375rem}.Form-Form-Form__secondary{display:inline}.Form-Form-Form__secondary input{display:inline;width:49%}.Form-Form-Form__secondary div{display:inline}.Form-Form-Form__safetech{display:inline-block;min-width:80%}.Form-Form-is-FormDisabled{opacity:.75}.Form-Form-Form_group{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 10px;margin:0 0 .625rem}.Form-Form-Form_field{border:1px solid #99d0d1;color:#000;font-size:14px;font-size:.875rem;line-height:24px;line-height:1.5rem;height:32px;height:2rem;margin:0 0 10px;margin:0 0 .625rem;padding:4.8px 8.4px;padding:.3rem .525rem;width:100%;display:block;position:relative}.Form-Form-Form_field:focus{border-color:rgba(2,33,64,.4)}.Form-Form-Form_field:disabled{background-color:transparent;opacity:.75}.Form-Form-Form_field a{color:#022140}.Form-Form-Form__secondary .Form-Form-Form_field{background-color:transparent;border-color:rgba(2,33,64,.4)}.Form-Form-Form__static .Form-Form-Form_field{border-color:#022140}.Form-Form-Form_group .Form-Form-Form_field{margin-bottom:0}.Form-Form-Form_addon .Form-Form-Form_field{background-color:rgba(2,33,64,.35);border:1px solid rgba(2,33,64,.4);border-right:0;border-radius:2px 0 0 2px}.Form-Form-Form_afterAddon .Form-Form-Form_field{border-left:0;border-radius:0 2px 2px 0}.Form-Form-Form_buttonLike .Form-Form-Form_field{background-color:#f3f5f7}.Form-Form-Form_field__small{height:24px;height:1.5rem;font-size:13.6px;font-size:.85rem}.Form-Form-Form_field__large{padding:9.8px 8.4px;padding:.6125rem .525rem;height:40px;height:2.5rem}.Form-Form-Form_field__withoutBorder{border:0;margin-bottom:0}textarea.Form-Form-Form_field{min-height:56px;min-height:3.5rem}@media (min-width:721px){textarea.Form-Form-Form_field{min-height:8.5rem}}textarea[rows]{height:auto;min-height:0;overflow:hidden}.Form-Form-Form_addon{max-width:80px;max-width:5rem;-ms-flex-negative:0;flex-shrink:0;border-radius:2px 0 0 2px}@media (min-width:721px){.Form-Form-Form_addon{max-width:7rem}}.Form-Form-Form_afterAddon{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.Form-Form-Form_error{background-color:#ffe5e5;border:1px solid #ff6e6e;color:red;font-size:14px;font-size:.875rem;line-height:2.15;margin:5px 0 10px;margin:5px 0 .625rem;padding:0 10px;padding:0 .625rem;width:100%;min-width:165px}.Form-Form-Form_error--fit{display:inline-block;width:auto}.Form-Form-Form_error:empty{display:none}.Form-Form-Form_title{color:rgba(0,0,0,.55);font-size:14.4px;font-size:.9rem}.Form-Form-Form_note{font-size:12px;font-size:.75rem}.Form-Form-Form_note:empty{display:none}.Form-Form-Form_note__medium{font-size:14.4px;font-size:.9rem}.Form-Form-Form_note__withBorder{border:1px solid rgba(2,33,64,.35);padding:8px;padding:.5rem;margin-bottom:10px;margin-bottom:.625rem}.Form-Form-Form_section{border-top:2px solid #e9edf0;padding:20px 25px;padding:1.25rem 1.5625rem}.Form-Form-Form_section__withoutBorder{border-top:0;padding-top:8px;padding-top:.5rem}.Form-Form-Form_section__secondary{padding-left:0;padding-right:0;padding-bottom:10px;padding-bottom:.625rem;border-top:1px solid rgba(2,33,64,.35)}.Form-Form-Form_info{background-color:#83fc9c;color:#2e9943;font-size:14px;font-size:.875rem;left:0;padding:14px 35px;position:absolute;top:40px;width:100%}@media (min-width:721px){.Form-Form-Form_info{height:57px;padding:20px 35px;top:0}}.Form-Form-Form__standard .Form-Form-Form_info{position:static;height:auto}.Form-Form-Form_info__error{background-color:#ffe5e5;color:red}.Form-Form-FormSelect{position:relative}.Form-Form-FormSelect.Form-Form-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.Form-Form-FormSelect__static{max-width:80%;margin:0 auto 40px;margin:0 auto 2.5rem}.Form-Form-FormSelect_label{display:block}.Form-Form-FormSelect--static .Form-Form-FormSelect_label{margin-bottom:8px;margin-bottom:.5rem;text-align:center}.Form-Form-FormSelect_value{position:absolute;top:0;bottom:0;right:0;left:0;margin:0;padding-right:22.4px;padding-right:1.4rem;white-space:nowrap;overflow:hidden;width:100%;-o-text-overflow:ellipsis;text-overflow:ellipsis}.Form-Form-FormSelect_value.Form-Form-is-default{color:rgba(0,0,0,.55)}.Form-Form-FormSelect_value:after{content:\"\";border:3px solid transparent;border-top:5px solid #022140;position:absolute;right:12.8px;right:.8rem;top:calc(50% - 3px)}.Form-Form-FormSelect_field:focus+.Form-Form-FormSelect_value{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;border-color:rgba(2,33,64,.4)}.Form-Form-FormSelect_field:disabled+.Form-Form-FormSelect_value,.Form-Form-FormSelect_field:disabled+.Form-Form-FormSelect_value:after{opacity:.75}.Form-Form-FormSelect__static .Form-Form-FormSelect_value{background-color:#fff;border-color:#022140;text-align:center}.Form-Form-FormSelect__static .Form-Form-FormSelect_value:after{border-width:6px;border-top-width:9px}.Form-Form-FormSelect_value.Form-Form-Form_field__large{line-height:1.2}.Form-Form-FormSelect_field,.Form-Form-FormSelect_field:disabled{opacity:0;z-index:1}.Form-Form-Form_range{-webkit-appearance:none;border:none;width:100%}.Form-Form-Form_range:focus{outline:none}.Form-Form-Form_range::-webkit-slider-runnable-track{width:100%;height:4px;background:#ddd;border:none}.Form-Form-Form_range::-moz-range-track{width:100%;height:4px;background:#ddd;border:none}.Form-Form-Form_range:-ms-track{width:100%;height:4px}.Form-Form-Form_range::-webkit-slider-thumb{-webkit-appearance:none;margin-top:-7px;border:none;height:18px;width:18px;border-radius:50%;background:#022140}.Form-Form-Form_range::-moz-range-thumb{border:none;height:18px;width:18px;border-radius:50%;background:#022140}.Form-Form-Form_range::-ms-thumb{border:none;height:18px;width:18px;border-radius:50%;background:#022140}.Form-Form-Form_range:focus::-webkit-slider-thumb{background:#03478c}.Form-Form-Form_range:-moz-focusring{outline:1px solid #fff;outline-offset:-1px}.Form-Form-Form_range:-ms-track{background:transparent;border-color:transparent;border-width:6px 0;color:transparent}.Form-Form-Form_range::-ms-fill-lower{background:#777}.Form-Form-Form_range::-ms-fill-upper{background:#ddd}.Form-Form-Form_range:focus::-ms-fill-lower{background:#888}.Form-Form-Form_range:focus::-ms-fill-upper{background:#ccc}.Form-Form-Form_range-axis{position:relative;margin:25.6px 9px 0;margin:1.6rem 9px 0;min-height:51.2px;min-height:3.2rem}.Form-Form-Form_range-mark{position:absolute;top:0;font-size:.8em;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);color:#022140}.Form-Form-Form_range-mark:after{content:\"|\";font-size:.5em;display:block;text-align:center}::-webkit-input-placeholder{color:rgba(0,0,0,.55);line-height:1}textarea::-webkit-input-placeholder{line-height:24px;line-height:1.5rem}::-moz-placeholder{color:rgba(0,0,0,.55)}:-ms-input-placeholder{color:rgba(0,0,0,.55)}", ""]);

// exports
exports.locals = {
	"Form": "Form-Form-Form",
	"Form__separated": "Form-Form-Form__separated",
	"Form__secondary": "Form-Form-Form__secondary",
	"Form__safetech": "Form-Form-Form__safetech",
	"is-FormDisabled": "Form-Form-is-FormDisabled",
	"Form_group": "Form-Form-Form_group",
	"Form_field": "Form-Form-Form_field",
	"Form__static": "Form-Form-Form__static",
	"Form_addon": "Form-Form-Form_addon",
	"Form_afterAddon": "Form-Form-Form_afterAddon",
	"Form_buttonLike": "Form-Form-Form_buttonLike",
	"Form_field__small": "Form-Form-Form_field__small",
	"Form_field__large": "Form-Form-Form_field__large",
	"Form_field__withoutBorder": "Form-Form-Form_field__withoutBorder",
	"Form_error": "Form-Form-Form_error",
	"Form_error--fit": "Form-Form-Form_error--fit",
	"Form_title": "Form-Form-Form_title",
	"Form_note": "Form-Form-Form_note",
	"Form_note__medium": "Form-Form-Form_note__medium",
	"Form_note__withBorder": "Form-Form-Form_note__withBorder",
	"Form_section": "Form-Form-Form_section",
	"Form_section__withoutBorder": "Form-Form-Form_section__withoutBorder",
	"Form_section__secondary": "Form-Form-Form_section__secondary",
	"Form_info": "Form-Form-Form_info",
	"Form__standard": "Form-Form-Form__standard",
	"Form_info__error": "Form-Form-Form_info__error",
	"FormSelect": "Form-Form-FormSelect",
	"flex": "Form-Form-flex",
	"FormSelect__static": "Form-Form-FormSelect__static",
	"FormSelect_label": "Form-Form-FormSelect_label",
	"FormSelect--static": "Form-Form-FormSelect--static",
	"FormSelect_value": "Form-Form-FormSelect_value",
	"is-default": "Form-Form-is-default",
	"FormSelect_field": "Form-Form-FormSelect_field",
	"Form_range": "Form-Form-Form_range",
	"Form_range-axis": "Form-Form-Form_range-axis",
	"Form_range-mark": "Form-Form-Form_range-mark"
};

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1063);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1065);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, "html{color:#222;font-weight:100;font-size:1em;font-family:Segoe UI,HelveticaNeue-Light,sans-serif;line-height:1.375;-webkit-box-sizing:border-box;box-sizing:border-box;height:100%}*,:after,:before{-webkit-box-sizing:inherit;box-sizing:inherit}body{margin:0;height:100%}a{color:#0074c2}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}select{-moz-appearance:none;-webkit-appearance:none}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}.Layout-Layout-box{background:#0376a3;height:100vh}", ""]);

// exports
exports.locals = {
	"box": "Layout-Layout-box"
};

/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(154);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(103);

var _LocationUtils = __webpack_require__(490);

var _createTransitionManager = __webpack_require__(491);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Popup-Popup-Popup_overlay,.Popup-Popup-Popup_wrapper{position:fixed;top:0;left:0;right:0;bottom:0}.Popup-Popup-Popup_wrapper{z-index:10000;overflow:auto}.Popup-Popup-Popup_overlay{background-color:rgba(233,237,240,.68)}.Popup-Popup-Popup{background-color:#fff;position:relative;min-height:100%}@media (min-width:721px){.Popup-Popup-Popup{width:379px;margin:100px auto;min-height:0;-webkit-box-shadow:#022140 2px 2px 5px;box-shadow:2px 2px 5px #022140}}.Popup-Popup-Popup__notification{padding:10px;padding:.625rem;max-width:80%;margin:16px auto;margin:1rem auto;min-height:0}@media (min-width:721px){.Popup-Popup-Popup__notification{width:450px;margin:12rem auto 0}}.Popup-Popup-Popup__editdevice{padding:10px;padding:.625rem;max-width:80%;margin:16px auto;margin:1rem auto;min-height:0}@media (min-width:721px){.Popup-Popup-Popup__editdevice{width:800px;margin:12rem auto 0}}@media (min-width:721px){.Popup-Popup-Popup__wider{width:500px}}.Popup-Popup-Popup__news{padding:16px 32px;padding:1rem 2rem;font-size:13.6px;font-size:.85rem;line-height:1.5}@media (min-width:721px){.Popup-Popup-Popup__news{width:468px}}.Popup-Popup-Popup_close{padding:8px 16px 0 0;padding:.5rem 1rem 0 0}.Popup-Popup-Popup--notification .Popup-Popup-Popup_close{display:none}.Popup-Popup-Popup__news .Popup-Popup-Popup_close{padding:0}.Popup-Popup-Popup_externalClose{position:absolute;right:0;top:0;padding:0;background-color:#dadada;z-index:1;display:none}@media (min-width:721px){.Popup-Popup-Popup_externalClose{display:block;-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}}.Popup-Popup-Popup_content{padding:16px 10px 0;padding:1rem .625rem 0}.Popup-Popup-Popup_content__small{padding-top:5px;padding-top:.3125rem}.Popup-Popup-Popup_contentScroll{font-size:14px;font-size:.875rem;max-height:320px;max-height:20rem;max-height:50vh;margin:8px 0;margin:.5rem 0;padding:8px;padding:.5rem;border:1px solid #000;overflow:auto}.Popup-Popup-Popup_tab{color:#022140;font-size:18px;font-size:1.125rem}.Popup-Popup-Popup_tab li{display:inline-block;margin:0;padding:1.6px 10px 6.4px;padding:.1rem .625rem .4rem;cursor:pointer}.Popup-Popup-Popup_tab li.Popup-Popup-is_selected{border-bottom:4px solid}.Popup-Popup-Popup__notification .Popup-Popup-Popup_tab li{padding-bottom:0}.Popup-Popup-Popup__notification .Popup-Popup-Popup_tab li:first-child{min-width:32%;text-align:right}.Popup-Popup-Popup_logout{font-size:14px;font-size:.875rem;padding:30px 40px;text-align:center}.Popup-Popup-Popup_logout__action{margin-top:10px}.Popup-Popup-Popup_logout__action strong{color:#022140;font-weight:700;cursor:pointer}.Popup-Popup-Popup_body{border-top:2px solid #e9edf0;padding-top:24px;padding-top:1.5rem;padding-bottom:24px;padding-bottom:1.5rem;font-size:14px;font-size:.875rem;text-align:center;margin-bottom:0}@media (min-width:721px){.Popup-Popup-Popup_body{padding:2rem 1.5625rem 2.5rem}}.Popup-Popup-Popup_body__flat{padding-bottom:0}.Popup-Popup-Button__close{font-size:25.6px;font-size:1.6rem;line-height:1;margin:0;padding:0}.Popup-Popup-floatRight{float:right}.Popup-Popup-u_cf:after,.Popup-Popup-u_cf:before{content:\" \";display:table}.Popup-Popup-u_cf:after{clear:both}.Popup-Popup-PopupOverview_close{position:absolute;right:0;top:0;padding:0;background-color:#0376a3;z-index:1;border:0;cursor:pointer}@media (min-width:721px){.Popup-Popup-PopupOverview_close{-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}}.Popup-Popup-close_spirotech{background-color:#facc3a}.Popup-Popup-white_text{color:#fff}.Popup-Popup-black_text{color:#000}.Popup-Popup-green_text{color:green}.Popup-Popup-orange_text{color:orange}.Popup-Popup-red_text{color:red}.Popup-Popup-superior_text{color:#fff}.Popup-Popup-wrapper{width:100%;overflow:hidden}.Popup-Popup-first,.Popup-Popup-second{width:50%;float:left}.Popup-Popup-iconWrapper{display:inline-block;cursor:pointer}.Popup-Popup-buttonHolder{text-align:center;margin:10px}", ""]);

// exports
exports.locals = {
	"Popup_wrapper": "Popup-Popup-Popup_wrapper",
	"Popup_overlay": "Popup-Popup-Popup_overlay",
	"Popup": "Popup-Popup-Popup",
	"Popup__notification": "Popup-Popup-Popup__notification",
	"Popup__editdevice": "Popup-Popup-Popup__editdevice",
	"Popup__wider": "Popup-Popup-Popup__wider",
	"Popup__news": "Popup-Popup-Popup__news",
	"Popup_close": "Popup-Popup-Popup_close",
	"Popup--notification": "Popup-Popup-Popup--notification",
	"Popup_externalClose": "Popup-Popup-Popup_externalClose",
	"Popup_content": "Popup-Popup-Popup_content",
	"Popup_content__small": "Popup-Popup-Popup_content__small",
	"Popup_contentScroll": "Popup-Popup-Popup_contentScroll",
	"Popup_tab": "Popup-Popup-Popup_tab",
	"is_selected": "Popup-Popup-is_selected",
	"Popup_logout": "Popup-Popup-Popup_logout",
	"Popup_logout__action": "Popup-Popup-Popup_logout__action",
	"Popup_body": "Popup-Popup-Popup_body",
	"Popup_body__flat": "Popup-Popup-Popup_body__flat",
	"Button__close": "Popup-Popup-Button__close",
	"floatRight": "Popup-Popup-floatRight",
	"u_cf": "Popup-Popup-u_cf",
	"PopupOverview_close": "Popup-Popup-PopupOverview_close",
	"close_spirotech": "Popup-Popup-close_spirotech",
	"saveButton": "Popup-Popup-saveButton",
	"white_text": "Popup-Popup-white_text",
	"black_text": "Popup-Popup-black_text",
	"green_text": "Popup-Popup-green_text",
	"orange_text": "Popup-Popup-orange_text",
	"red_text": "Popup-Popup-red_text",
	"superior_text": "Popup-Popup-superior_text",
	"wrapper": "Popup-Popup-wrapper",
	"first": "Popup-Popup-first",
	"second": "Popup-Popup-second",
	"iconWrapper": "Popup-Popup-iconWrapper",
	"buttonHolder": "Popup-Popup-buttonHolder"
};

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(70);
var factory = __webpack_require__(486);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1070);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Grid.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Grid.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Grid-Grid-u_sizeFit{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;width:auto!important}.Grid-Grid-u_sizeFill{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important;-ms-flex-preferred-size:0%!important;flex-basis:0%!important;width:auto!important}.Grid-Grid-u_sizeFull{width:100%!important}.Grid-Grid-u_sizeAuto{width:auto!important}.Grid-Grid-u_size1of12{width:8.33333%!important}.Grid-Grid-u_size1of10{width:10%!important}.Grid-Grid-u_size2of12{width:16.66667%!important}.Grid-Grid-u_size2of10{width:20%!important}.Grid-Grid-u_size3of12{width:25%!important}.Grid-Grid-u_size3of10{width:30%!important}.Grid-Grid-u_size4of12{width:33.33333%!important}.Grid-Grid-u_size3of8{width:37.5%!important}.Grid-Grid-u_size4of10{width:40%!important}.Grid-Grid-size5of10,.Grid-Grid-size6of12,.Grid-Grid-u_size5of10,.Grid-Grid-u_size6of12{width:50%!important}.Grid-Grid-u_size7of12{width:58.33333%!important}.Grid-Grid-u_size6of10{width:60%!important}.Grid-Grid-u_size7of10{width:70%!important}.Grid-Grid-u_size9of12{width:75%!important}.Grid-Grid-u_size8of10{width:80%!important}.Grid-Grid-u_size10of12{width:83.33333%!important}.Grid-Grid-u_size9of10{width:90%!important}.Grid-Grid-u_size11of12{width:91.66667%!important}@media (min-width:480px){.Grid-Grid-u_sizeFull-sm{width:100%!important}.Grid-Grid-u_sizeAuto-sm{width:auto!important}.Grid-Grid-u_size1of12-sm{width:8.33333%!important}.Grid-Grid-u_size1of10-sm{width:10%!important}.Grid-Grid-u_size2of12-sm{width:16.66667%!important}.Grid-Grid-u_size2of10-sm{width:20%!important}.Grid-Grid-u_size3of12-sm{width:25%!important}.Grid-Grid-u_size3of10-sm{width:30%!important}.Grid-Grid-u_size4of12-sm{width:33.33333%!important}.Grid-Grid-u_size3of8-sm{width:37.5%!important}.Grid-Grid-u_size4of10-sm{width:40%!important}.Grid-Grid-u_size5of12-sm{width:41.66667%!important}.Grid-Grid-u_size5of10-sm,.Grid-Grid-u_size6of12-sm{width:50%!important}.Grid-Grid-u_size7of12-sm{width:58.33333%!important}.Grid-Grid-u_size6of10-sm{width:60%!important}.Grid-Grid-u_size8of12-sm{width:66.66667%!important}.Grid-Grid-u_size7of10{width:70%!important}.Grid-Grid-u_size9of12-sm{width:75%!important}.Grid-Grid-u_size8of10-sm{width:80%!important}.Grid-Grid-u_size10of12-sm{width:83.33333%!important}.Grid-Grid-u_size9of10-sm{width:90%!important}.Grid-Grid-u_size11of12-sm{width:91.66667%!important}}@media (min-width:721px){.Grid-Grid-u_sizeFull-md{width:100%!important}.Grid-Grid-u_sizeAuto-md{width:auto!important}.Grid-Grid-u_size1of12-md{width:8.33333%!important}.Grid-Grid-u_size1of10-md{width:10%!important}.Grid-Grid-u_size2of12-md{width:16.66667%!important}.Grid-Grid-u_size2of10-md{width:20%!important}.Grid-Grid-u_size3of12-md{width:25%!important}.Grid-Grid-u_size3of10-md{width:30%!important}.Grid-Grid-u_size4of12-md{width:33.33333%!important}.Grid-Grid-u_size3of8-md{width:37.5%!important}.Grid-Grid-u_size4of10-md{width:40%!important}.Grid-Grid-u_size5of12-md{width:41.66667%!important}.Grid-Grid-u_size5of10-md,.Grid-Grid-u_size6of12-md{width:50%!important}.Grid-Grid-u_size7of12-md{width:58.33333%!important}.Grid-Grid-u_size6of10-md{width:60%!important}.Grid-Grid-u_size8of12-md{width:66.66667%!important}.Grid-Grid-u_size7of10-md{width:70%!important}.Grid-Grid-u_size9of12-md{width:75%!important}.Grid-Grid-u_size8of10-md{width:80%!important}.Grid-Grid-u_size10of12-md{width:83.33333%!important}.Grid-Grid-u_size9of10-md{width:90%!important}.Grid-Grid-u_size11of12-md{width:91.66667%!important}}@media (min-width:1280px){.Grid-Grid-u_sizeFull-lg{width:100%!important}.Grid-Grid-u_sizeAuto-lg{width:auto!important}.Grid-Grid-u_size1of12-lg{width:8.33333%!important}.Grid-Grid-u_size1of10-lg{width:10%!important}.Grid-Grid-u_size2of12-lg{width:16.66667%!important}.Grid-Grid-u_size2of10-lg{width:20%!important}.Grid-Grid-u_size3of12-lg{width:25%!important}.Grid-Grid-u_size3of10-lg{width:30%!important}.Grid-Grid-u_size4of12-lg{width:33.33333%!important}.Grid-Grid-u_size3of8-lg{width:37.5%!important}.Grid-Grid-u_size4of10-lg{width:40%!important}.Grid-Grid-u_size5of12-lg{width:41.66667%!important}.Grid-Grid-u_size5of10-lg,.Grid-Grid-u_size6of12-lg{width:50%!important}.Grid-Grid-u_size7of12-lg{width:58.33333%!important}.Grid-Grid-u_size6of10-lg{width:60%!important}.Grid-Grid-u_size8of12-lg{width:66.66667%!important}.Grid-Grid-u_size7of10-lg{width:70%!important}.Grid-Grid-u_size9of12-lg{width:75%!important}.Grid-Grid-u_size8of10-lg{width:80%!important}.Grid-Grid-u_size10of12-lg{width:83.33333%!important}.Grid-Grid-u_size9of10-lg{width:90%!important}.Grid-Grid-u_size11of12-lg{width:91.66667%!important}}.Grid-Grid-u_sizeHeightFull{height:100%!important}.Grid-Grid-Grid{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;margin:0;padding:0}.Grid-Grid-Grid__alignCenter{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.Grid-Grid-Grid__alignRight{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.Grid-Grid-Grid__alignSides{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.Grid-Grid-Grid__alignMiddle{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.Grid-Grid-Grid__alignBottom{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.Grid-Grid-Grid__fit>.Grid-Grid-Grid-cell{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}.Grid-Grid-Grid__equalHeight>.Grid-Grid-Grid-cell{display:-webkit-box;display:-ms-flexbox;display:flex}.Grid-Grid-Grid__withGutter{margin:0 -7.5px;margin:0 -.46875rem}.Grid-Grid-Grid__withGutter>.Grid-Grid-Grid-cell{padding:0 7.5px;padding:0 .46875rem}.Grid-Grid-Grid__withGutter>.Grid-Grid-Grid-cell--fit{padding:0 3px}.Grid-Grid-Grid__withGutter2x{margin:0 -15px;margin:0 -.9375rem}.Grid-Grid-Grid__withGutter2x>.Grid-Grid-Grid-cell{padding:0 15px;padding:0 .9375rem}.Grid-Grid-Gridcell{-webkit-box-sizing:inherit;box-sizing:inherit;width:100%;-ms-flex-negative:1;flex-shrink:1}.Grid-Grid-Gridcell--center{margin:0 auto;display:block}.Grid-Grid-u_size5of12{width:41.66667%!important}.Grid-Grid-u_size6of12{width:50%!important}.Grid-Grid-u_size12of12{width:100%!important}.Grid-Grid-u_size8of12{width:66.66667%!important}.Grid-Grid-u_spaceTop{margin-top:15px!important;margin-top:.9375rem!important}.Grid-Grid-u_textRight{text-align:right!important}", ""]);

// exports
exports.locals = {
	"u_sizeFit": "Grid-Grid-u_sizeFit",
	"u_sizeFill": "Grid-Grid-u_sizeFill",
	"u_sizeFull": "Grid-Grid-u_sizeFull",
	"u_sizeAuto": "Grid-Grid-u_sizeAuto",
	"u_size1of12": "Grid-Grid-u_size1of12",
	"u_size1of10": "Grid-Grid-u_size1of10",
	"u_size2of12": "Grid-Grid-u_size2of12",
	"u_size2of10": "Grid-Grid-u_size2of10",
	"u_size3of12": "Grid-Grid-u_size3of12",
	"u_size3of10": "Grid-Grid-u_size3of10",
	"u_size4of12": "Grid-Grid-u_size4of12",
	"u_size3of8": "Grid-Grid-u_size3of8",
	"u_size4of10": "Grid-Grid-u_size4of10",
	"u_size5of12": "Grid-Grid-u_size5of12",
	"u_size5of10": "Grid-Grid-u_size5of10",
	"u_size6of12": "Grid-Grid-u_size6of12",
	"size5of10": "Grid-Grid-size5of10",
	"size6of12": "Grid-Grid-size6of12",
	"u_size7of12": "Grid-Grid-u_size7of12",
	"u_size6of10": "Grid-Grid-u_size6of10",
	"u_size8of12": "Grid-Grid-u_size8of12",
	"u_size7of10": "Grid-Grid-u_size7of10",
	"u_size9of12": "Grid-Grid-u_size9of12",
	"u_size8of10": "Grid-Grid-u_size8of10",
	"u_size10of12": "Grid-Grid-u_size10of12",
	"u_size9of10": "Grid-Grid-u_size9of10",
	"u_size11of12": "Grid-Grid-u_size11of12",
	"u_sizeFull@sm": "Grid-Grid-u_sizeFull-sm",
	"u_sizeAuto@sm": "Grid-Grid-u_sizeAuto-sm",
	"u_size1of12@sm": "Grid-Grid-u_size1of12-sm",
	"u_size1of10@sm": "Grid-Grid-u_size1of10-sm",
	"u_size2of12@sm": "Grid-Grid-u_size2of12-sm",
	"u_size2of10@sm": "Grid-Grid-u_size2of10-sm",
	"u_size3of12@sm": "Grid-Grid-u_size3of12-sm",
	"u_size3of10@sm": "Grid-Grid-u_size3of10-sm",
	"u_size4of12@sm": "Grid-Grid-u_size4of12-sm",
	"u_size3of8@sm": "Grid-Grid-u_size3of8-sm",
	"u_size4of10@sm": "Grid-Grid-u_size4of10-sm",
	"u_size5of12@sm": "Grid-Grid-u_size5of12-sm",
	"u_size5of10@sm": "Grid-Grid-u_size5of10-sm",
	"u_size6of12@sm": "Grid-Grid-u_size6of12-sm",
	"u_size7of12@sm": "Grid-Grid-u_size7of12-sm",
	"u_size6of10@sm": "Grid-Grid-u_size6of10-sm",
	"u_size8of12@sm": "Grid-Grid-u_size8of12-sm",
	"u_size9of12@sm": "Grid-Grid-u_size9of12-sm",
	"u_size8of10@sm": "Grid-Grid-u_size8of10-sm",
	"u_size10of12@sm": "Grid-Grid-u_size10of12-sm",
	"u_size9of10@sm": "Grid-Grid-u_size9of10-sm",
	"u_size11of12@sm": "Grid-Grid-u_size11of12-sm",
	"u_sizeFull@md": "Grid-Grid-u_sizeFull-md",
	"u_sizeAuto@md": "Grid-Grid-u_sizeAuto-md",
	"u_size1of12@md": "Grid-Grid-u_size1of12-md",
	"u_size1of10@md": "Grid-Grid-u_size1of10-md",
	"u_size2of12@md": "Grid-Grid-u_size2of12-md",
	"u_size2of10@md": "Grid-Grid-u_size2of10-md",
	"u_size3of12@md": "Grid-Grid-u_size3of12-md",
	"u_size3of10@md": "Grid-Grid-u_size3of10-md",
	"u_size4of12@md": "Grid-Grid-u_size4of12-md",
	"u_size3of8@md": "Grid-Grid-u_size3of8-md",
	"u_size4of10@md": "Grid-Grid-u_size4of10-md",
	"u_size5of12@md": "Grid-Grid-u_size5of12-md",
	"u_size5of10@md": "Grid-Grid-u_size5of10-md",
	"u_size6of12@md": "Grid-Grid-u_size6of12-md",
	"u_size7of12@md": "Grid-Grid-u_size7of12-md",
	"u_size6of10@md": "Grid-Grid-u_size6of10-md",
	"u_size8of12@md": "Grid-Grid-u_size8of12-md",
	"u_size7of10@md": "Grid-Grid-u_size7of10-md",
	"u_size9of12@md": "Grid-Grid-u_size9of12-md",
	"u_size8of10@md": "Grid-Grid-u_size8of10-md",
	"u_size10of12@md": "Grid-Grid-u_size10of12-md",
	"u_size9of10@md": "Grid-Grid-u_size9of10-md",
	"u_size11of12@md": "Grid-Grid-u_size11of12-md",
	"u_sizeFull@lg": "Grid-Grid-u_sizeFull-lg",
	"u_sizeAuto@lg": "Grid-Grid-u_sizeAuto-lg",
	"u_size1of12@lg": "Grid-Grid-u_size1of12-lg",
	"u_size1of10@lg": "Grid-Grid-u_size1of10-lg",
	"u_size2of12@lg": "Grid-Grid-u_size2of12-lg",
	"u_size2of10@lg": "Grid-Grid-u_size2of10-lg",
	"u_size3of12@lg": "Grid-Grid-u_size3of12-lg",
	"u_size3of10@lg": "Grid-Grid-u_size3of10-lg",
	"u_size4of12@lg": "Grid-Grid-u_size4of12-lg",
	"u_size3of8@lg": "Grid-Grid-u_size3of8-lg",
	"u_size4of10@lg": "Grid-Grid-u_size4of10-lg",
	"u_size5of12@lg": "Grid-Grid-u_size5of12-lg",
	"u_size5of10@lg": "Grid-Grid-u_size5of10-lg",
	"u_size6of12@lg": "Grid-Grid-u_size6of12-lg",
	"u_size7of12@lg": "Grid-Grid-u_size7of12-lg",
	"u_size6of10@lg": "Grid-Grid-u_size6of10-lg",
	"u_size8of12@lg": "Grid-Grid-u_size8of12-lg",
	"u_size7of10@lg": "Grid-Grid-u_size7of10-lg",
	"u_size9of12@lg": "Grid-Grid-u_size9of12-lg",
	"u_size8of10@lg": "Grid-Grid-u_size8of10-lg",
	"u_size10of12@lg": "Grid-Grid-u_size10of12-lg",
	"u_size9of10@lg": "Grid-Grid-u_size9of10-lg",
	"u_size11of12@lg": "Grid-Grid-u_size11of12-lg",
	"u_sizeHeightFull": "Grid-Grid-u_sizeHeightFull",
	"Grid": "Grid-Grid-Grid",
	"Grid__alignCenter": "Grid-Grid-Grid__alignCenter",
	"Grid__alignRight": "Grid-Grid-Grid__alignRight",
	"Grid__alignSides": "Grid-Grid-Grid__alignSides",
	"Grid__alignMiddle": "Grid-Grid-Grid__alignMiddle",
	"Grid__alignBottom": "Grid-Grid-Grid__alignBottom",
	"Grid__fit": "Grid-Grid-Grid__fit",
	"Grid-cell": "Grid-Grid-Grid-cell",
	"Grid__equalHeight": "Grid-Grid-Grid__equalHeight",
	"Grid__withGutter": "Grid-Grid-Grid__withGutter",
	"Grid-cell--fit": "Grid-Grid-Grid-cell--fit",
	"Grid__withGutter2x": "Grid-Grid-Grid__withGutter2x",
	"Gridcell": "Grid-Grid-Gridcell",
	"Gridcell--center": "Grid-Grid-Gridcell--center",
	"u_size12of12": "Grid-Grid-u_size12of12",
	"u_spaceTop": "Grid-Grid-u_spaceTop",
	"u_textRight": "Grid-Grid-u_textRight"
};

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1072);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Input.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Input.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Input-Input-Form_field{color:#000;font-size:14px;font-size:.875rem;line-height:24px;line-height:1.5rem;height:32px;height:2rem;margin:0 0 10px;margin:0 0 .625rem;padding:4.8px 8.4px;padding:.3rem .525rem;width:100%;display:block;position:relative}.Input-Input-Form_field:focus{border-color:rgba(2,33,64,.4)}.Input-Input-Form_field:disabled{background-color:transparent;opacity:.75}.Input-Input-Form_field a{color:#022140}.Input-Input-Form__secondary .Input-Input-Form_field{background-color:transparent;border-color:rgba(2,33,64,.4)}.Input-Input-Form__static .Input-Input-Form_field{border-color:#022140}.Input-Input-Form_group .Input-Input-Form_field{margin-bottom:0}.Input-Input-Form_addon .Input-Input-Form_field{background-color:rgba(2,33,64,.35);border:1px solid rgba(2,33,64,.4);border-right:0;border-radius:2px 0 0 2px}.Input-Input-Form_afterAddon .Input-Input-Form_field{border-left:0;border-radius:0 2px 2px 0}.Input-Input-Form_buttonLike .Input-Input-Form_field{background-color:#f3f5f7}.Input-Input-Form_field__small{height:32px;height:2rem;font-size:13.6px;font-size:.85rem}.Input-Input-Form_field__large{padding:9.8px 8.4px;padding:.6125rem .525rem;height:40px;height:2.5rem}.Input-Input-Form_field__withoutBorder{border:0;margin-bottom:0}textarea.Input-Input-Form_field{min-height:56px;min-height:3.5rem}@media (min-width:721px){textarea.Input-Input-Form_field{min-height:8.5rem}}", ""]);

// exports
exports.locals = {
	"Form_field": "Input-Input-Form_field",
	"Form__secondary": "Input-Input-Form__secondary",
	"Form__static": "Input-Input-Form__static",
	"Form_group": "Input-Input-Form_group",
	"Form_addon": "Input-Input-Form_addon",
	"Form_afterAddon": "Input-Input-Form_afterAddon",
	"Form_buttonLike": "Input-Input-Form_buttonLike",
	"Form_field__small": "Input-Input-Form_field__small",
	"Form_field__large": "Input-Input-Form_field__large",
	"Form_field__withoutBorder": "Input-Input-Form_field__withoutBorder"
};

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1074);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SaveChangesButton.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SaveChangesButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".SaveChangeButtonPopup-SaveChangesButton-black_text{color:#000}.SaveChangeButtonPopup-SaveChangesButton-superior_text{color:#fff}", ""]);

// exports
exports.locals = {
	"black_text": "SaveChangeButtonPopup-SaveChangesButton-black_text",
	"superior_text": "SaveChangeButtonPopup-SaveChangesButton-superior_text"
};

/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1076);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryListPopUp.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryListPopUp.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryListPopUp-HistoryListPopUp-Popup__editdevice{padding:10px;padding:.625rem;max-width:100%;margin:16px auto;margin:1rem auto;min-height:0}@media (min-width:721px){.HistoryListPopUp-HistoryListPopUp-Popup__editdevice{width:800px!important;margin:12rem auto 0}}.HistoryListPopUp-HistoryListPopUp-Popup_history{background-color:#fff;position:relative;min-height:100%}@media (min-width:721px){.HistoryListPopUp-HistoryListPopUp-Popup_history{width:520px;margin:100px auto;min-height:0;-webkit-box-shadow:#022140 2px 2px 5px;box-shadow:2px 2px 5px #022140}}.HistoryListPopUp-HistoryListPopUp-pickerStyled{width:100%;float:left;padding:10px;margin-left:20px}@media (min-width:920px){.HistoryListPopUp-HistoryListPopUp-pickerStyled{width:50%}}.HistoryListPopUp-HistoryListPopUp-marginLeft{text-align:center}@media (min-width:920px){.HistoryListPopUp-HistoryListPopUp-marginLeft{margin-left:50%;text-align:right}}.HistoryListPopUp-HistoryListPopUp-blackButton{color:#000;height:50px;overflow:hidden}.HistoryListPopUp-HistoryListPopUp-whiteButton{color:#fff;height:50px;overflow:hidden}.HistoryListPopUp-HistoryListPopUp-historyFailed{text-align:center;color:red}.HistoryListPopUp-HistoryListPopUp-historyDownloading{text-align:center}", ""]);

// exports
exports.locals = {
	"Popup__editdevice": "HistoryListPopUp-HistoryListPopUp-Popup__editdevice",
	"Popup_history": "HistoryListPopUp-HistoryListPopUp-Popup_history",
	"pickerStyled": "HistoryListPopUp-HistoryListPopUp-pickerStyled",
	"marginLeft": "HistoryListPopUp-HistoryListPopUp-marginLeft",
	"blackButton": "HistoryListPopUp-HistoryListPopUp-blackButton",
	"whiteButton": "HistoryListPopUp-HistoryListPopUp-whiteButton",
	"historyFailed": "HistoryListPopUp-HistoryListPopUp-historyFailed",
	"historyDownloading": "HistoryListPopUp-HistoryListPopUp-historyDownloading"
};

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryDocuments-HistoryDocument-iconWrapper{display:inline-block}.HistoryDocuments-HistoryDocument-u_flexGrow1{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important}.HistoryDocuments-HistoryDocument-green{color:green}.HistoryDocuments-HistoryDocument-iconsWrapper{display:-webkit-box;display:-ms-flexbox;display:flex;float:right;cursor:pointer}.HistoryDocuments-HistoryDocument-listBordered{padding:8px;padding:.5rem}.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item,.HistoryDocuments-HistoryDocument-listBordered>li{padding:10px 0;padding:.625rem 0;font-size:13.6px;font-size:.85rem;display:block;border-bottom:1px solid #e9edf0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item:last-child,.HistoryDocuments-HistoryDocument-listBordered>li:last-child{border-bottom:0}.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted,.HistoryDocuments-HistoryDocument-listBordered>li.HistoryDocuments-HistoryDocument-is_highlighted{background-color:#f3f5f7;position:relative}.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted:before,.HistoryDocuments-HistoryDocument-listBordered>li.HistoryDocuments-HistoryDocument-is_highlighted:before{content:\"\";position:absolute;top:-1px;left:0;right:0;height:1px;background-color:#e9edf0}.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted,.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted+.HistoryDocuments-HistoryDocument-listBordered_item:not(.HistoryDocuments-HistoryDocument-is_highlighted),.HistoryDocuments-HistoryDocument-listBordered .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted+li,.HistoryDocuments-HistoryDocument-listBordered>li.HistoryDocuments-HistoryDocument-is_highlighted,.HistoryDocuments-HistoryDocument-listBordered>li.HistoryDocuments-HistoryDocument-is_highlighted+.HistoryDocuments-HistoryDocument-listBordered_item:not(.HistoryDocuments-HistoryDocument-is_highlighted),.HistoryDocuments-HistoryDocument-listBordered>li.HistoryDocuments-HistoryDocument-is_highlighted+li{margin:0 -8px;margin:0 -.5rem;padding:10px 8px;padding:.625rem .5rem}.HistoryDocuments-HistoryDocument-Alerts{background-color:#fff}.HistoryDocuments-HistoryDocument-Alert_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}.HistoryDocuments-HistoryDocument-listBordered__large{padding:15px;padding:.9375rem}.HistoryDocuments-HistoryDocument-listBordered__large .HistoryDocuments-HistoryDocument-listBordered-item,.HistoryDocuments-HistoryDocument-listBordered__large li{padding:15px 0;padding:.9375rem 0;font-size:15.2px;font-size:.95rem}.HistoryDocuments-HistoryDocument-listBordered__large .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted,.HistoryDocuments-HistoryDocument-listBordered__large .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted+.HistoryDocuments-HistoryDocument-listBordered-item:not(.HistoryDocuments-HistoryDocument-is-highlighted),.HistoryDocuments-HistoryDocument-listBordered__large .HistoryDocuments-HistoryDocument-listBordered_item.HistoryDocuments-HistoryDocument-is_highlighted+li,.HistoryDocuments-HistoryDocument-listBordered__large li.HistoryDocuments-HistoryDocument-is_highlighted,.HistoryDocuments-HistoryDocument-listBordered__large li.HistoryDocuments-HistoryDocument-is_highlighted+.HistoryDocuments-HistoryDocument-listBordered-item:not(.HistoryDocuments-HistoryDocument-is-highlighted),.HistoryDocuments-HistoryDocument-listBordered__large li.HistoryDocuments-HistoryDocument-is_highlighted+li{margin:0 -var(--base-gutter);padding:15px;padding:.9375rem}.HistoryDocuments-HistoryDocument-listBordered__flat{padding-top:0;padding-bottom:0}", ""]);

// exports
exports.locals = {
	"iconWrapper": "HistoryDocuments-HistoryDocument-iconWrapper",
	"u_flexGrow1": "HistoryDocuments-HistoryDocument-u_flexGrow1",
	"green": "HistoryDocuments-HistoryDocument-green",
	"iconsWrapper": "HistoryDocuments-HistoryDocument-iconsWrapper",
	"listBordered": "HistoryDocuments-HistoryDocument-listBordered",
	"listBordered_item": "HistoryDocuments-HistoryDocument-listBordered_item",
	"is_highlighted": "HistoryDocuments-HistoryDocument-is_highlighted",
	"Alerts": "HistoryDocuments-HistoryDocument-Alerts",
	"Alert_container": "HistoryDocuments-HistoryDocument-Alert_container",
	"listBordered__large": "HistoryDocuments-HistoryDocument-listBordered__large",
	"listBordered-item": "HistoryDocuments-HistoryDocument-listBordered-item",
	"is-highlighted": "HistoryDocuments-HistoryDocument-is-highlighted",
	"listBordered__flat": "HistoryDocuments-HistoryDocument-listBordered__flat"
};

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1079);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1082);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./react-datepicker.css", function() {
        content = require("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./react-datepicker.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{-webkit-box-sizing:content-box;box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12.8px;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:15.104px;font-size:.944rem}.react-datepicker-time__header{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:27.2px;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:7.2px solid transparent;border:.45rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:6.4px;margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:70px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:30px;width:100%;-webkit-box-sizing:content-box;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:27.2px;width:1.7rem;line-height:27.2px;line-height:1.7rem;text-align:center;margin:2.656px;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:27.2px;width:1.7rem;line-height:27.2px;line-height:1.7rem;text-align:center;margin:2.656px;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:7.2px;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:4.8px;border-bottom-left-radius:.3rem;border-bottom-right-radius:4.8px;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;outline:0;padding:0;vertical-align:middle;position:absolute;height:16px;width:16px;top:25%;right:7px}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:0;text-align:center}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:48px;width:3rem;line-height:48px;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:23.04px;font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:12.96px solid transparent;border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);

// exports


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1084);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./react-datepicker-cssmodules.css", function() {
        content = require("!!../../css-loader/index.js??ref--2-rules-1!../../postcss-loader/lib/index.js??ref--2-rules-3!./react-datepicker-cssmodules.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{-webkit-box-sizing:content-box;box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12.8px;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:15.104px;font-size:.944rem}.react-datepicker-time__header{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:27.2px;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:7.2px solid transparent;border:.45rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:6.4px;margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:70px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:30px;width:100%;-webkit-box-sizing:content-box;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:27.2px;width:1.7rem;line-height:27.2px;line-height:1.7rem;text-align:center;margin:2.656px;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:27.2px;width:1.7rem;line-height:27.2px;line-height:1.7rem;text-align:center;margin:2.656px;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:7.2px;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:4.8px;border-bottom-left-radius:.3rem;border-bottom-right-radius:4.8px;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;outline:0;padding:0;vertical-align:middle;position:absolute;height:16px;width:16px;top:25%;right:7px}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:0;text-align:center}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:48px;width:3rem;line-height:48px;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:23.04px;font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:12.96px solid transparent;border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);

// exports


/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryAlarms-HistoryAlarms-Alerts{background-color:#fff}.HistoryAlarms-HistoryAlarms-Alert_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}.HistoryAlarms-HistoryAlarms-u_flexGrow1{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important}.HistoryAlarms-HistoryAlarms-listBordered{padding:8px;padding:.5rem}.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item,.HistoryAlarms-HistoryAlarms-listBordered>li{padding:10px 0;padding:.625rem 0;font-size:13.6px;font-size:.85rem;display:block;border-bottom:1px solid #e9edf0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item:last-child,.HistoryAlarms-HistoryAlarms-listBordered>li:last-child{border-bottom:0}.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted,.HistoryAlarms-HistoryAlarms-listBordered>li.HistoryAlarms-HistoryAlarms-is_highlighted{background-color:#f3f5f7;position:relative}.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted:before,.HistoryAlarms-HistoryAlarms-listBordered>li.HistoryAlarms-HistoryAlarms-is_highlighted:before{content:\"\";position:absolute;top:-1px;left:0;right:0;height:1px;background-color:#e9edf0}.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted,.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted+.HistoryAlarms-HistoryAlarms-listBordered_item:not(.HistoryAlarms-HistoryAlarms-is_highlighted),.HistoryAlarms-HistoryAlarms-listBordered .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted+li,.HistoryAlarms-HistoryAlarms-listBordered>li.HistoryAlarms-HistoryAlarms-is_highlighted,.HistoryAlarms-HistoryAlarms-listBordered>li.HistoryAlarms-HistoryAlarms-is_highlighted+.HistoryAlarms-HistoryAlarms-listBordered_item:not(.HistoryAlarms-HistoryAlarms-is_highlighted),.HistoryAlarms-HistoryAlarms-listBordered>li.HistoryAlarms-HistoryAlarms-is_highlighted+li{margin:0 -8px;margin:0 -.5rem;padding:10px 8px;padding:.625rem .5rem}.HistoryAlarms-HistoryAlarms-listBordered__large{padding:15px;padding:.9375rem}.HistoryAlarms-HistoryAlarms-listBordered__large .HistoryAlarms-HistoryAlarms-listBordered-item,.HistoryAlarms-HistoryAlarms-listBordered__large li{padding:15px 0;padding:.9375rem 0;font-size:15.2px;font-size:.95rem}.HistoryAlarms-HistoryAlarms-listBordered__large .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted,.HistoryAlarms-HistoryAlarms-listBordered__large .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted+.HistoryAlarms-HistoryAlarms-listBordered-item:not(.HistoryAlarms-HistoryAlarms-is-highlighted),.HistoryAlarms-HistoryAlarms-listBordered__large .HistoryAlarms-HistoryAlarms-listBordered_item.HistoryAlarms-HistoryAlarms-is_highlighted+li,.HistoryAlarms-HistoryAlarms-listBordered__large li.HistoryAlarms-HistoryAlarms-is_highlighted,.HistoryAlarms-HistoryAlarms-listBordered__large li.HistoryAlarms-HistoryAlarms-is_highlighted+.HistoryAlarms-HistoryAlarms-listBordered-item:not(.HistoryAlarms-HistoryAlarms-is-highlighted),.HistoryAlarms-HistoryAlarms-listBordered__large li.HistoryAlarms-HistoryAlarms-is_highlighted+li{margin:0 -var(--base-gutter);padding:15px;padding:.9375rem}.HistoryAlarms-HistoryAlarms-listBordered__flat{padding-top:0;padding-bottom:0}", ""]);

// exports
exports.locals = {
	"Alerts": "HistoryAlarms-HistoryAlarms-Alerts",
	"Alert_container": "HistoryAlarms-HistoryAlarms-Alert_container",
	"u_flexGrow1": "HistoryAlarms-HistoryAlarms-u_flexGrow1",
	"listBordered": "HistoryAlarms-HistoryAlarms-listBordered",
	"listBordered_item": "HistoryAlarms-HistoryAlarms-listBordered_item",
	"is_highlighted": "HistoryAlarms-HistoryAlarms-is_highlighted",
	"listBordered__large": "HistoryAlarms-HistoryAlarms-listBordered__large",
	"listBordered-item": "HistoryAlarms-HistoryAlarms-listBordered-item",
	"is-highlighted": "HistoryAlarms-HistoryAlarms-is-highlighted",
	"listBordered__flat": "HistoryAlarms-HistoryAlarms-listBordered__flat"
};

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1087);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListContainer.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryListPopUp-ListContainer-Alerts{background-color:#fff}.HistoryListPopUp-ListContainer-Alert_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}", ""]);

// exports
exports.locals = {
	"Alerts": "HistoryListPopUp-ListContainer-Alerts",
	"Alert_container": "HistoryListPopUp-ListContainer-Alert_container"
};

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".SafeTechPopup-SafeTechPopup-Popup__editdevice{padding:10px;padding:.625rem;max-width:80%;margin:16px auto;margin:1rem auto;min-height:0}@media (min-width:721px){.SafeTechPopup-SafeTechPopup-Popup__editdevice{width:800px;margin:12rem auto 0}}", ""]);

// exports
exports.locals = {
	"Popup__editdevice": "SafeTechPopup-SafeTechPopup-Popup__editdevice"
};

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1090);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./PopupOverview.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./PopupOverview.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Popup-PopupOverview-PopupOverview{position:fixed;background-color:hsla(0,0%,100%,.9);top:0;bottom:0;left:0;right:0;overflow:hidden;z-index:10000}@media (min-width:721px){.Popup-PopupOverview-PopupOverview{padding:1.5625rem .9375rem}}.Popup-PopupOverview-PopupOverview_overlay{position:fixed;top:0;left:0;right:0;bottom:0}.Popup-PopupOverview-PopupOverview_content{position:relative;margin:auto;height:100%}@media (min-width:721px){.Popup-PopupOverview-PopupOverview_content{height:auto;max-width:1280px;width:calc(100% - 52px)}}.Popup-PopupOverview-PopupOverview_box{overflow:auto;height:100%;max-height:100%;margin-bottom:0}@media (min-width:721px){.Popup-PopupOverview-PopupOverview_box{max-height:calc(100vh - 3.125rem)}}.Popup-PopupOverview-PopupOverview_close{position:absolute;right:0;top:0;padding:0;background-color:#0376a3;z-index:1;border:0;cursor:pointer}@media (min-width:721px){.Popup-PopupOverview-PopupOverview_close{-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}}.Popup-PopupOverview-close_spirotech{background-color:#facc3a}", ""]);

// exports
exports.locals = {
	"PopupOverview": "Popup-PopupOverview-PopupOverview",
	"PopupOverview_overlay": "Popup-PopupOverview-PopupOverview_overlay",
	"PopupOverview_content": "Popup-PopupOverview-PopupOverview_content",
	"PopupOverview_box": "Popup-PopupOverview-PopupOverview_box",
	"PopupOverview_close": "Popup-PopupOverview-PopupOverview_close",
	"close_spirotech": "Popup-PopupOverview-close_spirotech"
};

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryEvents-HistoryEvents-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryEvents-HistoryEvents-row_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px;background:#fff}.HistoryEvents-HistoryEvents-header_color{border:1px solid #0376a3;background:#0376a3;color:#fff}.HistoryEvents-HistoryEvents-spirotech_header_color{border:1px solid #fae04e;background:#fae04e;color:#000}.HistoryEvents-HistoryEvents-data_color{border:1px solid #0376a3;padding:0 10px}@media (min-width:721px){.HistoryEvents-HistoryEvents-data_color{min-width:7rem}}.HistoryEvents-HistoryEvents-spirotech_data_color{border:1px solid #fae04e;color:#000;padding:0 10px}@media (min-width:721px){.HistoryEvents-HistoryEvents-spirotech_data_color{min-width:7rem}}.HistoryEvents-HistoryEvents-center{text-align:center}.HistoryEvents-HistoryEvents-red{background:red!important}", ""]);

// exports
exports.locals = {
	"Table_container": "HistoryEvents-HistoryEvents-Table_container",
	"row_container": "HistoryEvents-HistoryEvents-row_container",
	"header_color": "HistoryEvents-HistoryEvents-header_color",
	"spirotech_header_color": "HistoryEvents-HistoryEvents-spirotech_header_color",
	"data_color": "HistoryEvents-HistoryEvents-data_color",
	"spirotech_data_color": "HistoryEvents-HistoryEvents-spirotech_data_color",
	"center": "HistoryEvents-HistoryEvents-center",
	"red": "HistoryEvents-HistoryEvents-red"
};

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1093);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEventsHeader.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEventsHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryEvents-HistoryEventsHeader-container{width:100%;margin:auto}.HistoryEvents-HistoryEventsHeader-left{width:60%;float:left}.HistoryEvents-HistoryEventsHeader-right{float:right}.HistoryEvents-HistoryEventsHeader-center{text-align:center;padding:5px}.HistoryEvents-HistoryEventsHeader-blackButton{color:#000;height:50px;overflow:hidden}.HistoryEvents-HistoryEventsHeader-whiteButton{color:#fff;height:50px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "HistoryEvents-HistoryEventsHeader-container",
	"left": "HistoryEvents-HistoryEventsHeader-left",
	"right": "HistoryEvents-HistoryEventsHeader-right",
	"center": "HistoryEvents-HistoryEventsHeader-center",
	"blackButton": "HistoryEvents-HistoryEventsHeader-blackButton",
	"whiteButton": "HistoryEvents-HistoryEventsHeader-whiteButton"
};

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1095);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Select.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".SelectMultiple-Select-u_hidden{display:none!important}.SelectMultiple-Select-big{height:128px!important;height:8rem!important}.SelectMultiple-Select-Form_field{border:1px solid #99d0d1;color:#000;font-size:14px;font-size:.875rem;line-height:24px;line-height:1.5rem;height:32px;height:2rem;margin:0 0 10px;margin:0 0 .625rem;padding:4.8px 8.4px;padding:.3rem .525rem;width:100%;display:block;position:relative}.SelectMultiple-Select-Form_field:focus{border-color:rgba(2,33,64,.4)}.SelectMultiple-Select-Form_field:disabled{background-color:transparent;opacity:.75}.SelectMultiple-Select-Form_field a{color:#022140}.SelectMultiple-Select-Form__secondary .SelectMultiple-Select-Form_field{background-color:transparent;border-color:rgba(2,33,64,.4)}.SelectMultiple-Select-Form__static .SelectMultiple-Select-Form_field{border-color:#022140}.SelectMultiple-Select-Form_group .SelectMultiple-Select-Form_field{margin-bottom:0}.SelectMultiple-Select-Form_addon .SelectMultiple-Select-Form_field{background-color:rgba(2,33,64,.35);border:1px solid rgba(2,33,64,.4);border-right:0;border-radius:2px 0 0 2px}.SelectMultiple-Select-Form_afterAddon .SelectMultiple-Select-Form_field{border-left:0;border-radius:0 2px 2px 0}.SelectMultiple-Select-Form_buttonLike .SelectMultiple-Select-Form_field{background-color:#f3f5f7}.SelectMultiple-Select-FormSelect{position:relative}.SelectMultiple-Select-FormSelect__static{max-width:80%;margin:0 auto 40px;margin:0 auto 2.5rem}.SelectMultiple-Select-FormSelect__label{display:block}.SelectMultiple-Select-FormSelect__static .SelectMultiple-Select-FormSelect__label{margin-bottom:8px;margin-bottom:.5rem;text-align:center}.SelectMultiple-Select-FormSelect_value{position:absolute;top:0;bottom:0;right:0;left:0;margin:0;padding-right:22.4px;padding-right:1.4rem;white-space:nowrap;overflow:hidden;width:100%;-o-text-overflow:ellipsis;text-overflow:ellipsis}.SelectMultiple-Select-FormSelect_value.SelectMultiple-Select-is-default{color:rgba(0,0,0,.55)}.SelectMultiple-Select-FormSelect_value:after{content:\"\";border:3px solid transparent;border-top:5px solid #022140;position:absolute;right:12.8px;right:.8rem;top:calc(50% - 3px)}.SelectMultiple-Select-FormSelect_field:focus+.SelectMultiple-Select-FormSelect_value{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;border-color:rgba(2,33,64,.4)}.SelectMultiple-Select-FormSelect_field:disabled+.SelectMultiple-Select-FormSelect_value,.SelectMultiple-Select-FormSelect_field:disabled+.SelectMultiple-Select-FormSelect_value:after{opacity:.75}.SelectMultiple-Select-FormSelect__static .SelectMultiple-Select-FormSelect_value{background-color:#fff;border-color:#022140;text-align:center}.SelectMultiple-Select-FormSelect__static .SelectMultiple-Select-FormSelect_value:after{border-width:6px;border-top-width:9px}.SelectMultiple-Select-FormSelect_value.SelectMultiple-Select-Form_field__large{line-height:1.2}", ""]);

// exports
exports.locals = {
	"u_hidden": "SelectMultiple-Select-u_hidden",
	"big": "SelectMultiple-Select-big",
	"Form_field": "SelectMultiple-Select-Form_field",
	"Form__secondary": "SelectMultiple-Select-Form__secondary",
	"Form__static": "SelectMultiple-Select-Form__static",
	"Form_group": "SelectMultiple-Select-Form_group",
	"Form_addon": "SelectMultiple-Select-Form_addon",
	"Form_afterAddon": "SelectMultiple-Select-Form_afterAddon",
	"Form_buttonLike": "SelectMultiple-Select-Form_buttonLike",
	"FormSelect": "SelectMultiple-Select-FormSelect",
	"FormSelect__static": "SelectMultiple-Select-FormSelect__static",
	"FormSelect__label": "SelectMultiple-Select-FormSelect__label",
	"FormSelect_value": "SelectMultiple-Select-FormSelect_value",
	"is-default": "SelectMultiple-Select-is-default",
	"FormSelect_field": "SelectMultiple-Select-FormSelect_field",
	"Form_field__large": "SelectMultiple-Select-Form_field__large"
};

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1097);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEventsFilterbox.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEventsFilterbox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryEvents-HistoryEventsFilterbox-column_superior{width:33%;background:#fff}.HistoryEvents-HistoryEventsFilterbox-column_softener{width:15%;background:#fff}.HistoryEvents-HistoryEventsFilterbox-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryEvents-HistoryEventsFilterbox-table_border{padding:10px}.HistoryEvents-HistoryEventsFilterbox-header{color:#0376a3}.HistoryEvents-HistoryEventsFilterbox-spirotech{background:#fae03a;color:#000}", ""]);

// exports
exports.locals = {
	"column_superior": "HistoryEvents-HistoryEventsFilterbox-column_superior",
	"column_softener": "HistoryEvents-HistoryEventsFilterbox-column_softener",
	"Table_container": "HistoryEvents-HistoryEventsFilterbox-Table_container",
	"table_border": "HistoryEvents-HistoryEventsFilterbox-table_border",
	"header": "HistoryEvents-HistoryEventsFilterbox-header",
	"spirotech": "HistoryEvents-HistoryEventsFilterbox-spirotech"
};

/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryParameters-HistoryParameters-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryParameters-HistoryParameters-row_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}.HistoryParameters-HistoryParameters-header_color{border:1px solid #0376a3;background:#0376a3;color:#fff}.HistoryParameters-HistoryParameters-data_color{background:#fff;border:1px solid #0376a3}@media (min-width:721px){.HistoryParameters-HistoryParameters-data_color{min-width:8rem}}.HistoryParameters-HistoryParameters-spirotech_header_color{background:#fae04e}.HistoryParameters-HistoryParameters-spirotech_data_color{background:#fff;border:1px solid #fae04e}@media (min-width:721px){.HistoryParameters-HistoryParameters-spirotech_data_color{min-width:8rem}}.HistoryParameters-HistoryParameters-red{background:red}.HistoryParameters-HistoryParameters-center{text-align:center}.HistoryParameters-HistoryParameters-button{border:none;background:none}", ""]);

// exports
exports.locals = {
	"Table_container": "HistoryParameters-HistoryParameters-Table_container",
	"row_container": "HistoryParameters-HistoryParameters-row_container",
	"header_color": "HistoryParameters-HistoryParameters-header_color",
	"data_color": "HistoryParameters-HistoryParameters-data_color",
	"spirotech_header_color": "HistoryParameters-HistoryParameters-spirotech_header_color",
	"spirotech_data_color": "HistoryParameters-HistoryParameters-spirotech_data_color",
	"red": "HistoryParameters-HistoryParameters-red",
	"center": "HistoryParameters-HistoryParameters-center",
	"button": "HistoryParameters-HistoryParameters-button"
};

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1100);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParametersFilterbox.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParametersFilterbox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryParameters-HistoryParametersFilterbox-column_superior{width:33%;background:#fff}.HistoryParameters-HistoryParametersFilterbox-column_softener{width:25%;background:#fff}.HistoryParameters-HistoryParametersFilterbox-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryParameters-HistoryParametersFilterbox-table_border{padding:10px}", ""]);

// exports
exports.locals = {
	"column_superior": "HistoryParameters-HistoryParametersFilterbox-column_superior",
	"column_softener": "HistoryParameters-HistoryParametersFilterbox-column_softener",
	"Table_container": "HistoryParameters-HistoryParametersFilterbox-Table_container",
	"table_border": "HistoryParameters-HistoryParametersFilterbox-table_border"
};

/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1102);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParametersHeader.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParametersHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".HistoryParameters-HistoryParametersHeader-container{width:100%;margin:auto;background:#fff}.HistoryParameters-HistoryParametersHeader-left{width:60%;float:left;min-height:140px}.HistoryParameters-HistoryParametersHeader-right{float:right}.HistoryParameters-HistoryParametersHeader-blackButton{color:#000;height:50px;overflow:hidden}.HistoryParameters-HistoryParametersHeader-whiteButton{color:#fff;height:50px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "HistoryParameters-HistoryParametersHeader-container",
	"left": "HistoryParameters-HistoryParametersHeader-left",
	"right": "HistoryParameters-HistoryParametersHeader-right",
	"blackButton": "HistoryParameters-HistoryParametersHeader-blackButton",
	"whiteButton": "HistoryParameters-HistoryParametersHeader-whiteButton"
};

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".ConversationPopup-ConversationPopup-Box{background-color:#fff;padding:25px;padding:1.5625rem;margin-bottom:15px;margin-bottom:.9375rem;position:relative;width:100%}.ConversationPopup-ConversationPopup-ConversationPopup{position:fixed;top:0;bottom:0;left:0;right:0;overflow:hidden;z-index:10000}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup{padding:1.5625rem .9375rem}}.ConversationPopup-ConversationPopup-ConversationPopup_overlay{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(233,237,240,.68)}.ConversationPopup-ConversationPopup-ConversationPopup_content{position:relative;margin:auto;height:100%}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup_content{height:auto;max-width:705px;width:calc(100% - 5rem)}}.ConversationPopup-ConversationPopup-ConversationPopup_box{overflow:auto;height:100%;margin-bottom:0;padding:24px 40px;padding:1.5rem 2.5rem}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup_box{max-height:calc(100vh - 3.125rem)}}.ConversationPopup-ConversationPopup-ConversationPopup_close{position:absolute;right:0;top:0;padding:0;background-color:#dadada;z-index:1}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup_close{-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}}.ConversationPopup-ConversationPopup-ConversationPopup_teaser{white-space:pre-wrap;color:#000}.ConversationPopup-ConversationPopup-ConversationPopup_message{font-size:13.6px;font-size:.85rem;margin:16px 0 0;margin:1rem 0 0}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup_message{margin-left:3rem}}.ConversationPopup-ConversationPopup-ConversationPopup_textarea{margin-bottom:24px;margin-bottom:1.5rem}@media (min-width:721px){.ConversationPopup-ConversationPopup-ConversationPopup_textarea textarea{min-height:5rem;width:100%}}.ConversationPopup-ConversationPopup-ConversationPopup_icon{position:absolute;top:16px;top:1rem;right:24px;right:1.5rem;z-index:1}.ConversationPopup-ConversationPopup-ConversationPopup_loadPrevious{text-align:center;color:#3e80b3}.ConversationPopup-ConversationPopup-ConversationMessage{padding-top:20px;padding-top:1.25rem}.ConversationPopup-ConversationPopup-ConversationMessage:last-child{margin-bottom:20px;margin-bottom:1.25rem}.ConversationPopup-ConversationPopup-ConversationMessage--new{padding-top:12px;padding-top:.75rem;background-color:#f7faf7}.ConversationPopup-ConversationPopup-ConversationMessage_info{color:#f00540;text-transform:uppercase;text-align:center;font-weight:700}.ConversationPopup-ConversationPopup-ConversationMessage_text{border-bottom:1.6px solid #b8ceb8;border-bottom:.1rem solid #b8ceb8;padding-bottom:8px;padding-bottom:.5rem;margin-bottom:0}.ConversationPopup-ConversationPopup-ConversationMessage_author{color:gray}.ConversationPopup-ConversationPopup-close_spirotech{background-color:#facc3a}.ConversationPopup-ConversationPopup-Button__primary{background-color:#0376a3;color:#fff}.ConversationPopup-ConversationPopup-Button__primary:focus,.ConversationPopup-ConversationPopup-Button__primary:hover{background-color:rgba(2,33,64,.7)}.ConversationPopup-ConversationPopup-light_spirotech{background-color:#fae04e}.ConversationPopup-ConversationPopup-black_text{color:#000}.ConversationPopup-ConversationPopup-superior_text{color:#fff}", ""]);

// exports
exports.locals = {
	"Box": "ConversationPopup-ConversationPopup-Box",
	"ConversationPopup": "ConversationPopup-ConversationPopup-ConversationPopup",
	"ConversationPopup_overlay": "ConversationPopup-ConversationPopup-ConversationPopup_overlay",
	"ConversationPopup_content": "ConversationPopup-ConversationPopup-ConversationPopup_content",
	"ConversationPopup_box": "ConversationPopup-ConversationPopup-ConversationPopup_box",
	"ConversationPopup_close": "ConversationPopup-ConversationPopup-ConversationPopup_close",
	"ConversationPopup_teaser": "ConversationPopup-ConversationPopup-ConversationPopup_teaser",
	"ConversationPopup_message": "ConversationPopup-ConversationPopup-ConversationPopup_message",
	"ConversationPopup_textarea": "ConversationPopup-ConversationPopup-ConversationPopup_textarea",
	"ConversationPopup_icon": "ConversationPopup-ConversationPopup-ConversationPopup_icon",
	"ConversationPopup_loadPrevious": "ConversationPopup-ConversationPopup-ConversationPopup_loadPrevious",
	"ConversationMessage": "ConversationPopup-ConversationPopup-ConversationMessage",
	"ConversationMessage--new": "ConversationPopup-ConversationPopup-ConversationMessage--new",
	"ConversationMessage_info": "ConversationPopup-ConversationPopup-ConversationMessage_info",
	"ConversationMessage_text": "ConversationPopup-ConversationPopup-ConversationMessage_text",
	"ConversationMessage_author": "ConversationPopup-ConversationPopup-ConversationMessage_author",
	"close_spirotech": "ConversationPopup-ConversationPopup-close_spirotech",
	"Button__primary": "ConversationPopup-ConversationPopup-Button__primary",
	"light_spirotech": "ConversationPopup-ConversationPopup-light_spirotech",
	"black_text": "ConversationPopup-ConversationPopup-black_text",
	"superior_text": "ConversationPopup-ConversationPopup-superior_text"
};

/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1105);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Header.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".BasicHeader-Header-u_sizeFit{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;width:auto!important}.BasicHeader-Header-u_sizeFill{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important;-ms-flex-preferred-size:0%!important;flex-basis:0%!important;width:auto!important}.BasicHeader-Header-u_sizeFull{width:100%!important}.BasicHeader-Header-u_sizeAuto{width:auto!important}.BasicHeader-Header-u_size1of12{width:8.33333%!important}.BasicHeader-Header-u_size1of10{width:10%!important}.BasicHeader-Header-u_size2of12{width:16.66667%!important}.BasicHeader-Header-u_size2of10{width:20%!important}.BasicHeader-Header-u_size3of12{width:25%!important}.BasicHeader-Header-u_size3of10{width:30%!important}.BasicHeader-Header-u_size4of12{width:33.33333%!important}.BasicHeader-Header-u_size3of8{width:37.5%!important}.BasicHeader-Header-u_size4of10{width:40%!important}.BasicHeader-Header-u_size5of12{width:41.66667%!important}.BasicHeader-Header-size5of10,.BasicHeader-Header-size6of12,.BasicHeader-Header-u_size5of10,.BasicHeader-Header-u_size6of12{width:50%!important}.BasicHeader-Header-u_size7of12{width:58.33333%!important}.BasicHeader-Header-u_size6of10{width:60%!important}.BasicHeader-Header-u_size8of12{width:66.66667%!important}.BasicHeader-Header-u_size7of10{width:70%!important}.BasicHeader-Header-u_size9of12{width:75%!important}.BasicHeader-Header-u_size8of10{width:80%!important}.BasicHeader-Header-u_size10of12{width:83.33333%!important}.BasicHeader-Header-u_size9of10{width:90%!important}.BasicHeader-Header-u_size11of12{width:91.66667%!important}@media (min-width:480px){.BasicHeader-Header-u_sizeFull-sm{width:100%!important}.BasicHeader-Header-u_sizeAuto-sm{width:auto!important}.BasicHeader-Header-u_size1of12-sm{width:8.33333%!important}.BasicHeader-Header-u_size1of10-sm{width:10%!important}.BasicHeader-Header-u_size2of12-sm{width:16.66667%!important}.BasicHeader-Header-u_size2of10-sm{width:20%!important}.BasicHeader-Header-u_size3of12-sm{width:25%!important}.BasicHeader-Header-u_size3of10-sm{width:30%!important}.BasicHeader-Header-u_size4of12-sm{width:33.33333%!important}.BasicHeader-Header-u_size3of8-sm{width:37.5%!important}.BasicHeader-Header-u_size4of10-sm{width:40%!important}.BasicHeader-Header-u_size5of12-sm{width:41.66667%!important}.BasicHeader-Header-u_size5of10-sm,.BasicHeader-Header-u_size6of12-sm{width:50%!important}.BasicHeader-Header-u_size7of12-sm{width:58.33333%!important}.BasicHeader-Header-u_size6of10-sm{width:60%!important}.BasicHeader-Header-u_size8of12-sm{width:66.66667%!important}.BasicHeader-Header-u_size7of10{width:70%!important}.BasicHeader-Header-u_size9of12-sm{width:75%!important}.BasicHeader-Header-u_size8of10-sm{width:80%!important}.BasicHeader-Header-u_size10of12-sm{width:83.33333%!important}.BasicHeader-Header-u_size9of10-sm{width:90%!important}.BasicHeader-Header-u_size11of12-sm{width:91.66667%!important}}@media (min-width:721px){.BasicHeader-Header-u_sizeFull-md{width:100%!important}.BasicHeader-Header-u_sizeAuto-md{width:auto!important}.BasicHeader-Header-u_size1of12-md{width:8.33333%!important}.BasicHeader-Header-u_size1of10-md{width:10%!important}.BasicHeader-Header-u_size2of12-md{width:16.66667%!important}.BasicHeader-Header-u_size2of10-md{width:20%!important}.BasicHeader-Header-u_size3of12-md{width:25%!important}.BasicHeader-Header-u_size3of10-md{width:30%!important}.BasicHeader-Header-u_size4of12-md{width:33.33333%!important}.BasicHeader-Header-u_size3of8-md{width:37.5%!important}.BasicHeader-Header-u_size4of10-md{width:40%!important}.BasicHeader-Header-u_size5of12-md{width:41.66667%!important}.BasicHeader-Header-u_size5of10-md,.BasicHeader-Header-u_size6of12-md{width:50%!important}.BasicHeader-Header-u_size7of12-md{width:58.33333%!important}.BasicHeader-Header-u_size6of10-md{width:60%!important}.BasicHeader-Header-u_size8of12-md{width:66.66667%!important}.BasicHeader-Header-u_size7of10-md{width:70%!important}.BasicHeader-Header-u_size9of12-md{width:75%!important}.BasicHeader-Header-u_size8of10-md{width:80%!important}.BasicHeader-Header-u_size10of12-md{width:83.33333%!important}.BasicHeader-Header-u_size9of10-md{width:90%!important}.BasicHeader-Header-u_size11of12-md{width:91.66667%!important}}@media (min-width:1280px){.BasicHeader-Header-u_sizeFull-lg{width:100%!important}.BasicHeader-Header-u_sizeAuto-lg{width:auto!important}.BasicHeader-Header-u_size1of12-lg{width:8.33333%!important}.BasicHeader-Header-u_size1of10-lg{width:10%!important}.BasicHeader-Header-u_size2of12-lg{width:16.66667%!important}.BasicHeader-Header-u_size2of10-lg{width:20%!important}.BasicHeader-Header-u_size3of12-lg{width:25%!important}.BasicHeader-Header-u_size3of10-lg{width:30%!important}.BasicHeader-Header-u_size4of12-lg{width:33.33333%!important}.BasicHeader-Header-u_size3of8-lg{width:37.5%!important}.BasicHeader-Header-u_size4of10-lg{width:40%!important}.BasicHeader-Header-u_size5of12-lg{width:41.66667%!important}.BasicHeader-Header-u_size5of10-lg,.BasicHeader-Header-u_size6of12-lg{width:50%!important}.BasicHeader-Header-u_size7of12-lg{width:58.33333%!important}.BasicHeader-Header-u_size6of10-lg{width:60%!important}.BasicHeader-Header-u_size8of12-lg{width:66.66667%!important}.BasicHeader-Header-u_size7of10-lg{width:70%!important}.BasicHeader-Header-u_size9of12-lg{width:75%!important}.BasicHeader-Header-u_size8of10-lg{width:80%!important}.BasicHeader-Header-u_size10of12-lg{width:83.33333%!important}.BasicHeader-Header-u_size9of10-lg{width:90%!important}.BasicHeader-Header-u_size11of12-lg{width:91.66667%!important}}.BasicHeader-Header-u_sizeHeightFull{height:100%!important}.BasicHeader-Header-root{background:#fefefe;color:#fff;min-height:60px}@media (min-width:721px){.BasicHeader-Header-root{min-height:120px}}.BasicHeader-Header-container{margin:0 auto;padding:20px 0;max-width:1366px}@media (min-width:721px){.BasicHeader-Header-container{padding:48px 0}}.BasicHeader-Header-Header_inner{position:relative;min-height:60px;margin-top:30px}@media (min-width:721px){.BasicHeader-Header-Header_inner{margin-top:0}}.BasicHeader-Header-Header_logo{width:130px;top:-25%;position:absolute;left:10px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.BasicHeader-Header-Header_logo img{max-width:100%}@media (min-width:920px){.BasicHeader-Header-Header_logo{width:190px;top:50%;left:15%;margin:0;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}}.BasicHeader-Header-brandTxt{margin-left:10px}.BasicHeader-Header-banner{text-align:center}.BasicHeader-Header-bannerTitle{margin:0;padding:10px;font-weight:400;font-size:4em;line-height:1em}.BasicHeader-Header-u_cf:after,.BasicHeader-Header-u_cf:before{content:\" \";display:table}.BasicHeader-Header-u_cf:after{clear:both}", ""]);

// exports
exports.locals = {
	"u_sizeFit": "BasicHeader-Header-u_sizeFit",
	"u_sizeFill": "BasicHeader-Header-u_sizeFill",
	"u_sizeFull": "BasicHeader-Header-u_sizeFull",
	"u_sizeAuto": "BasicHeader-Header-u_sizeAuto",
	"u_size1of12": "BasicHeader-Header-u_size1of12",
	"u_size1of10": "BasicHeader-Header-u_size1of10",
	"u_size2of12": "BasicHeader-Header-u_size2of12",
	"u_size2of10": "BasicHeader-Header-u_size2of10",
	"u_size3of12": "BasicHeader-Header-u_size3of12",
	"u_size3of10": "BasicHeader-Header-u_size3of10",
	"u_size4of12": "BasicHeader-Header-u_size4of12",
	"u_size3of8": "BasicHeader-Header-u_size3of8",
	"u_size4of10": "BasicHeader-Header-u_size4of10",
	"u_size5of12": "BasicHeader-Header-u_size5of12",
	"u_size5of10": "BasicHeader-Header-u_size5of10",
	"u_size6of12": "BasicHeader-Header-u_size6of12",
	"size5of10": "BasicHeader-Header-size5of10",
	"size6of12": "BasicHeader-Header-size6of12",
	"u_size7of12": "BasicHeader-Header-u_size7of12",
	"u_size6of10": "BasicHeader-Header-u_size6of10",
	"u_size8of12": "BasicHeader-Header-u_size8of12",
	"u_size7of10": "BasicHeader-Header-u_size7of10",
	"u_size9of12": "BasicHeader-Header-u_size9of12",
	"u_size8of10": "BasicHeader-Header-u_size8of10",
	"u_size10of12": "BasicHeader-Header-u_size10of12",
	"u_size9of10": "BasicHeader-Header-u_size9of10",
	"u_size11of12": "BasicHeader-Header-u_size11of12",
	"u_sizeFull@sm": "BasicHeader-Header-u_sizeFull-sm",
	"u_sizeAuto@sm": "BasicHeader-Header-u_sizeAuto-sm",
	"u_size1of12@sm": "BasicHeader-Header-u_size1of12-sm",
	"u_size1of10@sm": "BasicHeader-Header-u_size1of10-sm",
	"u_size2of12@sm": "BasicHeader-Header-u_size2of12-sm",
	"u_size2of10@sm": "BasicHeader-Header-u_size2of10-sm",
	"u_size3of12@sm": "BasicHeader-Header-u_size3of12-sm",
	"u_size3of10@sm": "BasicHeader-Header-u_size3of10-sm",
	"u_size4of12@sm": "BasicHeader-Header-u_size4of12-sm",
	"u_size3of8@sm": "BasicHeader-Header-u_size3of8-sm",
	"u_size4of10@sm": "BasicHeader-Header-u_size4of10-sm",
	"u_size5of12@sm": "BasicHeader-Header-u_size5of12-sm",
	"u_size5of10@sm": "BasicHeader-Header-u_size5of10-sm",
	"u_size6of12@sm": "BasicHeader-Header-u_size6of12-sm",
	"u_size7of12@sm": "BasicHeader-Header-u_size7of12-sm",
	"u_size6of10@sm": "BasicHeader-Header-u_size6of10-sm",
	"u_size8of12@sm": "BasicHeader-Header-u_size8of12-sm",
	"u_size9of12@sm": "BasicHeader-Header-u_size9of12-sm",
	"u_size8of10@sm": "BasicHeader-Header-u_size8of10-sm",
	"u_size10of12@sm": "BasicHeader-Header-u_size10of12-sm",
	"u_size9of10@sm": "BasicHeader-Header-u_size9of10-sm",
	"u_size11of12@sm": "BasicHeader-Header-u_size11of12-sm",
	"u_sizeFull@md": "BasicHeader-Header-u_sizeFull-md",
	"u_sizeAuto@md": "BasicHeader-Header-u_sizeAuto-md",
	"u_size1of12@md": "BasicHeader-Header-u_size1of12-md",
	"u_size1of10@md": "BasicHeader-Header-u_size1of10-md",
	"u_size2of12@md": "BasicHeader-Header-u_size2of12-md",
	"u_size2of10@md": "BasicHeader-Header-u_size2of10-md",
	"u_size3of12@md": "BasicHeader-Header-u_size3of12-md",
	"u_size3of10@md": "BasicHeader-Header-u_size3of10-md",
	"u_size4of12@md": "BasicHeader-Header-u_size4of12-md",
	"u_size3of8@md": "BasicHeader-Header-u_size3of8-md",
	"u_size4of10@md": "BasicHeader-Header-u_size4of10-md",
	"u_size5of12@md": "BasicHeader-Header-u_size5of12-md",
	"u_size5of10@md": "BasicHeader-Header-u_size5of10-md",
	"u_size6of12@md": "BasicHeader-Header-u_size6of12-md",
	"u_size7of12@md": "BasicHeader-Header-u_size7of12-md",
	"u_size6of10@md": "BasicHeader-Header-u_size6of10-md",
	"u_size8of12@md": "BasicHeader-Header-u_size8of12-md",
	"u_size7of10@md": "BasicHeader-Header-u_size7of10-md",
	"u_size9of12@md": "BasicHeader-Header-u_size9of12-md",
	"u_size8of10@md": "BasicHeader-Header-u_size8of10-md",
	"u_size10of12@md": "BasicHeader-Header-u_size10of12-md",
	"u_size9of10@md": "BasicHeader-Header-u_size9of10-md",
	"u_size11of12@md": "BasicHeader-Header-u_size11of12-md",
	"u_sizeFull@lg": "BasicHeader-Header-u_sizeFull-lg",
	"u_sizeAuto@lg": "BasicHeader-Header-u_sizeAuto-lg",
	"u_size1of12@lg": "BasicHeader-Header-u_size1of12-lg",
	"u_size1of10@lg": "BasicHeader-Header-u_size1of10-lg",
	"u_size2of12@lg": "BasicHeader-Header-u_size2of12-lg",
	"u_size2of10@lg": "BasicHeader-Header-u_size2of10-lg",
	"u_size3of12@lg": "BasicHeader-Header-u_size3of12-lg",
	"u_size3of10@lg": "BasicHeader-Header-u_size3of10-lg",
	"u_size4of12@lg": "BasicHeader-Header-u_size4of12-lg",
	"u_size3of8@lg": "BasicHeader-Header-u_size3of8-lg",
	"u_size4of10@lg": "BasicHeader-Header-u_size4of10-lg",
	"u_size5of12@lg": "BasicHeader-Header-u_size5of12-lg",
	"u_size5of10@lg": "BasicHeader-Header-u_size5of10-lg",
	"u_size6of12@lg": "BasicHeader-Header-u_size6of12-lg",
	"u_size7of12@lg": "BasicHeader-Header-u_size7of12-lg",
	"u_size6of10@lg": "BasicHeader-Header-u_size6of10-lg",
	"u_size8of12@lg": "BasicHeader-Header-u_size8of12-lg",
	"u_size7of10@lg": "BasicHeader-Header-u_size7of10-lg",
	"u_size9of12@lg": "BasicHeader-Header-u_size9of12-lg",
	"u_size8of10@lg": "BasicHeader-Header-u_size8of10-lg",
	"u_size10of12@lg": "BasicHeader-Header-u_size10of12-lg",
	"u_size9of10@lg": "BasicHeader-Header-u_size9of10-lg",
	"u_size11of12@lg": "BasicHeader-Header-u_size11of12-lg",
	"u_sizeHeightFull": "BasicHeader-Header-u_sizeHeightFull",
	"root": "BasicHeader-Header-root",
	"container": "BasicHeader-Header-container",
	"Header_inner": "BasicHeader-Header-Header_inner",
	"Header_logo": "BasicHeader-Header-Header_logo",
	"brand": "BasicHeader-Header-brand",
	"brandTxt": "BasicHeader-Header-brandTxt",
	"banner": "BasicHeader-Header-banner",
	"bannerTitle": "BasicHeader-Header-bannerTitle",
	"u_cf": "BasicHeader-Header-u_cf"
};

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1107);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Navigation.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".BasicNavigation-Navigation-u_sizeFit{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;width:auto!important}.BasicNavigation-Navigation-u_sizeFill{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important;-ms-flex-preferred-size:0%!important;flex-basis:0%!important;width:auto!important}.BasicNavigation-Navigation-u_sizeFull{width:100%!important}.BasicNavigation-Navigation-u_sizeAuto{width:auto!important}.BasicNavigation-Navigation-u_size1of12{width:8.33333%!important}.BasicNavigation-Navigation-u_size1of10{width:10%!important}.BasicNavigation-Navigation-u_size2of12{width:16.66667%!important}.BasicNavigation-Navigation-u_size2of10{width:20%!important}.BasicNavigation-Navigation-u_size3of12{width:25%!important}.BasicNavigation-Navigation-u_size3of10{width:30%!important}.BasicNavigation-Navigation-u_size4of12{width:33.33333%!important}.BasicNavigation-Navigation-u_size3of8{width:37.5%!important}.BasicNavigation-Navigation-u_size4of10{width:40%!important}.BasicNavigation-Navigation-u_size5of12{width:41.66667%!important}.BasicNavigation-Navigation-size5of10,.BasicNavigation-Navigation-size6of12,.BasicNavigation-Navigation-u_size5of10,.BasicNavigation-Navigation-u_size6of12{width:50%!important}.BasicNavigation-Navigation-u_size7of12{width:58.33333%!important}.BasicNavigation-Navigation-u_size6of10{width:60%!important}.BasicNavigation-Navigation-u_size8of12{width:66.66667%!important}.BasicNavigation-Navigation-u_size7of10{width:70%!important}.BasicNavigation-Navigation-u_size9of12{width:75%!important}.BasicNavigation-Navigation-u_size8of10{width:80%!important}.BasicNavigation-Navigation-u_size10of12{width:83.33333%!important}.BasicNavigation-Navigation-u_size9of10{width:90%!important}.BasicNavigation-Navigation-u_size11of12{width:91.66667%!important}@media (min-width:480px){.BasicNavigation-Navigation-u_sizeFull-sm{width:100%!important}.BasicNavigation-Navigation-u_sizeAuto-sm{width:auto!important}.BasicNavigation-Navigation-u_size1of12-sm{width:8.33333%!important}.BasicNavigation-Navigation-u_size1of10-sm{width:10%!important}.BasicNavigation-Navigation-u_size2of12-sm{width:16.66667%!important}.BasicNavigation-Navigation-u_size2of10-sm{width:20%!important}.BasicNavigation-Navigation-u_size3of12-sm{width:25%!important}.BasicNavigation-Navigation-u_size3of10-sm{width:30%!important}.BasicNavigation-Navigation-u_size4of12-sm{width:33.33333%!important}.BasicNavigation-Navigation-u_size3of8-sm{width:37.5%!important}.BasicNavigation-Navigation-u_size4of10-sm{width:40%!important}.BasicNavigation-Navigation-u_size5of12-sm{width:41.66667%!important}.BasicNavigation-Navigation-u_size5of10-sm,.BasicNavigation-Navigation-u_size6of12-sm{width:50%!important}.BasicNavigation-Navigation-u_size7of12-sm{width:58.33333%!important}.BasicNavigation-Navigation-u_size6of10-sm{width:60%!important}.BasicNavigation-Navigation-u_size8of12-sm{width:66.66667%!important}.BasicNavigation-Navigation-u_size7of10{width:70%!important}.BasicNavigation-Navigation-u_size9of12-sm{width:75%!important}.BasicNavigation-Navigation-u_size8of10-sm{width:80%!important}.BasicNavigation-Navigation-u_size10of12-sm{width:83.33333%!important}.BasicNavigation-Navigation-u_size9of10-sm{width:90%!important}.BasicNavigation-Navigation-u_size11of12-sm{width:91.66667%!important}}@media (min-width:721px){.BasicNavigation-Navigation-u_sizeFull-md{width:100%!important}.BasicNavigation-Navigation-u_sizeAuto-md{width:auto!important}.BasicNavigation-Navigation-u_size1of12-md{width:8.33333%!important}.BasicNavigation-Navigation-u_size1of10-md{width:10%!important}.BasicNavigation-Navigation-u_size2of12-md{width:16.66667%!important}.BasicNavigation-Navigation-u_size2of10-md{width:20%!important}.BasicNavigation-Navigation-u_size3of12-md{width:25%!important}.BasicNavigation-Navigation-u_size3of10-md{width:30%!important}.BasicNavigation-Navigation-u_size4of12-md{width:33.33333%!important}.BasicNavigation-Navigation-u_size3of8-md{width:37.5%!important}.BasicNavigation-Navigation-u_size4of10-md{width:40%!important}.BasicNavigation-Navigation-u_size5of12-md{width:41.66667%!important}.BasicNavigation-Navigation-u_size5of10-md,.BasicNavigation-Navigation-u_size6of12-md{width:50%!important}.BasicNavigation-Navigation-u_size7of12-md{width:58.33333%!important}.BasicNavigation-Navigation-u_size6of10-md{width:60%!important}.BasicNavigation-Navigation-u_size8of12-md{width:66.66667%!important}.BasicNavigation-Navigation-u_size7of10-md{width:70%!important}.BasicNavigation-Navigation-u_size9of12-md{width:75%!important}.BasicNavigation-Navigation-u_size8of10-md{width:80%!important}.BasicNavigation-Navigation-u_size10of12-md{width:83.33333%!important}.BasicNavigation-Navigation-u_size9of10-md{width:90%!important}.BasicNavigation-Navigation-u_size11of12-md{width:91.66667%!important}}@media (min-width:1280px){.BasicNavigation-Navigation-u_sizeFull-lg{width:100%!important}.BasicNavigation-Navigation-u_sizeAuto-lg{width:auto!important}.BasicNavigation-Navigation-u_size1of12-lg{width:8.33333%!important}.BasicNavigation-Navigation-u_size1of10-lg{width:10%!important}.BasicNavigation-Navigation-u_size2of12-lg{width:16.66667%!important}.BasicNavigation-Navigation-u_size2of10-lg{width:20%!important}.BasicNavigation-Navigation-u_size3of12-lg{width:25%!important}.BasicNavigation-Navigation-u_size3of10-lg{width:30%!important}.BasicNavigation-Navigation-u_size4of12-lg{width:33.33333%!important}.BasicNavigation-Navigation-u_size3of8-lg{width:37.5%!important}.BasicNavigation-Navigation-u_size4of10-lg{width:40%!important}.BasicNavigation-Navigation-u_size5of12-lg{width:41.66667%!important}.BasicNavigation-Navigation-u_size5of10-lg,.BasicNavigation-Navigation-u_size6of12-lg{width:50%!important}.BasicNavigation-Navigation-u_size7of12-lg{width:58.33333%!important}.BasicNavigation-Navigation-u_size6of10-lg{width:60%!important}.BasicNavigation-Navigation-u_size8of12-lg{width:66.66667%!important}.BasicNavigation-Navigation-u_size7of10-lg{width:70%!important}.BasicNavigation-Navigation-u_size9of12-lg{width:75%!important}.BasicNavigation-Navigation-u_size8of10-lg{width:80%!important}.BasicNavigation-Navigation-u_size10of12-lg{width:83.33333%!important}.BasicNavigation-Navigation-u_size9of10-lg{width:90%!important}.BasicNavigation-Navigation-u_size11of12-lg{width:91.66667%!important}}.BasicNavigation-Navigation-u_sizeHeightFull{height:100%!important}.BasicNavigation-Navigation-root{float:right;margin:6px 0 0;display:none}@media (min-width:920px){.BasicNavigation-Navigation-root{display:block}}.BasicNavigation-Navigation-rootSmall{margin:6px 0 0;display:block}@media (min-width:920px){.BasicNavigation-Navigation-rootSmall{display:none}}.BasicNavigation-Navigation-link{display:inline-block;padding:3px 8px;text-decoration:none;font-size:1.125em}.BasicNavigation-Navigation-link,.BasicNavigation-Navigation-link:active,.BasicNavigation-Navigation-link:visited{color:hsla(0,0%,100%,.6)}.BasicNavigation-Navigation-link:hover{color:#fff}.BasicNavigation-Navigation-highlight{margin-right:8px;margin-left:8px;border-radius:3px;background:rgba(0,0,0,.15);color:#fff}.BasicNavigation-Navigation-highlight:hover{background:rgba(0,0,0,.3)}.BasicNavigation-Navigation-spacer{color:hsla(0,0%,100%,.3)}.BasicNavigation-Navigation-Header-menu{float:right;margin:7.68px 0 7.2px;margin:.48rem 0 .45rem;padding-left:2.4px;padding-left:.15rem}.BasicNavigation-Navigation-headerText{color:#000;text-align:center;background:#033f57;color:#fff;padding:5px}.BasicNavigation-Navigation-spirotech{background:#facc3a;color:#000}.BasicNavigation-Navigation-center{margin:0 auto}", ""]);

// exports
exports.locals = {
	"u_sizeFit": "BasicNavigation-Navigation-u_sizeFit",
	"u_sizeFill": "BasicNavigation-Navigation-u_sizeFill",
	"u_sizeFull": "BasicNavigation-Navigation-u_sizeFull",
	"u_sizeAuto": "BasicNavigation-Navigation-u_sizeAuto",
	"u_size1of12": "BasicNavigation-Navigation-u_size1of12",
	"u_size1of10": "BasicNavigation-Navigation-u_size1of10",
	"u_size2of12": "BasicNavigation-Navigation-u_size2of12",
	"u_size2of10": "BasicNavigation-Navigation-u_size2of10",
	"u_size3of12": "BasicNavigation-Navigation-u_size3of12",
	"u_size3of10": "BasicNavigation-Navigation-u_size3of10",
	"u_size4of12": "BasicNavigation-Navigation-u_size4of12",
	"u_size3of8": "BasicNavigation-Navigation-u_size3of8",
	"u_size4of10": "BasicNavigation-Navigation-u_size4of10",
	"u_size5of12": "BasicNavigation-Navigation-u_size5of12",
	"u_size5of10": "BasicNavigation-Navigation-u_size5of10",
	"u_size6of12": "BasicNavigation-Navigation-u_size6of12",
	"size5of10": "BasicNavigation-Navigation-size5of10",
	"size6of12": "BasicNavigation-Navigation-size6of12",
	"u_size7of12": "BasicNavigation-Navigation-u_size7of12",
	"u_size6of10": "BasicNavigation-Navigation-u_size6of10",
	"u_size8of12": "BasicNavigation-Navigation-u_size8of12",
	"u_size7of10": "BasicNavigation-Navigation-u_size7of10",
	"u_size9of12": "BasicNavigation-Navigation-u_size9of12",
	"u_size8of10": "BasicNavigation-Navigation-u_size8of10",
	"u_size10of12": "BasicNavigation-Navigation-u_size10of12",
	"u_size9of10": "BasicNavigation-Navigation-u_size9of10",
	"u_size11of12": "BasicNavigation-Navigation-u_size11of12",
	"u_sizeFull@sm": "BasicNavigation-Navigation-u_sizeFull-sm",
	"u_sizeAuto@sm": "BasicNavigation-Navigation-u_sizeAuto-sm",
	"u_size1of12@sm": "BasicNavigation-Navigation-u_size1of12-sm",
	"u_size1of10@sm": "BasicNavigation-Navigation-u_size1of10-sm",
	"u_size2of12@sm": "BasicNavigation-Navigation-u_size2of12-sm",
	"u_size2of10@sm": "BasicNavigation-Navigation-u_size2of10-sm",
	"u_size3of12@sm": "BasicNavigation-Navigation-u_size3of12-sm",
	"u_size3of10@sm": "BasicNavigation-Navigation-u_size3of10-sm",
	"u_size4of12@sm": "BasicNavigation-Navigation-u_size4of12-sm",
	"u_size3of8@sm": "BasicNavigation-Navigation-u_size3of8-sm",
	"u_size4of10@sm": "BasicNavigation-Navigation-u_size4of10-sm",
	"u_size5of12@sm": "BasicNavigation-Navigation-u_size5of12-sm",
	"u_size5of10@sm": "BasicNavigation-Navigation-u_size5of10-sm",
	"u_size6of12@sm": "BasicNavigation-Navigation-u_size6of12-sm",
	"u_size7of12@sm": "BasicNavigation-Navigation-u_size7of12-sm",
	"u_size6of10@sm": "BasicNavigation-Navigation-u_size6of10-sm",
	"u_size8of12@sm": "BasicNavigation-Navigation-u_size8of12-sm",
	"u_size9of12@sm": "BasicNavigation-Navigation-u_size9of12-sm",
	"u_size8of10@sm": "BasicNavigation-Navigation-u_size8of10-sm",
	"u_size10of12@sm": "BasicNavigation-Navigation-u_size10of12-sm",
	"u_size9of10@sm": "BasicNavigation-Navigation-u_size9of10-sm",
	"u_size11of12@sm": "BasicNavigation-Navigation-u_size11of12-sm",
	"u_sizeFull@md": "BasicNavigation-Navigation-u_sizeFull-md",
	"u_sizeAuto@md": "BasicNavigation-Navigation-u_sizeAuto-md",
	"u_size1of12@md": "BasicNavigation-Navigation-u_size1of12-md",
	"u_size1of10@md": "BasicNavigation-Navigation-u_size1of10-md",
	"u_size2of12@md": "BasicNavigation-Navigation-u_size2of12-md",
	"u_size2of10@md": "BasicNavigation-Navigation-u_size2of10-md",
	"u_size3of12@md": "BasicNavigation-Navigation-u_size3of12-md",
	"u_size3of10@md": "BasicNavigation-Navigation-u_size3of10-md",
	"u_size4of12@md": "BasicNavigation-Navigation-u_size4of12-md",
	"u_size3of8@md": "BasicNavigation-Navigation-u_size3of8-md",
	"u_size4of10@md": "BasicNavigation-Navigation-u_size4of10-md",
	"u_size5of12@md": "BasicNavigation-Navigation-u_size5of12-md",
	"u_size5of10@md": "BasicNavigation-Navigation-u_size5of10-md",
	"u_size6of12@md": "BasicNavigation-Navigation-u_size6of12-md",
	"u_size7of12@md": "BasicNavigation-Navigation-u_size7of12-md",
	"u_size6of10@md": "BasicNavigation-Navigation-u_size6of10-md",
	"u_size8of12@md": "BasicNavigation-Navigation-u_size8of12-md",
	"u_size7of10@md": "BasicNavigation-Navigation-u_size7of10-md",
	"u_size9of12@md": "BasicNavigation-Navigation-u_size9of12-md",
	"u_size8of10@md": "BasicNavigation-Navigation-u_size8of10-md",
	"u_size10of12@md": "BasicNavigation-Navigation-u_size10of12-md",
	"u_size9of10@md": "BasicNavigation-Navigation-u_size9of10-md",
	"u_size11of12@md": "BasicNavigation-Navigation-u_size11of12-md",
	"u_sizeFull@lg": "BasicNavigation-Navigation-u_sizeFull-lg",
	"u_sizeAuto@lg": "BasicNavigation-Navigation-u_sizeAuto-lg",
	"u_size1of12@lg": "BasicNavigation-Navigation-u_size1of12-lg",
	"u_size1of10@lg": "BasicNavigation-Navigation-u_size1of10-lg",
	"u_size2of12@lg": "BasicNavigation-Navigation-u_size2of12-lg",
	"u_size2of10@lg": "BasicNavigation-Navigation-u_size2of10-lg",
	"u_size3of12@lg": "BasicNavigation-Navigation-u_size3of12-lg",
	"u_size3of10@lg": "BasicNavigation-Navigation-u_size3of10-lg",
	"u_size4of12@lg": "BasicNavigation-Navigation-u_size4of12-lg",
	"u_size3of8@lg": "BasicNavigation-Navigation-u_size3of8-lg",
	"u_size4of10@lg": "BasicNavigation-Navigation-u_size4of10-lg",
	"u_size5of12@lg": "BasicNavigation-Navigation-u_size5of12-lg",
	"u_size5of10@lg": "BasicNavigation-Navigation-u_size5of10-lg",
	"u_size6of12@lg": "BasicNavigation-Navigation-u_size6of12-lg",
	"u_size7of12@lg": "BasicNavigation-Navigation-u_size7of12-lg",
	"u_size6of10@lg": "BasicNavigation-Navigation-u_size6of10-lg",
	"u_size8of12@lg": "BasicNavigation-Navigation-u_size8of12-lg",
	"u_size7of10@lg": "BasicNavigation-Navigation-u_size7of10-lg",
	"u_size9of12@lg": "BasicNavigation-Navigation-u_size9of12-lg",
	"u_size8of10@lg": "BasicNavigation-Navigation-u_size8of10-lg",
	"u_size10of12@lg": "BasicNavigation-Navigation-u_size10of12-lg",
	"u_size9of10@lg": "BasicNavigation-Navigation-u_size9of10-lg",
	"u_size11of12@lg": "BasicNavigation-Navigation-u_size11of12-lg",
	"u_sizeHeightFull": "BasicNavigation-Navigation-u_sizeHeightFull",
	"root": "BasicNavigation-Navigation-root",
	"rootSmall": "BasicNavigation-Navigation-rootSmall",
	"link": "BasicNavigation-Navigation-link",
	"highlight": "BasicNavigation-Navigation-highlight",
	"spacer": "BasicNavigation-Navigation-spacer",
	"Header-menu": "BasicNavigation-Navigation-Header-menu",
	"headerText": "BasicNavigation-Navigation-headerText",
	"spirotech": "BasicNavigation-Navigation-spirotech",
	"center": "BasicNavigation-Navigation-center"
};

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1109);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavigationButton.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavigationButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".NavigationButton-NavigationButton-u_sizeFit{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;width:auto!important}.NavigationButton-NavigationButton-u_sizeFill{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important;-ms-flex-preferred-size:0%!important;flex-basis:0%!important;width:auto!important}.NavigationButton-NavigationButton-u_sizeFull{width:100%!important}.NavigationButton-NavigationButton-u_sizeAuto{width:auto!important}.NavigationButton-NavigationButton-u_size1of12{width:8.33333%!important}.NavigationButton-NavigationButton-u_size1of10{width:10%!important}.NavigationButton-NavigationButton-u_size2of12{width:16.66667%!important}.NavigationButton-NavigationButton-u_size2of10{width:20%!important}.NavigationButton-NavigationButton-u_size3of12{width:25%!important}.NavigationButton-NavigationButton-u_size3of10{width:30%!important}.NavigationButton-NavigationButton-u_size4of12{width:33.33333%!important}.NavigationButton-NavigationButton-u_size3of8{width:37.5%!important}.NavigationButton-NavigationButton-u_size4of10{width:40%!important}.NavigationButton-NavigationButton-u_size5of12{width:41.66667%!important}.NavigationButton-NavigationButton-size5of10,.NavigationButton-NavigationButton-size6of12,.NavigationButton-NavigationButton-u_size5of10,.NavigationButton-NavigationButton-u_size6of12{width:50%!important}.NavigationButton-NavigationButton-u_size7of12{width:58.33333%!important}.NavigationButton-NavigationButton-u_size6of10{width:60%!important}.NavigationButton-NavigationButton-u_size8of12{width:66.66667%!important}.NavigationButton-NavigationButton-u_size7of10{width:70%!important}.NavigationButton-NavigationButton-u_size9of12{width:75%!important}.NavigationButton-NavigationButton-u_size8of10{width:80%!important}.NavigationButton-NavigationButton-u_size10of12{width:83.33333%!important}.NavigationButton-NavigationButton-u_size9of10{width:90%!important}.NavigationButton-NavigationButton-u_size11of12{width:91.66667%!important}@media (min-width:480px){.NavigationButton-NavigationButton-u_sizeFull-sm{width:100%!important}.NavigationButton-NavigationButton-u_sizeAuto-sm{width:auto!important}.NavigationButton-NavigationButton-u_size1of12-sm{width:8.33333%!important}.NavigationButton-NavigationButton-u_size1of10-sm{width:10%!important}.NavigationButton-NavigationButton-u_size2of12-sm{width:16.66667%!important}.NavigationButton-NavigationButton-u_size2of10-sm{width:20%!important}.NavigationButton-NavigationButton-u_size3of12-sm{width:25%!important}.NavigationButton-NavigationButton-u_size3of10-sm{width:30%!important}.NavigationButton-NavigationButton-u_size4of12-sm{width:33.33333%!important}.NavigationButton-NavigationButton-u_size3of8-sm{width:37.5%!important}.NavigationButton-NavigationButton-u_size4of10-sm{width:40%!important}.NavigationButton-NavigationButton-u_size5of12-sm{width:41.66667%!important}.NavigationButton-NavigationButton-u_size5of10-sm,.NavigationButton-NavigationButton-u_size6of12-sm{width:50%!important}.NavigationButton-NavigationButton-u_size7of12-sm{width:58.33333%!important}.NavigationButton-NavigationButton-u_size6of10-sm{width:60%!important}.NavigationButton-NavigationButton-u_size8of12-sm{width:66.66667%!important}.NavigationButton-NavigationButton-u_size7of10{width:70%!important}.NavigationButton-NavigationButton-u_size9of12-sm{width:75%!important}.NavigationButton-NavigationButton-u_size8of10-sm{width:80%!important}.NavigationButton-NavigationButton-u_size10of12-sm{width:83.33333%!important}.NavigationButton-NavigationButton-u_size9of10-sm{width:90%!important}.NavigationButton-NavigationButton-u_size11of12-sm{width:91.66667%!important}}@media (min-width:721px){.NavigationButton-NavigationButton-u_sizeFull-md{width:100%!important}.NavigationButton-NavigationButton-u_sizeAuto-md{width:auto!important}.NavigationButton-NavigationButton-u_size1of12-md{width:8.33333%!important}.NavigationButton-NavigationButton-u_size1of10-md{width:10%!important}.NavigationButton-NavigationButton-u_size2of12-md{width:16.66667%!important}.NavigationButton-NavigationButton-u_size2of10-md{width:20%!important}.NavigationButton-NavigationButton-u_size3of12-md{width:25%!important}.NavigationButton-NavigationButton-u_size3of10-md{width:30%!important}.NavigationButton-NavigationButton-u_size4of12-md{width:33.33333%!important}.NavigationButton-NavigationButton-u_size3of8-md{width:37.5%!important}.NavigationButton-NavigationButton-u_size4of10-md{width:40%!important}.NavigationButton-NavigationButton-u_size5of12-md{width:41.66667%!important}.NavigationButton-NavigationButton-u_size5of10-md,.NavigationButton-NavigationButton-u_size6of12-md{width:50%!important}.NavigationButton-NavigationButton-u_size7of12-md{width:58.33333%!important}.NavigationButton-NavigationButton-u_size6of10-md{width:60%!important}.NavigationButton-NavigationButton-u_size8of12-md{width:66.66667%!important}.NavigationButton-NavigationButton-u_size7of10-md{width:70%!important}.NavigationButton-NavigationButton-u_size9of12-md{width:75%!important}.NavigationButton-NavigationButton-u_size8of10-md{width:80%!important}.NavigationButton-NavigationButton-u_size10of12-md{width:83.33333%!important}.NavigationButton-NavigationButton-u_size9of10-md{width:90%!important}.NavigationButton-NavigationButton-u_size11of12-md{width:91.66667%!important}}@media (min-width:1280px){.NavigationButton-NavigationButton-u_sizeFull-lg{width:100%!important}.NavigationButton-NavigationButton-u_sizeAuto-lg{width:auto!important}.NavigationButton-NavigationButton-u_size1of12-lg{width:8.33333%!important}.NavigationButton-NavigationButton-u_size1of10-lg{width:10%!important}.NavigationButton-NavigationButton-u_size2of12-lg{width:16.66667%!important}.NavigationButton-NavigationButton-u_size2of10-lg{width:20%!important}.NavigationButton-NavigationButton-u_size3of12-lg{width:25%!important}.NavigationButton-NavigationButton-u_size3of10-lg{width:30%!important}.NavigationButton-NavigationButton-u_size4of12-lg{width:33.33333%!important}.NavigationButton-NavigationButton-u_size3of8-lg{width:37.5%!important}.NavigationButton-NavigationButton-u_size4of10-lg{width:40%!important}.NavigationButton-NavigationButton-u_size5of12-lg{width:41.66667%!important}.NavigationButton-NavigationButton-u_size5of10-lg,.NavigationButton-NavigationButton-u_size6of12-lg{width:50%!important}.NavigationButton-NavigationButton-u_size7of12-lg{width:58.33333%!important}.NavigationButton-NavigationButton-u_size6of10-lg{width:60%!important}.NavigationButton-NavigationButton-u_size8of12-lg{width:66.66667%!important}.NavigationButton-NavigationButton-u_size7of10-lg{width:70%!important}.NavigationButton-NavigationButton-u_size9of12-lg{width:75%!important}.NavigationButton-NavigationButton-u_size8of10-lg{width:80%!important}.NavigationButton-NavigationButton-u_size10of12-lg{width:83.33333%!important}.NavigationButton-NavigationButton-u_size9of10-lg{width:90%!important}.NavigationButton-NavigationButton-u_size11of12-lg{width:91.66667%!important}}.NavigationButton-NavigationButton-u_sizeHeightFull{height:100%!important}.NavigationButton-NavigationButton-root{float:right;margin:6px 0 0}.NavigationButton-NavigationButton-link{display:inline-block;padding:3px 5px;text-decoration:none;font-size:1.125em}@media (min-width:1280px){.NavigationButton-NavigationButton-link{padding:3px 20px}}.NavigationButton-NavigationButton-button{text-align:center;margin:0 10px;display:none;position:relative!important}@media (min-width:721px){.NavigationButton-NavigationButton-button{display:inline-block}}@media (min-width:1280px){.NavigationButton-NavigationButton-button{margin:0 20px}}.NavigationButton-NavigationButton-below{display:block}.NavigationButton-NavigationButton-link,.NavigationButton-NavigationButton-link:active,.NavigationButton-NavigationButton-link:hover,.NavigationButton-NavigationButton-link:visited{color:#000}.NavigationButton-NavigationButton-highlight{margin-right:8px;margin-left:8px;border-radius:3px;background:rgba(0,0,0,.15);color:#fff}.NavigationButton-NavigationButton-highlight:hover{background:rgba(0,0,0,.3)}.NavigationButton-NavigationButton-spacer{color:hsla(0,0%,100%,.3)}", ""]);

// exports
exports.locals = {
	"u_sizeFit": "NavigationButton-NavigationButton-u_sizeFit",
	"u_sizeFill": "NavigationButton-NavigationButton-u_sizeFill",
	"u_sizeFull": "NavigationButton-NavigationButton-u_sizeFull",
	"u_sizeAuto": "NavigationButton-NavigationButton-u_sizeAuto",
	"u_size1of12": "NavigationButton-NavigationButton-u_size1of12",
	"u_size1of10": "NavigationButton-NavigationButton-u_size1of10",
	"u_size2of12": "NavigationButton-NavigationButton-u_size2of12",
	"u_size2of10": "NavigationButton-NavigationButton-u_size2of10",
	"u_size3of12": "NavigationButton-NavigationButton-u_size3of12",
	"u_size3of10": "NavigationButton-NavigationButton-u_size3of10",
	"u_size4of12": "NavigationButton-NavigationButton-u_size4of12",
	"u_size3of8": "NavigationButton-NavigationButton-u_size3of8",
	"u_size4of10": "NavigationButton-NavigationButton-u_size4of10",
	"u_size5of12": "NavigationButton-NavigationButton-u_size5of12",
	"u_size5of10": "NavigationButton-NavigationButton-u_size5of10",
	"u_size6of12": "NavigationButton-NavigationButton-u_size6of12",
	"size5of10": "NavigationButton-NavigationButton-size5of10",
	"size6of12": "NavigationButton-NavigationButton-size6of12",
	"u_size7of12": "NavigationButton-NavigationButton-u_size7of12",
	"u_size6of10": "NavigationButton-NavigationButton-u_size6of10",
	"u_size8of12": "NavigationButton-NavigationButton-u_size8of12",
	"u_size7of10": "NavigationButton-NavigationButton-u_size7of10",
	"u_size9of12": "NavigationButton-NavigationButton-u_size9of12",
	"u_size8of10": "NavigationButton-NavigationButton-u_size8of10",
	"u_size10of12": "NavigationButton-NavigationButton-u_size10of12",
	"u_size9of10": "NavigationButton-NavigationButton-u_size9of10",
	"u_size11of12": "NavigationButton-NavigationButton-u_size11of12",
	"u_sizeFull@sm": "NavigationButton-NavigationButton-u_sizeFull-sm",
	"u_sizeAuto@sm": "NavigationButton-NavigationButton-u_sizeAuto-sm",
	"u_size1of12@sm": "NavigationButton-NavigationButton-u_size1of12-sm",
	"u_size1of10@sm": "NavigationButton-NavigationButton-u_size1of10-sm",
	"u_size2of12@sm": "NavigationButton-NavigationButton-u_size2of12-sm",
	"u_size2of10@sm": "NavigationButton-NavigationButton-u_size2of10-sm",
	"u_size3of12@sm": "NavigationButton-NavigationButton-u_size3of12-sm",
	"u_size3of10@sm": "NavigationButton-NavigationButton-u_size3of10-sm",
	"u_size4of12@sm": "NavigationButton-NavigationButton-u_size4of12-sm",
	"u_size3of8@sm": "NavigationButton-NavigationButton-u_size3of8-sm",
	"u_size4of10@sm": "NavigationButton-NavigationButton-u_size4of10-sm",
	"u_size5of12@sm": "NavigationButton-NavigationButton-u_size5of12-sm",
	"u_size5of10@sm": "NavigationButton-NavigationButton-u_size5of10-sm",
	"u_size6of12@sm": "NavigationButton-NavigationButton-u_size6of12-sm",
	"u_size7of12@sm": "NavigationButton-NavigationButton-u_size7of12-sm",
	"u_size6of10@sm": "NavigationButton-NavigationButton-u_size6of10-sm",
	"u_size8of12@sm": "NavigationButton-NavigationButton-u_size8of12-sm",
	"u_size9of12@sm": "NavigationButton-NavigationButton-u_size9of12-sm",
	"u_size8of10@sm": "NavigationButton-NavigationButton-u_size8of10-sm",
	"u_size10of12@sm": "NavigationButton-NavigationButton-u_size10of12-sm",
	"u_size9of10@sm": "NavigationButton-NavigationButton-u_size9of10-sm",
	"u_size11of12@sm": "NavigationButton-NavigationButton-u_size11of12-sm",
	"u_sizeFull@md": "NavigationButton-NavigationButton-u_sizeFull-md",
	"u_sizeAuto@md": "NavigationButton-NavigationButton-u_sizeAuto-md",
	"u_size1of12@md": "NavigationButton-NavigationButton-u_size1of12-md",
	"u_size1of10@md": "NavigationButton-NavigationButton-u_size1of10-md",
	"u_size2of12@md": "NavigationButton-NavigationButton-u_size2of12-md",
	"u_size2of10@md": "NavigationButton-NavigationButton-u_size2of10-md",
	"u_size3of12@md": "NavigationButton-NavigationButton-u_size3of12-md",
	"u_size3of10@md": "NavigationButton-NavigationButton-u_size3of10-md",
	"u_size4of12@md": "NavigationButton-NavigationButton-u_size4of12-md",
	"u_size3of8@md": "NavigationButton-NavigationButton-u_size3of8-md",
	"u_size4of10@md": "NavigationButton-NavigationButton-u_size4of10-md",
	"u_size5of12@md": "NavigationButton-NavigationButton-u_size5of12-md",
	"u_size5of10@md": "NavigationButton-NavigationButton-u_size5of10-md",
	"u_size6of12@md": "NavigationButton-NavigationButton-u_size6of12-md",
	"u_size7of12@md": "NavigationButton-NavigationButton-u_size7of12-md",
	"u_size6of10@md": "NavigationButton-NavigationButton-u_size6of10-md",
	"u_size8of12@md": "NavigationButton-NavigationButton-u_size8of12-md",
	"u_size7of10@md": "NavigationButton-NavigationButton-u_size7of10-md",
	"u_size9of12@md": "NavigationButton-NavigationButton-u_size9of12-md",
	"u_size8of10@md": "NavigationButton-NavigationButton-u_size8of10-md",
	"u_size10of12@md": "NavigationButton-NavigationButton-u_size10of12-md",
	"u_size9of10@md": "NavigationButton-NavigationButton-u_size9of10-md",
	"u_size11of12@md": "NavigationButton-NavigationButton-u_size11of12-md",
	"u_sizeFull@lg": "NavigationButton-NavigationButton-u_sizeFull-lg",
	"u_sizeAuto@lg": "NavigationButton-NavigationButton-u_sizeAuto-lg",
	"u_size1of12@lg": "NavigationButton-NavigationButton-u_size1of12-lg",
	"u_size1of10@lg": "NavigationButton-NavigationButton-u_size1of10-lg",
	"u_size2of12@lg": "NavigationButton-NavigationButton-u_size2of12-lg",
	"u_size2of10@lg": "NavigationButton-NavigationButton-u_size2of10-lg",
	"u_size3of12@lg": "NavigationButton-NavigationButton-u_size3of12-lg",
	"u_size3of10@lg": "NavigationButton-NavigationButton-u_size3of10-lg",
	"u_size4of12@lg": "NavigationButton-NavigationButton-u_size4of12-lg",
	"u_size3of8@lg": "NavigationButton-NavigationButton-u_size3of8-lg",
	"u_size4of10@lg": "NavigationButton-NavigationButton-u_size4of10-lg",
	"u_size5of12@lg": "NavigationButton-NavigationButton-u_size5of12-lg",
	"u_size5of10@lg": "NavigationButton-NavigationButton-u_size5of10-lg",
	"u_size6of12@lg": "NavigationButton-NavigationButton-u_size6of12-lg",
	"u_size7of12@lg": "NavigationButton-NavigationButton-u_size7of12-lg",
	"u_size6of10@lg": "NavigationButton-NavigationButton-u_size6of10-lg",
	"u_size8of12@lg": "NavigationButton-NavigationButton-u_size8of12-lg",
	"u_size7of10@lg": "NavigationButton-NavigationButton-u_size7of10-lg",
	"u_size9of12@lg": "NavigationButton-NavigationButton-u_size9of12-lg",
	"u_size8of10@lg": "NavigationButton-NavigationButton-u_size8of10-lg",
	"u_size10of12@lg": "NavigationButton-NavigationButton-u_size10of12-lg",
	"u_size9of10@lg": "NavigationButton-NavigationButton-u_size9of10-lg",
	"u_size11of12@lg": "NavigationButton-NavigationButton-u_size11of12-lg",
	"u_sizeHeightFull": "NavigationButton-NavigationButton-u_sizeHeightFull",
	"root": "NavigationButton-NavigationButton-root",
	"link": "NavigationButton-NavigationButton-link",
	"button": "NavigationButton-NavigationButton-button",
	"below": "NavigationButton-NavigationButton-below",
	"highlight": "NavigationButton-NavigationButton-highlight",
	"spacer": "NavigationButton-NavigationButton-spacer"
};

/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1111);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavigationSmallButton.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavigationSmallButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".NavigationSmallButton-NavigationSmallButton-u_sizeFit{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_sizeFill{-webkit-box-flex:1!important;-ms-flex:1 1 0%!important;flex:1 1 0%!important;-ms-flex-preferred-size:0%!important;flex-basis:0%!important;width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_sizeFull{width:100%!important}.NavigationSmallButton-NavigationSmallButton-u_sizeAuto{width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_size1of12{width:8.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size1of10{width:10%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of12{width:16.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of10{width:20%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of12{width:25%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of10{width:30%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of12{width:33.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of8{width:37.5%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of10{width:40%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of12{width:41.66667%!important}.NavigationSmallButton-NavigationSmallButton-size5of10,.NavigationSmallButton-NavigationSmallButton-size6of12,.NavigationSmallButton-NavigationSmallButton-u_size5of10,.NavigationSmallButton-NavigationSmallButton-u_size6of12{width:50%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of12{width:58.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size6of10{width:60%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of12{width:66.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of10{width:70%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of12{width:75%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of10{width:80%!important}.NavigationSmallButton-NavigationSmallButton-u_size10of12{width:83.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of10{width:90%!important}.NavigationSmallButton-NavigationSmallButton-u_size11of12{width:91.66667%!important}@media (min-width:480px){.NavigationSmallButton-NavigationSmallButton-u_sizeFull-sm{width:100%!important}.NavigationSmallButton-NavigationSmallButton-u_sizeAuto-sm{width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_size1of12-sm{width:8.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size1of10-sm{width:10%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of12-sm{width:16.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of10-sm{width:20%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of12-sm{width:25%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of10-sm{width:30%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of12-sm{width:33.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of8-sm{width:37.5%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of10-sm{width:40%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of12-sm{width:41.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of10-sm,.NavigationSmallButton-NavigationSmallButton-u_size6of12-sm{width:50%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of12-sm{width:58.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size6of10-sm{width:60%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of12-sm{width:66.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of10{width:70%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of12-sm{width:75%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of10-sm{width:80%!important}.NavigationSmallButton-NavigationSmallButton-u_size10of12-sm{width:83.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of10-sm{width:90%!important}.NavigationSmallButton-NavigationSmallButton-u_size11of12-sm{width:91.66667%!important}}@media (min-width:721px){.NavigationSmallButton-NavigationSmallButton-u_sizeFull-md{width:100%!important}.NavigationSmallButton-NavigationSmallButton-u_sizeAuto-md{width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_size1of12-md{width:8.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size1of10-md{width:10%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of12-md{width:16.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of10-md{width:20%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of12-md{width:25%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of10-md{width:30%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of12-md{width:33.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of8-md{width:37.5%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of10-md{width:40%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of12-md{width:41.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of10-md,.NavigationSmallButton-NavigationSmallButton-u_size6of12-md{width:50%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of12-md{width:58.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size6of10-md{width:60%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of12-md{width:66.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of10-md{width:70%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of12-md{width:75%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of10-md{width:80%!important}.NavigationSmallButton-NavigationSmallButton-u_size10of12-md{width:83.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of10-md{width:90%!important}.NavigationSmallButton-NavigationSmallButton-u_size11of12-md{width:91.66667%!important}}@media (min-width:1280px){.NavigationSmallButton-NavigationSmallButton-u_sizeFull-lg{width:100%!important}.NavigationSmallButton-NavigationSmallButton-u_sizeAuto-lg{width:auto!important}.NavigationSmallButton-NavigationSmallButton-u_size1of12-lg{width:8.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size1of10-lg{width:10%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of12-lg{width:16.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size2of10-lg{width:20%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of12-lg{width:25%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of10-lg{width:30%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of12-lg{width:33.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size3of8-lg{width:37.5%!important}.NavigationSmallButton-NavigationSmallButton-u_size4of10-lg{width:40%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of12-lg{width:41.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size5of10-lg,.NavigationSmallButton-NavigationSmallButton-u_size6of12-lg{width:50%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of12-lg{width:58.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size6of10-lg{width:60%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of12-lg{width:66.66667%!important}.NavigationSmallButton-NavigationSmallButton-u_size7of10-lg{width:70%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of12-lg{width:75%!important}.NavigationSmallButton-NavigationSmallButton-u_size8of10-lg{width:80%!important}.NavigationSmallButton-NavigationSmallButton-u_size10of12-lg{width:83.33333%!important}.NavigationSmallButton-NavigationSmallButton-u_size9of10-lg{width:90%!important}.NavigationSmallButton-NavigationSmallButton-u_size11of12-lg{width:91.66667%!important}}.NavigationSmallButton-NavigationSmallButton-u_sizeHeightFull{height:100%!important}.NavigationSmallButton-NavigationSmallButton-link{display:inline-block;padding:8px 0;text-decoration:none;font-size:1.125em}@media (min-width:1280px){.NavigationSmallButton-NavigationSmallButton-link{padding:3px 20px}}.NavigationSmallButton-NavigationSmallButton-smallMenuButton{color:#000;display:inline-block;background:#005d82;text-align:center;width:16.666%}.NavigationSmallButton-NavigationSmallButton-priviliged{width:20%!important}.NavigationSmallButton-NavigationSmallButton-nodevice{width:25%!important}.NavigationSmallButton-NavigationSmallButton-active{background:#033f57!important}.NavigationSmallButton-NavigationSmallButton-spirotech{background:#fae03a!important}.NavigationSmallButton-NavigationSmallButton-spirotechActive{background:#facc3a!important}", ""]);

// exports
exports.locals = {
	"u_sizeFit": "NavigationSmallButton-NavigationSmallButton-u_sizeFit",
	"u_sizeFill": "NavigationSmallButton-NavigationSmallButton-u_sizeFill",
	"u_sizeFull": "NavigationSmallButton-NavigationSmallButton-u_sizeFull",
	"u_sizeAuto": "NavigationSmallButton-NavigationSmallButton-u_sizeAuto",
	"u_size1of12": "NavigationSmallButton-NavigationSmallButton-u_size1of12",
	"u_size1of10": "NavigationSmallButton-NavigationSmallButton-u_size1of10",
	"u_size2of12": "NavigationSmallButton-NavigationSmallButton-u_size2of12",
	"u_size2of10": "NavigationSmallButton-NavigationSmallButton-u_size2of10",
	"u_size3of12": "NavigationSmallButton-NavigationSmallButton-u_size3of12",
	"u_size3of10": "NavigationSmallButton-NavigationSmallButton-u_size3of10",
	"u_size4of12": "NavigationSmallButton-NavigationSmallButton-u_size4of12",
	"u_size3of8": "NavigationSmallButton-NavigationSmallButton-u_size3of8",
	"u_size4of10": "NavigationSmallButton-NavigationSmallButton-u_size4of10",
	"u_size5of12": "NavigationSmallButton-NavigationSmallButton-u_size5of12",
	"u_size5of10": "NavigationSmallButton-NavigationSmallButton-u_size5of10",
	"u_size6of12": "NavigationSmallButton-NavigationSmallButton-u_size6of12",
	"size5of10": "NavigationSmallButton-NavigationSmallButton-size5of10",
	"size6of12": "NavigationSmallButton-NavigationSmallButton-size6of12",
	"u_size7of12": "NavigationSmallButton-NavigationSmallButton-u_size7of12",
	"u_size6of10": "NavigationSmallButton-NavigationSmallButton-u_size6of10",
	"u_size8of12": "NavigationSmallButton-NavigationSmallButton-u_size8of12",
	"u_size7of10": "NavigationSmallButton-NavigationSmallButton-u_size7of10",
	"u_size9of12": "NavigationSmallButton-NavigationSmallButton-u_size9of12",
	"u_size8of10": "NavigationSmallButton-NavigationSmallButton-u_size8of10",
	"u_size10of12": "NavigationSmallButton-NavigationSmallButton-u_size10of12",
	"u_size9of10": "NavigationSmallButton-NavigationSmallButton-u_size9of10",
	"u_size11of12": "NavigationSmallButton-NavigationSmallButton-u_size11of12",
	"u_sizeFull@sm": "NavigationSmallButton-NavigationSmallButton-u_sizeFull-sm",
	"u_sizeAuto@sm": "NavigationSmallButton-NavigationSmallButton-u_sizeAuto-sm",
	"u_size1of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size1of12-sm",
	"u_size1of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size1of10-sm",
	"u_size2of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size2of12-sm",
	"u_size2of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size2of10-sm",
	"u_size3of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size3of12-sm",
	"u_size3of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size3of10-sm",
	"u_size4of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size4of12-sm",
	"u_size3of8@sm": "NavigationSmallButton-NavigationSmallButton-u_size3of8-sm",
	"u_size4of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size4of10-sm",
	"u_size5of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size5of12-sm",
	"u_size5of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size5of10-sm",
	"u_size6of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size6of12-sm",
	"u_size7of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size7of12-sm",
	"u_size6of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size6of10-sm",
	"u_size8of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size8of12-sm",
	"u_size9of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size9of12-sm",
	"u_size8of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size8of10-sm",
	"u_size10of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size10of12-sm",
	"u_size9of10@sm": "NavigationSmallButton-NavigationSmallButton-u_size9of10-sm",
	"u_size11of12@sm": "NavigationSmallButton-NavigationSmallButton-u_size11of12-sm",
	"u_sizeFull@md": "NavigationSmallButton-NavigationSmallButton-u_sizeFull-md",
	"u_sizeAuto@md": "NavigationSmallButton-NavigationSmallButton-u_sizeAuto-md",
	"u_size1of12@md": "NavigationSmallButton-NavigationSmallButton-u_size1of12-md",
	"u_size1of10@md": "NavigationSmallButton-NavigationSmallButton-u_size1of10-md",
	"u_size2of12@md": "NavigationSmallButton-NavigationSmallButton-u_size2of12-md",
	"u_size2of10@md": "NavigationSmallButton-NavigationSmallButton-u_size2of10-md",
	"u_size3of12@md": "NavigationSmallButton-NavigationSmallButton-u_size3of12-md",
	"u_size3of10@md": "NavigationSmallButton-NavigationSmallButton-u_size3of10-md",
	"u_size4of12@md": "NavigationSmallButton-NavigationSmallButton-u_size4of12-md",
	"u_size3of8@md": "NavigationSmallButton-NavigationSmallButton-u_size3of8-md",
	"u_size4of10@md": "NavigationSmallButton-NavigationSmallButton-u_size4of10-md",
	"u_size5of12@md": "NavigationSmallButton-NavigationSmallButton-u_size5of12-md",
	"u_size5of10@md": "NavigationSmallButton-NavigationSmallButton-u_size5of10-md",
	"u_size6of12@md": "NavigationSmallButton-NavigationSmallButton-u_size6of12-md",
	"u_size7of12@md": "NavigationSmallButton-NavigationSmallButton-u_size7of12-md",
	"u_size6of10@md": "NavigationSmallButton-NavigationSmallButton-u_size6of10-md",
	"u_size8of12@md": "NavigationSmallButton-NavigationSmallButton-u_size8of12-md",
	"u_size7of10@md": "NavigationSmallButton-NavigationSmallButton-u_size7of10-md",
	"u_size9of12@md": "NavigationSmallButton-NavigationSmallButton-u_size9of12-md",
	"u_size8of10@md": "NavigationSmallButton-NavigationSmallButton-u_size8of10-md",
	"u_size10of12@md": "NavigationSmallButton-NavigationSmallButton-u_size10of12-md",
	"u_size9of10@md": "NavigationSmallButton-NavigationSmallButton-u_size9of10-md",
	"u_size11of12@md": "NavigationSmallButton-NavigationSmallButton-u_size11of12-md",
	"u_sizeFull@lg": "NavigationSmallButton-NavigationSmallButton-u_sizeFull-lg",
	"u_sizeAuto@lg": "NavigationSmallButton-NavigationSmallButton-u_sizeAuto-lg",
	"u_size1of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size1of12-lg",
	"u_size1of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size1of10-lg",
	"u_size2of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size2of12-lg",
	"u_size2of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size2of10-lg",
	"u_size3of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size3of12-lg",
	"u_size3of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size3of10-lg",
	"u_size4of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size4of12-lg",
	"u_size3of8@lg": "NavigationSmallButton-NavigationSmallButton-u_size3of8-lg",
	"u_size4of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size4of10-lg",
	"u_size5of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size5of12-lg",
	"u_size5of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size5of10-lg",
	"u_size6of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size6of12-lg",
	"u_size7of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size7of12-lg",
	"u_size6of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size6of10-lg",
	"u_size8of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size8of12-lg",
	"u_size7of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size7of10-lg",
	"u_size9of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size9of12-lg",
	"u_size8of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size8of10-lg",
	"u_size10of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size10of12-lg",
	"u_size9of10@lg": "NavigationSmallButton-NavigationSmallButton-u_size9of10-lg",
	"u_size11of12@lg": "NavigationSmallButton-NavigationSmallButton-u_size11of12-lg",
	"u_sizeHeightFull": "NavigationSmallButton-NavigationSmallButton-u_sizeHeightFull",
	"link": "NavigationSmallButton-NavigationSmallButton-link",
	"smallMenuButton": "NavigationSmallButton-NavigationSmallButton-smallMenuButton",
	"priviliged": "NavigationSmallButton-NavigationSmallButton-priviliged",
	"nodevice": "NavigationSmallButton-NavigationSmallButton-nodevice",
	"active": "NavigationSmallButton-NavigationSmallButton-active",
	"spirotech": "NavigationSmallButton-NavigationSmallButton-spirotech",
	"spirotechActive": "NavigationSmallButton-NavigationSmallButton-spirotechActive"
};

/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3ccd232.png";

/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "118ef9c0.png";

/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec998f9c.png";

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1116);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Footer.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".Footer-Footer-root{background:#005d82;color:#fff;position:fixed;left:0;bottom:0;width:100%;z-index:1005}.Footer-Footer-spirotech{background-color:#fae03a;color:#000}.Footer-Footer-container{margin:0 auto;padding:10px 15px;max-width:1200px;text-align:center}.Footer-Footer-text{color:hsla(0,0%,100%,.5)}.Footer-Footer-spacer{color:hsla(0,0%,100%,.3)}.Footer-Footer-link,.Footer-Footer-text{padding:2px 5px;font-size:1em}.Footer-Footer-link,.Footer-Footer-link:active,.Footer-Footer-link:visited{color:hsla(0,0%,100%,.6);text-decoration:none}.Footer-Footer-link:hover{color:#fff}.Footer-Footer-link_spirotech{color:#000!important}", ""]);

// exports
exports.locals = {
	"root": "Footer-Footer-root",
	"spirotech": "Footer-Footer-spirotech",
	"container": "Footer-Footer-container",
	"text": "Footer-Footer-text",
	"spacer": "Footer-Footer-spacer",
	"link": "Footer-Footer-link",
	"link_spirotech": "Footer-Footer-link_spirotech"
};

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1454);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./PrivacyPages.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./PrivacyPages.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(70);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(79);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(855);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(477);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(80);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js
var index_es = __webpack_require__(101);

// EXTERNAL MODULE: ./src/components/PrivacyPages/PrivacyPages.css
var PrivacyPages = __webpack_require__(1411);
var PrivacyPages_default = /*#__PURE__*/__webpack_require__.n(PrivacyPages);

// EXTERNAL MODULE: ./src/constants/websites.js
var websites = __webpack_require__(935);

// CONCATENATED MODULE: ./src/components/PrivacyPages/Messages.js


function Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    spirotech_user_agreement_part1: {
      'id': 'spirotech_user_agreement_part1',
      'defaultMessage': 'I consent to having my personal data contained in the registration form processed as stated in the posted'
    },
    spirotech_user_agreement_part2: {
      'id': 'spirotech_user_agreement_part2',
      'defaultMessage': 'privacy statement'
    },
    spirotech_privacy_introduce_part1: {
      'id': 'spirotech_privacy_introduce_part1',
      'defaultMessage': 'The controller of your personal data, provided by you during registration on the website: https://i-connect.spirotech.com (hereinafter \u201CWebsite\u201D), is Husty M.Stycze\u0144, J.Hupert sp. j. (hereinafter \u201CHusty\u201D).'
    },
    spirotech_privacy_introduce_part2: {
      'id': 'spirotech_privacy_introduce_part2',
      'defaultMessage': 'Husty takes the protection of your privacy very seriously. We therefore handle your personal data confidentially and with the greatest possible care.'
    },
    spirotech_privacy_introduce_part3: {
      'id': 'spirotech_privacy_introduce_part3',
      'defaultMessage': 'This Privacy Policy applies to all personal data that are collected and used by Husty. These data are customer data provided by you, but also data concerning visits to the Website.'
    },
    spirotech_privacy_introduce_part4: {
      'id': 'spirotech_privacy_introduce_part4',
      'defaultMessage': 'Husty only uses your data if you consent or if Husty needs your data to deliver products or services to you or has already done so. Husty does not sell your personal data to third parties. Husty only makes the data available to third parties involved in the performance of the agreement between Husty and yourself. If and when Husty processes your data in any other way, such will require your (express) consent.'
    },
    spirotech_privacy_contact_part1: {
      'id': 'spirotech_privacy_contact_part1',
      'defaultMessage': 'Our contact details are:'
    },
    spirotech_privacy_contact_part2: {
      'id': 'spirotech_privacy_contact_part2',
      'defaultMessage': 'HUSTY M. Stycze\u0144, J.Hupert sp.j.'
    },
    spirotech_privacy_contact_part3: {
      'id': 'spirotech_privacy_contact_part3',
      'defaultMessage': 'ul.Rzepakowa 5E'
    },
    spirotech_privacy_contact_part4: {
      'id': 'spirotech_privacy_contact_part4',
      'defaultMessage': '31-989 Krak\xF3w, Poland'
    },
    spirotech_privacy_point_1_text: {
      'id': 'spirotech_privacy_point_1_text',
      'defaultMessage': 'General'
    },
    spirotech_privacy_point_1: {
      'id': 'spirotech_privacy_point_1',
      'defaultMessage': 'The protection of your personal data is very important to us. That is why we comply strictly with the rules that apply to data protection as well as telemedia legislation. Our employees commit that they will comply with the data protection regulations when handling your personal data. We wish to inform you by means of this privacy statement of the nature, scope and purpose of the collection, processing and use of personal data, as well as your rights. The term personal data is defined in the EU General Data Protection Regulation (GDPR). According to this regulation, personal data concerns all information with respect to an identified or identifiable natural person. This includes for example your name, your address, your telephone number and your e-mail address'
    },
    spirotech_privacy_point_2_text: {
      'id': 'spirotech_privacy_point_2_text',
      'defaultMessage': 'Collection, processing and use of personal data'
    },
    spirotech_privacy_point_2: {
      'id': 'spirotech_privacy_point_2',
      'defaultMessage': 'Husty collects, processes and uses personal data insofar as the EU GDPR or another statutory provision permits or requires this or if the person involved has consented thereto. We wish to inform you that providing personal data such as name, surname and e-mail address is voluntary, but necessary to register in our service. The legal basis for processing the personal data is article 6 (1)(a) EU GDPR. We refer to the fact that unencrypted data transfer on the internet, such as communication by e-mail, may result in security issues. Complete protection of the data against third-party access is impossible.'
    },
    spirotech_privacy_point_3_text: {
      'id': 'spirotech_privacy_point_3_text',
      'defaultMessage': 'Transfer of data to third parties'
    },
    spirotech_privacy_point_3: {
      'id': 'spirotech_privacy_point_3',
      'defaultMessage': 'Husty does not sell or provide your personal data to third parties and only makes these data available to third parties that are involved in the provision of the agreed services. Our employees and hired third parties are obliged to respect the confidentiality of your data. We wish to inform you that we do not transfer your personal data outside the EU.'
    },
    spirotech_privacy_point_4_text: {
      'id': 'spirotech_privacy_point_4_text',
      'defaultMessage': 'Data retention'
    },
    spirotech_privacy_point_4: {
      'id': 'spirotech_privacy_point_4',
      'defaultMessage': 'Husty retains your personal data for as long as this is necessary to provide our services. If you decide to stop using our services, we will remove your personal data at your request. Please bear in mind that a copy of these data may be stored in back-ups.'
    },
    spirotech_privacy_point_5_text: {
      'id': 'spirotech_privacy_point_5_text',
      'defaultMessage': 'Information, correction and objection'
    },
    spirotech_privacy_point_5: {
      'id': 'spirotech_privacy_point_5',
      'defaultMessage': 'You have the right to request information concerning the personal data stored by us and to have these corrected or removed. What is more, you can withdraw your consent to future use of your data at any time or request that your data be transferred to another provider. An e-mail to the following address is sufficient: info@husty.com. You also have the right to submit a complaint to the supervising data protection authority.'
    },
    spirotech_privacy_point_6_text: {
      'id': 'spirotech_privacy_point_6_text',
      'defaultMessage': 'Changes to this Privacy Policy'
    },
    spirotech_privacy_point_6: {
      'id': 'spirotech_privacy_point_6',
      'defaultMessage': 'This Privacy Policy may be updated as a result of changes to the applicable legislation or as a result of changes within our business or our services. We will announce any adjustments via this page. We therefore recommend that you read the Privacy Policy regularly in order to stay informed. In the event we implement changes that have a significant impact on you, we will inform you thereof by sending an e-mail message or via our services for example.'
    },
    spirotech_cookie_part_1_text: {
      'id': 'spirotech_cookie_part_1_text',
      'defaultMessage': 'Cookie Statement'
    },
    spirotech_cookie_part_1: {
      'id': 'spirotech_cookie_part_1',
      'defaultMessage': 'The Website, as a part of domain: https://www.spirotech.com/, is the property of Spirotech bv (hereinafter \u201CSpirotech\u201D). The Website uses cookies. A cookie is a text file that is sent when visiting a website as a visitor and that is stored in the cache of the hard drive of your computer. The browser of your computer sends the cookie received previously back to the server if you as a visitor to the website connect again to the relevant server of the website. If this is the case, the server will be able to evaluate the information obtained by means of this procedure in various ways. Cookies may be used to send advertisements or facilitate navigation to a website for example. If you as the user of the website wish to prevent cookies from being used, you can realise this by changing the local browser settings, which means in the program on the device for opening and showing websites (such as Internet Explorer, Mozilla Firefox, Chrome or Safari).'
    },
    spirotech_cookie_part_1a: {
      'id': 'spirotech_cookie_part_1a',
      'defaultMessage': 'The Website uses the following three types of cookies:'
    },
    spirotech_cookie_part_2_text: {
      'id': 'spirotech_cookie_part_2_text',
      'defaultMessage': 'Functional and necessary cookies'
    },
    spirotech_cookie_part_2: {
      'id': 'spirotech_cookie_part_2',
      'defaultMessage': 'Some cookies are necessary for the correct operation of The Website. We use these cookies to store your preferences. These are cookies that are used to recognise you as soon as you have registered. This means that you do not have to enter your username and/or password each time you visit The Website and we will be certain that you have the right to visit and modify secure areas of The Website such as your personal data.'
    },
    spirotech_cookie_part_3_text: {
      'id': 'spirotech_cookie_part_3_text',
      'defaultMessage': 'Social media and external cookies'
    },
    spirotech_cookie_part_3: {
      'id': 'spirotech_cookie_part_3',
      'defaultMessage': 'ou can make use of additional functionalities if you have logged into social network sites (Facebook, Google, etc.) and have consented to this category of cookies on the The Website. These functionalities include the simple sharing of information via Facebook Like, Google+, Twitter etc. Review the policy of the social media companies for the cookies they place and the possible data they collect when doing so. Bear in mind that this policy may change on a regular basis. This is beyond Husty\u2019s control.'
    },
    spirotech_cookie_part_4_text: {
      'id': 'spirotech_cookie_part_4_text',
      'defaultMessage': 'Optimisation and relevance of cookies'
    },
    spirotech_cookie_part_4: {
      'id': 'spirotech_cookie_part_4',
      'defaultMessage': 'We also use cookies to collect information. This information shows us which pages are visited most often, which pages work well, and which pages display error messages. We use this information to improve the ease of use of The Website.'
    },
    spirotech_cookie_part_5_text: {
      'id': 'spirotech_cookie_part_5_text',
      'defaultMessage': 'Google Analytics'
    },
    spirotech_cookie_part_5: {
      'id': 'spirotech_cookie_part_5',
      'defaultMessage': 'The Website also uses Analytics cookies placed by Google Analytics to measure the number of visits and the sections of the website that are most popular among the visitors to the website. This information is used for aggregated and statistical information concerning the use of our website and is used to improve the content of our website for a better user experience. The Website also uses Analytics cookies to measure your experience of our website and to be able to measures the effectiveness of e-mail campaigns, advertisements of Adwords on other, third-party websites. Husty uses Google Analytics in a privacy-friendly manner. Among other things, Spirotech as the owner of the domain, concluded a processing agreement that obliges Google Analytics to use data exclusively for the abovementioned analysis purposes, to remove the last 4 digits of your IP address and to oblige Google to use the data separately from their other services.'
    },
    husty_user_agreement: {
      'id': 'husty_user_agreement',
      'defaultMessage': 'I consent to having my personal data contained in the registration form of SaoCal  water treatment system Internet service processed by Husty M.Stycze\u0144, J.Hupert sp. j. registered in Krakow [ul. Rzepakowa 5E, 31-989 Krak\xF3w, entered in the Register of Entrepreneurs kept by the District Court for Krak\xF3w-\u015Ar\xF3dmie\u015Bcie District in Krakow, 9th Commercial Department of the National Court Register, entry no. KRS 91562, Tax ID No. NIP 6770082043, Business Statistical No. REGON 350690189] for the purpose and to the extent required to complete the registration process in the service and operate the account created in the service.'
    },
    husty_privacy_point_1: {
      'id': 'husty_privacy_point_1',
      'defaultMessage': 'Your personal data administrator is Husty M.Stycze\u0144, J.Hupert sp. j. registered in Krakow [ul. Rzepakowa 5E, 31-989 Krak\xF3w, entered in the Register of Entrepreneurs kept by the District Court for Krak\xF3w-\u015Ar\xF3dmie\u015Bcie District in Krakow, 9th Commercial Department of the National Court Register, entry no. KRS 91562, Tax ID No. NIP 6770082043, Business Statistical No. REGON 350690189 (\u201Cthe Administrator\u201D)]; the Administrator\u2019s contact details: info@husty.pl  Tel. +48(012) 645-03-04; fax +48(012) 645-03-33.'
    },
    husty_privacy_point_2: {
      'id': 'husty_privacy_point_2',
      'defaultMessage': 'The Administrator has not appointed the Personal Data Protection Inspector.'
    },
    husty_privacy_point_3: {
      'id': 'husty_privacy_point_3',
      'defaultMessage': 'Be informed that your personal data is processed for the purpose of registration in the Internet Service for SaoCal water treatment systems and for the purpose of keeping your account created in the Service. Your email address given during your registration in the Service is required, in particular, to log into the Service and recover your lost or forgotten password. Furthermore, notifications about devices linked  to your account shall be emailed to your email address.'
    },
    husty_privacy_point_4: {
      'id': 'husty_privacy_point_4',
      'defaultMessage': 'Your personal data is processed on the basis of your voluntarily given consent, constituting the premise legalising personal data processing in accordance with the provisions of art. 6 item 1a of the Regulation (EU) on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (General Data Protection Regulation - the GDPR).'
    },
    husty_privacy_point_5: {
      'id': 'husty_privacy_point_5',
      'defaultMessage': 'It is a contractual requirement to have your personal data in the Internet Service. You are not obligated to enter or otherwise give us your personal data; however, it is not possible to register in the Internet Service operated for SaoCal water treatment systems without entering your personal data.'
    },
    husty_privacy_point_6: {
      'id': 'husty_privacy_point_6',
      'defaultMessage': 'Your personal data entered in the registration form shall be transferred to hosting companies responsible for ensuring appropriate and adequate technological and organisational measures in place as required by the GDPR. Neither the Administrator nor the hosting companies working with the Administrator shall hand over, transfer or otherwise make your data available to any third countries (i.e. any countries outside the European Union).'
    },
    husty_privacy_point_7: {
      'id': 'husty_privacy_point_7',
      'defaultMessage': 'Your personal data shall be kept for the duration of your keeping your account in the Internet Service for the SaoCal water treatment system and removed without a delay after your account is closed or removed.'
    },
    husty_privacy_point_8: {
      'id': 'husty_privacy_point_8',
      'defaultMessage': 'Be informed that you have the right to:'
    },
    husty_privacy_point_8_a: {
      'id': 'husty_privacy_point_8_a',
      'defaultMessage': 'request access to your personal data from the Administrator;'
    },
    husty_privacy_point_8_b: {
      'id': 'husty_privacy_point_8_b',
      'defaultMessage': 'when the personal data processed by the Administrator is incorrect, you have the right to correct, change, amend or modify it;'
    },
    husty_privacy_point_8_c: {
      'id': 'husty_privacy_point_8_c',
      'defaultMessage': 'in the case when the Administrator does not need your personal data for the purpose for which it has been collected as well as when the data should be removed to comply with applicable laws or the data has been collected further to provision of services offered electronically to a child, you have the right to request removal of your personal data by the Administrator;'
    },
    husty_privacy_point_8_d: {
      'id': 'husty_privacy_point_8_d',
      'defaultMessage': 'in case when you question correctness of the personal data processed by the Administrator, you may request to have its processing limited for the period allowing the Administrator to verify correctness of the data;'
    },
    husty_privacy_point_8_e: {
      'id': 'husty_privacy_point_8_e',
      'defaultMessage': 'except for the case specified in let. d) above, you have the right to limiting personal data processing when the personal data is unlawfully processed by the Administrator but you refuse to have it removed or when the Administrator does not need your personal data for the purpose of its processing but you need the data for the purpose of pursuing claims or defence.'
    },
    husty_privacy_point_8_f: {
      'id': 'husty_privacy_point_8_f',
      'defaultMessage': 'to request a transfer of you personal data which you may specify.'
    },
    field_max_length_25: {
      'id': 'field_max_length_25',
      'defaultMessage': 'Field must be a maximum 25 characters length'
    },
    husty_cookie_part_1: {
      'id': 'husty_cookie_part_1',
      'defaultMessage': 'Cookies files are IT data, in particular text files, kept in the end device of the Service User and designated for using the Service websites. Typically, cookies include the name of the website of their origin, the period/duration of their keeping on the end device and their unique number.'
    },
    husty_cookie_part_2: {
      'id': 'husty_cookie_part_2',
      'defaultMessage': 'The entity introducing and storing cookies on the end device of the Service User and having access to the cookies is HUSTY, registered in Krakow, ul.Rzepakowa 5E, 31-989 Krak\xF3w'
    },
    husty_cookie_part_3: {
      'id': 'husty_cookie_part_3',
      'defaultMessage': 'Cookies are used for the purpose of collecting information about the use the Service by the User. In particular, cookies make it possible:'
    },
    husty_cookie_part_3_1: {
      'id': 'husty_cookie_part_3_1',
      'defaultMessage': 'To keep a session of the Service User (once logged in) open - the User does not need to log into each Service page again by entering his login and password;'
    },
    husty_cookie_part_3_2: {
      'id': 'husty_cookie_part_3_2',
      'defaultMessage': 'Adapt the content of the Service website to the User\u2019s preferences and optimise the use of websites; in particular, the files allow for identifying the User\u2019s device and display the website in the right display mode as needed by the User;'
    },
    husty_cookie_part_3_3: {
      'id': 'husty_cookie_part_3_3',
      'defaultMessage': 'To generate the statistics helpful in understanding the pattern of website browsing and using by the Service User in order to improve its structure and content.'
    },
    husty_cookie_part_4: {
      'id': 'husty_cookie_part_4',
      'defaultMessage': 'Two basic types of cookies are used in the Service: session cookies and persistent cookies. Session cookies are temporary files stored in the end device of the Service User until they log out leaving the website or shutting down the software (the Internet browser). Persistent cookies are stored in the User\u2019s end device for the time specified in the parameters of the cookies or until they are removed by the User.'
    },
    husty_cookie_part_5: {
      'id': 'husty_cookie_part_5',
      'defaultMessage': 'The following types of cookies are used in the Service:'
    },
    husty_cookie_part_5_1: {
      'id': 'husty_cookie_part_5_1',
      'defaultMessage': '\u201Cnecessary\u201D cookies which make it possible to use services available in the Service e.g. authenticated the cookies used for services which require authentication in the Service;'
    },
    husty_cookie_part_5_2: {
      'id': 'husty_cookie_part_5_2',
      'defaultMessage': '\u201Cperformance\u201D cookies which make it possible to collect information on the Service websites are used.'
    },
    husty_cookie_part_5_3: {
      'id': 'husty_cookie_part_5_3',
      'defaultMessage': '\u201Cfunctional\u201D cookies which make it possible to \u201Cremember\u201D the settings selected by the User and personalise the User interface.'
    },
    husty_cookie_part_6: {
      'id': 'husty_cookie_part_6',
      'defaultMessage': 'In many cases, the web search software (a web browser), by default, allows for storing cookies in the User\u2019s end device. Service Users may change their cookies settings at any time. In particular, the settings may be changed to block the automatic servicing of the cookies in the Internet browser settings or the Service User is notified about each attempt to add/ insert cookies to their devices. For more information about cookies, their operation and service methods check your Internet software (browser) settings.'
    },
    husty_cookie_part_7: {
      'id': 'husty_cookie_part_7',
      'defaultMessage': 'Be informed that limitations in the application of cookies may affect certain functionalities available on the Service websites.'
    },
    husty_cookie_part_8: {
      'id': 'husty_cookie_part_8',
      'defaultMessage': 'For more information about cookies, see wszystkoociasteczkach.pl or clik Help section in your Internet browser menu.'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/PrivacyPages/Cookies.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Cookies_Cookies = function (_React$Component) {
  _inherits(Cookies, _React$Component);

  function Cookies() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cookies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cookies.__proto__ || Object.getPrototypeOf(Cookies)).call.apply(_ref, [this].concat(args))), _this), _this.renderCommon = function (messages) {
      return _jsx('div', {
        className: PrivacyPages_default.a.wrapper
      }, void 0, _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_1)), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_2)), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_3)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_3_1)), _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_3_2)), _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_3_3))), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_4)), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_5)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_5_1)), _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_5_2)), _jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_5_3))), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_6)), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_7)), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_cookie_part_8))));
    }, _this.renderSpirotech = function (messages) {
      return _jsx('div', {
        className: PrivacyPages_default.a.wrapper
      }, void 0, _jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_1)), _jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_1a)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_2_text)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_2))), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_3_text)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_3))), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_4_text)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_4))), _jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_5_text)), _jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, _jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_cookie_part_5)))));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cookies, [{
    key: 'render',
    value: function render() {
      var messages = Messages();
      var hostname = this.props.hostname;

      switch (hostname) {
        case websites["a" /* ILEXCONNECT_URL */]:
          return this.renderCommon(messages);
        case websites["b" /* SPIROTECH_URL */]:
        case websites["c" /* TEST_SPIROTECH_URL */]:
          return this.renderSpirotech(messages);
        default:
          return this.renderSpirotech(messages);
      }
    }
  }]);

  return Cookies;
}(react_default.a.Component);

Cookies_Cookies.defaultProps = {
  hostname: ''
};

/* harmony default export */ var PrivacyPages_Cookies = (withStyles_default()(PrivacyPages_default.a)(Cookies_Cookies));
// CONCATENATED MODULE: ./src/components/PrivacyPages/GDPR.js
var GDPR__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var GDPR__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GDPR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GDPR__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GDPR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var GDPR_GDPR = function (_React$Component) {
  GDPR__inherits(GDPR, _React$Component);

  function GDPR() {
    var _ref;

    var _temp, _this, _ret;

    GDPR__classCallCheck(this, GDPR);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = GDPR__possibleConstructorReturn(this, (_ref = GDPR.__proto__ || Object.getPrototypeOf(GDPR)).call.apply(_ref, [this].concat(args))), _this), _this.renderCommon = function (messages) {
      return GDPR__jsx('div', {
        className: PrivacyPages_default.a.wrapper
      }, void 0, GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_1)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_2)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_3)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_4)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_5)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_6)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_7)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_1)), GDPR__jsx('li', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8)), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8_a)), GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8_b)), GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8_c)), GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8_d)), GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_characters
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.husty_privacy_point_8_f)))));
    }, _this.renderSpirotech = function (messages) {
      return GDPR__jsx('div', {
        className: PrivacyPages_default.a.wrapperSpirotech
      }, void 0, GDPR__jsx('div', {}, void 0, GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_introduce_part1)), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_introduce_part2)), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_introduce_part3)), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_introduce_part4))), GDPR__jsx('div', {}, void 0, GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_contact_part1))), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_contact_part2)), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_contact_part3)), GDPR__jsx('p', {
        className: PrivacyPages_default.a.introduce
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_contact_part4))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_1_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_1))), GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_2_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_2))), GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_3_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_3))), GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_4_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_4))), GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_5_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_5))), GDPR__jsx('li', {}, void 0, GDPR__jsx('b', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_6_text))), GDPR__jsx('ul', {
        className: PrivacyPages_default.a.test_ul
      }, void 0, GDPR__jsx('li', {
        className: PrivacyPages_default.a.list_none
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.spirotech_privacy_point_6)))));
    }, _temp), GDPR__possibleConstructorReturn(_this, _ret);
  }

  GDPR__createClass(GDPR, [{
    key: 'render',
    value: function render() {
      var messages = Messages();
      var hostname = this.props.hostname;
      // const hostname = TEST_SPIROTECH_URL;

      switch (hostname) {
        case websites["a" /* ILEXCONNECT_URL */]:
          return this.renderCommon(messages);
        case websites["b" /* SPIROTECH_URL */]:
        case websites["c" /* TEST_SPIROTECH_URL */]:
          return this.renderSpirotech(messages);
        default:
          return this.renderCommon(messages);
      }
    }
  }]);

  return GDPR;
}(react_default.a.Component);

GDPR_GDPR.defaultProps = {
  hostname: ''
};

/* harmony default export */ var PrivacyPages_GDPR = (withStyles_default()(PrivacyPages_default.a)(GDPR_GDPR));
// CONCATENATED MODULE: ./src/components/PrivacyPages/PrivacyPagesView.js
var PrivacyPagesView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











function PrivacyPagesView(props) {
  var page = props.page,
      runtime = props.runtime;

  var hostname = runtime.hostname;

  switch (page) {
    case 'cookies':
      return PrivacyPagesView__jsx(PrivacyPages_Cookies, {
        hostname: hostname
      });
    case 'gdpr':
      return PrivacyPagesView__jsx(PrivacyPages_GDPR, {
        hostname: hostname
      });
    default:
      return null;
  }
}

PrivacyPagesView.defaultProps = {
  company: ''
};

var mapState = function mapState(state) {
  return {
    runtime: state.runtime
  };
};

/* harmony default export */ var PrivacyPages_PrivacyPagesView = __webpack_exports__["a"] = (Object(redux_es["compose"])(withStyles_default()(PrivacyPages_default.a), Object(es["b" /* connect */])(mapState, null))(PrivacyPagesView));

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(857)(false);
// imports


// module
exports.push([module.i, ".PrivacyPages-PrivacyPages-wrapper{padding:40px 20px;background:#0376a3}.PrivacyPages-PrivacyPages-wrapperSpirotech{padding:40px 20px;background:#fae04e}.PrivacyPages-PrivacyPages-test_ul{padding-left:3em;margin-left:0;background-color:#fff;margin:0}.PrivacyPages-PrivacyPages-test_ul li{list-style-type:decimal;padding:5px}.PrivacyPages-PrivacyPages-list_characters{list-style-type:lower-alpha}.PrivacyPages-PrivacyPages-list_none{list-style-type:none}.PrivacyPages-PrivacyPages-introduce{padding:10px 20px;margin:0;background-color:#fff}", ""]);

// exports
exports.locals = {
	"wrapper": "PrivacyPages-PrivacyPages-wrapper",
	"wrapperSpirotech": "PrivacyPages-PrivacyPages-wrapperSpirotech",
	"test_ul": "PrivacyPages-PrivacyPages-test_ul",
	"list_characters": "PrivacyPages-PrivacyPages-list_characters",
	"list_none": "PrivacyPages-PrivacyPages-list_none",
	"introduce": "PrivacyPages-PrivacyPages-introduce"
};

/***/ }),

/***/ 1828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(70);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 82 modules
var Layout = __webpack_require__(948);

// EXTERNAL MODULE: ./src/components/PrivacyPages/PrivacyPagesView.js + 3 modules
var PrivacyPagesView = __webpack_require__(1453);

// CONCATENATED MODULE: ./src/routes/gdpr/Gdpr.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var _ref = _jsx(PrivacyPagesView["a" /* default */], {
  page: 'gdpr'
});

function Gdpr(props) {
  return _ref;
}

/* harmony default export */ var gdpr_Gdpr = (Gdpr);
// CONCATENATED MODULE: ./src/routes/gdpr/index.js
var gdpr__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var title = 'GDPR';

var gdpr__ref = gdpr__jsx(Layout["a" /* default */], {
  loggedOut: true
}, void 0, gdpr__jsx(gdpr_Gdpr, {}));

function action(context) {
  return {
    chunks: ['gdpr'],
    title: title,
    component: gdpr__ref
  };
}

/* harmony default export */ var gdpr = __webpack_exports__["default"] = (action);

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(949);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(954);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(955);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(959);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(983);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(70);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(79);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(484);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.removeCss = this.context.insertCss.apply(undefined, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          setTimeout(this.removeCss, 0);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 857:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(991);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(993);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["r"] = setDeviceCommandValue;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateDeviceCommandValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearWorkHistoryPage;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearErrorHistoryPage;
/* harmony export (immutable) */ __webpack_exports__["z"] = setScreenNextPreviousPage;
/* harmony export (immutable) */ __webpack_exports__["y"] = setScreen;
/* harmony export (immutable) */ __webpack_exports__["B"] = setUserData;
/* harmony export (immutable) */ __webpack_exports__["u"] = setPopupNotAvailable;
/* harmony export (immutable) */ __webpack_exports__["i"] = getLiveFakeDeviceData;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearDeviceUserData;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDeviceInfo;
/* unused harmony export getDeviceDetail */
/* harmony export (immutable) */ __webpack_exports__["h"] = getLiveDeviceData;
/* harmony export (immutable) */ __webpack_exports__["f"] = editDevice;
/* harmony export (immutable) */ __webpack_exports__["n"] = saveDeviceData;
/* harmony export (immutable) */ __webpack_exports__["o"] = saveInstallationData;
/* harmony export (immutable) */ __webpack_exports__["m"] = resetConnectedDevice;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeOwnership;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeProtectedInstallation;
/* harmony export (immutable) */ __webpack_exports__["j"] = getOwnership;
/* harmony export (immutable) */ __webpack_exports__["t"] = setOwnershipEmails;
/* harmony export (immutable) */ __webpack_exports__["p"] = saveOwnership;
/* harmony export (immutable) */ __webpack_exports__["A"] = setSearchQuery;
/* harmony export (immutable) */ __webpack_exports__["s"] = setLeftArrow;
/* harmony export (immutable) */ __webpack_exports__["x"] = setRightArrow;
/* harmony export (immutable) */ __webpack_exports__["w"] = setPowerPopup;
/* harmony export (immutable) */ __webpack_exports__["C"] = setWarningPopup;
/* harmony export (immutable) */ __webpack_exports__["q"] = setAlarmPopup;
/* harmony export (immutable) */ __webpack_exports__["v"] = setPowerDown;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearWarning;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearAlarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_urls__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(6);
/* eslint-disable import/prefer-default-export */







function setDeviceCommandValue(deviceid, command, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_34" /* SET_DEVICE_COMMAND_VALUE */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/set', {
      deviceid: deviceid,
      command: command,
      value: value
    })
  };
}

function updateDeviceCommandValue(deviceid, command, value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_67" /* UPDATE_DEVICE_COMMAND_VALUE */],
    devicetype: devicetype,
    command: command,
    value: value
  };
}

function clearWorkHistoryPage(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["p" /* CLEAR_WORK_HISTORY_PAGE */],
    devicetype: devicetype
  };
}
function clearErrorHistoryPage(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* CLEAR_ERROR_HISTORY_PAGE */],
    devicetype: devicetype
  };
}

function setScreenNextPreviousPage(screen, value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_25" /* SET_COMMON_SCREEN_NEXT_PREVIOUS_PAGE */],
    screen: screen,
    value: value,
    devicetype: devicetype
  };
}

function setScreen(screen, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_20" /* SET_COMMON_DEVICE_SCREEN */],
    screen: screen,
    devicetype: devicetype
  };
}

function setUserData(command, value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_26" /* SET_COMMON_USER_DATA */],
    command: command,
    value: value,
    devicetype: devicetype
  };
}

function setPopupNotAvailable(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_22" /* SET_COMMON_POPUP_NOTAVAILABLE */],
    value: value,
    devicetype: devicetype
  };
}

function getLiveFakeDeviceData(diff, devicetype) {
  return {
    type: 'GET_FAKE_COMMON_LIVE_DEVICE_DATA',
    devicetype: devicetype,
    diff: diff
  };
}

function clearDeviceUserData(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CLEAR_DEVICE_USER_DATA */],
    devicetype: devicetype
  };
}

/* eslint-disable import/prefer-default-export */

function getDeviceInfo(deviceId, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* GET_COMMON_DEVICE_INFO */],
    devicetype: devicetype,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceId)
  };
}

function getDeviceDetail(deviceid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["E" /* GET_DEVICE_DETAILS */],
    devicetype: devicetype,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceId + '/details')
  };
}

function getLiveDeviceData(deviceId, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* GET_COMMON_LIVE_DEVICE_DATA */],
    devicetype: devicetype,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceId + '/live')
  };
}

function editDevice(deviceid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* EDIT_DEVICE */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/edit')
  };
}

function saveDeviceData(deviceid, data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_4" /* SAVE_DEVICE_DATA */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/edit', data)
  };
}

function saveInstallationData(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_5" /* SAVE_INSTALLATION_DATA */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/installation', data)
  };
}

function resetConnectedDevice(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["Y" /* RESET_CONNECTED_DEVICE */],
    devicetype: devicetype
  };
}

function removeOwnership(deviceid, action) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["U" /* REMOVE_OWNERSHIP */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/ownership', { action: action })
  };
}

function removeProtectedInstallation(installation_id, serial) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* REMOVE_PROTECTED_INSTALLATION */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/installation/' + installation_id, { serial: serial })
  };
}

function getOwnership(deviceid, userType, params) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__["a" /* insertParams */])(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/ownership/role/' + userType, params);
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["M" /* GET_OWNERSHIP */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(url)
  };
}

function setOwnershipEmails(deviceid, alarms) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* SET_OWNERSHIP_EMAILS */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/ownership/email/' + alarms, {})
  };
}

function saveOwnership(deviceid, data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ADD_OWNERSHIP */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__constants_urls__["a" /* default */].API2_URL + '/' + deviceid + '/ownership', data)
  };
}

function setSearchQuery(searchQuery) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* SET_OWNERSHIP_SEARCH_QUERY */],
    searchQuery: searchQuery
  };
}

function setLeftArrow(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_21" /* SET_COMMON_LEFT_ARROW */],
    value: value,
    devicetype: devicetype
  };
}

function setRightArrow(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_24" /* SET_COMMON_RIGHT_ARROW */],
    value: value,
    devicetype: devicetype
  };
}

function setPowerPopup(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_23" /* SET_COMMON_POWER_POPUP */],
    value: value,
    devicetype: devicetype
  };
}

function setWarningPopup(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_27" /* SET_COMMON_WARNING_POPUP */],
    value: value,
    devicetype: devicetype
  };
}

function setAlarmPopup(value, devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_19" /* SET_COMMON_ALARM_POPUP */],
    value: value,
    devicetype: devicetype
  };
}

function setPowerDown(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* SET_POWER_DOWN */],
    devicetype: devicetype
  };
}

function clearWarning(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_18" /* SET_CLEAN_WARNING */],
    devicetype: devicetype
  };
}

function clearAlarm(devicetype) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["_17" /* SET_CLEAN_ALARM */],
    devicetype: devicetype
  };
}

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_css__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function Icon(props) {
  var size = {
    width: props.fullSize ? '100%' : props.size,
    height: props.fullSize ? '100%' : props.size
  };
  var iconName = props.iconName,
      small = props.small;

  var className = small ? __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a.Icon, __WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a.block, __WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a.small, __WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a[iconName]) : __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a.Icon, __WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a.block, __WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a[iconName]);
  return _jsx('div', {
    className: className,
    style: size,
    onClick: props.onClick
  }, void 0, props.children);
}

Icon.defaultProps = {
  size: 41
};


Icon.defaultProps = {
  small: false
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__Icon_css___default.a)(Icon));

/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var _ref = _jsx('g', {
  fill: 'none',
  strokeWidth: '20',
  transform: 'translate(100,100)'
}, void 0, _jsx('path', {
  d: 'M 86.6,-50 A 100,100 0 0,1 86.6,50',
  stroke: 'url(#transparent)'
}), _jsx('path', {
  d: 'M 86.6,50 A 100,100 0 0,1 0,100',
  stroke: 'url(#one)'
}), _jsx('path', {
  d: 'M 0,100 A 100,100 0 0,1 -86.6,50',
  stroke: 'url(#two)'
}), _jsx('path', {
  d: 'M -86.6,50 A 100,100 0 0,1 -86.6,-50',
  stroke: 'url(#three)'
}), _jsx('path', {
  d: 'M -86.6,-50 A 100,100 0 0,1 0,-100',
  stroke: 'url(#four)'
}), _jsx('path', {
  d: 'M 0,-100 A 100,100 0 0,1 86.6,-50',
  stroke: 'url(#five)',
  strokeLinecap: 'round'
}));

function Loader(props) {
  var color = props.light ? '255, 255, 255' : '119, 119, 119';
  var loaderStyles = props.block ? __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.Loader, __WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.Loader__block) : __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.Loader);

  return _jsx('div', {
    className: loaderStyles
  }, void 0, _jsx('svg', {
    className: __WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.Loader_svg,
    xmlns: 'http://www.w3.org/2000/svg',
    version: '1.1',
    viewBox: '-10 -10 220 220'
  }, void 0, _jsx('defs', {}, void 0, _jsx('linearGradient', {
    id: 'transparent',
    gradientUnits: 'objectBoundingBox',
    x1: '0',
    y1: '0',
    x2: '0',
    y2: '1'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 0)',
    stopOpacity: '0'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 0)',
    stopOpacity: '0'
  })), _jsx('linearGradient', {
    id: 'one',
    gradientUnits: 'objectBoundingBox',
    x1: '1',
    y1: '0',
    x2: '0',
    y2: '1'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 0)',
    stopOpacity: '0'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 0.33)'
  })), _jsx('linearGradient', {
    id: 'two',
    gradientUnits: 'objectBoundingBox',
    x1: '1',
    y1: '1',
    x2: '0',
    y2: '0'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 0.33)'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 0.66)'
  })), _jsx('linearGradient', {
    id: 'three',
    gradientUnits: 'objectBoundingBox',
    x1: '0',
    y1: '1',
    x2: '0',
    y2: '0'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 0.66)'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 1)'
  })), _jsx('linearGradient', {
    id: 'four',
    gradientUnits: 'objectBoundingBox',
    x1: '0',
    y1: '1',
    x2: '1',
    y2: '0'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 1)'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 1)'
  })), _jsx('linearGradient', {
    id: 'five',
    gradientUnits: 'objectBoundingBox',
    x1: '0',
    y1: '0',
    x2: '1',
    y2: '1'
  }, void 0, _jsx('stop', {
    offset: '0%',
    stopColor: 'rgba(' + color + ', 1)'
  }), _jsx('stop', {
    offset: '100%',
    stopColor: 'rgba(' + color + ', 1)'
  }))), _ref));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a)(Loader));

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_css__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Button_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var types = ['button', 'reset', 'submit'];

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'renderAnchor',
    value: function renderAnchor(classes) {
      var href = this.props.href || '#';
      return _jsx('a', {
        href: href,
        onClick: this.props.onClick,
        className: classes,
        role: 'button'
      }, void 0, this.props.children);
    }
  }, {
    key: 'renderButton',
    value: function renderButton(classes) {
      return _jsx('button', {
        onClick: this.props.onClick,
        title: this.props.title,
        type: this.props.type || 'button',
        disabled: this.props.disabled ? 'disabled' : null,
        className: classes
      }, void 0, this.props.children);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          buttonClass = _props.buttonClass,
          buttonColor = _props.buttonColor;

      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Button_css___default.a.Button, __WEBPACK_IMPORTED_MODULE_4__Button_css___default.a[buttonClass], __WEBPACK_IMPORTED_MODULE_4__Button_css___default.a[buttonColor]);
      return this[this.props.href ? 'renderAnchor' : 'renderButton'](classes);
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.defaultProps = {
  title: ''
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Button_css___default.a)(Button));

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1067);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Popup.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Popup.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getCommandByScreen;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCheckCommandByScreen;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDeviceType;
/* harmony export (immutable) */ __webpack_exports__["j"] = padNew;
/* unused harmony export changeFromBits */
/* harmony export (immutable) */ __webpack_exports__["b"] = getChlorineGeneratorThreshold;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLinkToDevice;
/* harmony export (immutable) */ __webpack_exports__["g"] = handleBlockDays;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPriviliged;
/* harmony export (immutable) */ __webpack_exports__["h"] = isAdmin;
/* harmony export (immutable) */ __webpack_exports__["f"] = getPayloadId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_roles__ = __webpack_require__(912);






function getCharlieCommandByScreen(screen, number, getSCR) {
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].IWHSCREEN:
      return 'setIWH';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].OWHSCREEN:
      return 'setOWH';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].WATERPRESSURESCREEN:
      return 'setMPR';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].LANGUAGESCREEN:
      return 'setLAN';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].SOUNDSCREENCHARLIE:
      return 'setSND';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].UWHSCREEN:
      return 'setWHU';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].MAINSCREENSALT1:
      return 'setSV1';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].REGENERANTSCREEN:
      return 'setRDO';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RPENUMBERSCREEN:
      if (+getSCR === 1) {
        switch (number) {
          case '1':
            return 'setRPD_months';
          case '2':
            return 'setRPD_days';
          default:
            return screen;
        }
      }
      return 'setRPD';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RPEDAYSSCREEN:
      return 'setRPW';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].REGENERATIONSCREEN:
      return 'setRTY';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].AWUSCREEN:
      return 'setDWF';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RESERVETYPESCREEN:
      return 'setREK';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].CHLORINEGENERATORTHRESHOLDRSCREEN:
      return 'setCGT';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RESERVEPERCENTAGESCREEN:
      return 'setCOR';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].LEAKAGEMAXVOLUMESCREEN:
      return 'setLMV';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].LEAKAGEMAXZEITSCREEN:
      return 'setLMT';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].LEAKAGEPROTECTIONENABLESCREEN:
      return 'setLPE';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].RPENUMBERDISINFECTIONSCREEN:
      return 'setMPD';
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEBACKWASHNODISINFECTIONSCREEN:
      switch (number) {
        case '1':
          return 'setBTM';
        case '2':
          return 'setBTS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEFASTRINSENODISINFECTIONSCREEN:
      switch (number) {
        case '1':
          return 'setFWM';
        case '2':
          return 'setFWS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEBACKWASHSCREEN:
      switch (number) {
        case '1':
          return 'setBDM';
        case '2':
          return 'setBDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEBRINEDRAWSCREEN:
      switch (number) {
        case '1':
          return 'setWDM';
        case '2':
          return 'setWDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POESLOWRINSESCREEN:
      switch (number) {
        case '1':
          return 'setSTM';
        case '2':
          return 'setSTS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEFASTRINSESCREEN:
      switch (number) {
        case '1':
          return 'setFDM';
        case '2':
          return 'setFDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEREFILLSCREEN:
      switch (number) {
        case '1':
          return 'setRDM';
        case '2':
          return 'setRDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants_screentypes_charlie__["a" /* default */].POEPAUSESCREEN:
      switch (number) {
        case '1':
          return 'setPDM';
        case '2':
          return 'setPDS';
        default:
          return screen;
      }
    default:
      return screen;
  }
}

function getSimplexCommandByScreen(screen, number, getSCR) {
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].IWHSCREEN:
      return 'setIWH';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].OWHSCREEN:
      return 'setOWH';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].WATERPRESSURESCREEN:
      return 'setMPR';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].LANGUAGESCREEN:
      return 'setLAN';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].SOUNDSCREEN:
      return 'setSND';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].UWHSCREEN:
      return 'setWHU';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].MAINSCREENSALT1:
      return 'setSV1';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].MAINSCREENKMN04:
      return 'setSV1';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].REGENERANTSCREEN:
      return 'setRDO';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RPENUMBERSCREEN:
      if (+getSCR === 1) {
        switch (number) {
          case '1':
            return 'setRPD_months';
          case '2':
            return 'setRPD_days';
          default:
            return screen;
        }
      }
      return 'setRPD';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RPEDAYSSCREEN:
      return 'setRPW';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].REGENERATIONSCREEN:
      return 'setRTY';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].PRESSURESENSORSCREEN:
      return 'setPST';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].AWUSCREEN:
      return 'setDWF';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RESERVETYPESCREEN:
      return 'setREK';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RESERVEPERCENTAGESCREEN:
      return 'setCOR';

    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].BACKWASHSCREEN:
      switch (number) {
        case '1':
          return 'setBDM';
        case '2':
          return 'setBDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].BRINEDRAWSCREEN:
      switch (number) {
        case '1':
          return 'setWDM';
        case '2':
          return 'setWDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].SLOWRINSESCREEN:
      switch (number) {
        case '1':
          return 'setSTM';
        case '2':
          return 'setSTS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].FASTRINSESCREEN:
      switch (number) {
        case '1':
          return 'setFDM';
        case '2':
          return 'setFDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].REFILLSCREEN:
      switch (number) {
        case '1':
          return 'setRDM';
        case '2':
          return 'setRDS';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].INSPECTIONINTERVALSCREEN:
      return 'setIPE';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].INSPECTIONUSERSCREEN:
      return 'setIPR';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RESERVEPERIODSCREEN:
      return 'setRPE';
    case __WEBPACK_IMPORTED_MODULE_3__constants_screentypes_simplex__["a" /* default */].RESINVOLUMESCREEN:
      return 'setREV';
    default:
      return screen;
  }
}

function getSoftenerCommandByScreenForCycleTimes(screen, number) {
  var command = "";
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].REFILLINGTIMESCREEN:
      command = 'setRFT';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RINSINGTIMESCREEN:
      command = 'setBT1';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RAPIDRINSINGTIMESCREEN:
      command = 'setFT1';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].BRINGINGTIMESCREEN:
      command = 'setBRT';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].SLOWRINSINGTIMESCREEN:
      command = 'setSRT';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].BACKWASH2TIMESCREEN:
      command = 'setBT2';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RAPIDRINSING2TIMESCREEN:
      command = 'setFT2';
      break;
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].PERIODICFLUSHINGSCREEN:
      command = 'setFLP';
      break;
  }
  switch (number) {
    case '1':
      return command + '_minutes';
    case '2':
      return command + '_seconds';
    default:
      return screen;
  }
}

function getSoftenerCommandByScreen(screen, number) {
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].MAINSCREENSALT1:
      return 'setSV1';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].MAINSCREENSALT2:
      return 'setSV2';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].MAINSCREENSALT3:
      return 'setSV3';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].IWHSCREEN:
      return 'setIWH';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].OWHSCREEN:
      return 'setOWH';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].UWHSCREEN:
      return 'setWHU';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RTESCREEN:
      switch (number) {
        case '1':
          return 'setRTH';
        case '2':
          return 'setRTM';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RPESCREENMAIN:
      switch (number) {
        case '1':
          return 'setRPW';
        case '2':
          return 'setRPD';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].AWUSCREEN:
      return 'setDWF';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].FCOSCREEN:
      return 'setFCO';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RESERVETYPESCREEN:
      return 'setREK';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RESERVEPERCENTAGESCREEN:
      return 'setCOR';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RESERVEPERIODSCREEN:
      return 'setRPE';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].REFILLINGTIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RINSINGTIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RAPIDRINSINGTIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].BRINGINGTIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].SLOWRINSINGTIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].BACKWASH2TIMESCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RAPIDRINSING2TIMESCREEN:
      return getSoftenerCommandByScreenForCycleTimes(screen, number);
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RPENUMBERSCREEN:
      return 'setRPD';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RESINVOLUMESCREEN:
      return 'setREV';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].REGENERANTSCREEN:
      return 'setRDO';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].REGENERATIONSCREEN:
      return 'setRTY';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].PRESSURESENSORSCREEN:
      return 'setPST';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].WATERPRESSURESCREEN:
      return 'setMPR';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].CHLORINEGENERATORSCREEN:
      return 'setCHG';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].CANCELVACATIONMODESCREEN:
      return 'setHOT';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].IMMEDIATEREGENERATIONSCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].IMMEDIATEREGENERATIONNEWSCREEN:
      return 'setSIR';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].DELAYEDREGENERATIONSCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].DELAYEDREGENERATIONNEWSCREEN:
      return 'setSDR';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].IMMEDIATEMULTIREGENERATIONSCREEN:
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].IMMEDIATEMULTIREGENERATIONNEWSCREEN:
      return 'getSMR';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].RPEDAYSSCREEN:
      return 'setRPW';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].LANGUAGESCREEN:
      return 'setLAN';
    case __WEBPACK_IMPORTED_MODULE_1__constants_screentypes_softener__["a" /* default */].PERIODICFLUSHINGSCREEN:
      switch (number) {
        case '1':
          return 'setFLP';
        case '2':
          return 'setFLL';
        default:
          return screen;
      }
    default:
      console.log('not implemented command for ', screen);
      return 'notImplemented';
  }
}

function getSuperiorCheckCommandByScreen(screen, number) {
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].DEGASSINGFIRSTSCREEN:
      switch (number) {
        case '1':
          return 'setDE1';
        case '2':
          return 'setPE1';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].DEGASSINGSECONDSCREEN:
      switch (number) {
        case '1':
          return 'setDE2';
        case '2':
          return 'setPE2';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN1:
      return 'setBE1';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN2:
      return 'setBE2';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN3:
      return 'setBE3';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN4:
      return 'setBE4';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN5:
      return 'setBE5';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BOILERINTERLOCKSETTINGSSCREEN:
      return 'setBIC';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].EXTERNALPUMPSCREEN:
      return 'setEPV';
    default:
      break;
  };
}

function getSuperiorCommandByScreen(screen, number) {
  switch (screen) {
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BOILERINTERLOCKPRESSURESSCREEN:
      switch (number) {
        case '1':
          return 'setBIL';
        case '2':
          return 'setBIH';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGWEEKDAYSCREEN:
      return 'setDBW';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BOILSERINTERLOCKCONTACTDELAYSCREEN:
      return 'setCRD';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].LANGUAGESCREEN:
      return 'setLAN';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].COMMONFAULTSCREEN:
      return 'setCFM';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].FLUSHINGPHASESCREEN:
      return 'setRT9';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].VACCUMPHASESCREEN:
      return 'setVT9';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].SMARTSWITCHDELAYSCREEN:
      return 'setSSD';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MAXALLOWABLEPRESSUREDIFFSCREEN:
      return 'setMPD';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].INITIALFILLTIMESCREEN:
      return 'setIFT';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].DELTAPRESSURESCREEN:
      switch (number) {
        case '1':
          return 'setLDP';
        case '2':
          return 'setUDP';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].PUMPTESTTIMESCREEN:
      switch (number) {
        case '1':
          return 'setPTP';
        case '2':
          return 'setPTT';
        default:
          return screen;
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].SYSTEMFILLTIMESSCREEN:
      return 'setSFV';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WATERCRITICALTEMPSCREEN:
      switch (number) {
        case '1':
          return 'setMIT';
        case '2':
          return 'getMAT';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].DEGASSINGFIRSTSCREEN:
      switch (number) {
        case '1':
          return 'setDH1';
        case '2':
          return 'setDM1';
        case '3':
          return 'setPH1';
        case '4':
          return 'setPM1';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].DEGASSINGSECONDSCREEN:
      switch (number) {
        case '1':
          return 'setDH2';
        case '2':
          return 'setDM2';
        case '3':
          return 'setPH2';
        case '4':
          return 'setPM2';
        default:
          return 'notImplemented';
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN1:
      switch (number) {
        case '1':
          return 'setBD1';
        case '2':
          return 'setBM1';
        case '3':
          return 'setKD1';
        case '4':
          return 'setKM1';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN2:
      switch (number) {
        case '1':
          return 'setBD2';
        case '2':
          return 'setBM2';
        case '3':
          return 'setKD2';
        case '4':
          return 'setKM2';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN3:
      switch (number) {
        case '1':
          return 'setBD3';
        case '2':
          return 'setBM3';
        case '3':
          return 'setKD3';
        case '4':
          return 'setKM3';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN4:
      switch (number) {
        case '1':
          return 'setBD4';
        case '2':
          return 'setBM4';
        case '3':
          return 'setKD4';
        case '4':
          return 'setKM4';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BLOCKDEGASSINGPERIODSCREEN5:
      switch (number) {
        case '1':
          return 'setBD5';
        case '2':
          return 'setBM5';
        case '3':
          return 'setKD5';
        case '4':
          return 'setKM5';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ALTERNATIVEDEGASSINGDURATIONSCREEN:
      return 'setADD';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MINSHORTVACUUMTIMESCREEN:
      return 'setMSV';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].CRITICALERRCONTACTDELAYSCREEN:
      return 'setCRD';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].REFILLVOLUMESCREEN:
      return 'setRAV';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].REFILLTIMESCREEN:
      return 'setRAT';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].REFILLPERIODSCREEN:
      return 'setRAP';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MINREFILLINTERVALSCREEN:
      return 'setMRI';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].FLUSHPERIODCOMPARESCREEN:
      return 'setFPC';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].FLUSHPERIODSTARTSCREEN:
      return 'setFPS';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].CRITICALREFILLTIMESCREEN:
      switch (number) {
        case '1':
          return 'setCRF';
        case '2':
          return 'setCRS';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WARNING01TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW01';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WARNING02TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW02';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WARNING10TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW10';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WARNING11TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setT11';
        case '2':
          return 'setS11';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].WARNING31TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setW31';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR71TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setEC6';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR72TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setET7';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR33TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setC33';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR35TIMERSCREEN:
      switch (number) {
        case '2':
          return 'setC35';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR36TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setE36';
        case '2':
          return 'setC36';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERROR37TIMERSCREEN:
      switch (number) {
        case '1':
          return 'setE37';
        case '2':
          return 'setC37';
        default:
          return 'notImplemented';
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].UNITTYPESCREEN:
      return 'setDTY';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].EXTERNALPUMPSCREEN:
      return 'setEPV';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].ERRORDETECTIONSCREEN:
      return 'setEDT';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MEDIUMSUPERIORSCREEN:
      return 'setMED';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].PRESSURESENSORTYPESCREEN:
      return 'setPST';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MINREFILLFLOWSCREEN:
      return 'setMRF';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].MINSYSTEMPRESSURE:
      return 'setMOP';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].PRESSUREMEASURESETTINGSSCREEN:
      switch (number) {
        case '1':
          return 'setPDL';
        case '2':
          return 'setPSN';
        default:
          return 'notImplemented';
      }
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].INITIALDEAERATIONSCREEN:
      return 'setIDT';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].BOILERINTERLOCKSETTINGSSCREEN:
      return 'setBIM';
    case __WEBPACK_IMPORTED_MODULE_2__constants_screentypes_superior__["a" /* default */].REFILLPRESSURESCREEN:
    default:
      return 'notImplemented';
  }
}

function getCommandByScreen(screen, devicetype, position, getSCR) {
  switch (devicetype) {
    case 'charlie':
      return getCharlieCommandByScreen(screen, position, getSCR);
    case 'simplex':
      return getSimplexCommandByScreen(screen, position, getSCR);
    case 'softener':
      return getSoftenerCommandByScreen(screen, position);
    case 'superior':
      return getSuperiorCommandByScreen(screen, position);
    case 'reverseosmosis':
      return '';
    default:
      return '';
  }
}

function getCheckCommandByScreen(screen, devicetype, position) {
  switch (devicetype) {
    case 'superior':
      return getSuperiorCheckCommandByScreen(screen, position);
    default:
      return '';
  }
}

function getDeviceType(serial) {
  var deviceType = 'unknown';
  if (typeof serial !== 'undefined') {
    if (serial.startsWith('L')) {
      deviceType = 'softener';
    }
    if (serial.startsWith('C')) {
      deviceType = 'charlie';
    }
    if (serial.startsWith('S')) {
      deviceType = 'superior';
    }
    if (serial.startsWith('F')) {
      deviceType = 'foxtrot';
    }
    if (serial.startsWith('A')) {
      deviceType = 'safe-t';
    }
    if (serial.startsWith('T')) {
      deviceType = 'safetech';
    }
    if (serial.startsWith('K')) {
      deviceType = 'safefloor';
    }
    if (serial.startsWith('M')) {
      deviceType = 'simplex';
    }
  }
  return deviceType;
}

function dec2bin(dec) {
  return (dec >>> 0).toString(2);
}

function pad(num, size) {
  var s = '00000' + num;
  return s.substr(s.length - size);
}

function padNew(value, size) {
  if (value === "--") return value;
  var sign = Math.sign(value) === -1 ? '-' : '';
  return sign + new Array(size).concat([Math.abs(value)]).join('0').slice(-size);
}

function changeFromBits(value) {
  var decValue = pad(dec2bin(value), 2);
  var newValue = decValue.split("").reverse().join();
  return newValue;
}

function getChlorineGeneratorThreshold(getCGT) {
  if (getCGT !== undefined && getCGT != "") {
    return +getCGT == 0 ? "150mA" : "50mA";
  }
  return "";
}

function getLinkToDevice(deviceType, serial) {
  switch (deviceType) {
    case 'safetech':
      return 'T' + serial;
    case 'safefloor':
      return 'K' + serial;
    case 'safe-t':
      return 'A' + serial;
    default:
      return serial;
  }
};

function handleBlockDays(value, daysString) {
  var days = [0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40];
  var valueInt = parseInt(value, 10);
  var myString = '';
  for (var i = 0; i < 7; i += 1) {
    if (valueInt & days[i]) {
      if (i > 0) {
        if (myString === '') {
          myString += daysString[i];
        } else {
          myString += ',';
          myString += daysString[i];
        }
      } else {
        myString += daysString[i];
      }
    }
  }
  return myString;
}

function isPriviliged(userRole) {
  var priviligedRoles = [+__WEBPACK_IMPORTED_MODULE_4__constants_roles__["a" /* default */].admin, +__WEBPACK_IMPORTED_MODULE_4__constants_roles__["a" /* default */].manufacturer, +__WEBPACK_IMPORTED_MODULE_4__constants_roles__["a" /* default */].service];
  return priviligedRoles.indexOf(+userRole) > -1;
}

function isAdmin(userRole) {
  var priviligedRoles = [+__WEBPACK_IMPORTED_MODULE_4__constants_roles__["a" /* default */].admin];
  return priviligedRoles.indexOf(+userRole) > -1;
}

function getPayloadId(payload, alertType) {
  switch (alertType) {
    case 'softener-device-notification':
      return 'softener_notifications_' + payload + '_text';
    case 'softener-device-alarm':
      return 'softener_alarm_' + payload + '_text';
    case 'superior-device-notification':
      return 'problems_dictionary_' + payload + '_sup';
    case 'superior-device-alarm':
      return 'problems_dictionary_' + payload + '_sup';
    case 'safetech-device-alarm':
      return 'safetech_alarm_' + payload.substring(1) + '_text';
    case 'safet-device-alarm':
      return 'safet_alarm_' + payload.substring(1) + '_text';
    default:
      return 'problems_dictionary_0_sup';
  }
}

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(894)('wks');
var uid = __webpack_require__(887);
var Symbol = __webpack_require__(868).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form_css__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Form_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// TODO: this class can be removed and formsy-react form can be used directly but I'll keep it for now as there may be a need to change and use it

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.getModel = function () {
      var _this$refs$form;

      return (_this$refs$form = _this.refs.form).getModel.apply(_this$refs$form, arguments);
    }, _this.submit = function () {
      var _this$refs$form2;

      (_this$refs$form2 = _this.refs.form).submit.apply(_this$refs$form2, arguments);
    }, _this.reset = function () {
      var _this$refs$form3;

      (_this$refs$form3 = _this.refs.form).reset.apply(_this$refs$form3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          className = _props.className,
          children = _props.children,
          outerInfoMessage = _props.outerInfoMessage,
          outerErrorMessage = _props.outerErrorMessage,
          props = _objectWithoutProperties(_props, ['onSubmit', 'className', 'children', 'outerInfoMessage', 'outerErrorMessage']);

      var wrapClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Form_css___default.a.Form_info, __WEBPACK_IMPORTED_MODULE_6__Form_css___default.a.Form_info__error);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_formsy_react___default.a,
        _extends({}, props, {
          onValidSubmit: onSubmit,
          onChange: this.props.onChange,
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Form_css___default.a.Form, __WEBPACK_IMPORTED_MODULE_6__Form_css___default.a[className]),
          ref: 'form' }),
        outerErrorMessage ? _jsx('section', {
          className: wrapClass
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], {
          id: outerErrorMessage
        })) : null,
        outerInfoMessage ? _jsx('section', {
          className: __WEBPACK_IMPORTED_MODULE_6__Form_css___default.a.Form_info
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], {
          id: outerInfoMessage
        })) : null,
        children
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__Form_css___default.a)(Form));

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 869:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(877);
var IE8_DOM_DEFINE = __webpack_require__(919);
var toPrimitive = __webpack_require__(895);
var dP = Object.defineProperty;

exports.f = __webpack_require__(871) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(881)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(488);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function handleClick(event) {
  if (this.props.onClick) {
    this.props.onClick(event);
  }

  if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    return;
  }

  if (event.defaultPrevented === true) {
    return;
  }

  event.preventDefault();
  __WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */].push(this.props.to);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.go = function (event) {
      return handleClick.call(_this, event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['to', 'children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({ href: to }, props, { onClick: this.go }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  onClick: null
};




/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_file_download__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mandatoryAttributes__ = __webpack_require__(1045);






// https://tonyspiro.com/how-to-keep-session-data-after-fetch-post-with-express/#comment-2544007117

function getUrl(path) {
  if (path.startsWith('http') || __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_ExecutionEnvironment___default.a.canUseDOM) {
    return path;
  }
  return process.env.WEBSITE_HOSTNAME ? 'http://' + process.env.WEBSITE_HOSTNAME + path : 'http://127.0.0.1:3000' + path;
}

var HttpClient = {
  get: function get(path) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(getUrl(path), { credentials: 'include' }).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      });
    });
  },

  // get: (path, params = mandatoryServerSide(path)) => new Promise((resolve, reject) => {
  //   const headers = params ? params.headers : {accept: 'application/json'};
  //   request
  //     .get(getUrl(path))
  //     .set(headers)
  //     .end((err, res) => {
  //       if (err) {
  //         if (err.status === 404) {
  //           resolve(null);
  //         } else {
  //           reject(err);
  //         }
  //       } else {
  //         resolve(res.body);
  //       }
  //     });
  // }),


  postDownload: function postDownload(path, dataObject) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(getUrl(path), {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: dataObject
      }).then(function (response) {
        return response.blob();
      }).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2_js_file_download___default()(data, 'file2.pdf');
        resolve('ok');
      });
    });
  },

  postAsync: function postAsync(path, dataObject) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(getUrl(path), {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        body: dataObject
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        resolve(data);
      });
    });
  },

  post: function post(path, dataObject) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(getUrl(path)).accept('application/json').send(dataObject || {}).end(function (err, res) {
        if (err) {
          if (err.status === 409) {
            // resolve(null);
            reject(err);
          } else {
            reject(err);
          }
        } else {
          resolve(res.text);
        }
      });
    });
  },

  delete: function _delete(path, dataObject) {
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(getUrl(path), {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(dataObject)
      }).then(function (response) {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  }

};

/* harmony default export */ __webpack_exports__["a"] = (HttpClient);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(102)))

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid_css__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Grid_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function Grid(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a.Gridcell
  }, void 0, props.children);
}

Grid.Cell = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'Cell',
  render: function render() {
    var className = this.props.className;
    if (typeof className !== 'undefined') {

      var elements = className.split(' ');
      var myClassName = '';
      for (var i = 0; i < elements.length; i += 1) {
        if ('' + __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a[elements[i]] !== undefined) {
          if (myClassName === '') {
            myClassName += '' + __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a[elements[i]];
          } else {
            myClassName += ' ' + __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a[elements[i]];
          }
        }
      }
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a.Gridcell + ' ' + myClassName
      }, void 0, this.props.children);
    }
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a.Gridcell
    }, void 0, this.props.children);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5__Grid_css___default.a)(Grid));

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(868);
var core = __webpack_require__(864);
var ctx = __webpack_require__(918);
var hide = __webpack_require__(876);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(870);
var createDesc = __webpack_require__(888);
module.exports = __webpack_require__(871) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(878);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(965);
var defined = __webpack_require__(892);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.withFormsy = exports.validationRules = exports.propTypes = exports.addValidationRule = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _formDataToObject = __webpack_require__(1054);

var _formDataToObject2 = _interopRequireDefault(_formDataToObject);

var _propTypes = __webpack_require__(79);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(70);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(930);

var _utils2 = _interopRequireDefault(_utils);

var _validationRules = __webpack_require__(1055);

var _validationRules2 = _interopRequireDefault(_validationRules);

var _Wrapper = __webpack_require__(1056);

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-unused-state, react/default-props-match-prop-types */

var Formsy = function (_React$Component) {
  _inherits(Formsy, _React$Component);

  function Formsy(props) {
    _classCallCheck(this, Formsy);

    var _this = _possibleConstructorReturn(this, (Formsy.__proto__ || Object.getPrototypeOf(Formsy)).call(this, props));

    _this.getChildContext = function () {
      return {
        formsy: {
          attachToForm: _this.attachToForm,
          detachFromForm: _this.detachFromForm,
          validate: _this.validate,
          isFormDisabled: _this.isFormDisabled,
          isValidValue: function isValidValue(component, value) {
            return _this.runValidation(component, value).isValid;
          }
        }
      };
    };

    _this.componentDidMount = function () {
      _this.validateForm();
    };

    _this.componentWillUpdate = function () {
      // Keep a reference to input names before form updates,
      // to check if inputs has changed after render
      _this.prevInputNames = _this.inputs.map(function (component) {
        return component.props.name;
      });
    };

    _this.componentDidUpdate = function () {
      if (_this.props.validationErrors && _typeof(_this.props.validationErrors) === 'object' && Object.keys(_this.props.validationErrors).length > 0) {
        _this.setInputValidationErrors(_this.props.validationErrors);
      }

      var newInputNames = _this.inputs.map(function (component) {
        return component.props.name;
      });
      if (_utils2.default.arraysDiffer(_this.prevInputNames, newInputNames)) {
        _this.validateForm();
      }
    };

    _this.getCurrentValues = function () {
      return _this.inputs.reduce(function (data, component) {
        var name = component.props.name;

        var dataCopy = Object.assign({}, data); // avoid param reassignment
        dataCopy[name] = component.state.value;
        return dataCopy;
      }, {});
    };

    _this.getModel = function () {
      var currentValues = _this.getCurrentValues();
      return _this.mapModel(currentValues);
    };

    _this.getPristineValues = function () {
      return _this.inputs.reduce(function (data, component) {
        var name = component.props.name;

        var dataCopy = Object.assign({}, data); // avoid param reassignment
        dataCopy[name] = component.props.value;
        return dataCopy;
      }, {});
    };

    _this.setFormPristine = function (isPristine) {
      _this.setState({
        formSubmitted: !isPristine
      });

      // Iterate through each component and set it as pristine
      // or "dirty".
      _this.inputs.forEach(function (component) {
        component.setState({
          formSubmitted: !isPristine,
          isPristine: isPristine
        });
      });
    };

    _this.setInputValidationErrors = function (errors) {
      _this.inputs.forEach(function (component) {
        var name = component.props.name;

        var args = [{
          isValid: !(name in errors),
          validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
        }];
        component.setState.apply(component, args);
      });
    };

    _this.isFormDisabled = function () {
      return _this.props.disabled;
    };

    _this.mapModel = function (model) {
      if (_this.props.mapping) {
        return _this.props.mapping(model);
      }

      return _formDataToObject2.default.toObj(Object.keys(model).reduce(function (mappedModel, key) {
        var keyArray = key.split('.');
        var base = mappedModel;
        while (keyArray.length) {
          var currentKey = keyArray.shift();
          base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
          base = base[currentKey];
        }
        return mappedModel;
      }, {}));
    };

    _this.reset = function (data) {
      _this.setFormPristine(true);
      _this.resetModel(data);
    };

    _this.resetInternal = function (event) {
      event.preventDefault();
      _this.reset();
      if (_this.props.onReset) {
        _this.props.onReset();
      }
    };

    _this.resetModel = function (data) {
      _this.inputs.forEach(function (component) {
        var name = component.props.name;

        if (data && Object.prototype.hasOwnProperty.call(data, name)) {
          component.setValue(data[name]);
        } else {
          component.resetValue();
        }
      });
      _this.validateForm();
    };

    _this.runValidation = function (component) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : component.state.value;

      var currentValues = _this.getCurrentValues();
      var _component$props = component.props,
          validationError = _component$props.validationError,
          validationErrors = _component$props.validationErrors;


      var validationResults = _utils2.default.runRules(value, currentValues, component.validations, _validationRules2.default);

      var requiredResults = _utils2.default.runRules(value, currentValues, component.requiredValidations, _validationRules2.default);

      var isRequired = Object.keys(component.requiredValidations).length ? !!requiredResults.success.length : false;
      var isValid = !validationResults.failed.length && !(_this.props.validationErrors && _this.props.validationErrors[component.props.name]);

      return {
        isRequired: isRequired,
        isValid: isRequired ? false : isValid,
        error: function () {
          if (isValid && !isRequired) {
            return [];
          }

          if (validationResults.errors.length) {
            return validationResults.errors;
          }

          if (_this.props.validationErrors && _this.props.validationErrors[component.props.name]) {
            return typeof _this.props.validationErrors[component.props.name] === 'string' ? [_this.props.validationErrors[component.props.name]] : _this.props.validationErrors[component.props.name];
          }

          if (isRequired) {
            var error = validationErrors[requiredResults.success[0]];
            return error ? [error] : null;
          }

          if (validationResults.failed.length) {
            return validationResults.failed.map(function (failed) {
              return validationErrors[failed] ? validationErrors[failed] : validationError;
            }).filter(function (x, pos, arr) {
              return arr.indexOf(x) === pos;
            }); // remove duplicates
          }

          return undefined;
        }()
      };
    };

    _this.attachToForm = function (component) {
      if (_this.inputs.indexOf(component) === -1) {
        _this.inputs.push(component);
      }

      _this.validate(component);
    };

    _this.detachFromForm = function (component) {
      var componentPos = _this.inputs.indexOf(component);

      if (componentPos !== -1) {
        _this.inputs = _this.inputs.slice(0, componentPos).concat(_this.inputs.slice(componentPos + 1));
      }

      _this.validateForm();
    };

    _this.isChanged = function () {
      return !_utils2.default.isSame(_this.getPristineValues(), _this.getCurrentValues());
    };

    _this.submit = function (event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }

      // Trigger form as not pristine.
      // If any inputs have not been touched yet this will make them dirty
      // so validation becomes visible (if based on isPristine)
      _this.setFormPristine(false);
      var model = _this.getModel();
      _this.props.onSubmit(model, _this.resetModel, _this.updateInputsWithError);
      if (_this.state.isValid) {
        _this.props.onValidSubmit(model, _this.resetModel, _this.updateInputsWithError);
      } else {
        _this.props.onInvalidSubmit(model, _this.resetModel, _this.updateInputsWithError);
      }
    };

    _this.updateInputsWithError = function (errors) {
      Object.keys(errors).forEach(function (name) {
        var component = _utils2.default.find(_this.inputs, function (input) {
          return input.props.name === name;
        });
        if (!component) {
          throw new Error('You are trying to update an input that does not exist. Verify errors object with input names. ' + JSON.stringify(errors));
        }
        var args = [{
          isValid: _this.props.preventExternalInvalidation,
          externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
        }];
        component.setState.apply(component, args);
      });
    };

    _this.validate = function (component) {
      // Trigger onChange
      if (_this.state.canChange) {
        _this.props.onChange(_this.getCurrentValues(), _this.isChanged());
      }

      var validation = _this.runValidation(component);
      // Run through the validations, split them up and call
      // the validator IF there is a value or it is required
      component.setState({
        isValid: validation.isValid,
        isRequired: validation.isRequired,
        validationError: validation.error,
        externalError: null
      }, _this.validateForm);
    };

    _this.validateForm = function () {
      // We need a callback as we are validating all inputs again. This will
      // run when the last component has set its state
      var onValidationComplete = function onValidationComplete() {
        var allIsValid = _this.inputs.every(function (component) {
          return component.state.isValid;
        });

        _this.setState({
          isValid: allIsValid
        });

        if (allIsValid) {
          _this.props.onValid();
        } else {
          _this.props.onInvalid();
        }

        // Tell the form that it can start to trigger change events
        _this.setState({
          canChange: true
        });
      };

      // Run validation again in case affected by other inputs. The
      // last component validated will run the onValidationComplete callback
      _this.inputs.forEach(function (component, index) {
        var validation = _this.runValidation(component);
        if (validation.isValid && component.state.externalError) {
          validation.isValid = false;
        }
        component.setState({
          isValid: validation.isValid,
          isRequired: validation.isRequired,
          validationError: validation.error,
          externalError: !validation.isValid && component.state.externalError ? component.state.externalError : null
        }, index === _this.inputs.length - 1 ? onValidationComplete : null);
      });

      // If there are no inputs, set state where form is ready to trigger
      // change event. New inputs might be added later
      if (!_this.inputs.length) {
        _this.setState({
          canChange: true
        });
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          getErrorMessage = _this$props.getErrorMessage,
          getErrorMessages = _this$props.getErrorMessages,
          getValue = _this$props.getValue,
          hasValue = _this$props.hasValue,
          isFormDisabled = _this$props.isFormDisabled,
          isFormSubmitted = _this$props.isFormSubmitted,
          isPristine = _this$props.isPristine,
          isRequired = _this$props.isRequired,
          isValid = _this$props.isValid,
          isValidValue = _this$props.isValidValue,
          mapping = _this$props.mapping,
          onChange = _this$props.onChange,
          onInvalidSubmit = _this$props.onInvalidSubmit,
          onInvalid = _this$props.onInvalid,
          onReset = _this$props.onReset,
          onSubmit = _this$props.onSubmit,
          onValid = _this$props.onValid,
          onValidSubmit = _this$props.onValidSubmit,
          preventExternalInvalidation = _this$props.preventExternalInvalidation,
          resetValue = _this$props.resetValue,
          setValidations = _this$props.setValidations,
          setValue = _this$props.setValue,
          showError = _this$props.showError,
          showRequired = _this$props.showRequired,
          validationErrors = _this$props.validationErrors,
          nonFormsyProps = _objectWithoutProperties(_this$props, ['getErrorMessage', 'getErrorMessages', 'getValue', 'hasValue', 'isFormDisabled', 'isFormSubmitted', 'isPristine', 'isRequired', 'isValid', 'isValidValue', 'mapping', 'onChange', 'onInvalidSubmit', 'onInvalid', 'onReset', 'onSubmit', 'onValid', 'onValidSubmit', 'preventExternalInvalidation', 'resetValue', 'setValidations', 'setValue', 'showError', 'showRequired', 'validationErrors']);

      return _react2.default.createElement('form', _extends({
        onReset: _this.resetInternal,
        onSubmit: _this.submit
      }, nonFormsyProps), _this.props.children);
    };

    _this.state = {
      isValid: true,
      isSubmitting: false,
      canChange: false
    };
    _this.inputs = [];
    return _this;
  }

  // Reset each key in the model to the original / initial / specified value


  // Checks validation on current value or a passed value


  // Method put on each input component to register
  // itself to the form


  // Method put on each input component to unregister
  // itself from the form


  // Checks if the values have changed from their initial value


  // Update model, submit to url prop and send the model


  // Go through errors from server and grab the components
  // stored in the inputs map. Change their state to invalid
  // and set the serverError message


  // Use the binded values and the actual input value to
  // validate the input and set its state. Then check the
  // state of the form itself


  // Validate the form by going through all child input components
  // and check their state


  return Formsy;
}(_react2.default.Component);

Formsy.displayName = 'Formsy';

Formsy.defaultProps = {
  children: null,
  disabled: false,
  getErrorMessage: function getErrorMessage() {},
  getErrorMessages: function getErrorMessages() {},
  getValue: function getValue() {},
  hasValue: function hasValue() {},
  isFormDisabled: function isFormDisabled() {},
  isFormSubmitted: function isFormSubmitted() {},
  isPristine: function isPristine() {},
  isRequired: function isRequired() {},
  isValid: function isValid() {},
  isValidValue: function isValidValue() {},
  mapping: null,
  onChange: function onChange() {},
  onError: function onError() {},
  onInvalid: function onInvalid() {},
  onInvalidSubmit: function onInvalidSubmit() {},
  onReset: function onReset() {},
  onSubmit: function onSubmit() {},
  onValid: function onValid() {},
  onValidSubmit: function onValidSubmit() {},
  preventExternalInvalidation: false,
  resetValue: function resetValue() {},
  setValidations: function setValidations() {},
  setValue: function setValue() {},
  showError: function showError() {},
  showRequired: function showRequired() {},
  validationErrors: null
};

Formsy.propTypes = {
  children: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  getErrorMessage: _propTypes2.default.func,
  getErrorMessages: _propTypes2.default.func,
  getValue: _propTypes2.default.func,
  hasValue: _propTypes2.default.func,
  isFormDisabled: _propTypes2.default.func,
  isFormSubmitted: _propTypes2.default.func,
  isPristine: _propTypes2.default.func,
  isRequired: _propTypes2.default.func,
  isValid: _propTypes2.default.func,
  isValidValue: _propTypes2.default.func,
  mapping: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onInvalid: _propTypes2.default.func,
  onInvalidSubmit: _propTypes2.default.func,
  onReset: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  onValid: _propTypes2.default.func,
  onValidSubmit: _propTypes2.default.func,
  preventExternalInvalidation: _propTypes2.default.bool,
  resetValue: _propTypes2.default.func,
  setValidations: _propTypes2.default.func,
  setValue: _propTypes2.default.func,
  showError: _propTypes2.default.func,
  showRequired: _propTypes2.default.func,
  validationErrors: _propTypes2.default.object // eslint-disable-line
};

Formsy.childContextTypes = {
  formsy: _propTypes2.default.object
};

var addValidationRule = function addValidationRule(name, func) {
  _validationRules2.default[name] = func;
};

var withFormsy = _Wrapper2.default;

var didWarnAboutWrapperDeprecation = false;

var deprecatedWrapper = function deprecatedWrapper(Component) {
  if (!didWarnAboutWrapperDeprecation) {
    // eslint-disable-next-line no-console
    console.warn('Wrapper has been renamed to withFormsy. Importing Wrapper from formsy-react is depreacted and will be removed in the future. Please rename your Wrapper imports to withFormsy.');
    didWarnAboutWrapperDeprecation = true;
  }

  return withFormsy(Component);
};

exports.addValidationRule = addValidationRule;
exports.propTypes = _Wrapper.propTypes;
exports.validationRules = _validationRules2.default;
exports.withFormsy = withFormsy;
exports.Wrapper = deprecatedWrapper;
exports.default = Formsy;

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(70);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(79);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(856);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js
var index_es = __webpack_require__(101);

// EXTERNAL MODULE: ./node_modules/formsy-react/lib/index.js
var lib = __webpack_require__(880);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(855);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// CONCATENATED MODULE: ./src/components/Input/Messages.js


function Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    field_required: {
      'id': 'field_required',
      'defaultMessage': 'Field required'
    }
  });
  return messages;
}
// EXTERNAL MODULE: ./src/components/Input/Input.css
var Input_Input = __webpack_require__(1071);
var Input_default = /*#__PURE__*/__webpack_require__.n(Input_Input);

// CONCATENATED MODULE: ./src/components/Input/Input.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Input_Input_Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.state = {
      canDisplayError: false
    };
    _this.displayError = _this.displayError.bind(_this);
    _this.changeValue = _this.changeValue.bind(_this);
    return _this;
  }

  // setValue() will set the value of the component, which in
  // turn will validate it and the rest of the form


  _createClass(Input, [{
    key: 'changeValue',
    value: function changeValue(event) {
      var value = event.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value'];
      this.props.setValue(value);

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: 'displayError',
    value: function displayError(event) {
      this.setState({
        canDisplayError: true
      });
      this.changeValue(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Set a specific className based on the validation
      // state of this component. showRequired() is true
      // when the value is empty and the required prop is
      // passed to the input. showError() is true when the
      // value typed is invalid
      var className = this.props.className;
      if (this.props.showRequired()) {
        className = classnames_default()(Input_default.a.required, Input_default.a[className]);
      } else if (this.props.showError()) {
        className = classnames_default()(Input_default.a.error, Input_default.a[className]);
      }

      var intl = this.props.intl;

      var messages = Messages();

      var inputClassNames = classnames_default()(Input_default.a.Form_field, Input_default.a.Form_field__small);
      // const inputClassNames = classNames({
      //   'Form_field': true,
      //   'Form_field__small': !!this.props.small,
      //   'Form_field__large': !!this.props.large,
      //   'Form_field__withoutBorder': !!this.props.withoutBorder,
      // });

      // An error message is returned ONLY if the component is invalid
      // or the server has returned an error message
      var errorMessage = this.props.getErrorMessage() || (this.props.showRequired() && this.props.isFormSubmitted() ? intl.formatMessage(_extends({}, messages.field_required)) : null);

      return _jsx('div', {
        className: className
      }, void 0, this.props.titleVisibility ? _jsx('label', {
        htmlFor: this.props.name
      }, void 0, _jsx('span', {}, void 0, this.props.title)) : null, react_default.a.createElement('input', {
        ref: function ref(input) {
          return _this2.input = input;
        },
        className: inputClassNames,
        type: this.props.type || 'text',
        name: this.props.name,
        id: this.props.name,
        disabled: this.props.disabled ? 'disabled' : null,
        onChange: this.changeValue,
        onBlur: this.displayError,
        onSubmit: this.props.onSubmit,
        autoFocus: this.props.autofocus,
        value: this.props.getValue(),
        checked: this.props.type === 'checkbox' && this.props.getValue() ? 'checked' : null,
        placeholder: this.props.title
      }), (this.state.canDisplayError || this.props.isFormSubmitted()) && errorMessage ? _jsx('div', {
        className: Input_default.a.Form_error
      }, void 0, _jsx('span', {}, void 0, errorMessage)) : null);
    }
  }]);

  return Input;
}(react_default.a.Component);

;

Input_Input_Input.defaultProps = {
  large: false,
  titleVisibility: false
};

/* harmony default export */ var components_Input_Input = __webpack_exports__["a"] = (Object(index_es["g" /* injectIntl */])(Object(lib["withFormsy"])(withStyles_default()(Input_default.a)(Input_Input_Input, { withRef: true }))));

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var urls = {
  MAIN_LOGIN_URL: '/',
  API_URL: '/api/test',
  API2_URL: '/api/devices',
  API_LISTS: '/api/lists',
  API_USERS: '/api/users',
  MAIN_LOGOUT_URL: '/login',
  MAIN_NEWPASSWORD_URL: '/profile/password'
};

/* harmony default export */ __webpack_exports__["a"] = (urls);

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = optionsParser;
/* harmony export (immutable) */ __webpack_exports__["d"] = safeFloorParser;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventsParser;
/* harmony export (immutable) */ __webpack_exports__["b"] = getOptionsTranslator;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function optionsParser(item) {
  return {
    title: item.get(1),
    value: item.get(0)
  };
}

function safeFloorParser(item) {
  return {
    title: item.get('serial'),
    value: item.get('serial')
  };
}

function eventsParser(item) {
  var value = item.get(1);
  var isSpaced = value.split(' ').length > 1;
  value = isSpaced ? value.split(' ')[1] : value;
  return {
    title: value,
    value: item.get(0)
  };
}

function getOptionsTranslator(intl, messages) {
  return function (item) {
    item.title = intl.formatMessage(_extends({}, messages[item.title]));
    return item;
  };
}

/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = insertParams;
function insertParams(url, params) {
  if (!params) {
    return url;
  }
  var outputUrl = url;
  if (url.indexOf('?') === -1) {
    outputUrl += '?';
  } else {
    outputUrl += '&';
  }
  var keys = Object.keys(params);
  var index = 0;
  return keys.reduce(function (currentUrl, key) {
    var value = params[key];
    if (value) {
      return currentUrl + (index++ > 0 ? '&' : '') + encodeURI(key) + '=' + encodeURI(value);
    }
    return currentUrl;
  }, outputUrl);
}

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 889:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1078)();
}


/***/ }),

/***/ 891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function topPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetTop + topPosition(domElt.offsetParent);
}

var InfiniteScroll = function (_React$Component) {
  _inherits(InfiniteScroll, _React$Component);

  function InfiniteScroll() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteScroll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call.apply(_ref, [this].concat(args))), _this), _this.scrollListener = function () {
      var el = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this);
      var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if (topPosition(el) + el.offsetHeight - scrollTop - window.innerHeight < Number(_this.props.threshold)) {
        _this.detachScrollListener();
        // call loadMore after detachScrollListener to allow
        // for non-async loadMore functions
        _this.props.loadMore(_this.pageLoaded += 1);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.detachScrollListener();
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      if (!this.props.hasMore) {
        return;
      }
      window.addEventListener('scroll', this.scrollListener);
      window.addEventListener('resize', this.scrollListener);
      this.scrollListener();
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      window.removeEventListener('scroll', this.scrollListener);
      window.removeEventListener('resize', this.scrollListener);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.table) {
        return _jsx('tbody', {}, void 0, this.props.children, this.props.hasMore ? this.props.loader : null);
      }
      return _jsx('div', {
        className: this.props.className
      }, void 0, this.props.children, this.props.hasMore ? this.props.loader : null);
    }
  }]);

  return InfiniteScroll;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InfiniteScroll.defaultProps = {
  pageStart: 0,
  hasMore: false,
  loadMore: function loadMore() {},
  threshold: 250,
  table: false
};

/* harmony default export */ __webpack_exports__["a"] = (InfiniteScroll);

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(894)('keys');
var uid = __webpack_require__(887);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(868);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(878);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(962)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(922)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 897:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(877);
var dPs = __webpack_require__(964);
var enumBugKeys = __webpack_require__(902);
var IE_PROTO = __webpack_require__(893)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(920)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(969).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(924);
var enumBugKeys = __webpack_require__(902);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 901:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(870).f;
var has = __webpack_require__(869);
var TAG = __webpack_require__(866)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(970);
var global = __webpack_require__(868);
var hide = __webpack_require__(876);
var Iterators = __webpack_require__(882);
var TO_STRING_TAG = __webpack_require__(866)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(866);


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(868);
var core = __webpack_require__(864);
var LIBRARY = __webpack_require__(898);
var wksExt = __webpack_require__(905);
var defineProperty = __webpack_require__(870).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 907:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1085);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryAlarms.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryAlarms.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1091);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEvents.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryEvents.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1103);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ConversationPopup.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ConversationPopup.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Select_css__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Select_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.state = {
      selectTitle: '',
      canDisplayError: false
    };
    _this.changeValue = _this.changeValue.bind(_this);
    _this.displayError = _this.displayError.bind(_this);
    return _this;
  }

  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.defaultValue) {
        this.props.setValue(this.props.defaultValue);
      }
      this.isFirefox = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1; // tmp
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.state.selectTitle && nextProps.defaultValue) {
        this.props.setValue(nextProps.defaultValue);
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var _this2 = this;

      var title = null;

      if (this.props.defaultValue && this.props.options.length) {
        var defaultOption = this.props.options.find(function (option) {
          return option.value === _this2.props.defaultValue;
        });
        title = defaultOption ? defaultOption.title : title;
      }
      // title=null;
      return title || this.props.title || this.props.options[0].title;
    }
  }, {
    key: 'changeValue',
    value: function changeValue(event) {
      this.setState({
        selectTitle: event.target.options[event.target.selectedIndex].label
      });
      this.props.setValue(event.currentTarget.value);

      if (this.props.onChange) {
        this.props.onChange(event.currentTarget.value);
      }
    }
  }, {
    key: 'keyDown',
    value: function keyDown(event) {
      var _this3 = this;

      if (event.keyCode === 40 || event.keyCode === 38) {
        setTimeout(function () {
          _this3.refs.select.blur();
          _this3.refs.select.focus();
        }, 0);
      }
    }
  }, {
    key: 'displayError',
    value: function displayError() {
      this.setState({
        canDisplayError: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'FormSelect';
      if (this.props.showRequired()) {
        className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.required, __WEBPACK_IMPORTED_MODULE_6__Select_css___default.a[className]);
      } else if (this.props.showError()) {
        className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.error, __WEBPACK_IMPORTED_MODULE_6__Select_css___default.a[className]);
      }
      var errorMessage = this.props.getErrorMessage() || (this.props.showRequired() && this.props.isFormSubmitted() ? 'field_required' : null);

      var options = this.props.options.map(function (option) {
        return _jsx('option', {
          value: option.value
        }, option.title + option.value, option.title);
      });

      var selectTitle = this.state.selectTitle ? this.state.selectTitle : this.getTitle();
      var selectClassNames = this.props.multiple ? __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.Form_field, __WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.big) : __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.Form_field);

      var labelClassNames = this.props.titleVisibility ? __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.FormSelect__label) : __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.FormSelect__label, __WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.u_hidden);

      var selectedValue = this.props.realValue || this.props.getValue();
      return _jsx('div', {
        className: className
      }, void 0, _jsx('label', {
        htmlFor: this.props.name,
        className: labelClassNames
      }, void 0, this.props.title), _jsx('div', {
        className: 'u-posRelative'
      }, void 0, selectTitle !== this.props.title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          ref: 'select',
          multiple: this.props.multiple,
          className: selectClassNames,
          name: this.props.name,
          disabled: this.props.disabled ? 'disabled' : null,
          onChange: this.changeValue,
          onKeyDown: this.isFirefox ? this.keyDown : null,
          onBlur: this.displayError,
          value: selectedValue },
        options
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          ref: 'select',
          multiple: this.props.multiple,
          className: selectClassNames,
          name: this.props.name,
          disabled: this.props.disabled ? 'disabled' : null,
          onChange: this.changeValue,
          onKeyDown: this.isFirefox ? this.keyDown : null,
          onBlur: this.displayError,
          value: selectedValue },
        _jsx('option', {
          className: __WEBPACK_IMPORTED_MODULE_6__Select_css___default.a.u_hidden
        }, '$selectTitle.title', ' ', selectTitle, ' '),
        options
      )), this.props.isFormSubmitted() && errorMessage ? _jsx('div', {
        className: 'Form-error'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], {
        id: errorMessage
      })) : null);
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

;

Select.defaultProps = {
  large: false,
  multiple: false,
  withoutBorder: false,
  titleVisibility: false,
  realValue: null
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_formsy_react__["withFormsy"])(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__Select_css___default.a)(Select)));

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  admin: '1',
  manufacturer: '2',
  installer: '3',
  enduser: '4',
  service: '5'
});

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Badge_css__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Badge_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Badge = function (_Component) {
  _inherits(Badge, _Component);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: 'render',
    value: function render() {
      var number = this.props.number;
      var showEmpty = this.props.showEmpty;
      return number || showEmpty ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Badge_css___default.a.Badge, __WEBPACK_IMPORTED_MODULE_4__Badge_css___default.a[this.props.className])
      }, void 0, !showEmpty ? number : null) : null;
    }
  }]);

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Badge_css___default.a)(Badge));

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlerts;
/* harmony export (immutable) */ __webpack_exports__["h"] = setSort;
/* harmony export (immutable) */ __webpack_exports__["f"] = setFilter;
/* harmony export (immutable) */ __webpack_exports__["g"] = setSearchQuery;
/* harmony export (immutable) */ __webpack_exports__["e"] = resetPaging;
/* harmony export (immutable) */ __webpack_exports__["d"] = resetAlerts;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlertsCount;
/* unused harmony export markAlertAsRead */
/* unused harmony export markAllAlertsAsRead */
/* unused harmony export markAlertAsSeen */
/* harmony export (immutable) */ __webpack_exports__["c"] = markAllAlertsAsSeen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);




function getAlerts(params, reqParams) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__["a" /* insertParams */])('/api/alerts', params);
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* GET_ALERTS */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(url, reqParams)
  };
}

function setSort(sort) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["_12" /* SET_ALERTS_SORT */],
    sort: sort
  };
}

function setFilter(filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["_10" /* SET_ALERTS_FILTER */],
    filter: filter
  };
}

function setSearchQuery(searchQuery) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["_11" /* SET_ALERTS_SEARCH_QUERY */],
    searchQuery: searchQuery
  };
}

function resetPaging() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["X" /* RESET_ALERTS_PAGING */]
  };
}

function resetAlerts() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["W" /* RESET_ALERTS */]
  };
}

function getAlertsCount() {
  var url = '/api/alerts/count';
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* GET_ALERTS_COUNT */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(url)
  };
}

function markAlertAsRead(alertId) {
  return {
    type: 'MARK_ALERT_AS_READ',
    alertId: alertId,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/alerts/' + alertId + '?action_type=read')
  };
}

function markAllAlertsAsRead() {
  return {
    type: 'MARK_ALL_ALERTS_AS_READ',
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/alerts?action_type=read')
  };
}

function markAlertAsSeen(alertId) {
  return {
    type: 'MARK_ALERT_AS_SEEN',
    alertId: alertId,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/alerts/' + alertId + '?action_type=seen')
  };
}

function markAllAlertsAsSeen() {
  return {
    type: 'MARK_ALL_ALERTS_AS_SEEN',
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/alerts?action_type=seen')
  };
}

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(892);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(869);
var toObject = __webpack_require__(916);
var IE_PROTO = __webpack_require__(893)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(953);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(871) && !__webpack_require__(881)(function () {
  return Object.defineProperty(__webpack_require__(920)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(878);
var document = __webpack_require__(868).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(960);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(973);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(898);
var $export = __webpack_require__(875);
var redefine = __webpack_require__(923);
var hide = __webpack_require__(876);
var has = __webpack_require__(869);
var Iterators = __webpack_require__(882);
var $iterCreate = __webpack_require__(963);
var setToStringTag = __webpack_require__(903);
var getPrototypeOf = __webpack_require__(917);
var ITERATOR = __webpack_require__(866)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(876);


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(869);
var toIObject = __webpack_require__(879);
var arrayIndexOf = __webpack_require__(966)(false);
var IE_PROTO = __webpack_require__(893)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 925:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(924);
var hiddenKeys = __webpack_require__(902).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(907);
var createDesc = __webpack_require__(888);
var toIObject = __webpack_require__(879);
var toPrimitive = __webpack_require__(895);
var has = __webpack_require__(869);
var IE8_DOM_DEFINE = __webpack_require__(919);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(871) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(901);
var TAG = __webpack_require__(866)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 929:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Warstwa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='41px' height='42px' viewBox='0 0 41 42' enable-background='new 0 0 41 42' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M20.707,1.317c10.771,0,19.503,8.731,19.503,19.502s-8.731,19.502-19.503,19.502c-10.77,0-19.501-8.731-19.501-19.502 S9.937,1.317,20.707,1.317L20.707,1.317z'/%3E %3Cpath fill='none' stroke='%23000000' stroke-width='1.4998' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='22.9256' d=' M9.006,9.118l23.401,23.402 M9.006,32.521L32.408,9.118'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = {
  arraysDiffer: function arraysDiffer(a, b) {
    var _this = this;

    var isDifferent = false;
    if (a.length !== b.length) {
      isDifferent = true;
    } else {
      a.forEach(function (item, index) {
        if (!_this.isSame(item, b[index])) {
          isDifferent = true;
        }
      }, this);
    }
    return isDifferent;
  },
  objectsDiffer: function objectsDiffer(a, b) {
    var _this2 = this;

    var isDifferent = false;
    if (Object.keys(a).length !== Object.keys(b).length) {
      isDifferent = true;
    } else {
      Object.keys(a).forEach(function (key) {
        if (!_this2.isSame(a[key], b[key])) {
          isDifferent = true;
        }
      }, this);
    }
    return isDifferent;
  },
  isSame: function isSame(a, b) {
    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
      return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      return !this.arraysDiffer(a, b);
    } else if (typeof a === 'function') {
      return a.toString() === b.toString();
    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
      return !this.objectsDiffer(a, b);
    }

    return a === b;
  },
  find: function find(collection, fn) {
    for (var i = 0, l = collection.length; i < l; i += 1) {
      var item = collection[i];
      if (fn(item)) {
        return item;
      }
    }
    return null;
  },
  runRules: function runRules(value, currentValues, validations, validationRules) {
    var results = {
      errors: [],
      failed: [],
      success: []
    };

    if (Object.keys(validations).length) {
      Object.keys(validations).forEach(function (validationMethod) {
        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
        }

        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
        }

        if (typeof validations[validationMethod] === 'function') {
          var validation = validations[validationMethod](currentValues, value);
          if (typeof validation === 'string') {
            results.errors.push(validation);
            results.failed.push(validationMethod);
          } else if (!validation) {
            results.failed.push(validationMethod);
          }
          return;
        } else if (typeof validations[validationMethod] !== 'function') {
          var _validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);

          if (typeof _validation === 'string') {
            results.errors.push(_validation);
            results.failed.push(validationMethod);
          } else if (!_validation) {
            results.failed.push(validationMethod);
          } else {
            results.success.push(validationMethod);
          }
          return;
        }

        results.success.push(validationMethod);
      });
    }

    return results;
  }
};

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1077);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryDocument.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryDocument.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1088);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SafeTechPopup.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SafeTechPopup.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1098);
    var insertCss = __webpack_require__(858);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParameters.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HistoryParameters.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section_css__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Section_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Section_css___default.a.Section);
      if (this.props.main) {
        classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, __WEBPACK_IMPORTED_MODULE_4__Section_css___default.a.Section__main);
      }
      if (this.props.sidebar) {
        classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, __WEBPACK_IMPORTED_MODULE_4__Section_css___default.a.Section__sidebar);
      }
      if (this.props.container) {
        classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, __WEBPACK_IMPORTED_MODULE_4__Section_css___default.a.Section__container);
      }
      return this[this.props.container ? 'renderContainer' : 'renderSection'](classes);
    }
  }, {
    key: 'renderContainer',
    value: function renderContainer(classes) {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.props.className, classes)
      }, void 0, this.props.children);
    }
  }, {
    key: 'renderSection',
    value: function renderSection(classes) {
      return _jsx('section', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.props.className, classes)
      }, void 0, this.props.children);
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Section_css___default.a)(Button));

/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ILEXCONNECT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TEST_SPIROTECH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPIROTECH_URL; });
var ILEXCONNECT_URL = 'i-lexconnect.com';
var TEST_SPIROTECH_URL = 'test.i-connect.spirotech.com';
var SPIROTECH_URL = 'i-connect.spirotech.com';

/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_timers__ = __webpack_require__(941);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CommonDevice = function (_React$Component) {
  _inherits(CommonDevice, _React$Component);

  function CommonDevice() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommonDevice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommonDevice.__proto__ || Object.getPrototypeOf(CommonDevice)).call.apply(_ref, [this].concat(args))), _this), _this.startSendingRemoteControl = function () {
      var intervalRce = __WEBPACK_IMPORTED_MODULE_2__constants_timers__["b" /* REMOTE_CONTROL_INTERVAL */] * 1000;
      if (_this.intervalRceId) {
        return;
      }
      _this.sendRemoteControl();
      _this.intervalRceId = window.setInterval(_this.sendRemoteControl, intervalRce);
    }, _this.startCheckingNewData = function () {
      var interval = 1000 * __WEBPACK_IMPORTED_MODULE_2__constants_timers__["a" /* CHECK_INTERVAL */];
      if (_this.intervalId) {
        return;
      }
      _this.checkForNewData();
      _this.intervalId = window.setInterval(_this.checkForNewData, interval);
    }, _this.sendRemoteControl = function () {
      var username = _this.props.user.get('id');
      _this.props.setDeviceCommandValue(_this.props.serial, 'setRCE', username);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommonDevice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCheckingNewData();
      this.startSendingRemoteControl();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var serial = this.props.device.get('serial');
      clearInterval(this.intervalId);
      clearInterval(this.intervalRceId);
      this.props.setDeviceCommandValue(serial, 'setRCE', '0');
    }
  }]);

  return CommonDevice;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CommonDevice);

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showPopup;
/* harmony export (immutable) */ __webpack_exports__["a"] = hidePopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(6);


function showPopup(subtype, options, noTimeout) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_66" /* SHOW_CUSTOM_POPUP */],
    subtype: subtype,
    options: options,
    noTimeout: noTimeout
  };
}

function hidePopup() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["R" /* HIDE_POPUP */]
  };
}

/***/ }),

/***/ 941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOTE_CONTROL_INTERVAL; });
var CHECK_INTERVAL = 2;
var REMOTE_CONTROL_INTERVAL = 10;

/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setUserAuthenticated */
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserPriviliges;
/* harmony export (immutable) */ __webpack_exports__["c"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearLoginActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
/* eslint-disable import/prefer-default-export */






function setUserAuthenticated(userId) {
  return {
    type: 'authenticated',
    userId: userId
  };
}

function getUserPriviliges() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants__["P" /* GET_USER_PRIVILIGES */],
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1__constants_urls__["a" /* default */].API_USERS + '/priviliges')
  };
}

function login(username, password) {
  return {
    type: 'LOGIN',
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/login', { username: username, password: password })
  };
}

function clearLoginActions() {
  return {
    type: 'CLEAR_LOGIN_ACTIONS'
  };
}

/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getConversation;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendMessageToConversation;
/* harmony export (immutable) */ __webpack_exports__["f"] = sendMessageToUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = resetPaging;
/* harmony export (immutable) */ __webpack_exports__["c"] = resetConversation;
/* harmony export (immutable) */ __webpack_exports__["g"] = showConversation;
/* harmony export (immutable) */ __webpack_exports__["b"] = hideConversation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__ = __webpack_require__(886);



function getConversation(conversationId, params, reqParams) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__["a" /* insertParams */])('/api/messages/' + conversationId + '?page_size=5', params);
  return {
    type: 'GET_CONVERSATION',
    conversationId: conversationId,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].get(url, reqParams)
  };
}

function sendMessageToConversation(conversationId, data) {
  return {
    type: 'SEND_MESSAGE_TO_CONVERSATION',
    conversationId: conversationId,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/messages/' + conversationId + '?action_type=send', data)
  };
}

function sendMessageToUser(userId, data) {
  return {
    type: 'SEND_MESSAGE_TO_USER',
    userId: userId,
    promise: __WEBPACK_IMPORTED_MODULE_0__core_HttpClient__["a" /* default */].post('/api/messages/direct/' + userId, data)
  };
}

function resetPaging() {
  return {
    type: 'RESET_CONVERSATION_PAGING'
  };
}

function resetConversation() {
  return {
    type: 'RESET_CONVERSATION'
  };
}

function showConversation(conversationId, recipient) {
  return {
    type: 'SHOW_CONVERSATION',
    conversationId: conversationId,
    recipient: recipient
  };
}

function hideConversation() {
  return {
    type: 'HIDE_CONVERSATION'
  };
}

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortInput_css__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SortInput_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SortInput = function (_React$Component) {
  _inherits(SortInput, _React$Component);

  function SortInput(props) {
    _classCallCheck(this, SortInput);

    var _this = _possibleConstructorReturn(this, (SortInput.__proto__ || Object.getPrototypeOf(SortInput)).call(this, props));

    _this.updateSearch = function (event) {
      var searchTerm = event.target.value;
      _this.setState({
        searchTerm: searchTerm
      }, function () {
        // if (this._throttleTimeout) {
        //   clearTimeout(this._throttleTimeout);
        // }

        // this._throttleTimeout = setTimeout(this.props.onChange, this.props.throttle, searchTerm);
      });
    };

    _this._handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.props.onChange(_this.state.searchTerm);
        _this.setState({
          readonly: !_this.state.readonly
        });
      }

      // if (event.keyCode === 8) {
      //   this.setState({
      //     searchTerm: '',
      //   });
      //   this.props.onChange('');
      //   this.setState({
      //     readonly: !this.state.readonly,
      //   });
      // }
    };

    _this.setSearch = function (event) {
      _this.props.onChange(_this.state.searchTerm);
      _this.setState({
        readonly: !_this.state.readonly
      });
    };

    _this.clearSearch = function (event) {
      _this.setState({
        searchTerm: ''
      });
      _this.props.onChange('');
      _this.setState({
        readonly: !_this.state.readonly
      });
    };

    _this.state = {
      searchTerm: '',
      readonly: false
    };
    return _this;
  }

  _createClass(SortInput, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          placeholder = _props.placeholder,
          valueholder = _props.valueholder;

      if (placeholder === valueholder) {
        this.setState({
          searchTerm: valueholder
        });
        this.setState({
          readonly: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var wrappedClass = this.state.searchTerm ? __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput, __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.is_active, __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a[this.props.className]) : __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput, __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.is_active);

      if (!this.state.readonly) {
        return _jsx('div', {
          className: wrappedClass
        }, void 0, _jsx('label', {
          htmlFor: this.props.name,
          className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_label
        }, void 0, this.props.title ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], {
          id: this.props.title
        }) : null), _jsx('input', {
          className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_field,
          type: 'search',
          name: this.props.name,
          id: this.props.name,
          placeholder: this.props.placeholder,
          value: this.state.searchTerm,
          onChange: this.updateSearch,
          onKeyDown: this._handleKeyDown
        }), _jsx(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
          disabled: this.props.requestInProgress ? true : false,
          buttonClass: 'search',
          block: true,
          type: 'button',
          onClick: this.setSearch
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */], {
          iconName: 'lupka',
          className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_icon,
          size: 20
        })));
      }
      return _jsx('div', {
        className: wrappedClass
      }, void 0, _jsx('label', {
        htmlFor: this.props.name,
        className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_label
      }, void 0, this.props.title ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], {
        id: this.props.title
      }) : null), _jsx('input', {
        readOnly: true,
        className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_field,
        type: 'search',
        name: this.props.name,
        id: this.props.name,
        placeholder: this.props.placeholder,
        value: this.state.searchTerm,
        onChange: this.updateSearch,
        onKeyDown: this._handleKeyDown
      }), _jsx(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
        disabled: this.props.requestInProgress ? true : false,
        buttonClass: 'search',
        block: true,
        type: 'button',
        onClick: this.clearSearch
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */], {
        iconName: 'odrzuc_margin',
        className: __WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a.SortInput_icon,
        size: 20
      })));
    }
  }]);

  return SortInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SortInput.defaultProps = {
  throttle: 200,
  requestInProgress: false
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["g" /* injectIntl */])(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7__SortInput_css___default.a)(SortInput)));

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sort_css__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sort_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sort_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function Sort(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Sort_css___default.a.Sort, __WEBPACK_IMPORTED_MODULE_4__Sort_css___default.a[props.className])
  }, void 0, props.children);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Sort_css___default.a)(Sort));

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getAvailableProducers;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAvailableDeviceTypes;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDevicesList;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSafeFloorList;
/* harmony export (immutable) */ __webpack_exports__["i"] = setSort;
/* harmony export (immutable) */ __webpack_exports__["e"] = setConnectFilter;
/* harmony export (immutable) */ __webpack_exports__["g"] = setProducentFilter;
/* harmony export (immutable) */ __webpack_exports__["f"] = setDeviceTypeFilter;
/* harmony export (immutable) */ __webpack_exports__["h"] = setSearchQuery;
/* unused harmony export resetPaging */
/* unused harmony export resetDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_HttpClient__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(884);
/* eslint-disable import/prefer-default-export */






function getAvailableProducers() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* GET_AVAILABLE_PRODUCERS */],
    promise: __WEBPACK_IMPORTED_MODULE_2__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["a" /* default */].API_LISTS + '/producers')
  };
}

function getAvailableDeviceTypes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* GET_AVAILABLE_DEVICETYPES */],
    promise: __WEBPACK_IMPORTED_MODULE_2__core_HttpClient__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants_urls__["a" /* default */].API_LISTS + '/devicetypes')
  };
}

function getDevicesList(params) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__["a" /* insertParams */])('' + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["a" /* default */].API2_URL, params);
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* GET_DEVICES_LIST */],
    promise: __WEBPACK_IMPORTED_MODULE_2__core_HttpClient__["a" /* default */].get(url)
  };
}

function getSafeFloorList(params) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_actionHelpers__["a" /* insertParams */])('' + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["a" /* default */].API2_URL, params);
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["O" /* GET_SAFEFLOORS_LIST */],
    promise: __WEBPACK_IMPORTED_MODULE_2__core_HttpClient__["a" /* default */].get(url)
  };
}
function setSort(sort) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_33" /* SET_DEVICES_SORT */],
    sort: sort
  };
}

function setConnectFilter(filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_29" /* SET_DEVICES_CONNECT_FILTER */],
    filter: filter
  };
}

function setProducentFilter(filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_31" /* SET_DEVICES_PRODUCENT_FILTER */],
    filter: filter
  };
}

function setDeviceTypeFilter(filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_30" /* SET_DEVICES_DEVICETYPE_FILTER */],
    filter: filter
  };
}

function setSearchQuery(searchQuery) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_32" /* SET_DEVICES_SEARCH_QUERY */],
    searchQuery: searchQuery
  };
}

function resetPaging() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_0" /* RESET_DEVICES_PAGING */]
  };
}

function resetDevices() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* RESET_DEVICES */]
  };
}

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(70);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(79);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./src/components/InfiniteScroll/InfiniteScroll.js
var InfiniteScroll = __webpack_require__(891);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(856);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(855);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./src/components/InfiniteScroll/ListWithLoadMore.css
var ListWithLoadMore = __webpack_require__(1001);
var ListWithLoadMore_default = /*#__PURE__*/__webpack_require__.n(ListWithLoadMore);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(862);

// EXTERNAL MODULE: ./src/components/InfiniteScroll/otworz.svg
var otworz = __webpack_require__(1005);
var otworz_default = /*#__PURE__*/__webpack_require__.n(otworz);

// CONCATENATED MODULE: ./src/components/InfiniteScroll/ListWithLoadMore.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var _ref = _jsx('img', {
  src: otworz_default.a,
  width: '38',
  height: '38'
});

var _ref2 = _jsx('img', {
  src: otworz_default.a,
  width: '38',
  height: '38'
});

function ListWithLoadMore_ListWithLoadMore(props) {
  if (props.table) {
    return _jsx('tbody', {}, void 0, props.children, props.hasMore ? _jsx('tr', {}, void 0, _jsx('div', {
      className: ListWithLoadMore_default.a.showMoreIcon
    }, void 0, _jsx(Button["a" /* default */], {
      buttonClass: 'transparent',
      block: true,
      type: 'button',
      onClick: props.loadMore
    }, void 0, _ref))) : null);
  }
  return _jsx('div', {}, void 0, props.children, props.hasMore ? _jsx('div', {
    className: ListWithLoadMore_default.a.showMoreIcon
  }, void 0, _jsx(Button["a" /* default */], {
    buttonClass: 'transparent',
    block: true,
    type: 'button',
    onClick: props.loadMore
  }, void 0, _ref2)) : null);
}

/* harmony default export */ var InfiniteScroll_ListWithLoadMore = (withStyles_default()(ListWithLoadMore_default.a)(ListWithLoadMore_ListWithLoadMore));
// EXTERNAL MODULE: ./src/components/Loader/Loader.js
var Loader = __webpack_require__(861);

// CONCATENATED MODULE: ./src/components/InfiniteScroll/InfiniteScrollWithLoadMore.js
var InfiniteScrollWithLoadMore__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var InfiniteScrollWithLoadMore__ref = InfiniteScrollWithLoadMore__jsx(Loader["a" /* default */], {
  block: true
});

function InfiniteScrollWithLoadMore(props) {
  return props.showLoadMore ? react_default.a.createElement(InfiniteScroll_ListWithLoadMore, props) : react_default.a.createElement(InfiniteScroll["a" /* default */], _extends({}, props, { loader: InfiniteScrollWithLoadMore__ref }));
}

/* harmony default export */ var InfiniteScroll_InfiniteScrollWithLoadMore = __webpack_exports__["a"] = (InfiniteScrollWithLoadMore);

/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(70);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(79);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(855);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(1062);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/components/Layout/Layout.css
var Layout = __webpack_require__(1064);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout);

// EXTERNAL MODULE: ./node_modules/fbjs/lib/ExecutionEnvironment.js
var ExecutionEnvironment = __webpack_require__(20);
var ExecutionEnvironment_default = /*#__PURE__*/__webpack_require__.n(ExecutionEnvironment);

// EXTERNAL MODULE: ./node_modules/history/createBrowserHistory.js
var createBrowserHistory = __webpack_require__(489);
var createBrowserHistory_default = /*#__PURE__*/__webpack_require__.n(createBrowserHistory);

// EXTERNAL MODULE: ./node_modules/history/createMemoryHistory.js
var createMemoryHistory = __webpack_require__(1066);
var createMemoryHistory_default = /*#__PURE__*/__webpack_require__.n(createMemoryHistory);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(487);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// CONCATENATED MODULE: ./src/core/Location.js





// import useQueries from 'history/lib/useQueries';

var Location_location = query_string_default.a.parse(ExecutionEnvironment["canUseDOM"] ? createBrowserHistory_default.a : createMemoryHistory_default.a);
// const location = useQueries(canUseDOM ? createHistory : createMemoryHistory)();

/* harmony default export */ var core_Location = (Location_location);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(477);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(872);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js
var index_es = __webpack_require__(101);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(856);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/Popup/Popup.css
var Popup = __webpack_require__(863);
var Popup_default = /*#__PURE__*/__webpack_require__.n(Popup);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(862);

// EXTERNAL MODULE: ./src/components/Icon/Icon.js
var Icon = __webpack_require__(860);

// CONCATENATED MODULE: ./src/utils/DOMUtils.js
function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function windowScrollX() {
  return window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
}

function windowScrollY() {
  return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

function getNoScrollLocationState() {
  return { scrollY: document.body.classList.contains('is-fixed') ? -parseInt(document.body.style.top, 10) : windowScrollY() };
}
// CONCATENATED MODULE: ./src/components/Popup/popupBehaviour.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ESC_KEY_CODE = 27;
/* harmony default export */ var Popup_popupBehaviour = (function (ComposedComponent) {
  return function (_React$Component) {
    _inherits(popupBehaviour, _React$Component);

    function popupBehaviour() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, popupBehaviour);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = popupBehaviour.__proto__ || Object.getPrototypeOf(popupBehaviour)).call.apply(_ref, [this].concat(args))), _this), _this.closePopup = function (e) {
        if (_this.props.overrideOnClose) {
          _this.props.onClose(e);
          return;
        }
        var currentLocation = core_Location.getCurrentLocation();
        var query = Object.assign({}, currentLocation.query);

        delete query[_this.props.popupQueryIdentifier || 'showPopup'];

        core_Location.push({
          pathname: currentLocation.pathname,
          state: getNoScrollLocationState(),
          query: query
        });
        if (_this.props.onClose) {
          _this.props.onClose(e);
        }
      }, _this.handleWindowKeyUp = function (e) {
        if (e.keyCode === ESC_KEY_CODE) {
          _this.closePopup(e);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(popupBehaviour, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            onClose = _props.onClose,
            overrideOnClose = _props.overrideOnClose,
            popupQueryIdentifier = _props.popupQueryIdentifier,
            props = _objectWithoutProperties(_props, ['onClose', 'overrideOnClose', 'popupQueryIdentifier']);

        return react_default.a.createElement(ComposedComponent, _extends({}, props, { onClose: this.closePopup }));
      }
    }]);

    return popupBehaviour;
  }(react_default.a.Component);
});
// CONCATENATED MODULE: ./src/components/Popup/Popup.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var Popup__ref = _jsx(Icon["a" /* default */], {
  iconName: "odrzuc",
  size: 20
});

function Popup_Popup(props) {
  var devicetype = props.devicetype;

  var PopupOverviewClose = devicetype === 'superior' ? classnames_default()(Popup_default.a.PopupOverview_close, Popup_default.a.close_spirotech) : classnames_default()(Popup_default.a.PopupOverview_close);

  var className = props.className;

  var wrappedStyle = classnames_default()(Popup_default.a.Popup, className);
  return _jsx('div', {
    className: Popup_default.a.Popup_wrapper
  }, void 0, _jsx('div', {
    className: Popup_default.a.Popup_overlay,
    onClick: props.onClose
  }), _jsx('div', {
    className: wrappedStyle
  }, void 0, _jsx('div', {
    className: classnames_default()(Popup_default.a.Popup_close, Popup_default.a.u_cf)
  }, void 0, _jsx('button', {
    type: 'button',
    className: PopupOverviewClose,
    onClick: props.onClose
  }, void 0, Popup__ref)), props.children));
}

Popup_Popup.defaultProps = {
  devicetype: ''
};

/* harmony default export */ var components_Popup_Popup = (Popup_popupBehaviour(withStyles_default()(Popup_default.a)(Popup_Popup)));
// CONCATENATED MODULE: ./src/components/Popup/Messages.js


function Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    serial_number_label_main_screen_text: {
      'id': 'serial_number_label_main_screen_text',
      'defaultMessage': 'Serial number'
    },
    address_label_main_screen_text: {
      'id': 'address_label_main_screen_text',
      'defaultMessage': 'Address'
    },
    address_noinformation_main_screen_text: {
      'id': 'address_noinformation_main_screen_text',
      'defaultMessage': 'No information'
    },
    address_placeholder_main_screen_text: {
      'id': 'address_placeholder_main_screen_text',
      'defaultMessage': 'Enter a new address'
    },
    additional_information_label_main_screen_text: {
      'id': 'additional_information_label_main_screen_text',
      'defaultMessage': 'Name'
    },
    comment_noinformation_main_screen_text: {
      'id': 'comment_noinformation_main_screen_text',
      'defaultMessage': 'No information'
    },
    comment_placeholder_main_screen_text: {
      'id': 'comment_placeholder_main_screen_text',
      'defaultMessage': 'Enter a new additional information'
    },
    bottle_configuration_main_screen_text: {
      'id': 'bottle_configuration_main_screen_text',
      'defaultMessage': 'Bottle configuration'
    },
    valve_main_screen_text: {
      'id': 'valve_main_screen_text',
      'defaultMessage': 'Valve'
    },
    save_changes_button_main_screen_text: {
      'id': 'save_changes_button_main_screen_text',
      'defaultMessage': 'Save changes'
    },
    send_command_command_popup: {
      'id': 'send_command_command_popup',
      'defaultMessage': 'Command'
    },
    send_command_value_popup: {
      'id': 'send_command_value_popup',
      'defaultMessage': 'Value'
    },
    pairing_cofirmation_info_text: {
      'id': 'pairing_cofirmation_info_text',
      'defaultMessage': 'To pair a new sensor, click the `Add` button <br/>The device must be active and assigned to the user account.<br/>To activate (wake up) the sensor, open the top cover of the housing and press the button.'
    },
    pairing_confirmation_text: {
      'id': 'pairing_confirmation_text',
      'defaultMessage': 'Add'
    },
    pairing_start_button_text: {
      'id': 'pairing_start_button_text',
      'defaultMessage': 'Pair with'
    },
    pairing_already_connected_list_text: {
      'id': 'pairing_already_connected_list_text',
      'defaultMessage': 'List of paired floor sensors:'
    },
    pairing_available_floor_sensors: {
      'id': 'pairing_available_floor_sensors',
      'defaultMessage': 'Available floor sensors'
    },
    pairing_paired_on_device: {
      'id': 'pairing_paired_on_device',
      'defaultMessage': 'Paired only on device'
    },
    pairing_paired_on_device_and_service: {
      'id': 'pairing_paired_on_device_and_service',
      'defaultMessage': 'Paired locally and via web service'
    },
    pairing_paired_on_service: {
      'id': 'pairing_paired_on_service',
      'defaultMessage': 'Paired only with web service'
    },
    pairing_pair_only_in_service: {
      'id': 'pairing_pair_only_in_service',
      'defaultMessage': 'The sensor cannot be paired with the device via the local network (WiFi).<br/>Do you want to continue and combine the devices only via the internet web application?'
    },
    pairing_status_active: {
      'id': 'pairing_status_active',
      'defaultMessage': 'Pairing in progress...'
    },
    pairing_status_not_paired: {
      'id': 'pairing_status_not_paired',
      'defaultMessage': 'Not paired'
    },
    pairing_status_paired: {
      'id': 'pairing_status_paired',
      'defaultMessage': 'Paired'
    },
    pairing_no_floor_sensors: {
      'id': 'pairing_no_floor_sensors',
      'defaultMessage': 'No available floor sensors'
    },
    pairing_connected_safetech_to_softeners_text: {
      'id': 'pairing_connected_safetech_to_softeners_text',
      'defaultMessage': 'List of connected SafeTech devices'
    },
    pairing_connected_softeners_to_safetech_text: {
      'id': 'pairing_connected_softeners_to_safetech_text',
      'defaultMessage': 'List of connected softeners'
    },
    create_ownership_popup_title: {
      'id': 'create_ownership_popup_title',
      'defaultMessage': 'Add device ownership'
    },
    create_ownership_popup_msg: {
      'id': 'create_ownership_popup_msg',
      'defaultMessage': 'Device has been added to your account'
    },
    remove_ownership_popup_title: {
      'id': 'remove_ownership_popup_title',
      'defaultMessage': 'Remove device from user'
    },
    remove_ownership_popup_msg: {
      'id': 'remove_ownership_popup_msg',
      'defaultMessage': 'Device has been removed'
    },
    save_password_popup_title: {
      'id': 'save_password_popup_title',
      'defaultMessage': 'New password'
    },
    save_password_popup_msg: {
      'id': 'save_password_popup_msg',
      'defaultMessage': 'New password has been set'
    },
    blocked_interaction_popup_title: {
      'id': 'blocked_interaction_popup_title',
      'defaultMessage': 'Action is blocked'
    },
    blocked_interaction_popup_msg: {
      'id': 'blocked_interaction_popup_msg',
      'defaultMessage': 'Action is blocked'
    },
    edit_personal_data_popup_title: {
      'id': 'edit_personal_data_popup_title',
      'defaultMessage': 'Personal data'
    },
    edit_personal_data_popup_msg: {
      'id': 'edit_personal_data_popup_msg',
      'defaultMessage': 'Your personal data have been saved'
    },
    save_notification_config_popup_title: {
      'id': 'save_notification_config_popup_title',
      'defaultMessage': 'Email notifications'
    },
    save_notification_config_popup_msg: {
      'id': 'save_notification_config_popup_msg',
      'defaultMessage': 'Your email notifications have been saved'
    },
    add_ownership_failure_popup_title: {
      'id': 'add_ownership_failure_popup_title',
      'defaultMessage': 'Add device to user'
    },
    add_ownership_failure_popup_msg: {
      'id': 'add_ownership_failure_popup_msg',
      'defaultMessage': 'We could not add device to user'
    },
    remove_ownership_failure_popup_title: {
      'id': 'remove_ownership_failure_popup_title',
      'defaultMessage': 'Remove device from user'
    },
    remove_ownership_failure_popup_msg: {
      'id': 'remove_ownership_failure_popup_msg',
      'defaultMessage': 'We could not remove user assigment'
    },
    no_users_found_title: {
      'id': 'no_users_found_title',
      'defaultMessage': 'No users found'
    },
    edit_popup_users_text: {
      'id': 'edit_popup_users_text',
      'defaultMessage': 'users'
    },
    edit_popup_user_text: {
      'id': 'edit_popup_user_text',
      'defaultMessage': 'user'
    },
    add_device_incorrect_serial_number_title: {
      'id': 'add_device_incorrect_serial_number_title',
      'defaultMessage': 'Serial number of the device is not correct'
    },
    add_device_incorrect_serial_number_msg: {
      'id': 'add_device_incorrect_serial_number_msg',
      'defaultMessage': 'Correct serial number has 9 digits and is preceded by single character (C/M/L or S). Serial number of the device can be found on a sticker in its back or in menu at Info/Status screen'
    },
    add_device_not_found_title: {
      'id': 'add_device_not_found_title',
      'defaultMessage': 'Device has not been found'
    },
    add_device_not_found_msg: {
      'id': 'add_device_not_found_msg',
      'defaultMessage': 'Please check if device is powered on, connected to the network and has Internet access'
    },
    add_device_unavailable_title: {
      'id': 'add_device_unavailable_title',
      'defaultMessage': 'Device is unavailable'
    },
    add_device_unavailable_msg: {
      'id': 'add_device_unavailable_msg',
      'defaultMessage': 'Device  assigned to other user. To assign to your account , you need to remove it from current assigned account'
    },
    add_device_error_title: {
      'id': 'add_device_error_title',
      'defaultMessage': 'Error occured'
    },
    add_device_error_msg: {
      'id': 'add_device_error_msg',
      'defaultMessage': 'Contact administrator'
    },
    add_device_to_installation_title: {
      'id': 'add_device_to_installation_title',
      'defaultMessage': 'Protection installation'
    },
    add_device_to_installation_msg: {
      'id': 'add_device_to_installation_msg',
      'defaultMessage': 'Device has been added'
    },
    add_device_to_installation_already_exists_title: {
      'id': 'add_device_to_installation_already_exists_title',
      'defaultMessage': 'Protedction installation already exists'
    },
    add_device_to_installation_already_exists_msg: {
      'id': 'add_device_to_installation_already_exists_msg',
      'defaultMessage': 'Installation already exists'
    },
    add_device_to_installation_not_exist_title: {
      'id': 'add_device_to_installation_not_exist_title',
      'defaultMessage': 'Protection installation: device does not exist'
    },
    add_device_to_installation_not_exist_msg: {
      'id': 'add_device_to_installation_not_exist_msg',
      'defaultMessage': 'You can not add this device to installation, because it not exist or type is wrong'
    },
    remove_device_from_installation_title: {
      'id': 'remove_device_from_installation_title',
      'defaultMessage': 'Device has been deleted'
    },
    remove_device_from_installation_msg: {
      'id': 'remove_device_from_installation_msg',
      'defaultMessage': 'Device has been deleted from installation'
    },
    remove_device_from_installation_error_title: {
      'id': 'remove_device_from_installation_error_title',
      'defaultMessage': 'Device has not been deleted'
    },
    remove_device_from_installation_error_msg: {
      'id': 'remove_device_from_installation_error_msg',
      'defaultMessage': 'You can not delete device from this installation'
    },
    salt_sensor_history_yes: {
      'id': 'salt_sensor_history_yes',
      'defaultMessage': 'Yes'
    },
    salt_sensor_history_no: {
      'id': 'salt_sensor_history_no',
      'defaultMessage': 'No'
    },
    medium_01_softener_text: {
      'id': 'medium_01_softener_text',
      'defaultMessage': 'Lewatit 1567'
    },
    medium_02_softener_text: {
      'id': 'medium_02_softener_text',
      'defaultMessage': 'Birm'
    },
    medium_03_softener_text: {
      'id': 'medium_03_softener_text',
      'defaultMessage': 'Greensand'
    },
    medium_05_softener_text: {
      'id': 'medium_05_softener_text',
      'defaultMessage': 'Crystal Right CR 200'
    },
    medium_06_softener_text: {
      'id': 'medium_06_softener_text',
      'defaultMessage': 'Activated carbon'
    },
    medium_07_softener_text: {
      'id': 'medium_07_softener_text',
      'defaultMessage': 'Multilayer activated carbon+sand+gravel'
    },
    medium_08_softener_text: {
      'id': 'medium_08_softener_text',
      'defaultMessage': 'Crystal Right CR 100'
    },
    medium_09_softener_text: {
      'id': 'medium_09_softener_text',
      'defaultMessage': 'Filter AG Plus'
    },
    medium_10_softener_text: {
      'id': 'medium_10_softener_text',
      'defaultMessage': 'PA 202'
    },
    medium_11_softener_text: {
      'id': 'medium_11_softener_text',
      'defaultMessage': 'Ecomix A'
    },
    medium_12_softener_text: {
      'id': 'medium_12_softener_text',
      'defaultMessage': 'Nitro'
    },
    single_bottle_text: {
      'id': 'single_bottle_text',
      'defaultMessage': 'Pojedynczy'
    },
    singlefilter_bottle_text: {
      'id': 'singlefilter_bottle_text',
      'defaultMessage': 'Pojedynczy filtr'
    },
    doubleparallel_bottle_text: {
      'id': 'doubleparallel_bottle_text',
      'defaultMessage': 'Podw\xF3jny r\xF3wnoleg\u0142y'
    },
    doublealternative_bottle_text: {
      'id': 'doublealternative_bottle_text',
      'defaultMessage': 'Podw\xF3jny alternatywny'
    },
    doublefilter_bottle_text: {
      'id': 'doublefilter_bottle_text',
      'defaultMessage': 'Podw\xF3jny filtr'
    },
    tripleparallel_bottle_text: {
      'id': 'tripleparallel_bottle_text',
      'defaultMessage': 'Potr\xF3jny r\xF3wnoleg\u0142y'
    },
    triplealternative_bottle_text: {
      'id': 'triplealternative_bottle_text',
      'defaultMessage': 'Potr\xF3jny alternatywny'
    },
    triplefilter_bottle_text: {
      'id': 'triplefilter_bottle_text',
      'defaultMessage': 'Potr\xF3jny filtr'
    },
    search_box_device_list: {
      'id': 'search_box_device_list',
      'defaultMessage': 'Search'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/Popup/SimpleNotificationPopup.js
var SimpleNotificationPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









function SimpleNotificationPopup(props) {
  var messages = Messages();
  var title = props.title,
      message = props.message;

  return SimpleNotificationPopup__jsx(components_Popup_Popup, {
    className: Popup_default.a.Popup__notification,
    onClose: props.onClose,
    overrideOnClose: true
  }, void 0, SimpleNotificationPopup__jsx('ul', {
    className: Popup_default.a.Popup_tab
  }, void 0, SimpleNotificationPopup__jsx('li', {
    className: Popup_default.a.is_selected
  }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[title]))), SimpleNotificationPopup__jsx('p', {
    className: Popup_default.a.Popup_body
  }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[message])));
}

/* harmony default export */ var Popup_SimpleNotificationPopup = (withStyles_default()(Popup_default.a)(SimpleNotificationPopup));
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(80);

// EXTERNAL MODULE: ./src/components/Grid/Grid.js
var Grid = __webpack_require__(874);

// EXTERNAL MODULE: ./src/components/Input/Input.js + 1 modules
var Input = __webpack_require__(883);

// EXTERNAL MODULE: ./src/components/Form/Form.js
var Form = __webpack_require__(867);

// EXTERNAL MODULE: ./src/components/SaveChangeButtonPopup/SaveChangesButton.css
var SaveChangesButton = __webpack_require__(1073);
var SaveChangesButton_default = /*#__PURE__*/__webpack_require__.n(SaveChangesButton);

// CONCATENATED MODULE: ./src/components/SaveChangeButtonPopup/Messages.js


function Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    save_changes_button_main_screen_text: {
      'id': 'save_changes_button_main_screen_text',
      'defaultMessage': 'Save changes'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/SaveChangeButtonPopup/SaveChangesButton.js
var SaveChangesButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










function SaveChangesButton_SaveChangesButton(props) {
  var devicetype = props.devicetype;

  var isSuperior = devicetype === 'superior';
  var lightColor = isSuperior ? 'light_spirotech' : 'light';
  var colorStyled = isSuperior ? classnames_default()(SaveChangesButton_default.a.black_text) : classnames_default()(SaveChangesButton_default.a.superior_text);
  var messages = Messages_Messages();
  return SaveChangesButton__jsx(Button["a" /* default */], {
    buttonColor: lightColor,
    onClick: props.onClick,
    type: 'submit',
    block: true
  }, void 0, SaveChangesButton__jsx('div', {
    className: colorStyled
  }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.save_changes_button_main_screen_text)));
}

SaveChangesButton_SaveChangesButton.defaultProps = {
  devicetype: ''
};

/* harmony default export */ var SaveChangeButtonPopup_SaveChangesButton = (Object(index_es["g" /* injectIntl */])(withStyles_default()(SaveChangesButton_default.a)(SaveChangesButton_SaveChangesButton)));
// EXTERNAL MODULE: ./src/actions/device.js
var actions_device = __webpack_require__(859);

// CONCATENATED MODULE: ./src/components/Popup/EditDevicePopUp.js
var EditDevicePopUp__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var EditDevicePopUp__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function EditDevicePopUp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditDevicePopUp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditDevicePopUp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EditDevicePopUp_EditDevicePopup = function (_React$Component) {
  EditDevicePopUp__inherits(EditDevicePopup, _React$Component);

  function EditDevicePopup(props) {
    EditDevicePopUp__classCallCheck(this, EditDevicePopup);

    var _this = EditDevicePopUp__possibleConstructorReturn(this, (EditDevicePopup.__proto__ || Object.getPrototypeOf(EditDevicePopup)).call(this, props));

    _this.onClick = function () {
      _this.props.saveDeviceData(_this.props.serial, {
        additionalinfo: _this.state.additionalinfo,
        address: _this.state.address
      });
      _this.props.onClose();
    };

    _this.onFieldChange = function (field, e) {
      _this.setState(_defineProperty({}, field, e));
    };

    _this.renderForm = function (intl, messages, devicetype) {
      var notFirmwareTypes = ['safe-t', 'safetech', 'safefloor'];
      if (notFirmwareTypes.indexOf(devicetype) < 0) {
        return EditDevicePopUp__jsx(Form["a" /* default */], {
          onSubmit: _this.onSubmit
        }, void 0, EditDevicePopUp__jsx(Grid["a" /* default */].Cell, {}, void 0, EditDevicePopUp__jsx(Input["a" /* default */], {
          type: 'text',
          name: 'address',
          title: intl.formatMessage(messages.address_label_main_screen_text),
          value: _this.props.address,
          onChange: _this.onFieldChange.bind(_this, 'address'),
          titleVisibility: true
        })), EditDevicePopUp__jsx(Grid["a" /* default */].Cell, {}, void 0, EditDevicePopUp__jsx(Input["a" /* default */], {
          type: 'text',
          name: 'additionalinfo',
          title: intl.formatMessage(messages.additional_information_label_main_screen_text),
          value: _this.props.comment,
          onChange: _this.onFieldChange.bind(_this, 'additionalinfo'),
          titleVisibility: true
        })), EditDevicePopUp__jsx(SaveChangeButtonPopup_SaveChangesButton, {
          devicetype: devicetype,
          onClick: _this.onClick
        }));
      }
      return EditDevicePopUp__jsx(Form["a" /* default */], {
        onSubmit: _this.onSubmit
      }, void 0, EditDevicePopUp__jsx(Grid["a" /* default */].Cell, {}, void 0, EditDevicePopUp__jsx(Input["a" /* default */], {
        type: 'text',
        name: 'address',
        title: intl.formatMessage(messages.address_label_main_screen_text),
        value: _this.props.address,
        onChange: _this.onFieldChange.bind(_this, 'address'),
        titleVisibility: true
      })), EditDevicePopUp__jsx(SaveChangeButtonPopup_SaveChangesButton, {
        devicetype: devicetype,
        onClick: _this.onClick
      }));
    };

    _this.state = {
      additionalinfo: _this.props.comment,
      address: _this.props.address
    };
    return _this;
  }

  EditDevicePopUp__createClass(EditDevicePopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          devicetype = _props.devicetype,
          serial = _props.serial;

      var messages = Messages();
      var isSuperior = devicetype === 'superior';
      var notFirmwareTypes = ['safe-t', 'safetech', 'safefloor'];
      return EditDevicePopUp__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, serial, this.renderForm(intl, messages, devicetype));
    }
  }]);

  return EditDevicePopup;
}(react_default.a.Component);

EditDevicePopUp_EditDevicePopup.defaultProps = {
  comment: '',
  address: '',
  devicetype: ''
};

var EditDevicePopUp_mapDispatch = function mapDispatch(dispatch) {
  return {
    saveDeviceData: function saveDeviceData(serial, data) {
      return dispatch(Object(actions_device["n" /* saveDeviceData */])(serial, data));
    }
  };
};

/* harmony default export */ var EditDevicePopUp = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(null, EditDevicePopUp_mapDispatch), withStyles_default()(Popup_default.a))(EditDevicePopUp_EditDevicePopup)));
// EXTERNAL MODULE: ./src/core/deviceHelper.js
var deviceHelper = __webpack_require__(865);

// EXTERNAL MODULE: ./src/components/Loader/Loader.js
var Loader = __webpack_require__(861);

// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/utils.js
var utils__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ONLY_DEVICE_CONNECTION = 'ONLY_DEVICE_CONNECTION';
var DEVICE_PLUS_SERVICE_CONNECTION = 'DEVICE_PLUS_SERVICE_CONNECTION';
var ONLY_SERVICE_CONNECTION = 'ONLY_SERVICE_CONNECTION';

function getActiveNoConnectedFloorSensors(availableSafeFloors, listOfConnectedDevices) {
  var updatedDevicesOptions = [];
  if (availableSafeFloors === null) {
    return updatedDevicesOptions;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = availableSafeFloors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      var found = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = listOfConnectedDevices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el2 = _step2.value;

          if (el.value == el2['serial']) {
            found = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!found) {
        updatedDevicesOptions.push({ 'title': el.title, 'value': el.value });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return updatedDevicesOptions;
}

function concatenateLists(installations, connectedAtDevice) {

  var ouputList = [];
  var deviceFromInstallation = [];
  var deviceFromSafeTechLiveData = [];
  if (installations) {
    var serialFromInstallationList = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = installations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var element = _step3.value;

        serialFromInstallationList.push(element['serial']);
        // service
        deviceFromInstallation.push(utils__extends({}, element, {
          'type': ONLY_SERVICE_CONNECTION
        }));
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = connectedAtDevice[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var element2 = _step4.value;


        if (serialFromInstallationList.indexOf(element2['SN']) < 0) {
          // only on device
          deviceFromSafeTechLiveData.push({ 'id': null, 'serial': element2['SN'], 'type': ONLY_DEVICE_CONNECTION });
        } else {
          // got already installation, so update to device+service
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = deviceFromInstallation[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var install = _step5.value;

              install.type = DEVICE_PLUS_SERVICE_CONNECTION;
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  } else {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = connectedAtDevice[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _element = _step6.value;

        // only on device
        deviceFromSafeTechLiveData.push({
          'id': null,
          'serial': _element['SN'],
          'type': ONLY_DEVICE_CONNECTION
        });
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }
  // 
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = deviceFromInstallation[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var a = _step7.value;

      ouputList.push(a);
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = deviceFromSafeTechLiveData[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var _a = _step8.value;

      ouputList.push(_a);
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return ouputList;
}
// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/ConnectedDevicesCommon.js
var ConnectedDevicesCommon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function ConnectedDevicesCommon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConnectedDevicesCommon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConnectedDevicesCommon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ConnectedDevicesCommon_ConnectedDevicesCommon = function (_React$Component) {
	ConnectedDevicesCommon__inherits(ConnectedDevicesCommon, _React$Component);

	function ConnectedDevicesCommon() {
		var _ref;

		var _temp, _this, _ret;

		ConnectedDevicesCommon__classCallCheck(this, ConnectedDevicesCommon);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ConnectedDevicesCommon__possibleConstructorReturn(this, (_ref = ConnectedDevicesCommon.__proto__ || Object.getPrototypeOf(ConnectedDevicesCommon)).call.apply(_ref, [this].concat(args))), _this), _this.getValue = function (item, field) {
			var value = null;
			try {
				value = item.get(field);
			} catch (error) {
				value = item[field];
			}
			return value;
		}, _this.showText = function (item, userRole) {
			var isPriviligedUser = Object(deviceHelper["i" /* isPriviliged */])(userRole);
			var iconSize = 20;
			var id = _this.getValue(item, 'id');
			var serial = _this.getValue(item, 'serial');
			var haveInstallation = null;

			switch (_this.getValue(item, 'type')) {
				case ONLY_DEVICE_CONNECTION:
					haveInstallation = classnames_default()(Popup_default.a.marginRight, Popup_default.a.red_text);
					break;
				case DEVICE_PLUS_SERVICE_CONNECTION:
					haveInstallation = classnames_default()(Popup_default.a.marginRight, Popup_default.a.green_text);
					break;
				case ONLY_SERVICE_CONNECTION:
					haveInstallation = classnames_default()(Popup_default.a.marginRight, Popup_default.a.orange_text);
					break;
				default:
					haveInstallation = classnames_default()(Popup_default.a.marginRight);
					break;
			}

			return ConnectedDevicesCommon__jsx('span', {}, void 0, ConnectedDevicesCommon__jsx('span', {
				className: haveInstallation
			}, void 0, ConnectedDevicesCommon__jsx('li', {}, void 0, serial, isPriviligedUser ? ConnectedDevicesCommon__jsx('div', {
				className: Popup_default.a.iconWrapper,
				onClick: function onClick() {
					_this.deleteDevice(id, serial);
				}
			}, void 0, ConnectedDevicesCommon__jsx(Icon["a" /* default */], {
				iconName: 'kosz',
				size: iconSize,
				small: true
			})) : null)));
		}, _temp), ConnectedDevicesCommon__possibleConstructorReturn(_this, _ret);
	}

	return ConnectedDevicesCommon;
}(react_default.a.Component);

/* harmony default export */ var DevicePopups_ConnectedDevicesCommon = (ConnectedDevicesCommon_ConnectedDevicesCommon);
// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/ConnectedDevicesSoftenerXSafeTech.js
var ConnectedDevicesSoftenerXSafeTech__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConnectedDevicesSoftenerXSafeTech__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConnectedDevicesSoftenerXSafeTech__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConnectedDevicesSoftenerXSafeTech__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConnectedDevicesSoftenerXSafeTech__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ConnectedDevicesSoftenerXSafeTech_ConnectedDevicesSoftenerXSafeTech = function (_ConnectedDevicesComm) {
	ConnectedDevicesSoftenerXSafeTech__inherits(ConnectedDevicesSoftenerXSafeTech, _ConnectedDevicesComm);

	function ConnectedDevicesSoftenerXSafeTech() {
		var _ref;

		var _temp, _this, _ret;

		ConnectedDevicesSoftenerXSafeTech__classCallCheck(this, ConnectedDevicesSoftenerXSafeTech);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ConnectedDevicesSoftenerXSafeTech__possibleConstructorReturn(this, (_ref = ConnectedDevicesSoftenerXSafeTech.__proto__ || Object.getPrototypeOf(ConnectedDevicesSoftenerXSafeTech)).call.apply(_ref, [this].concat(args))), _this), _this.deleteDevice = function (installation_id, serial) {
			if (installation_id) {
				_this.props.removeProtectedInstallation(installation_id, serial);
			}
		}, _temp), ConnectedDevicesSoftenerXSafeTech__possibleConstructorReturn(_this, _ret);
	}

	ConnectedDevicesSoftenerXSafeTech__createClass(ConnectedDevicesSoftenerXSafeTech, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    device = _props.device,
			    userRole = _props.userRole,
			    serial = _props.serial;

			var messages = Messages();
			var installation = device.get('installation');
			var softeners = ['softener', 'charlie', 'simplex'];
			var softenerDevice = softeners.indexOf(device.get('device_type_name')) >= 0;

			if (installation) {
				if (softenerDevice) {
					return ConnectedDevicesSoftenerXSafeTech__jsx('div', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_connected_safetech_to_softeners_text), ConnectedDevicesSoftenerXSafeTech__jsx('ul', {}, void 0, installation.map(function (item, index) {
						return _this2.showText(item, userRole);
					})));
				} else {
					return ConnectedDevicesSoftenerXSafeTech__jsx('div', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_connected_softeners_to_safetech_text), ConnectedDevicesSoftenerXSafeTech__jsx('ul', {}, void 0, installation.map(function (item, index) {
						return _this2.showText(item, userRole);
					})));
				}
			} else {
				return null;
			}
		}
	}]);

	return ConnectedDevicesSoftenerXSafeTech;
}(DevicePopups_ConnectedDevicesCommon);

ConnectedDevicesSoftenerXSafeTech_ConnectedDevicesSoftenerXSafeTech.propTypes = {
	userRole: prop_types_default.a.string.isRequired,
	setDeviceCommandValue: prop_types_default.a.func.isRequired,
	device: prop_types_default.a.object.isRequired,
	serial: prop_types_default.a.string.isRequired
};

var ConnectedDevicesSoftenerXSafeTech_mapDispatch = function mapDispatch(dispatch) {
	return {
		setDeviceCommandValue: function setDeviceCommandValue(deviceId, command, value) {
			return dispatch(Object(actions_device["r" /* setDeviceCommandValue */])(deviceId, command, value));
		},
		removeProtectedInstallation: function removeProtectedInstallation(installation_id, action) {
			return dispatch(Object(actions_device["l" /* removeProtectedInstallation */])(installation_id, action));
		}
	};
};

/* harmony default export */ var DevicePopups_ConnectedDevicesSoftenerXSafeTech = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(null, ConnectedDevicesSoftenerXSafeTech_mapDispatch), withStyles_default()(Popup_default.a))(ConnectedDevicesSoftenerXSafeTech_ConnectedDevicesSoftenerXSafeTech)));
// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/NewInstallationPopUp.js
var NewInstallationPopUp__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NewInstallationPopUp__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NewInstallationPopUp__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function NewInstallationPopUp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NewInstallationPopUp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NewInstallationPopUp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var NewInstallationPopUp_NewInstallationPopup = function (_React$Component) {
  NewInstallationPopUp__inherits(NewInstallationPopup, _React$Component);

  function NewInstallationPopup(props) {
    NewInstallationPopUp__classCallCheck(this, NewInstallationPopup);

    var _this = NewInstallationPopUp__possibleConstructorReturn(this, (NewInstallationPopup.__proto__ || Object.getPrototypeOf(NewInstallationPopup)).call(this, props));

    _this.onClick = function () {
      var values = null;
      switch (_this.props.devicetype) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          values = {
            serial: _this.props.serial,
            softener_serial: _this.props.serial,
            safetech_serial: _this.state.serial
          };
          break;
        case 'safetech':
          values = {
            serial: _this.props.serial,
            safetech_serial: _this.props.serial,
            softener_serial: _this.state.serial
          };
          break;
        default:
          break;
      }
      if (values) {
        _this.props.saveInstallationData(values);
      }
    };

    _this.onFieldChange = function (field, e) {
      _this.setState(NewInstallationPopUp__defineProperty({}, field, e));
    };

    _this.state = {
      serial: null
    };
    return _this;
  }

  NewInstallationPopUp__createClass(NewInstallationPopup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getDeviceInfo(this.props.serial, this.props.devicetype);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          devicetype = _props.devicetype,
          serial = _props.serial,
          authentication = _props.authentication,
          devicesList = _props.devicesList;

      var userRole = authentication.get('userRole');
      var messages = Messages();
      var device = devicesList.find(function (item) {
        return item.get('serial') === serial;
      });
      return NewInstallationPopUp__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, NewInstallationPopUp__jsx('div', {
        className: Popup_default.a.wrapper
      }, void 0, NewInstallationPopUp__jsx('div', {
        className: Popup_default.a.first
      }, void 0, NewInstallationPopUp__jsx(DevicePopups_ConnectedDevicesSoftenerXSafeTech, {
        device: device,
        userRole: userRole,
        serial: serial
      })), NewInstallationPopUp__jsx('div', {
        className: Popup_default.a.second
      }, void 0, NewInstallationPopUp__jsx(Form["a" /* default */], {
        onSubmit: this.onSubmit
      }, void 0, NewInstallationPopUp__jsx(Grid["a" /* default */].Cell, {}, void 0, NewInstallationPopUp__jsx(Input["a" /* default */], {
        type: 'text',
        name: 'serial',
        title: intl.formatMessage(messages.serial_number_label_main_screen_text),
        onChange: this.onFieldChange.bind(this, 'serial'),
        titleVisibility: true
      })), NewInstallationPopUp__jsx(SaveChangeButtonPopup_SaveChangesButton, {
        devicetype: devicetype,
        onClick: this.onClick
      })))));
    }
  }]);

  return NewInstallationPopup;
}(react_default.a.Component);

NewInstallationPopUp_NewInstallationPopup.defaultProps = {
  devicetype: ''
};

var mapState = function mapState(state) {
  return {
    devicesList: state.deviceList,
    authentication: state.authentication
  };
};

var NewInstallationPopUp_mapDispatch = function mapDispatch(dispatch) {
  return {
    saveInstallationData: function saveInstallationData(data) {
      return dispatch(Object(actions_device["o" /* saveInstallationData */])(data));
    },
    getDeviceInfo: function getDeviceInfo(deviceId, deviceType) {
      return dispatch(Object(actions_device["g" /* getDeviceInfo */])(deviceId, deviceType));
    }
  };
};

/* harmony default export */ var NewInstallationPopUp = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(mapState, NewInstallationPopUp_mapDispatch), withStyles_default()(Popup_default.a))(NewInstallationPopUp_NewInstallationPopup)));
// EXTERNAL MODULE: ./src/components/Select/Select.js
var Select_Select = __webpack_require__(911);

// EXTERNAL MODULE: ./src/components/SortInput/SortInput.js
var SortInput = __webpack_require__(944);

// EXTERNAL MODULE: ./src/components/Sort/Sort.js
var Sort = __webpack_require__(945);

// CONCATENATED MODULE: ./src/components/Popup/UsersSearch.js
var UsersSearch__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var UsersSearch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var UsersSearch__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UsersSearch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UsersSearch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UsersSearch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UsersSearch_UsersSearch = function (_React$Component) {
  UsersSearch__inherits(UsersSearch, _React$Component);

  function UsersSearch() {
    var _ref;

    var _temp, _this, _ret;

    UsersSearch__classCallCheck(this, UsersSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = UsersSearch__possibleConstructorReturn(this, (_ref = UsersSearch.__proto__ || Object.getPrototypeOf(UsersSearch)).call.apply(_ref, [this].concat(args))), _this), _this.setSearchQuery = function (query) {
      if (query.length >= 2) {
        _this.props.setSearchQuery(query);
      } else {
        _this.props.setSearchQuery('');
      }
    }, _temp), UsersSearch__possibleConstructorReturn(_this, _ret);
  }

  UsersSearch__createClass(UsersSearch, [{
    key: 'render',
    value: function render() {
      var messages = Messages();
      var placeholderDefaultText = this.props.intl.formatMessage(UsersSearch__extends({}, messages.search_box_device_list));
      var placeholder = this.props.searchQuery ? this.props.searchQuery : placeholderDefaultText;
      var valueholder = this.props.searchQuery;

      if (this.props.usersCount || this.props.searchQuery) {
        return UsersSearch__jsx(Sort["a" /* default */], {}, void 0, UsersSearch__jsx(SortInput["a" /* default */], {
          className: 'SortInput__search',
          name: 'device',
          title: '',
          placeholder: placeholder,
          valuholder: valueholder,
          onChange: this.setSearchQuery
        }));
      }
      return null;
    }
  }]);

  return UsersSearch;
}(react_default.a.Component);

UsersSearch_UsersSearch.defaultProps = {
  searchQuery: ''
};

/* harmony default export */ var Popup_UsersSearch = (Object(index_es["g" /* injectIntl */])(UsersSearch_UsersSearch));
// EXTERNAL MODULE: ./src/core/utils.js
var utils = __webpack_require__(885);

// CONCATENATED MODULE: ./src/components/Popup/EditOwnershipPopupView.js
var EditOwnershipPopupView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var EditOwnershipPopupView__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var EditOwnershipPopupView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function EditOwnershipPopupView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditOwnershipPopupView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditOwnershipPopupView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EditOwnershipPopupView_EditOwnershipPopupView = function (_React$Component) {
  EditOwnershipPopupView__inherits(EditOwnershipPopupView, _React$Component);

  function EditOwnershipPopupView(props) {
    EditOwnershipPopupView__classCallCheck(this, EditOwnershipPopupView);

    var _this = EditOwnershipPopupView__possibleConstructorReturn(this, (EditOwnershipPopupView.__proto__ || Object.getPrototypeOf(EditOwnershipPopupView)).call(this, props));

    _this.getTitle = function (intl, messages, usersCount) {
      if (usersCount > 1) {
        return intl.formatMessage(EditOwnershipPopupView__extends({}, messages.create_ownership_popup_title)) + ' (' + usersCount + ' ' + intl.formatMessage(EditOwnershipPopupView__extends({}, messages.edit_popup_users_text)) + ' )';
      }
      return intl.formatMessage(EditOwnershipPopupView__extends({}, messages.create_ownership_popup_title)) + ' (' + usersCount + ' ' + intl.formatMessage(EditOwnershipPopupView__extends({}, messages.edit_popup_user_text)) + ' )';
    };

    _this.onClick = function () {
      console.log('clicked');
      // this.props.onSubmit();
    };

    _this.state = {};
    return _this;
  }

  EditOwnershipPopupView__createClass(EditOwnershipPopupView, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          ownershipData = _props.ownershipData,
          devicetype = _props.devicetype,
          serial = _props.serial;

      var users = ownershipData.get('users');
      var usersOptions = users.toArray().map(utils["c" /* optionsParser */]);
      var searchQuery = ownershipData.get('searchQuery');
      var usersCount = users.toArray().length;
      var messages = Messages();

      var title = this.getTitle(intl, messages, usersCount);
      var isSuperior = devicetype === 'superior';

      if (usersCount) {
        return EditOwnershipPopupView__jsx(components_Popup_Popup, {
          className: Popup_default.a.Popup__editdevice,
          onClose: this.props.onClose,
          devicetype: devicetype,
          overrideOnClose: true
        }, void 0, serial, EditOwnershipPopupView__jsx(Popup_UsersSearch, {
          searchQuery: searchQuery,
          setSearchQuery: this.props.setSearchQuery,
          usersCount: usersCount
        }), EditOwnershipPopupView__jsx(Form["a" /* default */], {
          onSubmit: this.props.onSubmit
        }, void 0, EditOwnershipPopupView__jsx(Grid["a" /* default */].Cell, {}, void 0, EditOwnershipPopupView__jsx(Select_Select["a" /* default */], {
          name: 'users',
          title: title,
          options: usersOptions,
          large: true
        })), EditOwnershipPopupView__jsx('div', {
          className: Popup_default.a.saveButton
        }, void 0, EditOwnershipPopupView__jsx(SaveChangeButtonPopup_SaveChangesButton, {
          devicetype: devicetype,
          onClick: this.onClick
        }))));
      }
      return EditOwnershipPopupView__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, EditOwnershipPopupView__jsx(Popup_UsersSearch, {
        searchQuery: searchQuery,
        setSearchQuery: this.props.setSearchQuery,
        usersCount: usersCount
      }), react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.no_users_found_title));
    }
  }]);

  return EditOwnershipPopupView;
}(react_default.a.Component);

EditOwnershipPopupView_EditOwnershipPopupView.defaultProps = {
  devicetype: ''
};

/* harmony default export */ var Popup_EditOwnershipPopupView = (Object(index_es["g" /* injectIntl */])(withStyles_default()(Popup_default.a)(EditOwnershipPopupView_EditOwnershipPopupView)));
// CONCATENATED MODULE: ./src/components/Popup/EditOwnershipPopup.js
var EditOwnershipPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var EditOwnershipPopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function EditOwnershipPopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditOwnershipPopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditOwnershipPopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EditOwnershipPopup_EditOwnershipPopup = function (_React$Component) {
  EditOwnershipPopup__inherits(EditOwnershipPopup, _React$Component);

  function EditOwnershipPopup() {
    var _ref;

    var _temp, _this, _ret;

    EditOwnershipPopup__classCallCheck(this, EditOwnershipPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = EditOwnershipPopup__possibleConstructorReturn(this, (_ref = EditOwnershipPopup.__proto__ || Object.getPrototypeOf(EditOwnershipPopup)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
      var user = data.users;
      _this.props.saveOwnership(_this.props.serial, {
        user: user,
        role: _this.props.userType
      });
      _this.props.onClose();
    }, _temp), EditOwnershipPopup__possibleConstructorReturn(_this, _ret);
  }

  EditOwnershipPopup__createClass(EditOwnershipPopup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getOwnership(this.props.serial, this.props.userType, {});
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      var searchQueryChanged = newProps.ownershipData.get('searchQuery') !== this.props.ownershipData.get('searchQuery');
      if (searchQueryChanged) {
        var search = newProps.ownershipData.get('searchQuery');
        this.props.getOwnership(this.props.serial, this.props.userType, { search: search });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return EditOwnershipPopup__jsx(Popup_EditOwnershipPopupView, {
        ownershipData: this.props.ownershipData,
        saveOwnership: this.props.saveOwnership,
        setSearchQuery: this.props.setSearchQuery,
        onSubmit: this.onSubmit,
        onClose: this.props.onClose,
        devicetype: this.props.devicetype,
        serial: this.props.serial
      });
    }
  }]);

  return EditOwnershipPopup;
}(react_default.a.Component);

var EditOwnershipPopup_mapState = function mapState(state) {
  return {
    ownershipData: state.ownershipData
  };
};

EditOwnershipPopup_EditOwnershipPopup.defaultProps = {
  devicetype: ''
};

var EditOwnershipPopup_mapDispatch = function mapDispatch(dispatch) {
  return {
    getOwnership: function getOwnership(serial, userType, params) {
      return dispatch(Object(actions_device["j" /* getOwnership */])(serial, userType, params));
    },
    saveOwnership: function saveOwnership(serial, data) {
      return dispatch(Object(actions_device["p" /* saveOwnership */])(serial, data));
    },
    setSearchQuery: function setSearchQuery(searchQuery) {
      return dispatch(Object(actions_device["A" /* setSearchQuery */])(searchQuery));
    }
  };
};

/* harmony default export */ var Popup_EditOwnershipPopup = (Object(redux_es["compose"])(Object(es["b" /* connect */])(EditOwnershipPopup_mapState, EditOwnershipPopup_mapDispatch), withStyles_default()(Popup_default.a))(EditOwnershipPopup_EditOwnershipPopup));
// CONCATENATED MODULE: ./src/components/Popup/ConfigurationPopUp.js
var ConfigurationPopUp__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConfigurationPopUp__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConfigurationPopUp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConfigurationPopUp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConfigurationPopUp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ConfigurationPopUp__ref = ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
  className: 'u_size6of12'
}, void 0, 'Medium');

var ConfigurationPopUp_ConfigurationPopUp = function (_React$Component) {
  ConfigurationPopUp__inherits(ConfigurationPopUp, _React$Component);

  function ConfigurationPopUp(props) {
    ConfigurationPopUp__classCallCheck(this, ConfigurationPopUp);

    var _this = ConfigurationPopUp__possibleConstructorReturn(this, (ConfigurationPopUp.__proto__ || Object.getPrototypeOf(ConfigurationPopUp)).call(this, props));

    _this.state = {};
    return _this;
  }

  ConfigurationPopUp__createClass(ConfigurationPopUp, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          devicetype = _props.devicetype,
          bottle = _props.bottle,
          valve = _props.valve,
          medium = _props.medium;

      var messages = Messages();
      var bottleLower = bottle.toLowerCase();
      var value = 'medium_' + medium + '_softener_text'; //medium
      var bottleValue = bottleLower + '_bottle_text'; //bottle

      console.log('value, bottleValue', value, bottleValue);
      return ConfigurationPopUp__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, ConfigurationPopUp__jsx('div', {}, void 0, ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
        className: 'u_size6of12'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.bottle_configuration_main_screen_text)), ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
        className: 'u_size6of12'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[bottleValue])), ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
        className: 'u_size6of12'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.valve_main_screen_text)), ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
        className: 'u_size6of12'
      }, void 0, valve), ConfigurationPopUp__ref, ConfigurationPopUp__jsx(Grid["a" /* default */].Cell, {
        className: 'u_size6of12'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[value]))));
    }
  }]);

  return ConfigurationPopUp;
}(react_default.a.Component);

/* harmony default export */ var Popup_ConfigurationPopUp = (Object(index_es["g" /* injectIntl */])(withStyles_default()(Popup_default.a)(ConfigurationPopUp_ConfigurationPopUp)));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(0);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/components/HistoryListPopUp/HistoryListPopUp.css
var HistoryListPopUp_HistoryListPopUp = __webpack_require__(1075);
var HistoryListPopUp_default = /*#__PURE__*/__webpack_require__.n(HistoryListPopUp_HistoryListPopUp);

// EXTERNAL MODULE: ./src/components/HistoryDocuments/HistoryDocument.css
var HistoryDocuments_HistoryDocument = __webpack_require__(931);
var HistoryDocument_default = /*#__PURE__*/__webpack_require__.n(HistoryDocuments_HistoryDocument);

// CONCATENATED MODULE: ./src/constants/documentTypes.js
/* harmony default export */ var documentTypes = ({
  arl: '0',
  arc: '1',
  arp: '2',
  arm: '3',
  pdf: '4'
});
// EXTERNAL MODULE: ./src/core/HttpClient.js
var HttpClient = __webpack_require__(873);

// EXTERNAL MODULE: ./src/constants/urls.js
var urls = __webpack_require__(884);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(6);

// CONCATENATED MODULE: ./src/actions/documents.js
/* eslint-disable import/prefer-default-export */






function documents_getDeviceDocumentsList(deviceid) {
  return {
    type: constants["G" /* GET_DEVICE_DOCUMENTS */],
    promise: HttpClient["a" /* default */].get(urls["a" /* default */].API2_URL + '/' + deviceid + '/filelist')
  };
}

function documents_setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType) {
  return {
    type: constants["_35" /* SET_DEVICE_DOCUMENT_INFO */],
    serial: serial,
    deviceName: deviceName,
    documentName: documentName,
    documentType: documentType,
    deviceType: deviceType
  };
}

function documents_removeDeviceDocument(deviceid, documentid) {
  return {
    type: constants["T" /* REMOVE_DEVICE_DOCUMENT */],
    promise: HttpClient["a" /* default */].delete(urls["a" /* default */].API2_URL + '/' + deviceid + '/filelist/' + documentid, {})
  };
}

function documents_getDeviceDocumentById(deviceid, documentid, filterData, page, pageSize) {
  if (filterData) {
    return {
      type: 'GET_DEVICE_DOCUMENT',
      promise: HttpClient["a" /* default */].postAsync(urls["a" /* default */].API2_URL + '/' + deviceid + '/filelist/' + documentid + '?page=' + page + '&page_size=' + pageSize, {})
    };
  }
  return {
    type: 'GET_DEVICE_DOCUMENT',
    promise: HttpClient["a" /* default */].get(urls["a" /* default */].API2_URL + '/' + deviceid + '/filelist/' + documentid + '?page=' + page + '&page_size=' + pageSize)
  };
}

function documents_downloadDeviceDocument(deviceid, documentid, filterData, events, page, pageSize) {
  var url = urls["a" /* default */].API2_URL + '/' + deviceid + '/filelist/' + documentid + '/download';
  if (page) {
    url += '?page=' + page + '&page_size=' + pageSize;
  }
  if (filterData) {
    if (events) {
      return {
        type: 'DOWNLOAD_DOCUMENT',
        promise: HttpClient["a" /* default */].postDownload(url, JSON.stringify({ 'filterData': filterData, 'events': events }))
      };
    }
    return {
      type: 'DOWNLOAD_DOCUMENT',
      promise: HttpClient["a" /* default */].postDownload(url, JSON.stringify({ 'filterData': filterData }))
    };
  }
  return {
    type: 'DOWNLOAD_DOCUMENT',
    promise: HttpClient["a" /* default */].get(url)
  };
}

function documents_clearDeviceDocumentsList() {
  return {
    type: constants["f" /* CLEAR_DEVICE_DOCUMENTS */]
  };
}

function documents_clearDeviceDocument() {
  return {
    type: constants["e" /* CLEAR_DEVICE_DOCUMENT */]
  };
}

function documents_setDeviceDocumentFilter(documentType, name, deviceType) {
  var isSoftener = deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex';
  var ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: constants["_49" /* SET_SOFTENER_EVENTS_FILTER */],
      name: name
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: constants["_51" /* SET_SOFTENER_PARAMETERS_FILTER */],
      name: name
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: constants["_56" /* SET_SUPERIOR_EVENTS_FILTER */],
      name: name
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: constants["_57" /* SET_SUPERIOR_PARAMETERS_FILTER */],
      name: name
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: constants["_58" /* SET_SUPERIOR_PRESSURES_FILTER */],
      name: name
    };
  }
  return ret;
}

function documents_setDeviceDocumentColumnFilter(documentType, name, deviceType, screenType) {
  var isSoftener = deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex';
  var ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: constants["_47" /* SET_SOFTENER_COLUMN_EVENTS_FILTER */],
      name: name,
      screenType: screenType
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: constants["_48" /* SET_SOFTENER_COLUMN_PARAMETERS_FILTER */],
      name: name
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: constants["_53" /* SET_SUPERIOR_COLUMN_EVENTS_FILTER */],
      name: name
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: constants["_54" /* SET_SUPERIOR_COLUMN_PARAMETERS_FILTER */],
      name: name
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: constants["_55" /* SET_SUPERIOR_COLUMN_PRESSURES_FILTER */],
      name: name
    };
  }
  return ret;
}

function documents_clearDocumentFilter(documentType, deviceType) {
  var devices = ['softener', 'charlie', 'simplex'];
  var isSoftener = devices.indexOf(deviceType) > -1;
  var ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: constants["j" /* CLEAR_SOFTENER_EVENTS_FILTER */]
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: constants["k" /* CLEAR_SOFTENER_PARAMETERS_FILTER */]
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: constants["l" /* CLEAR_SUPERIOR_EVENTS_FILTER */]
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: constants["m" /* CLEAR_SUPERIOR_PARAMETERS_FILTER */]
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: constants["n" /* CLEAR_SUPERIOR_PRESSURES_FILTER */]
    };
  }
  return ret;
}
// CONCATENATED MODULE: ./src/components/HistoryDocuments/HistoryDocument.js
var HistoryDocument__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryDocument__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryDocument__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryDocument__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryDocument__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DAY = 86400000;

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

var HistoryDocument__ref = HistoryDocument__jsx(Loader["a" /* default */], {});

var HistoryDocument_HistoryDocument = function (_React$Component) {
  HistoryDocument__inherits(HistoryDocument, _React$Component);

  function HistoryDocument(props) {
    HistoryDocument__classCallCheck(this, HistoryDocument);

    var _this = HistoryDocument__possibleConstructorReturn(this, (HistoryDocument.__proto__ || Object.getPrototypeOf(HistoryDocument)).call(this, props));

    _this.onSavePDF = function (serial, documentName) {
      _this.props.downloadDeviceDocument(serial, documentName, {});
    };

    _this.setDeviceDocumentInfo = function (serial, deviceName, documentName, documentType, deviceType) {
      _this.props.setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType);
    };

    _this.renderDownloading = function () {
      return HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.iconWrapper
      }, void 0, HistoryDocument__ref);
    };

    _this.renderDownload = function (documentName, iconSize) {
      // const bucketName = `test-attachments-history`;
      var bucketName = 'attachments-history';
      // const bucketName = process.env.AWS_BUCKET_NAME || `test-attachments-history`;
      var downloadLink = 'https://' + bucketName + '.s3.eu-west-3.amazonaws.com/device_history/' + documentName;
      // const downloadLink = `/uploads/${documentName}`
      return HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.iconWrapper
      }, void 0, HistoryDocument__jsx('a', {
        href: downloadLink,
        target: '_blank'
      }, void 0, HistoryDocument__jsx(Icon["a" /* default */], {
        iconName: 'pobierz',
        size: iconSize
      })));
    };

    _this.renderRemove = function (serial, documentName, iconSize) {
      return HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.iconWrapper,
        onClick: function onClick() {
          _this.props.removeDeviceDocument(serial, documentName);
          // this.props.getDeviceDocumentsList(serial);
        }
      }, void 0, HistoryDocument__jsx(Icon["a" /* default */], {
        iconName: 'kosz',
        size: iconSize
      }));
    };

    _this.renderDocumentName = function (documentName, documentSize, greenOne) {
      var documentStyle = greenOne ? classnames_default()(HistoryDocument_default.a.green, HistoryDocument_default.a.u_flexGrow1) : classnames_default()(HistoryDocument_default.a.u_flexGrow1);
      return HistoryDocument__jsx('div', {
        className: documentStyle
      }, void 0, documentName, ' ', documentSize, ' ', greenOne);
    };

    _this.state = {
      now: new Date()
    };
    return _this;
  }

  HistoryDocument__createClass(HistoryDocument, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      console.log('new prop-types');
      this.setState({
        now: new Date()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          serial = _props.serial,
          deviceType = _props.deviceType,
          newFilesDownloaded = _props.newFilesDownloaded,
          deviceName = _props.deviceName;

      var documentName = this.props.document.get('name');
      var documentSize = this.props.document.get('size');
      var documentType = documentTypes[documentName.split('.')[1]];
      var iconSize = 20;

      // const date = new Date(this.props.document.get('timestamp') * 1000);
      var date = new Date(0);
      date.setUTCSeconds(this.props.document.get('timestamp'));
      var greenOne = newFilesDownloaded && newFilesDownloaded.includes(this.props.document.get('timestamp'));
      var downloadingDocument = this.props.deviceDocumentsPaging.get('downloadingDocument');
      var formattedTime = this.state.now - date < DAY ? HistoryDocument__jsx(index_es["c" /* FormattedRelative */], {
        value: date,
        initialNow: new Date()
      }) : HistoryDocument__jsx(index_es["a" /* FormattedDate */], {
        value: date
      });

      if (+documentType === 3) {
        return HistoryDocument__jsx('div', {
          className: HistoryDocument_default.a.listBordered_item
        }, void 0, this.renderDocumentName(documentName, documentSize, greenOne), HistoryDocument__jsx('div', {
          className: HistoryDocument_default.a.iconsWrapper
        }, void 0, formattedTime, ' ', !downloadingDocument ? HistoryDocument__jsx('div', {
          className: HistoryDocument_default.a.iconWrapper,
          onClick: function onClick() {
            _this2.onSavePDF(serial, documentName);
          }
        }, void 0, HistoryDocument__jsx(Icon["a" /* default */], {
          iconName: 'lupka',
          size: iconSize
        })) : this.renderDownloading(), this.renderDownload(documentName, iconSize), this.renderRemove(serial, documentName, iconSize)));
      }

      return HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.listBordered_item
      }, void 0, this.renderDocumentName(documentName, documentSize, greenOne), HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.iconsWrapper
      }, void 0, formattedTime, ' ', HistoryDocument__jsx('div', {
        className: HistoryDocument_default.a.iconWrapper,
        onClick: function onClick() {
          _this2.setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType);
        }
      }, void 0, HistoryDocument__jsx(Icon["a" /* default */], {
        iconName: 'lupka',
        size: iconSize
      })), this.renderDownload(documentName, iconSize), this.renderRemove(serial, documentName, iconSize)));
    }
  }]);

  return HistoryDocument;
}(react_default.a.Component);

var HistoryDocument_mapDispatch = function mapDispatch(dispatch) {
  return {
    setDeviceDocumentInfo: function setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType) {
      return dispatch(documents_setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType));
    },
    removeDeviceDocument: function removeDeviceDocument(deviceid, documentid) {
      return dispatch(documents_removeDeviceDocument(deviceid, documentid));
    },
    downloadDeviceDocument: function downloadDeviceDocument(serial, documentId, filterData, events) {
      return dispatch(documents_downloadDeviceDocument(serial, documentId, filterData, events));
    }
  };
};

var HistoryDocument_mapState = function mapState(state) {
  return {
    deviceDocumentsPaging: state.deviceDocumentsPaging
  };
};

/* harmony default export */ var components_HistoryDocuments_HistoryDocument = (Object(redux_es["compose"])(withStyles_default()(HistoryDocument_default.a), Object(es["b" /* connect */])(HistoryDocument_mapState, HistoryDocument_mapDispatch))(HistoryDocument_HistoryDocument));
// EXTERNAL MODULE: ./src/components/InfiniteScroll/InfiniteScroll.js
var InfiniteScroll = __webpack_require__(891);

// CONCATENATED MODULE: ./src/components/HistoryDocuments/HistoryDocuments.js
var HistoryDocuments__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var MAX_NUMBER_OF_AUTOLOADS = 1;

function HistoryDocuments(props) {
  var deviceDocumentsPaging = props.deviceDocumentsPaging;

  var hasMore = deviceDocumentsPaging.get('itemsPerPage') * deviceDocumentsPaging.get('currentPage') < deviceDocumentsPaging.get('itemsCount');

  var wrappedClasses = classnames_default()(HistoryDocument_default.a.listBordered, HistoryDocument_default.a.listBordered__large, HistoryDocument_default.a.listBordered__flat);
  var numberOlderItemsFetched = deviceDocumentsPaging.get('numberOlderItemsFetched');
  return HistoryDocuments__jsx(InfiniteScroll["a" /* default */], {
    loadMore: props.getNextDocumentsPage,
    hasMore: hasMore,
    showLoadMore: numberOlderItemsFetched >= MAX_NUMBER_OF_AUTOLOADS,
    className: wrappedClasses
  }, void 0, props.deviceDocuments.valueSeq().map(function (document) {
    return HistoryDocuments__jsx(components_HistoryDocuments_HistoryDocument, {
      document: document,
      serial: props.serial,
      deviceType: props.deviceType,
      deviceName: props.deviceName,
      newFilesDownloaded: props.newFilesDownloaded,
      getDeviceDocumentsList: props.getDeviceDocumentsList
    }, document.get('name'));
  }));
}

var HistoryDocuments_mapState = function mapState(state) {
  return {
    deviceDocuments: state.deviceDocuments,
    deviceDocumentsPaging: state.deviceDocumentsPaging
  };
};

/* harmony default export */ var HistoryDocuments_HistoryDocuments = (Object(redux_es["compose"])(withStyles_default()(HistoryDocument_default.a), Object(es["b" /* connect */])(HistoryDocuments_mapState, null))(HistoryDocuments));
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(482);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function react_onclickoutside_es__objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(react_dom["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(react_dom["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = react_onclickoutside_es__objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(react["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(react["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ var react_onclickoutside_es = (onClickOutsideHOC);

// EXTERNAL MODULE: ./node_modules/react-popper/node_modules/prop-types/index.js
var node_modules_prop_types = __webpack_require__(890);
var node_modules_prop_types_default = /*#__PURE__*/__webpack_require__.n(node_modules_prop_types);

// CONCATENATED MODULE: ./node_modules/react-popper/lib/Manager.js
var Manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Manager__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Manager__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Manager__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager_Manager = function (_Component) {
  Manager__inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    Manager__classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Manager__possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), Manager__possibleConstructorReturn(_this, _ret);
  }

  Manager__createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = Manager__objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(react["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(react["Component"]);

Manager_Manager.childContextTypes = {
  popperManager: node_modules_prop_types_default.a.object.isRequired
};
Manager_Manager.propTypes = {
  tag: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.string, node_modules_prop_types_default.a.bool]),
  children: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func])
};
Manager_Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ var lib_Manager = (Manager_Manager);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Target.js
var Target__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Target__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target_Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = Target__objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = Target__extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(react["createElement"])(component, componentProps, children);
};

Target_Target.contextTypes = {
  popperManager: node_modules_prop_types_default.a.object.isRequired
};

Target_Target.propTypes = {
  component: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func]),
  innerRef: node_modules_prop_types_default.a.func,
  children: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func])
};

/* harmony default export */ var lib_Target = (Target_Target);
// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var esm_popper = __webpack_require__(1080);

// CONCATENATED MODULE: ./node_modules/react-popper/lib/Popper.js
var Popper__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Popper__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Popper__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Popper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Popper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Popper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = esm_popper["a" /* default */].placements;

var Popper_Popper = function (_Component) {
  Popper__inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    Popper__classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Popper__possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return Popper__extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), Popper__possibleConstructorReturn(_this, _ret);
  }

  Popper__createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = Popper__extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = Popper__extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new esm_popper["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = Popper__objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = Popper__extends({}, restProps, {
        style: Popper__extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(react["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(react["Component"]);

Popper_Popper.contextTypes = {
  popperManager: node_modules_prop_types_default.a.object
};
Popper_Popper.childContextTypes = {
  popper: node_modules_prop_types_default.a.object.isRequired
};
Popper_Popper.propTypes = {
  component: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func]),
  innerRef: node_modules_prop_types_default.a.func,
  placement: node_modules_prop_types_default.a.oneOf(placements),
  eventsEnabled: node_modules_prop_types_default.a.bool,
  modifiers: node_modules_prop_types_default.a.object,
  children: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func]),
  target: node_modules_prop_types_default.a.oneOfType([
  // the following check is needed for SSR
  node_modules_prop_types_default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), node_modules_prop_types_default.a.shape({
    getBoundingClientRect: node_modules_prop_types_default.a.func.isRequired,
    clientWidth: node_modules_prop_types_default.a.number.isRequired,
    clientHeight: node_modules_prop_types_default.a.number.isRequired
  })])
};
Popper_Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};


/* harmony default export */ var lib_Popper = (Popper_Popper);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Arrow.js
var Arrow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Arrow__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow_Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = Arrow__objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = Arrow__extends({}, restProps, {
    style: Arrow__extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(react["createElement"])(component, componentProps, children);
};

Arrow_Arrow.contextTypes = {
  popper: node_modules_prop_types_default.a.object.isRequired
};

Arrow_Arrow.propTypes = {
  component: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func]),
  innerRef: node_modules_prop_types_default.a.func,
  children: node_modules_prop_types_default.a.oneOfType([node_modules_prop_types_default.a.node, node_modules_prop_types_default.a.func])
};

/* harmony default export */ var lib_Arrow = (Arrow_Arrow);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/react-popper.js




// CONCATENATED MODULE: ./node_modules/react-datepicker/es/index.js







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var es_YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return react_default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? react_default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(react_default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          react_default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(react_default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          react_default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = classnames_default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return react_default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(react_default.a.Component);

es_YearDropdownOptions.propTypes = {
  minDate: prop_types_default.a.object,
  maxDate: prop_types_default.a.object,
  onCancel: prop_types_default.a.func.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  scrollableYearDropdown: prop_types_default.a.bool,
  year: prop_types_default.a.number.isRequired,
  yearDropdownItemNumber: prop_types_default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return moment_default()(point);
}

function newDateWithOffset(utcOffset) {
  return moment_default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = moment_default()(value, dateFormat, locale || moment_default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return moment_default.a.isMoment(date);
}

function isDate(date) {
  return moment_default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || moment_default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || moment_default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return moment_default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref5) {
  var minTime = _ref5.minTime,
      maxTime = _ref5.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = moment_default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref6.minDate,
      includeDates = _ref6.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref7.maxDate,
      includeDates = _ref7.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref8) {
  var minDate = _ref8.minDate,
      includeDates = _ref8.includeDates;

  if (includeDates && minDate) {
    return moment_default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return moment_default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref9) {
  var maxDate = _ref9.maxDate,
      includeDates = _ref9.includeDates;

  if (includeDates && maxDate) {
    return moment_default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return moment_default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = react_onclickoutside_es(es_YearDropdownOptions);

var es_YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(react_default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return react_default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return react_default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        react_default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        react_default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return react_default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return react_default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(react_default.a.Component);

es_YearDropdown.propTypes = {
  adjustDateOnChange: prop_types_default.a.bool,
  dropdownMode: prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: prop_types_default.a.object,
  minDate: prop_types_default.a.object,
  onChange: prop_types_default.a.func.isRequired,
  scrollableYearDropdown: prop_types_default.a.bool,
  year: prop_types_default.a.number.isRequired,
  yearDropdownItemNumber: prop_types_default.a.number,
  date: prop_types_default.a.object,
  onSelect: prop_types_default.a.func,
  setOpen: prop_types_default.a.func
};

var es_MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return react_default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? react_default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return react_default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(react_default.a.Component);

es_MonthDropdownOptions.propTypes = {
  onCancel: prop_types_default.a.func.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  month: prop_types_default.a.number.isRequired,
  monthNames: prop_types_default.a.arrayOf(prop_types_default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = react_onclickoutside_es(es_MonthDropdownOptions);

var es_MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return react_default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return react_default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return react_default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        react_default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        react_default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return react_default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return react_default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(react_default.a.Component);

es_MonthDropdown.propTypes = {
  dropdownMode: prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
  locale: prop_types_default.a.string,
  dateFormat: prop_types_default.a.string.isRequired,
  month: prop_types_default.a.number.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  useShortMonthInDropdown: prop_types_default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var es_MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return react_default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? react_default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = classnames_default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return react_default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(react_default.a.Component);

es_MonthYearDropdownOptions.propTypes = {
  minDate: prop_types_default.a.object.isRequired,
  maxDate: prop_types_default.a.object.isRequired,
  onCancel: prop_types_default.a.func.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  scrollableMonthYearDropdown: prop_types_default.a.bool,
  date: prop_types_default.a.object.isRequired,
  dateFormat: prop_types_default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = react_onclickoutside_es(es_MonthYearDropdownOptions);

var es_MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(react_default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return react_default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return react_default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        react_default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        react_default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return react_default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return react_default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(react_default.a.Component);

es_MonthYearDropdown.propTypes = {
  dropdownMode: prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: prop_types_default.a.string.isRequired,
  locale: prop_types_default.a.string,
  maxDate: prop_types_default.a.object.isRequired,
  minDate: prop_types_default.a.object.isRequired,
  date: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  scrollableMonthYearDropdown: prop_types_default.a.bool
};

var es_Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return classnames_default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return react_default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      getDate(this.props.day)
    );
  };

  return Day;
}(react_default.a.Component);

es_Day.propTypes = {
  day: prop_types_default.a.object.isRequired,
  dayClassName: prop_types_default.a.func,
  endDate: prop_types_default.a.object,
  highlightDates: prop_types_default.a.instanceOf(Map),
  inline: prop_types_default.a.bool,
  month: prop_types_default.a.number,
  onClick: prop_types_default.a.func,
  onMouseEnter: prop_types_default.a.func,
  preSelection: prop_types_default.a.object,
  selected: prop_types_default.a.object,
  selectingDate: prop_types_default.a.object,
  selectsEnd: prop_types_default.a.bool,
  selectsStart: prop_types_default.a.bool,
  startDate: prop_types_default.a.object,
  utcOffset: prop_types_default.a.number
};

var es_WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return react_default.a.createElement(
      "div",
      {
        className: classnames_default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(react_default.a.Component);

es_WeekNumber.propTypes = {
  weekNumber: prop_types_default.a.number.isRequired,
  onClick: prop_types_default.a.func
};

var es_Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(react_default.a.createElement(es_WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return react_default.a.createElement(es_Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return react_default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(react_default.a.Component);

es_Week.propTypes = {
  day: prop_types_default.a.object.isRequired,
  dayClassName: prop_types_default.a.func,
  endDate: prop_types_default.a.object,
  excludeDates: prop_types_default.a.array,
  filterDate: prop_types_default.a.func,
  formatWeekNumber: prop_types_default.a.func,
  highlightDates: prop_types_default.a.instanceOf(Map),
  includeDates: prop_types_default.a.array,
  inline: prop_types_default.a.bool,
  maxDate: prop_types_default.a.object,
  minDate: prop_types_default.a.object,
  month: prop_types_default.a.number,
  onDayClick: prop_types_default.a.func,
  onDayMouseEnter: prop_types_default.a.func,
  onWeekSelect: prop_types_default.a.func,
  preSelection: prop_types_default.a.object,
  selected: prop_types_default.a.object,
  selectingDate: prop_types_default.a.object,
  selectsEnd: prop_types_default.a.bool,
  selectsStart: prop_types_default.a.bool,
  showWeekNumber: prop_types_default.a.bool,
  startDate: prop_types_default.a.object,
  utcOffset: prop_types_default.a.number
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var es_Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(react_default.a.createElement(es_Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return classnames_default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return react_default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox"
      },
      this.renderWeeks()
    );
  };

  return Month;
}(react_default.a.Component);

es_Month.propTypes = {
  day: prop_types_default.a.object.isRequired,
  dayClassName: prop_types_default.a.func,
  endDate: prop_types_default.a.object,
  excludeDates: prop_types_default.a.array,
  filterDate: prop_types_default.a.func,
  fixedHeight: prop_types_default.a.bool,
  formatWeekNumber: prop_types_default.a.func,
  highlightDates: prop_types_default.a.instanceOf(Map),
  includeDates: prop_types_default.a.array,
  inline: prop_types_default.a.bool,
  maxDate: prop_types_default.a.object,
  minDate: prop_types_default.a.object,
  onDayClick: prop_types_default.a.func,
  onDayMouseEnter: prop_types_default.a.func,
  onMouseLeave: prop_types_default.a.func,
  onWeekSelect: prop_types_default.a.func,
  peekNextMonth: prop_types_default.a.bool,
  preSelection: prop_types_default.a.object,
  selected: prop_types_default.a.object,
  selectingDate: prop_types_default.a.object,
  selectsEnd: prop_types_default.a.bool,
  selectsStart: prop_types_default.a.bool,
  showWeekNumbers: prop_types_default.a.bool,
  startDate: prop_types_default.a.object,
  utcOffset: prop_types_default.a.number
};

var es_Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return react_default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM)
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    var multiplier = 60 / this.props.intervals;
    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
    this.list.scrollTop = 30 * (multiplier * currH);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef) {
      height = this.props.monthRef.clientHeight - 39;
    }

    return react_default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      react_default.a.createElement(
        "div",
        { className: "react-datepicker__header react-datepicker__header--time" },
        react_default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      react_default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        react_default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          react_default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(react_default.a.Component);

es_Time.propTypes = {
  format: prop_types_default.a.string,
  includeTimes: prop_types_default.a.array,
  intervals: prop_types_default.a.number,
  selected: prop_types_default.a.object,
  onChange: prop_types_default.a.func,
  todayButton: prop_types_default.a.string,
  minTime: prop_types_default.a.object,
  maxTime: prop_types_default.a.object,
  excludeTimes: prop_types_default.a.array,
  monthRef: prop_types_default.a.object,
  timeCaption: prop_types_default.a.string,
  injectTimes: prop_types_default.a.array
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return react_default.a.createElement(
    "div",
    { className: className },
    react_default.a.createElement("div", { className: "react-datepicker__triangle" }),
    children
  );
}

CalendarContainer.propTypes = {
  className: prop_types_default.a.string,
  children: prop_types_default.a.node
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var es_Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      var _ref;

      return _ref = {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month"
      }, _ref["previousMonthButtonLabel"] = "Next Month", _ref;
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(react_default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return react_default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return react_default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return react_default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return react_default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return react_default.a.createElement(es_YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return react_default.a.createElement(es_MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return react_default.a.createElement(es_MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return react_default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(react_default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          react_default.a.createElement(
            "div",
            { className: "react-datepicker__header" },
            _this.renderCurrentMonth(monthDate),
            react_default.a.createElement(
              "div",
              {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus
              },
              _this.renderMonthDropdown(i !== 0),
              _this.renderMonthYearDropdown(i !== 0),
              _this.renderYearDropdown(i !== 0)
            ),
            react_default.a.createElement(
              "div",
              { className: "react-datepicker__day-names" },
              _this.header(monthDate)
            )
          ),
          react_default.a.createElement(es_Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect) {
        return react_default.a.createElement(es_Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: _this.monthContainer
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return react_default.a.createElement(
      Container,
      {
        className: classnames_default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(react_default.a.Component);

es_Calendar.propTypes = {
  adjustDateOnChange: prop_types_default.a.bool,
  className: prop_types_default.a.string,
  children: prop_types_default.a.node,
  container: prop_types_default.a.func,
  dateFormat: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.array]).isRequired,
  dayClassName: prop_types_default.a.func,
  dropdownMode: prop_types_default.a.oneOf(["scroll", "select"]),
  endDate: prop_types_default.a.object,
  excludeDates: prop_types_default.a.array,
  filterDate: prop_types_default.a.func,
  fixedHeight: prop_types_default.a.bool,
  formatWeekNumber: prop_types_default.a.func,
  highlightDates: prop_types_default.a.instanceOf(Map),
  includeDates: prop_types_default.a.array,
  includeTimes: prop_types_default.a.array,
  injectTimes: prop_types_default.a.array,
  inline: prop_types_default.a.bool,
  locale: prop_types_default.a.string,
  maxDate: prop_types_default.a.object,
  minDate: prop_types_default.a.object,
  monthsShown: prop_types_default.a.number,
  onClickOutside: prop_types_default.a.func.isRequired,
  onMonthChange: prop_types_default.a.func,
  onYearChange: prop_types_default.a.func,
  forceShowMonthNavigation: prop_types_default.a.bool,
  onDropdownFocus: prop_types_default.a.func,
  onSelect: prop_types_default.a.func.isRequired,
  onWeekSelect: prop_types_default.a.func,
  showTimeSelect: prop_types_default.a.bool,
  showTimeSelectOnly: prop_types_default.a.bool,
  timeFormat: prop_types_default.a.string,
  timeIntervals: prop_types_default.a.number,
  onTimeChange: prop_types_default.a.func,
  minTime: prop_types_default.a.object,
  maxTime: prop_types_default.a.object,
  excludeTimes: prop_types_default.a.array,
  timeCaption: prop_types_default.a.string,
  openToDate: prop_types_default.a.object,
  peekNextMonth: prop_types_default.a.bool,
  scrollableYearDropdown: prop_types_default.a.bool,
  scrollableMonthYearDropdown: prop_types_default.a.bool,
  preSelection: prop_types_default.a.object,
  selected: prop_types_default.a.object,
  selectsEnd: prop_types_default.a.bool,
  selectsStart: prop_types_default.a.bool,
  showMonthDropdown: prop_types_default.a.bool,
  showMonthYearDropdown: prop_types_default.a.bool,
  showWeekNumbers: prop_types_default.a.bool,
  showYearDropdown: prop_types_default.a.bool,
  startDate: prop_types_default.a.object,
  todayButton: prop_types_default.a.string,
  useWeekdaysShort: prop_types_default.a.bool,
  formatWeekDay: prop_types_default.a.func,
  withPortal: prop_types_default.a.bool,
  utcOffset: prop_types_default.a.number,
  weekLabel: prop_types_default.a.string,
  yearDropdownItemNumber: prop_types_default.a.number,
  setOpen: prop_types_default.a.func,
  useShortMonthInDropdown: prop_types_default.a.bool,
  showDisabledMonthNavigation: prop_types_default.a.bool,
  previousMonthButtonLabel: prop_types_default.a.string,
  nextMonthButtonLabel: prop_types_default.a.string
};

var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var es_PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = classnames_default()("react-datepicker-popper", className);
      popper = react_default.a.createElement(
        lib_Popper,
        {
          className: classes,
          modifiers: popperModifiers,
          placement: popperPlacement
        },
        popperComponent
      );
    }

    if (this.props.popperContainer) {
      popper = react_default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return react_default.a.createElement(
      lib_Manager,
      null,
      react_default.a.createElement(
        lib_Target,
        { className: "react-datepicker-wrapper" },
        targetComponent
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(react_default.a.Component);

es_PopperComponent.propTypes = {
  className: prop_types_default.a.string,
  hidePopper: prop_types_default.a.bool,
  popperComponent: prop_types_default.a.element,
  popperModifiers: prop_types_default.a.object, // <datepicker/> props
  popperPlacement: prop_types_default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: prop_types_default.a.func,
  targetComponent: prop_types_default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = react_onclickoutside_es(es_Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */

var es_DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month"
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setOpen = function (open) {
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      });
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      _this.setOpen(false);
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if ((isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
      } else if (eventKey === "Tab") {
        _this.setOpen(false);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) return; // Let the input component handle this keydown
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && (!_this.state.open || _this.props.disabled || _this.props.readOnly)) {
        return null;
      }
      return react_default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = classnames_default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || react_default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return react_default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return react_default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return react_default.a.createElement(
        "div",
        null,
        !this.props.inline ? react_default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? react_default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return react_default.a.createElement(es_PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.state.open || this.props.disabled || this.props.readOnly,
      popperModifiers: this.props.popperModifiers,
      targetComponent: react_default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement
    });
  };

  return DatePicker;
}(react_default.a.Component);

es_DatePicker.propTypes = {
  adjustDateOnChange: prop_types_default.a.bool,
  allowSameDay: prop_types_default.a.bool,
  autoComplete: prop_types_default.a.string,
  autoFocus: prop_types_default.a.bool,
  calendarClassName: prop_types_default.a.string,
  calendarContainer: prop_types_default.a.func,
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  customInput: prop_types_default.a.element,
  customInputRef: prop_types_default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.array]),
  dateFormatCalendar: prop_types_default.a.string,
  dayClassName: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  disabledKeyboardNavigation: prop_types_default.a.bool,
  dropdownMode: prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: prop_types_default.a.object,
  excludeDates: prop_types_default.a.array,
  filterDate: prop_types_default.a.func,
  fixedHeight: prop_types_default.a.bool,
  formatWeekNumber: prop_types_default.a.func,
  highlightDates: prop_types_default.a.array,
  id: prop_types_default.a.string,
  includeDates: prop_types_default.a.array,
  includeTimes: prop_types_default.a.array,
  injectTimes: prop_types_default.a.array,
  inline: prop_types_default.a.bool,
  isClearable: prop_types_default.a.bool,
  locale: prop_types_default.a.string,
  maxDate: prop_types_default.a.object,
  minDate: prop_types_default.a.object,
  monthsShown: prop_types_default.a.number,
  name: prop_types_default.a.string,
  onBlur: prop_types_default.a.func,
  onChange: prop_types_default.a.func.isRequired,
  onSelect: prop_types_default.a.func,
  onWeekSelect: prop_types_default.a.func,
  onClickOutside: prop_types_default.a.func,
  onChangeRaw: prop_types_default.a.func,
  onFocus: prop_types_default.a.func,
  onKeyDown: prop_types_default.a.func,
  onMonthChange: prop_types_default.a.func,
  onYearChange: prop_types_default.a.func,
  openToDate: prop_types_default.a.object,
  peekNextMonth: prop_types_default.a.bool,
  placeholderText: prop_types_default.a.string,
  popperContainer: prop_types_default.a.func,
  popperClassName: prop_types_default.a.string, // <PopperComponent/> props
  popperModifiers: prop_types_default.a.object, // <PopperComponent/> props
  popperPlacement: prop_types_default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  preventOpenOnFocus: prop_types_default.a.bool,
  readOnly: prop_types_default.a.bool,
  required: prop_types_default.a.bool,
  scrollableYearDropdown: prop_types_default.a.bool,
  scrollableMonthYearDropdown: prop_types_default.a.bool,
  selected: prop_types_default.a.object,
  selectsEnd: prop_types_default.a.bool,
  selectsStart: prop_types_default.a.bool,
  showMonthDropdown: prop_types_default.a.bool,
  showMonthYearDropdown: prop_types_default.a.bool,
  showWeekNumbers: prop_types_default.a.bool,
  showYearDropdown: prop_types_default.a.bool,
  forceShowMonthNavigation: prop_types_default.a.bool,
  showDisabledMonthNavigation: prop_types_default.a.bool,
  startDate: prop_types_default.a.object,
  startOpen: prop_types_default.a.bool,
  tabIndex: prop_types_default.a.number,
  timeCaption: prop_types_default.a.string,
  title: prop_types_default.a.string,
  todayButton: prop_types_default.a.string,
  useWeekdaysShort: prop_types_default.a.bool,
  formatWeekDay: prop_types_default.a.func,
  utcOffset: prop_types_default.a.number,
  value: prop_types_default.a.string,
  weekLabel: prop_types_default.a.string,
  withPortal: prop_types_default.a.bool,
  yearDropdownItemNumber: prop_types_default.a.number,
  shouldCloseOnSelect: prop_types_default.a.bool,
  showTimeSelect: prop_types_default.a.bool,
  showTimeSelectOnly: prop_types_default.a.bool,
  timeFormat: prop_types_default.a.string,
  timeIntervals: prop_types_default.a.number,
  minTime: prop_types_default.a.object,
  maxTime: prop_types_default.a.object,
  excludeTimes: prop_types_default.a.array,
  useShortMonthInDropdown: prop_types_default.a.bool,
  clearButtonTitle: prop_types_default.a.string,
  previousMonthButtonLabel: prop_types_default.a.string,
  nextMonthButtonLabel: prop_types_default.a.string
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ var react_datepicker_es = (es_DatePicker);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(1081);
var react_datepicker_default = /*#__PURE__*/__webpack_require__.n(react_datepicker);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker-cssmodules.css
var react_datepicker_cssmodules = __webpack_require__(1083);
var react_datepicker_cssmodules_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_cssmodules);

// CONCATENATED MODULE: ./src/components/HistoryListPopUp/Picker.js
var Picker__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Picker__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Picker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Picker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Picker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// CSS Modules, react-datepicker-cssmodules.css


var Picker_Picker = function (_React$Component) {
  Picker__inherits(Picker, _React$Component);

  function Picker(props) {
    Picker__classCallCheck(this, Picker);

    var _this = Picker__possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

    _this.state = {
      startDate: moment_default()()
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Picker__createClass(Picker, [{
    key: 'handleChange',
    value: function handleChange(date) {
      this.props.fromParentToChildCallback(this.props.start, date.unix());
      this.setState({
        startDate: date
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.props.title;

      return Picker__jsx('div', {}, void 0, Picker__jsx('span', {}, void 0, title), Picker__jsx(react_datepicker_es, {
        selected: this.state.startDate,
        onChange: this.handleChange,
        dateFormat: 'DD/MM/YYYY'
      }));
    }
  }]);

  return Picker;
}(react_default.a.Component);

/* harmony default export */ var HistoryListPopUp_Picker = (withStyles_default()(react_datepicker_default.a)(Picker_Picker));
// EXTERNAL MODULE: ./src/components/HistoryAlarms/HistoryAlarms.css
var HistoryAlarms = __webpack_require__(908);
var HistoryAlarms_default = /*#__PURE__*/__webpack_require__.n(HistoryAlarms);

// CONCATENATED MODULE: ./src/components/HistoryAlarms/HistoryAlarmContainer.js
var HistoryAlarmContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function HistoryAlarmContainer(props) {
  var wrappedStyle = classnames_default()(HistoryAlarms_default.a.listBordered_item, HistoryAlarms_default.a.u_flexNoWrap, HistoryAlarms_default.a.u_linkPointer);
  return HistoryAlarmContainer__jsx('div', {
    className: wrappedStyle
  }, void 0, HistoryAlarmContainer__jsx('div', {
    className: HistoryAlarms_default.a.u_flexGrow1
  }, void 0, props.children, react_default.a.createElement(index_es["b" /* FormattedMessage */], props.message)), props.created ? HistoryAlarmContainer__jsx('span', {
    className: HistoryAlarms_default.a.Alert_time
  }, void 0, HistoryAlarmContainer__jsx(index_es["c" /* FormattedRelative */], {
    value: new Date(props.created),
    initialNow: new Date()
  })) : null);
}

/* harmony default export */ var HistoryAlarms_HistoryAlarmContainer = (withStyles_default()(HistoryAlarms_default.a)(HistoryAlarmContainer));
// CONCATENATED MODULE: ./src/components/HistoryAlarms/Messages.js


function HistoryAlarms_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    safet_alarm_0_text: {
      'id': 'safet_alarm_0_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 mikro wyciek (np. sp\u0142uczka WC). Dopuszczalny przep\u0142yw zosta\u0142 przekroczony'
    },
    safet_alarm_1_text: {
      'id': 'safet_alarm_1_text',
      'defaultMessage': 'Zaw\xF3r odcinaj\u0105cy zablokowany. Mo\u017Cliwe zanieczyszczenie lub defekt silnika. Ochrona przed przeciekami ograniczona'
    },
    safet_alarm_2_text: {
      'id': 'safet_alarm_2_text',
      'defaultMessage': 'Turbinka przep\u0142ywomierza zablokowana. Mo\u017Cliwe zanieczyszczenie lub uszkodzenie turbiny. Ochrona przed przeciekami ograniczona'
    },
    safet_alarm_3_text: {
      'id': 'safet_alarm_3_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 przeciek obj\u0119to\u015Bciowy. Dopuszczalny pob\xF3r wody zosta\u0142 przekroczony.'
    },
    safet_alarm_4_text: {
      'id': 'safet_alarm_4_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 zbyt du\u017Cy przep\u0142yw chwilowy (>3500l/h), np. p\u0119kni\u0119cie rury'
    },
    safet_alarm_5_text: {
      'id': 'safet_alarm_5_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 przeciek podczas ochrony urlopowej. Dopuszczalny pob\xF3r wody zosta\u0142 przekroczony'
    },
    safet_alarm_6_text: {
      'id': 'safet_alarm_6_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 przeciek przez czujnik pod\u0142ogowy'
    },
    safet_alarm_7_text: {
      'id': 'safet_alarm_7_text',
      'defaultMessage': 'Rozpoznany zosta\u0142 przeciek na wej\u015Bciu IN2.'
    },
    safet_alarm_8_text: {
      'id': 'safet_alarm_8_text',
      'defaultMessage': 'Wykryto przeciek 48h np. sp\u0142uczka WC'
    },
    safet_alarm_9_text: {
      'id': 'safet_alarm_9_text',
      'defaultMessage': 'Wyciek zwi\u0105zany z przekroczeniem czasu poboru wody. Czas poboru wody przekroczy\u0142 dopuszczalne warto\u015Bci.'
    },
    problems_dictionary_0_sup: {
      'id': 'problems_dictionary_0_sup',
      'defaultMessage': 'No error'
    },
    problems_dictionary_1_sup: {
      'id': 'problems_dictionary_1_sup',
      'defaultMessage': 'System pressure too low'
    },
    problems_dictionary_2_sup: {
      'id': 'problems_dictionary_2_sup',
      'defaultMessage': 'System pressure too high'
    },
    problems_dictionary_3_sup: {
      'id': 'problems_dictionary_3_sup',
      'defaultMessage': 'Too low water temperature'
    },
    problems_dictionary_4_sup: {
      'id': 'problems_dictionary_4_sup',
      'defaultMessage': 'Too high water temperature'
    },
    problems_dictionary_5_sup: {
      'id': 'problems_dictionary_5_sup',
      'defaultMessage': 'Input flow blocked'
    },
    problems_dictionary_6_sup: {
      'id': 'problems_dictionary_6_sup',
      'defaultMessage': 'Low level vessel repeatedly'
    },
    problems_dictionary_7_sup: {
      'id': 'problems_dictionary_7_sup',
      'defaultMessage': 'Low level vessel'
    },
    problems_dictionary_8_sup: {
      'id': 'problems_dictionary_8_sup',
      'defaultMessage': 'Main pump overheated'
    },
    problems_dictionary_9_sup: {
      'id': 'problems_dictionary_9_sup',
      'defaultMessage': 'Main pump overload'
    },
    problems_dictionary_10_sup: {
      'id': 'problems_dictionary_10_sup',
      'defaultMessage': 'Refill flow too low'
    },
    problems_dictionary_11_sup: {
      'id': 'problems_dictionary_11_sup',
      'defaultMessage': 'Refill valve open'
    },
    problems_dictionary_12_sup: {
      'id': 'problems_dictionary_12_sup',
      'defaultMessage': 'Unknown errror'
    },
    problems_dictionary_13_sup: {
      'id': 'problems_dictionary_13_sup',
      'defaultMessage': 'Refill: too often'
    },
    problems_dictionary_14_sup: {
      'id': 'problems_dictionary_14_sup',
      'defaultMessage': 'Refill: too long'
    },
    problems_dictionary_15_sup: {
      'id': 'problems_dictionary_15_sup',
      'defaultMessage': 'Refill: too much'
    },
    problems_dictionary_16_sup: {
      'id': 'problems_dictionary_16_sup',
      'defaultMessage': 'Unknown errror'
    },
    problems_dictionary_17_sup: {
      'id': 'problems_dictionary_17_sup',
      'defaultMessage': 'Wrong phase order'
    },
    problems_dictionary_18_sup: {
      'id': 'problems_dictionary_18_sup',
      'defaultMessage': 'Too big output pressure'
    },
    problems_dictionary_19_sup: {
      'id': 'problems_dictionary_19_sup',
      'defaultMessage': 'Pressure sensor fault'
    },
    problems_dictionary_20_sup: {
      'id': 'problems_dictionary_20_sup',
      'defaultMessage': 'Fuse 2 broken'
    },
    problems_dictionary_21_sup: {
      'id': 'problems_dictionary_21_sup',
      'defaultMessage': 'Fuse 3 broken'
    },
    problems_dictionary_22_sup: {
      'id': 'problems_dictionary_22_sup',
      'defaultMessage': 'Communication fault'
    },
    problems_dictionary_23_sup: {
      'id': 'problems_dictionary_23_sup',
      'defaultMessage': 'Too low expansion vessel'
    },
    problems_dictionary_24_sup: {
      'id': 'problems_dictionary_24_sup',
      'defaultMessage': 'Low level break tank'
    },
    problems_dictionary_25_sup: {
      'id': 'problems_dictionary_25_sup',
      'defaultMessage': 'Pump error'
    },
    problems_dictionary_26_sup: {
      'id': 'problems_dictionary_26_sup',
      'defaultMessage': 'Unknown error'
    },
    problems_dictionary_27_sup: {
      'id': 'problems_dictionary_27_sup',
      'defaultMessage': 'Unknown error'
    },
    problems_dictionary_28_sup: {
      'id': 'problems_dictionary_28_sup',
      'defaultMessage': 'Unknown error'
    },
    problems_dictionary_29_sup: {
      'id': 'problems_dictionary_29_sup',
      'defaultMessage': 'Unknown error'
    },
    problems_dictionary_30_sup: {
      'id': 'problems_dictionary_30_sup',
      'defaultMessage': 'Inlet blocked'
    },
    problems_dictionary_31_sup: {
      'id': 'problems_dictionary_31_sup',
      'defaultMessage': 'Fill time too long'
    },
    problems_dictionary_32_sup: {
      'id': 'problems_dictionary_32_sup',
      'defaultMessage': 'Pressure drop inlet too high'
    },
    problems_dictionary_33_sup: {
      'id': 'problems_dictionary_33_sup',
      'defaultMessage': 'Pressure drop inlet too low'
    },
    problems_dictionary_34_sup: {
      'id': 'problems_dictionary_34_sup',
      'defaultMessage': 'SmartSwitch broken'
    },
    problems_dictionary_35_sup: {
      'id': 'problems_dictionary_35_sup',
      'defaultMessage': 'Solenoid valve does not close'
    },
    problems_dictionary_36_sup: {
      'id': 'problems_dictionary_36_sup',
      'defaultMessage': 'Undesirable air intake'
    },
    problems_dictionary_37_sup: {
      'id': 'problems_dictionary_37_sup',
      'defaultMessage': 'Incompressible system'
    },
    problems_dictionary_38_sup: {
      'id': 'problems_dictionary_38_sup',
      'defaultMessage': 'Incompressible system'
    },
    softener_alarm_1_text: {
      'id': 'softener_alarm_1_text',
      'defaultMessage': 'No salt during regeneration'
    },
    softener_alarm_2_text: {
      'id': 'softener_alarm_2_text',
      'defaultMessage': 'Too low water pressure'
    },
    softener_alarm_3_text: {
      'id': 'softener_alarm_3_text',
      'defaultMessage': 'Too high water pressure'
    },
    softener_alarm_4_text: {
      'id': 'softener_alarm_4_text',
      'defaultMessage': 'Pressure sensor failure'
    },
    softener_alarm_5_text: {
      'id': 'softener_alarm_5_text',
      'defaultMessage': 'Valve mechanism failure'
    },
    softener_alarm_6_text: {
      'id': 'softener_alarm_6_text',
      'defaultMessage': 'Too low water pressure during regeneration'
    },
    softener_alarm_7_text: {
      'id': 'softener_alarm_7_text',
      'defaultMessage': 'Power break during regeneration'
    },
    softener_alarm_8_text: {
      'id': 'softener_alarm_8_text',
      'defaultMessage': 'Radio valve communication problem'
    },
    softener_alarm_9_text: {
      'id': 'softener_alarm_9_text',
      'defaultMessage': 'Time flow exceeded, leakage suspected'
    },
    softener_notifications_1_text: {
      'id': 'softener_notifications_1_text',
      'defaultMessage': 'Low predicted the amount of salt'
    },
    softener_notifications_2_text: {
      'id': 'softener_notifications_2_text',
      'defaultMessage': 'Water pressure under 1.5 bar'
    },
    softener_notifications_3_text: {
      'id': 'softener_notifications_3_text',
      'defaultMessage': 'Upcoming service'
    },
    softener_notifications_4_text: {
      'id': 'softener_notifications_4_text',
      'defaultMessage': 'Lack of water, pressure at 0 bar for more than 10 minutes'
    },
    softener_notifications_5_text: {
      'id': 'softener_notifications_5_text',
      'defaultMessage': 'Power break'
    },
    softener_device_notification: {
      'id': 'softener_device_notification',
      'defaultMessage': 'Notification'
    },
    softener_device_alarm: {
      'id': 'softener_device_alarm',
      'defaultMessage': 'Alarm'
    },
    superior_device_notification: {
      'id': 'superior_device_notification',
      'defaultMessage': 'Notification'
    },
    superior_device_alarm: {
      'id': 'superior_device_alarm',
      'defaultMessage': 'Alarm'
    },
    notifications_alerts_all: {
      'id': 'notifications_alerts_all',
      'defaultMessage': 'All'
    },
    alerts_all: {
      'id': 'alerts_all',
      'defaultMessage': 'Alerts'
    },
    notifications_all: {
      'id': 'notifications_all',
      'defaultMessage': 'Notifications'
    },
    notifications_search_box: {
      'id': 'notifications_search_box',
      'defaultMessage': 'Search'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/HistoryAlarms/HistoryAlarm.js
var HistoryAlarm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryAlarm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryAlarm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryAlarm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var HistoryAlarm_HistoryAlarm = function (_React$Component) {
  HistoryAlarm__inherits(HistoryAlarm, _React$Component);

  function HistoryAlarm() {
    var _ref;

    var _temp, _this, _ret;

    HistoryAlarm__classCallCheck(this, HistoryAlarm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryAlarm__possibleConstructorReturn(this, (_ref = HistoryAlarm.__proto__ || Object.getPrototypeOf(HistoryAlarm)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (url, event) {
      if (!event.target.rel || event.target.rel && event.target.rel !== 'userLink') {
        Location.push(url);
      }
    }, _temp), HistoryAlarm__possibleConstructorReturn(_this, _ret);
  }

  HistoryAlarm__createClass(HistoryAlarm, [{
    key: 'render',
    value: function render() {
      var alert = this.props.alert;
      var alertType = alert.get('alert_type');
      var payload = Object(deviceHelper["f" /* getPayloadId */])(alert.get('payload'), alertType);
      var messages = HistoryAlarms_Messages_Messages();
      var alertContainerProps = {
        created: this.props.small ? null : alert.get('created'),
        message: messages[payload]
      };
      // const currentLocation = Location.getCurrentLocation().pathname;
      var devicePhoto = '';

      switch (alertType) {
        case 'softener-device-notification':
        case 'softener-device-alarm':
        case 'superior-device-notification':
        case 'superior-device-alarm':
        case 'simplex-device-notification':
        case 'simplex-device-alarm':
          return react_default.a.createElement(HistoryAlarms_HistoryAlarmContainer, alertContainerProps);
        case 'safet-device-alarm':
        case 'safetech-device-alarm':
          return react_default.a.createElement(HistoryAlarms_HistoryAlarmContainer, alertContainerProps);
        default:
          return react_default.a.createElement(
            HistoryAlarms_HistoryAlarmContainer,
            alertContainerProps,
            'Unknown type (',
            alertType,
            ') of alert!'
          );
      }
    }
  }]);

  return HistoryAlarm;
}(react_default.a.Component);

/* harmony default export */ var HistoryAlarms_HistoryAlarm = (withStyles_default()(HistoryAlarms_default.a)(HistoryAlarm_HistoryAlarm));
// CONCATENATED MODULE: ./src/components/HistoryAlarms/HistoryAlarms.js
var HistoryAlarms__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var HistoryAlarms_MAX_NUMBER_OF_AUTOLOADS = 1;

function HistoryAlarms_HistoryAlarms(props) {
  var alertsPaging = props.alertsPaging;
  var hasMore = alertsPaging.get('itemsPerPage') * alertsPaging.get('currentPage') < alertsPaging.get('itemsCount');

  var wrappedClasses = classnames_default()(HistoryAlarms_default.a.listBordered, HistoryAlarms_default.a.listBordered__large, HistoryAlarms_default.a.listBordered__flat);
  var numberOlderItemsFetched = alertsPaging.get('numberOlderItemsFetched');
  var user = alertsPaging.get('user');
  return HistoryAlarms__jsx(InfiniteScroll["a" /* default */], {
    loadMore: props.getNextAlertPage,
    hasMore: hasMore,
    showLoadMore: numberOlderItemsFetched >= HistoryAlarms_MAX_NUMBER_OF_AUTOLOADS,
    className: wrappedClasses
  }, void 0, props.alerts.valueSeq().map(function (alert) {
    return HistoryAlarms__jsx(HistoryAlarms_HistoryAlarm, {
      alert: alert,
      user: user
    }, alert.get('id'));
  }));
}

var HistoryAlarms_mapState = function mapState(state) {
  return {
    alerts: state.alerts,
    alertsPaging: state.alertsPaging
  };
};

/* harmony default export */ var components_HistoryAlarms_HistoryAlarms = (Object(redux_es["compose"])(withStyles_default()(HistoryAlarms_default.a), Object(es["b" /* connect */])(HistoryAlarms_mapState, null))(HistoryAlarms_HistoryAlarms));
// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(934);

// EXTERNAL MODULE: ./src/components/HistoryListPopUp/ListContainer.css
var ListContainer = __webpack_require__(1086);
var ListContainer_default = /*#__PURE__*/__webpack_require__.n(ListContainer);

// CONCATENATED MODULE: ./src/components/HistoryListPopUp/ListContainer.js
var ListContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ListContainer_ListContainer(props) {
  return ListContainer__jsx('div', {
    className: ListContainer_default.a.Alert_container
  }, void 0, ListContainer__jsx(Section["a" /* default */], {
    container: true
  }, void 0, ListContainer__jsx(Section["a" /* default */], {}, void 0, ListContainer__jsx('div', {
    className: ListContainer_default.a.Alerts
  }, void 0, props.children))));
}

/* harmony default export */ var HistoryListPopUp_ListContainer = (withStyles_default()(ListContainer_default.a)(ListContainer_ListContainer));
// CONCATENATED MODULE: ./src/components/HistoryListPopUp/Messages.js


function HistoryListPopUp_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    save_as_pdf_button_history: {
      'id': 'save_as_pdf_button_history',
      'defaultMessage': 'Save shown records in PDF'
    },
    from_date_history_text: {
      'id': 'from_date_history_text',
      'defaultMessage': 'From date:'
    },
    to_date_history_text: {
      'id': 'to_date_history_text',
      'defaultMessage': 'To date:'
    },
    download_history_text: {
      'id': 'download_history_text',
      'defaultMessage': 'Download history'
    },
    download_pressure_log_text: {
      'id': 'download_pressure_log_text',
      'defaultMessage': 'Download degass log'
    },
    history_download_failed: {
      'id': 'history_download_failed',
      'defaultMessage': 'History download failed. History files have not been sent in preset time.'
    },
    files_count_downloaded: {
      'id': 'files_count_downloaded',
      'defaultMessage': 'Downloaded files'
    },
    no_files_text: {
      'id': 'no_files_text',
      'defaultMessage': 'No files'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/HistoryListPopUp/HistoryListPopUpView.js
var HistoryListPopUpView__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HistoryListPopUpView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryListPopUpView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryListPopUpView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryListPopUpView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryListPopUpView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var HistoryListPopUpView__ref2 = HistoryListPopUpView__jsx(Loader["a" /* default */], {
  block: true
});

var _ref3 = HistoryListPopUpView__jsx(Loader["a" /* default */], {
  block: true
});

var HistoryListPopUpView_HistoryListPopupView = function (_React$Component) {
  HistoryListPopUpView__inherits(HistoryListPopupView, _React$Component);

  function HistoryListPopupView() {
    var _ref;

    var _temp, _this, _ret;

    HistoryListPopUpView__classCallCheck(this, HistoryListPopupView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryListPopUpView__possibleConstructorReturn(this, (_ref = HistoryListPopupView.__proto__ || Object.getPrototypeOf(HistoryListPopupView)).call.apply(_ref, [this].concat(args))), _this), _this.downloadPicker = function (messages, intl) {
      return HistoryListPopUpView__jsx('div', {
        className: HistoryListPopUp_default.a.pickerStyled
      }, void 0, HistoryListPopUpView__jsx(HistoryListPopUp_Picker, {
        title: intl.formatMessage(HistoryListPopUpView__extends({}, messages.from_date_history_text)),
        start: 'start',
        fromParentToChildCallback: _this.props.fromParentToChildCallback
      }), HistoryListPopUpView__jsx(HistoryListPopUp_Picker, {
        title: intl.formatMessage(HistoryListPopUpView__extends({}, messages.to_date_history_text)),
        start: 'stop',
        fromParentToChildCallback: _this.props.fromParentToChildCallback
      }));
    }, _this.downloadFooter = function (messages, intl, deviceType, historyDownloadInProgress, historyDownloadFailed, filterConnect) {
      var iconSize = 41;
      var isSuperior = deviceType === 'superior';
      var buttonStyle = isSuperior ? classnames_default()(HistoryListPopUp_default.a.blackButton) : classnames_default()(HistoryListPopUp_default.a.whiteButton);
      var downloadIcon = isSuperior ? 'pobierz' : 'pobierz_white';
      var dark = isSuperior ? 'dark_spirotech' : 'dark';
      if (filterConnect === 'online') {
        if (!historyDownloadInProgress) {
          return HistoryListPopUpView__jsx('div', {}, void 0, historyDownloadFailed ? HistoryListPopUpView__jsx('div', {
            className: HistoryListPopUp_default.a.historyFailed
          }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.history_download_failed)) : null, _this.downloadPicker(messages, intl), HistoryListPopUpView__jsx('div', {
            className: HistoryListPopUp_default.a.marginLeft
          }, void 0, HistoryListPopUpView__jsx(Button["a" /* default */], {
            onClick: function onClick() {
              _this.props.onDownload();
            },
            buttonClass: 'mainPdf',
            buttonColor: dark
          }, void 0, ';', HistoryListPopUpView__jsx(Icon["a" /* default */], {
            iconName: downloadIcon,
            size: iconSize
          }), HistoryListPopUpView__jsx('div', {
            className: buttonStyle
          }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.download_history_text))), deviceType === 'superior' ? HistoryListPopUpView__jsx(Button["a" /* default */], {
            onClick: function onClick() {
              _this.props.onPulseMaskDownload();
            },
            buttonClass: 'mainPdf',
            buttonColor: dark
          }, void 0, HistoryListPopUpView__jsx(Icon["a" /* default */], {
            iconName: downloadIcon,
            size: iconSize
          }), HistoryListPopUpView__jsx('div', {
            className: buttonStyle
          }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.download_pressure_log_text))) : null));
        }
        var tmpFilesToDownload = _this.props.filesToDownloadValue - _this.props.filesToDownload;
        var filesCountLabel = tmpFilesToDownload + '/' + _this.props.filesToDownloadValue;
        return HistoryListPopUpView__jsx('div', {}, void 0, HistoryListPopUpView__jsx('div', {
          className: HistoryListPopUp_default.a.historyDownloading
        }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.files_count_downloaded), ' ', filesCountLabel), HistoryListPopUpView__ref2);
      }
      return null;
    }, _temp), HistoryListPopUpView__possibleConstructorReturn(_this, _ret);
  }

  HistoryListPopUpView__createClass(HistoryListPopupView, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          deviceType = _props.deviceType,
          serial = _props.serial,
          historyDownloadInProgress = _props.historyDownloadInProgress,
          historyDownloadFailed = _props.historyDownloadFailed,
          deviceDocumentsPaging = _props.deviceDocumentsPaging,
          devicePaging = _props.devicePaging,
          deviceName = _props.deviceName;

      var messages = HistoryListPopUp_Messages_Messages();

      var footerArguments = [messages, intl, deviceType, historyDownloadInProgress, historyDownloadFailed, devicePaging.get('filterConnect')];
      if (this.props.deviceDocumentsPaging.get('loaded')) {
        if (this.props.deviceDocuments.size) {
          return HistoryListPopUpView__jsx(components_Popup_Popup, {
            className: HistoryListPopUp_default.a.Popup__editdevice,
            onClose: this.props.onClose,
            devicetype: deviceType,
            overrideOnClose: true
          }, void 0, HistoryListPopUpView__jsx(HistoryListPopUp_ListContainer, {}, void 0, HistoryListPopUpView__jsx(HistoryDocuments_HistoryDocuments, {
            getNextDocumentsPage: this.props.getNextDocumentsPage,
            getDeviceDocumentsList: this.props.getDeviceDocumentsList,
            newFilesDownloaded: this.props.newFilesDownloaded,
            deviceType: deviceType,
            deviceName: deviceName,
            serial: serial
          })), this.downloadFooter.apply(this, footerArguments), HistoryListPopUpView__jsx(HistoryListPopUp_ListContainer, {}, void 0, HistoryListPopUpView__jsx(components_HistoryAlarms_HistoryAlarms, {
            getNextAlertPage: this.props.getNextAlertPage
          })));
        }
        return HistoryListPopUpView__jsx(components_Popup_Popup, {
          className: HistoryListPopUp_default.a.Popup__editdevice,
          onClose: this.props.onClose,
          overrideOnClose: true
        }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.no_files_text), this.downloadFooter.apply(this, footerArguments), HistoryListPopUpView__jsx(HistoryListPopUp_ListContainer, {}, void 0, HistoryListPopUpView__jsx(components_HistoryAlarms_HistoryAlarms, {
          getNextAlertPage: this.props.getNextAlertPage
        })));
      }
      return HistoryListPopUpView__jsx(components_Popup_Popup, {
        className: HistoryListPopUp_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        overrideOnClose: true
      }, void 0, _ref3, this.downloadFooter.apply(this, footerArguments), HistoryListPopUpView__jsx(HistoryListPopUp_ListContainer, {}, void 0, HistoryListPopUpView__jsx(components_HistoryAlarms_HistoryAlarms, {
        getNextAlertPage: this.props.getNextAlertPage
      })));
    }
  }]);

  return HistoryListPopupView;
}(react_default.a.Component);

/* harmony default export */ var HistoryListPopUpView = (Object(index_es["g" /* injectIntl */])(withStyles_default()(HistoryListPopUp_default.a)(HistoryListPopUpView_HistoryListPopupView)));
// EXTERNAL MODULE: ./src/actions/AlertsActions.js
var AlertsActions = __webpack_require__(914);

// CONCATENATED MODULE: ./src/components/HistoryListPopUp/utils.js
function compareNumbers(a, b) {
  return a - b;
};

function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (var i = 0; i < arr1.length; i = i + 1) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

function arrayDiffCounting(oldArray, newArray) {
  var count = 0;
  var foundNew = [];
  for (var i = 0; i < newArray.length; i += 1) {
    if (!oldArray.includes(newArray[i])) {
      count += 1;
      foundNew.push(newArray[i]);
    }
  }
  return { count: count, foundNew: foundNew };
};
// CONCATENATED MODULE: ./src/components/HistoryListPopUp/HistoryListPopUp.js
var HistoryListPopUp__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryListPopUp__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryListPopUp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryListPopUp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryListPopUp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var HistoryListPopUp_HistoryListPopUp_HistoryListPopUp = function (_React$Component) {
  HistoryListPopUp__inherits(HistoryListPopUp, _React$Component);

  function HistoryListPopUp(props) {
    HistoryListPopUp__classCallCheck(this, HistoryListPopUp);

    var _this = HistoryListPopUp__possibleConstructorReturn(this, (HistoryListPopUp.__proto__ || Object.getPrototypeOf(HistoryListPopUp)).call(this, props));

    _this.getNextAlertPage = function () {
      _this.props.getAlerts({
        page: +_this.props.alertsPaging.get('currentPage') + 1,
        search: _this.props.serial
      });
    };

    _this.getNextDocumentsPage = function () {};

    _this.getDeviceDocumentsList = function (serial) {
      _this.props.getDeviceDocumentsList(serial);
    };

    _this.onDownload = function () {
      var serial = _this.props.serial;
      var startCommand = 'setHST';
      var stopCommand = 'setHET';
      var fifCommand = 'setFIF';
      _this.props.setDeviceCommandValue(serial, startCommand, parseInt(_this.state.startDate, 10));
      _this.props.setDeviceCommandValue(serial, stopCommand, parseInt(_this.state.stopDate, 10));
      _this.setState({
        filesToDownloadValue: 2
      });
      _this.props.setDeviceCommandValue(serial, fifCommand, '0');
      _this.startCheckingNewData(2);
    };

    _this.onPulseMaskDownload = function () {
      var serial = _this.props.serial;
      var startCommand = 'setFMA';
      _this.props.setDeviceCommandValue(serial, startCommand, 1);
      _this.setState({
        filesToDownloadValue: 1
      });
      _this.startCheckingNewData(1);
    };

    _this.fromParentToChildCallback = function (value, date) {
      if (value === 'start') {
        _this.setState({
          startDate: date,
          changed: true
        });
      }
      if (value === 'stop') {
        _this.setState({
          stopDate: date,
          changed: true
        });
      }
    };

    _this.checkForNewData = function () {
      if (_this.state.maxCheckNumber === 0 || _this.state.filesToDownload === 0) {
        clearInterval(_this.intervalId);
        _this.intervalId = null;
        _this.setState({
          historyDownloadFailed: false,
          historyDownloadInProgress: false
        });
        if (_this.state.filesToDownload !== 0) {
          _this.setState({
            historyDownloadFailed: true
          });
        }
      }

      _this.props.getDeviceDocumentsList(_this.props.serial);
      _this.setState({
        maxCheckNumber: _this.state.maxCheckNumber - 1
      });
    };

    _this.startCheckingNewData = function (filesToDownload) {
      var interval = 1000 * 15;
      if (_this.intervalId) {
        return;
      }
      _this.checkForNewData();
      _this.intervalId = window.setInterval(_this.checkForNewData, interval);
      _this.setState({
        historyDownloadInProgress: true,
        historyDownloadFailed: false,
        filesToDownload: filesToDownload
      });
    };

    _this.state = {
      startDate: moment_default()().unix(),
      stopDate: moment_default()().unix(),
      changed: false,
      historyDownloadInProgress: false,
      historyDownloadFailed: false,
      filesToDownload: 0,
      maxCheckNumber: 20,
      filesToDownloadValue: 2,
      newFiles: []
    };
    return _this;
  }

  HistoryListPopUp__createClass(HistoryListPopUp, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var oldTimestamps = this.props.deviceDocuments.map(function (document) {
        return document.get('timestamp');
      });

      var newTimestamps = newProps.deviceDocuments.map(function (document) {
        return document.get('timestamp');
      });

      var result = arrayDiffCounting(oldTimestamps.toArray(), newTimestamps.toArray());
      if (this.state.historyDownloadInProgress) {
        this.setState({
          newFiles: result.foundNew
        });
      }
      if (result.count) {
        if (this.state.historyDownloadInProgress) {
          if (result.count > 1) {
            this.setState({
              filesToDownload: 0,
              historyDownloadFailed: false,
              historyDownloadInProgress: false
            });
          } else {
            this.setState({
              filesToDownload: this.state.filesToDownload - result.count,
              historyDownloadFailed: false,
              historyDownloadInProgress: false
            });
          }
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getDeviceDocumentsList(this.props.serial);
      this.props.getAlerts({ search: this.props.serial });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
      this.props.clearDeviceDocumentsList();
    }
  }, {
    key: 'render',
    value: function render() {
      return HistoryListPopUp__jsx(HistoryListPopUpView, {
        deviceDocuments: this.props.deviceDocuments,
        deviceDocumentsPaging: this.props.deviceDocumentsPaging,
        serial: this.props.serial,
        deviceName: this.props.deviceName,
        deviceType: this.props.deviceType,
        devicePaging: this.props.devicePaging,
        onClose: this.props.onClose,
        onDownload: this.onDownload,
        onPulseMaskDownload: this.onPulseMaskDownload,
        fromParentToChildCallback: this.fromParentToChildCallback,
        alerts: this.props.alerts,
        alertsPaging: this.props.alertsPaging,
        getNextAlertPage: this.getNextAlertPage,
        getNextDocumentsPage: this.getNextDocumentsPage,
        getDeviceDocumentsList: this.getDeviceDocumentsList,
        historyDownloadInProgress: this.state.historyDownloadInProgress,
        historyDownloadFailed: this.state.historyDownloadFailed,
        filesToDownload: this.state.filesToDownload,
        filesToDownloadValue: this.state.filesToDownloadValue,
        newFilesDownloaded: this.state.newFiles
      });
    }
  }]);

  return HistoryListPopUp;
}(react_default.a.Component);

var HistoryListPopUp_mapState = function mapState(state) {
  return {
    deviceDocuments: state.deviceDocuments,
    deviceDocumentsPaging: state.deviceDocumentsPaging,
    alerts: state.alerts,
    alertsPaging: state.alertsPaging,
    devicePaging: state.devicePaging
  };
};

var HistoryListPopUp_mapDispatch = function mapDispatch(dispatch) {
  return {
    getDeviceDocumentsList: function getDeviceDocumentsList(serial) {
      return dispatch(documents_getDeviceDocumentsList(serial));
    },
    clearDeviceDocumentsList: function clearDeviceDocumentsList() {
      return dispatch(documents_clearDeviceDocumentsList());
    },
    setDeviceCommandValue: function setDeviceCommandValue(device, command, value) {
      return Object(actions_device["r" /* setDeviceCommandValue */])(device, command, value);
    },
    getAlerts: function getAlerts(params, reqParams) {
      return dispatch(Object(AlertsActions["a" /* getAlerts */])(params, reqParams));
    }
  };
};

/* harmony default export */ var components_HistoryListPopUp_HistoryListPopUp = (Object(es["b" /* connect */])(HistoryListPopUp_mapState, HistoryListPopUp_mapDispatch)(HistoryListPopUp_HistoryListPopUp_HistoryListPopUp));
// EXTERNAL MODULE: ./src/components/SafeTechPopup/SafeTechPopup.css
var SafeTechPopup = __webpack_require__(932);
var SafeTechPopup_default = /*#__PURE__*/__webpack_require__.n(SafeTechPopup);

// CONCATENATED MODULE: ./src/components/SafeTechPopup/Messages.js


function SafeTechPopup_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    address_label_main_screen_text: {
      'id': 'address_label_main_screen_text',
      'defaultMessage': 'Address'
    },
    safetech_popup_add_profile: {
      'id': 'safetech_popup_add_profile',
      'defaultMessage': 'Add new profile'
    },
    safetech_popup_add_profile_value: {
      'id': 'safetech_popup_add_profile_value',
      'defaultMessage': 'New profile name'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/SafeTechPopup/AddProfilePopup.js
var AddProfilePopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AddProfilePopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AddProfilePopup__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AddProfilePopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AddProfilePopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AddProfilePopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var AddProfilePopup_AddProfilePopup = function (_React$Component) {
  AddProfilePopup__inherits(AddProfilePopup, _React$Component);

  function AddProfilePopup(props) {
    AddProfilePopup__classCallCheck(this, AddProfilePopup);

    var _this = AddProfilePopup__possibleConstructorReturn(this, (AddProfilePopup.__proto__ || Object.getPrototypeOf(AddProfilePopup)).call(this, props));

    _this.onClick = function () {
      var _this$props = _this.props,
          serial = _this$props.serial,
          nextProfile = _this$props.nextProfile;

      if (_this.state.profileName) {
        _this.props.setDeviceCommandValue(serial, 'setPN' + nextProfile, _this.state.profileName);
        _this.props.setDeviceCommandValue(serial, 'setPA' + nextProfile, 1);
      }
      _this.props.onClose();
    };

    _this.onFieldChange = function (field, e) {
      _this.setState(AddProfilePopup__defineProperty({}, field, e));
    };

    _this.state = {
      profileName: ''
    };
    return _this;
  }

  AddProfilePopup__createClass(AddProfilePopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          devicetype = _props.devicetype,
          serial = _props.serial;

      var messages = SafeTechPopup_Messages_Messages();

      return AddProfilePopup__jsx(components_Popup_Popup, {
        className: SafeTechPopup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, AddProfilePopup__jsx(Form["a" /* default */], {
        onSubmit: this.onSubmit
      }, void 0, AddProfilePopup__jsx(Grid["a" /* default */].Cell, {}, void 0, AddProfilePopup__jsx(Input["a" /* default */], {
        type: 'text',
        name: 'profileName',
        title: intl.formatMessage(messages.safetech_popup_add_profile),
        onChange: this.onFieldChange.bind(this, 'profileName'),
        titleVisibility: true
      })), AddProfilePopup__jsx(SaveChangeButtonPopup_SaveChangesButton, {
        devicetype: devicetype,
        onClick: this.onClick
      })));
    }
  }]);

  return AddProfilePopup;
}(react_default.a.Component);

AddProfilePopup_AddProfilePopup.defaultProps = {};

var AddProfilePopup_mapDispatch = function mapDispatch(dispatch) {
  return {
    saveDeviceData: function (_saveDeviceData) {
      function saveDeviceData(_x, _x2) {
        return _saveDeviceData.apply(this, arguments);
      }

      saveDeviceData.toString = function () {
        return _saveDeviceData.toString();
      };

      return saveDeviceData;
    }(function (serial, data) {
      return dispatch(saveDeviceData(serial, data));
    }),
    setDeviceCommandValue: function setDeviceCommandValue(deviceId, command, value) {
      return dispatch(Object(actions_device["r" /* setDeviceCommandValue */])(deviceId, command, value));
    }
  };
};

/* harmony default export */ var SafeTechPopup_AddProfilePopup = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(null, AddProfilePopup_mapDispatch), withStyles_default()(SafeTechPopup_default.a))(AddProfilePopup_AddProfilePopup)));
// CONCATENATED MODULE: ./src/components/SafeTechPopup/SafeTechPopup.js
var SafeTechPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











function SafeTechPopup_SafeTechPopup(props) {
  return SafeTechPopup__jsx('div', {}, void 0, SafeTechPopup__jsx(SafeTechPopup_AddProfilePopup, {
    onClose: props.onClose,
    serial: props.serial,
    nextProfile: props.nextProfile
  }));
}

var SafeTechPopup_mapState = function mapState(state) {
  return {};
};

var SafeTechPopup_mapDispatch = function mapDispatch(dispatch) {
  return {};
};

/* harmony default export */ var components_SafeTechPopup_SafeTechPopup = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(withStyles_default()(SafeTechPopup_default.a), Object(es["b" /* connect */])(SafeTechPopup_mapState, SafeTechPopup_mapDispatch))(SafeTechPopup_SafeTechPopup)));
// CONCATENATED MODULE: ./src/components/Popup/SendCommandPopup.js
var SendCommandPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SendCommandPopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SendCommandPopup__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SendCommandPopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SendCommandPopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SendCommandPopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SendCommandPopup_SendCommandPopup = function (_React$Component) {
  SendCommandPopup__inherits(SendCommandPopup, _React$Component);

  function SendCommandPopup(props) {
    SendCommandPopup__classCallCheck(this, SendCommandPopup);

    var _this = SendCommandPopup__possibleConstructorReturn(this, (SendCommandPopup.__proto__ || Object.getPrototypeOf(SendCommandPopup)).call(this, props));

    _this.onClick = function () {
      _this.props.setDeviceCommandValue(_this.props.serial, _this.state.commandToSend, _this.state.valueToSend);
      _this.props.onClose();
    };

    _this.onFieldChange = function (field, e) {
      _this.setState(SendCommandPopup__defineProperty({}, field, e));
    };

    _this.state = {
      commandToSend: '',
      valueToSend: ''
    };
    return _this;
  }

  SendCommandPopup__createClass(SendCommandPopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          devicetype = _props.devicetype,
          serial = _props.serial;

      var messages = Messages();

      return SendCommandPopup__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        devicetype: devicetype,
        overrideOnClose: true
      }, void 0, serial, SendCommandPopup__jsx(Form["a" /* default */], {
        onSubmit: this.onSubmit
      }, void 0, SendCommandPopup__jsx(Grid["a" /* default */].Cell, {}, void 0, SendCommandPopup__jsx(Input["a" /* default */], {
        type: 'text',
        name: 'command',
        title: intl.formatMessage(messages.send_command_command_popup),
        onChange: this.onFieldChange.bind(this, 'commandToSend'),
        titleVisibility: true
      })), SendCommandPopup__jsx(Grid["a" /* default */].Cell, {}, void 0, SendCommandPopup__jsx(Input["a" /* default */], {
        type: 'text',
        name: 'value',
        title: intl.formatMessage(messages.send_command_value_popup),
        onChange: this.onFieldChange.bind(this, 'valueToSend'),
        titleVisibility: true
      })), SendCommandPopup__jsx(SaveChangeButtonPopup_SaveChangesButton, {
        devicetype: devicetype,
        onClick: this.onClick
      })));
    }
  }]);

  return SendCommandPopup;
}(react_default.a.Component);

SendCommandPopup_SendCommandPopup.defaultProps = {
  devicetype: ''
};

var SendCommandPopup_mapDispatch = function mapDispatch(dispatch) {
  return {
    setDeviceCommandValue: function setDeviceCommandValue(deviceId, command, value) {
      return dispatch(Object(actions_device["r" /* setDeviceCommandValue */])(deviceId, command, value));
    }
  };
};

/* harmony default export */ var Popup_SendCommandPopup = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(null, SendCommandPopup_mapDispatch), withStyles_default()(Popup_default.a))(SendCommandPopup_SendCommandPopup)));
// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/PairingBox.js
var PairingBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PairingBox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var PairingBox__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PairingBox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PairingBox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PairingBox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var PairingBox__ref = PairingBox__jsx('div', {}, void 0, PairingBox__jsx(Loader["a" /* default */], {
  block: true
}));

var PairingBox__ref2 = PairingBox__jsx(Loader["a" /* default */], {
  block: true
});

var PairingBox_PairingBox = function (_React$Component) {
  PairingBox__inherits(PairingBox, _React$Component);

  function PairingBox(props) {
    PairingBox__classCallCheck(this, PairingBox);

    var _this = PairingBox__possibleConstructorReturn(this, (PairingBox.__proto__ || Object.getPrototypeOf(PairingBox)).call(this, props));

    _this.onChange = function (value) {
      _this.setState({
        safefloorSerialToPair: value
      });
      _this.props.onSelectChanged(value);
    };

    _this.renderForm = function (intl, messages, safeFloorsToConnect) {
      return PairingBox__jsx('div', {}, void 0, PairingBox__jsx(Form["a" /* default */], {}, void 0, PairingBox__jsx(Select_Select["a" /* default */], {
        name: 'floorsensors',
        title: intl.formatMessage(PairingBox__extends({}, messages.pairing_available_floor_sensors)),
        options: safeFloorsToConnect,
        onChange: _this.onChange,
        large: true
      })), PairingBox__jsx('div', {
        className: Popup_default.a.buttonHolder
      }, void 0, PairingBox__jsx(Button["a" /* default */], {
        buttonColor: 'light',
        onClick: _this.props.onClick,
        disabled: !_this.state.safefloorSerialToPair
      }, void 0, PairingBox__jsx('div', {
        className: Popup_default.a.white_text
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_start_button_text), _this.state.safefloorSerialToPair))));
    };

    _this.state = {
      safefloorSerialToPair: null
    };
    return _this;
  }

  PairingBox__createClass(PairingBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          device = _props.device,
          devicePaging = _props.devicePaging;

      var messages = Messages();
      var liveData = device.get('live');
      var info = device.get('info');
      var getFSL = liveData.getFSL;

      if (getFSL != undefined && info != null) {
        // safefloors already connected to safetech
        var safefloorsPairedOnSafeTech = getFSL != undefined ? JSON.parse(getFSL) : [];
        var safefloorsAlreadyConnectedToSafetech = info['safefloor_protection'];
        var safeFloorsMerged = concatenateLists(safefloorsAlreadyConnectedToSafetech, safefloorsPairedOnSafeTech);
        // available safefloors to be connected
        var safeFloorDevices = devicePaging.get('safefloorDevices');
        var availableSafeFloors = safeFloorDevices !== null ? safeFloorDevices.map(utils["d" /* safeFloorParser */]) : null;
        var safeFloorsToConnect = getActiveNoConnectedFloorSensors(availableSafeFloors, safeFloorsMerged);
        if (availableSafeFloors === null) {
          return PairingBox__ref;
        } else {
          if (this.props.allowToSaveInstallation) {
            return PairingBox__jsx('div', {}, void 0, PairingBox__jsx('div', {}, void 0, PairingBox__jsx('span', {
              dangerouslySetInnerHTML: { __html: intl.formatMessage(messages.pairing_pair_only_in_service) }
            }, void 0)), PairingBox__jsx('div', {
              className: Popup_default.a.buttonHolder
            }, void 0, PairingBox__jsx(Button["a" /* default */], {
              buttonColor: 'light',
              onClick: this.props.saveInstallationClick
            }, void 0, PairingBox__jsx('div', {
              className: Popup_default.a.white_text
            }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.salt_sensor_history_yes))), PairingBox__jsx('span', {
              className: Popup_default.a.white_text
            }, void 0, '|'), PairingBox__jsx(Button["a" /* default */], {
              buttonColor: 'light',
              onClick: this.props.cancelSaveInstallationClick
            }, void 0, PairingBox__jsx('div', {
              className: Popup_default.a.white_text
            }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.salt_sensor_history_no)))));
          }
          if (safeFloorsToConnect.length) {
            if (this.props.pairingStarted) {
              return PairingBox__jsx('div', {}, void 0, this.props.counter, ' ', this.props.pairingStatus, PairingBox__ref2);
            } else {
              return this.renderForm(intl, messages, safeFloorsToConnect);
            }
          } else {
            return PairingBox__jsx('div', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_no_floor_sensors));
          }
        }
      }
      return null;
    }
  }]);

  return PairingBox;
}(react_default.a.Component);

/* harmony default export */ var DevicePopups_PairingBox = (Object(index_es["g" /* injectIntl */])(withStyles_default()(Popup_default.a)(PairingBox_PairingBox)));
// EXTERNAL MODULE: ./src/actions/home.js
var home = __webpack_require__(946);

// EXTERNAL MODULE: ./src/components/CommonDevice/Main.js
var Main = __webpack_require__(939);

// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/ConnectedDevicesSafeTechXSafeFloor.js
var ConnectedDevicesSafeTechXSafeFloor__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConnectedDevicesSafeTechXSafeFloor__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConnectedDevicesSafeTechXSafeFloor__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConnectedDevicesSafeTechXSafeFloor__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConnectedDevicesSafeTechXSafeFloor__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ConnectedDevicesSafeTechXSafeFloor__ref2 = ConnectedDevicesSafeTechXSafeFloor__jsx('div', {}, void 0, ConnectedDevicesSafeTechXSafeFloor__jsx(Loader["a" /* default */], {
	block: true
}));

var ConnectedDevicesSafeTechXSafeFloor_ConnectedDevicesSafeTechXSafeFloor = function (_ConnectedDevicesComm) {
	ConnectedDevicesSafeTechXSafeFloor__inherits(ConnectedDevicesSafeTechXSafeFloor, _ConnectedDevicesComm);

	function ConnectedDevicesSafeTechXSafeFloor() {
		var _ref;

		var _temp, _this, _ret;

		ConnectedDevicesSafeTechXSafeFloor__classCallCheck(this, ConnectedDevicesSafeTechXSafeFloor);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ConnectedDevicesSafeTechXSafeFloor__possibleConstructorReturn(this, (_ref = ConnectedDevicesSafeTechXSafeFloor.__proto__ || Object.getPrototypeOf(ConnectedDevicesSafeTechXSafeFloor)).call.apply(_ref, [this].concat(args))), _this), _this.deleteDevice = function (installation_id, deviceId) {
			_this.props.setDeviceCommandValue(_this.props.serial, 'setFSR', deviceId);
			if (installation_id) {
				_this.props.removeProtectedInstallation(installation_id, deviceId);
				_this.props.getDeviceInfo(_this.props.serial, 'safetech');
			}
		}, _temp), ConnectedDevicesSafeTechXSafeFloor__possibleConstructorReturn(_this, _ret);
	}

	ConnectedDevicesSafeTechXSafeFloor__createClass(ConnectedDevicesSafeTechXSafeFloor, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    device = _props.device,
			    userRole = _props.userRole;

			var messages = Messages();
			var liveData = device.get('live');
			var info = device.get('info');
			var getFSL = liveData.getFSL;


			if (info !== null && 'safefloor_protection' in info) {
				var safefloor_protection = info['safefloor_protection'];
				var connectedSafeFloors = getFSL != undefined ? JSON.parse(getFSL) : [];
				var cl = concatenateLists(safefloor_protection, connectedSafeFloors);
				return ConnectedDevicesSafeTechXSafeFloor__jsx('div', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_already_connected_list_text), ConnectedDevicesSafeTechXSafeFloor__jsx('ul', {}, void 0, cl.map(function (item, index) {
					return _this2.showText(item, userRole);
				})), cl.length > 0 ? ConnectedDevicesSafeTechXSafeFloor__jsx('div', {}, void 0, ConnectedDevicesSafeTechXSafeFloor__jsx('div', {
					className: Popup_default.a.green_text
				}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_paired_on_device_and_service)), ConnectedDevicesSafeTechXSafeFloor__jsx('div', {
					className: Popup_default.a.orange_text
				}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_paired_on_service)), ConnectedDevicesSafeTechXSafeFloor__jsx('div', {
					className: Popup_default.a.red_text
				}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_paired_on_device))) : null);
			} else {
				return ConnectedDevicesSafeTechXSafeFloor__ref2;
			}
		}
	}]);

	return ConnectedDevicesSafeTechXSafeFloor;
}(DevicePopups_ConnectedDevicesCommon);

ConnectedDevicesSafeTechXSafeFloor_ConnectedDevicesSafeTechXSafeFloor.propTypes = {
	userRole: prop_types_default.a.string.isRequired,
	setDeviceCommandValue: prop_types_default.a.func.isRequired,
	device: prop_types_default.a.object.isRequired,
	serial: prop_types_default.a.string.isRequired
};

var ConnectedDevicesSafeTechXSafeFloor_mapDispatch = function mapDispatch(dispatch) {
	return {
		setDeviceCommandValue: function setDeviceCommandValue(deviceId, command, value) {
			return dispatch(Object(actions_device["r" /* setDeviceCommandValue */])(deviceId, command, value));
		},
		removeProtectedInstallation: function removeProtectedInstallation(installation_id, action) {
			return dispatch(Object(actions_device["l" /* removeProtectedInstallation */])(installation_id, action));
		},
		getDeviceInfo: function getDeviceInfo(deviceId, deviceType) {
			return dispatch(Object(actions_device["g" /* getDeviceInfo */])(deviceId, deviceType));
		}
	};
};

/* harmony default export */ var DevicePopups_ConnectedDevicesSafeTechXSafeFloor = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(null, ConnectedDevicesSafeTechXSafeFloor_mapDispatch), withStyles_default()(Popup_default.a))(ConnectedDevicesSafeTechXSafeFloor_ConnectedDevicesSafeTechXSafeFloor)));
// CONCATENATED MODULE: ./src/components/Popup/DevicePopups/SafeFloorInstallation.js
var SafeFloorInstallation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SafeFloorInstallation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SafeFloorInstallation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SafeFloorInstallation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SafeFloorInstallation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var SafeFloorInstallation__ref = SafeFloorInstallation__jsx('br', {});

var SafeFloorInstallation_SafeFloorInstallation = function (_CommonDevice) {
  SafeFloorInstallation__inherits(SafeFloorInstallation, _CommonDevice);

  function SafeFloorInstallation(props) {
    SafeFloorInstallation__classCallCheck(this, SafeFloorInstallation);

    var _this = SafeFloorInstallation__possibleConstructorReturn(this, (SafeFloorInstallation.__proto__ || Object.getPrototypeOf(SafeFloorInstallation)).call(this, props));

    _this.confirmClicked = function () {
      _this.setState({
        confirm: true
      });
    };

    _this.saveInstallation = function () {
      _this.props.saveInstallationData({
        serial: _this.props.serial,
        safetech_serial: _this.props.serial,
        safefloor_serial: _this.state.safefloorSerialToPair
      });
      _this.props.getDeviceInfo(_this.props.serial, 'safetech');
    };

    _this.saveInstallationClick = function () {
      _this.saveInstallation();
      _this.setState({
        allowToSaveInstallation: false
      });
    };

    _this.cancelSaveInstallationClick = function () {
      _this.setState({
        allowToSaveInstallation: false
      });
    };

    _this.checkForNewData = function () {
      var _this$props = _this.props,
          device = _this$props.device,
          serial = _this$props.serial;

      if (device.get('liveRequestInProgress') === false) {
        _this.checkStatus();
        _this.props.getLiveDeviceData(serial, 'safetech');
      }
    };

    _this.checkStatus = function () {
      // we want to check only 60 seconds
      var _this$props2 = _this.props,
          intl = _this$props2.intl,
          device = _this$props2.device;

      var messages = Messages();

      if (_this.state.counter && _this.state.pairingStarted) {
        // check status 
        var liveData = device.get('live');
        var pairingStatusFromDevice = liveData['getFSA' + _this.state.safefloorSerialToPair];
        var pairingStatus = null;
        var pairingStarted = true;
        var allowToSaveInstallation = false;
        if (pairingStatusFromDevice != undefined) {
          switch (+pairingStatusFromDevice) {
            case 0:
              pairingStatus = null;
              pairingStarted = false;
              allowToSaveInstallation = true;
              break;
            case 1:
              pairingStatus = intl.formatMessage(messages.pairing_status_active);
              break;
            case 2:
              pairingStatus = null;
              pairingStarted = false;
              _this.saveInstallation();
              break;
            default:
              break;
          }
          _this.setState({
            pairingStarted: pairingStarted,
            pairingStatus: pairingStatus,
            allowToSaveInstallation: allowToSaveInstallation
          });
        }

        _this.setState({
          counter: _this.state.counter - 1
        });
      } else {
        // clear before next
        if (_this.state.safefloorSerialToPair === null) {
          _this.setState({
            pairingStarted: false,
            safefloorSerialToPair: null,
            pairingStatus: null
          });
        }
      }
    };

    _this.onClick = function () {
      // check if safefloor is active
      _this.props.getLiveDeviceData(_this.state.safefloorSerialToPair, 'safefloor');
      var liveData = _this.props.safefloor.get('live');

      _this.props.setDeviceCommandValue(_this.props.serial, "setFSA", _this.state.safefloorSerialToPair);

      _this.setState({
        counter: 60,
        pairingStarted: true
      });
    };

    _this.onValueChange = function (value) {
      _this.setState({
        safefloorSerialToPair: value
      });
    };

    _this.state = {
      pairingStarted: false,
      allowToSaveInstallation: false,
      pairingStatus: null,
      counter: 0,
      confirm: false,
      safefloorSerialToPair: null
    };
    return _this;
  }

  SafeFloorInstallation__createClass(SafeFloorInstallation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var deviceName = 'safetech';

      this.props.clearDeviceUserData(deviceName);
      this.props.getDeviceInfo(this.props.serial, deviceName);
      this.props.getLiveDeviceData(this.props.serial, deviceName);

      this.props.getSafeFloorList({
        filterconnect: 'online',
        filterdevicetype: 'safefloor'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          device = _props.device,
          devicePaging = _props.devicePaging,
          authentication = _props.authentication,
          serial = _props.serial,
          intl = _props.intl;

      var userRole = authentication.get('userRole');
      var messages = Messages();

      return SafeFloorInstallation__jsx(components_Popup_Popup, {
        className: Popup_default.a.Popup__editdevice,
        onClose: this.props.onClose,
        overrideOnClose: true
      }, void 0, SafeFloorInstallation__jsx('div', {
        className: Popup_default.a.wrapper
      }, void 0, SafeFloorInstallation__jsx('div', {
        className: Popup_default.a.first
      }, void 0, SafeFloorInstallation__jsx(DevicePopups_ConnectedDevicesSafeTechXSafeFloor, {
        device: device,
        userRole: userRole,
        serial: serial
      })), SafeFloorInstallation__jsx('div', {
        className: Popup_default.a.second
      }, void 0, this.state.confirm ? SafeFloorInstallation__jsx(DevicePopups_PairingBox, {
        device: device,
        devicePaging: devicePaging,
        pairingStarted: this.state.pairingStarted,
        pairingStatus: this.state.pairingStatus,
        onSelectChanged: this.onValueChange,
        allowToSaveInstallation: this.state.allowToSaveInstallation,
        saveInstallationClick: this.saveInstallationClick,
        cancelSaveInstallationClick: this.cancelSaveInstallationClick,
        onClick: this.onClick
      }) : SafeFloorInstallation__jsx('div', {}, void 0, SafeFloorInstallation__jsx('span', {
        dangerouslySetInnerHTML: { __html: intl.formatMessage(messages.pairing_cofirmation_info_text) }
      }, void 0), SafeFloorInstallation__ref, SafeFloorInstallation__jsx('div', {
        className: Popup_default.a.buttonHolder
      }, void 0, SafeFloorInstallation__jsx(Button["a" /* default */], {
        buttonColor: 'light',
        onClick: this.confirmClicked
      }, void 0, SafeFloorInstallation__jsx('div', {
        className: Popup_default.a.white_text
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.pairing_confirmation_text))))))));
    }
  }]);

  return SafeFloorInstallation;
}(Main["a" /* default */]);

SafeFloorInstallation_SafeFloorInstallation.propTypes = {
  onClose: prop_types_default.a.func.isRequired,
  intl: index_es["h" /* intlShape */].isRequired,
  serial: prop_types_default.a.string.isRequired,
  devicetype: prop_types_default.a.string,
  getLiveDeviceData: prop_types_default.a.func.isRequired,
  getDeviceInfo: prop_types_default.a.func.isRequired,
  getSafeFloorList: prop_types_default.a.func.isRequired,
  clearDeviceUserData: prop_types_default.a.func.isRequired,
  device: prop_types_default.a.object.isRequired,
  safefloor: prop_types_default.a.object.isRequired,
  devicePaging: prop_types_default.a.object.isRequired,
  authentication: prop_types_default.a.object.isRequired

};

SafeFloorInstallation_SafeFloorInstallation.defaultProps = {
  devicetype: ''
};

var SafeFloorInstallation_mapState = function mapState(state) {
  return {
    device: state.safetechReducer,
    safefloor: state.safefloorReducer,
    devicePaging: state.devicePaging,
    user: state.user,
    authentication: state.authentication
  };
};

var SafeFloorInstallation_mapDispatch = function mapDispatch(dispatch) {
  return {
    getDeviceInfo: function getDeviceInfo(deviceId, deviceType) {
      return dispatch(Object(actions_device["g" /* getDeviceInfo */])(deviceId, deviceType));
    },
    getLiveDeviceData: function getLiveDeviceData(deviceId, deviceType) {
      return dispatch(Object(actions_device["h" /* getLiveDeviceData */])(deviceId, deviceType));
    },
    clearDeviceUserData: function clearDeviceUserData(devicetype) {
      return dispatch(Object(actions_device["b" /* clearDeviceUserData */])(devicetype));
    },
    getSafeFloorList: function getSafeFloorList(params) {
      return dispatch(Object(home["d" /* getSafeFloorList */])(params));
    },
    setDeviceCommandValue: function setDeviceCommandValue(deviceId, command, value) {
      return dispatch(Object(actions_device["r" /* setDeviceCommandValue */])(deviceId, command, value));
    },
    saveInstallationData: function saveInstallationData(data) {
      return dispatch(Object(actions_device["o" /* saveInstallationData */])(data));
    }
  };
};

/* harmony default export */ var DevicePopups_SafeFloorInstallation = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(Object(es["b" /* connect */])(SafeFloorInstallation_mapState, SafeFloorInstallation_mapDispatch), withStyles_default()(Popup_default.a))(SafeFloorInstallation_SafeFloorInstallation)));
// CONCATENATED MODULE: ./src/components/Popup/NotificationPopUpCustomContent.js
var NotificationPopUpCustomContent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NotificationPopUpCustomContent__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NotificationPopUpCustomContent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NotificationPopUpCustomContent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NotificationPopUpCustomContent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NotificationPopUpCustomContent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var NotificationPopUpCustomContent_NotificationPopupCustomContent = function (_React$Component) {
  NotificationPopUpCustomContent__inherits(NotificationPopupCustomContent, _React$Component);

  function NotificationPopupCustomContent() {
    var _ref;

    var _temp, _this, _ret;

    NotificationPopUpCustomContent__classCallCheck(this, NotificationPopupCustomContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NotificationPopUpCustomContent__possibleConstructorReturn(this, (_ref = NotificationPopupCustomContent.__proto__ || Object.getPrototypeOf(NotificationPopupCustomContent)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAndClose = function (event) {
      Object(Link["b" /* handleClick */])(event);
      _this.props.closePopup();
    }, _temp), NotificationPopUpCustomContent__possibleConstructorReturn(_this, _ret);
  }

  NotificationPopUpCustomContent__createClass(NotificationPopupCustomContent, [{
    key: 'render',
    value: function render() {
      var subtype = this.props.data.get('subtype');
      var options = this.props.data.get('options');
      var onClose = this.props.closePopup;
      var popupContent = {};
      switch (subtype) {
        case 'SHOW_HISTORY':
          return NotificationPopUpCustomContent__jsx(components_HistoryListPopUp_HistoryListPopUp, {
            onClose: onClose,
            deviceName: options.deviceName,
            serial: options.serial,
            deviceType: options.devicetype
          });
        case 'SAFETECH_ADD_PROFILE':
          return NotificationPopUpCustomContent__jsx(components_SafeTechPopup_SafeTechPopup, {
            onClose: onClose,
            serial: options.serial,
            nextProfile: options.nextProfile
          });
        case 'SHOW_HISTORY2':
          popupContent = {
            title: 'history_title',
            message: 'history_msg',
            error: true
          };
          return react_default.a.createElement(Popup_SimpleNotificationPopup, NotificationPopUpCustomContent__extends({}, popupContent, { onClose: onClose }));

        case 'SHOW_CONFIGURATION_INFO':
          return react_default.a.createElement(Popup_ConfigurationPopUp, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            bottle: options.bottle,
            valve: options.valve,
            medium: options.medium
          }));
        case 'EDIT_DEVICE':
          popupContent = {
            error: true
          };
          return react_default.a.createElement(EditDevicePopUp, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            comment: options.comment,
            address: options.address,
            devicetype: options.devicetype
          }));
        case 'NEW_INSTALLATION':
          popupContent = {
            error: true
          };
          return react_default.a.createElement(NewInstallationPopUp, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            devicetype: options.devicetype
          }));
        case 'SAFEFLOOR_INSTALLATION':
          popupContent = {
            error: false
          };
          return react_default.a.createElement(DevicePopups_SafeFloorInstallation, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            devicetype: options.devicetype,
            connecteddevices: options.connecteddevices
          }));

        case 'SEND_COMMAND':
          popupContent = {
            error: true
          };
          return react_default.a.createElement(Popup_SendCommandPopup, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            devicetype: options.devicetype
          }));
        case 'EDIT_INSTALLER':
          popupContent = {
            error: true
          };
          return react_default.a.createElement(Popup_EditOwnershipPopup, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            devicetype: options.devicetype,
            userType: 'installer'
          }));

        case 'EDIT_ENDUSER':
          popupContent = {
            error: true
          };
          return react_default.a.createElement(Popup_EditOwnershipPopup, NotificationPopUpCustomContent__extends({}, popupContent, {
            onClose: onClose,
            serial: options.serial,
            devicetype: options.devicetype,
            userType: 'viewer'
          }));
        default:
          return null;
      }
    }
  }]);

  return NotificationPopupCustomContent;
}(react_default.a.Component);

/* harmony default export */ var NotificationPopUpCustomContent = (NotificationPopUpCustomContent_NotificationPopupCustomContent);
// CONCATENATED MODULE: ./src/components/Popup/NotificationPopUpTextContent.js
var NotificationPopUpTextContent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function getContent(type, message) {
  switch (type) {
    case 'CREATE_OWNERSHIP':
      return {
        title: 'create_ownership_popup_title',
        message: 'create_ownership_popup_msg',
        error: true
      };
    case 'SAVE_PASSWORD':
      return {
        title: 'save_password_popup_title',
        message: 'save_password_popup_msg',
        error: true
      };
    case 'EDIT_PERSONAL_DATA':
    case 'EDIT_CONTACT_DATA':
      return {
        title: 'edit_personal_data_popup_title',
        message: 'edit_personal_data_popup_msg',
        error: true
      };
    case 'SAVE_NOTIFICATIONS_CONFIG':
      return {
        title: 'save_notification_config_popup_title',
        message: 'save_notification_config_popup_msg',
        error: true
      };
    case 'SAVE_PASSWORD_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true
      };
    case 'EDIT_DEVICE_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true
      };
    case 'CONNECT_DEVICE_FAILURE':
      return {
        title: 'add_idea_confirmation_title',
        message: 'add_idea_confirmation_description'
      };
    case 'REGISTER_USER_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true
      };
    case 'ADD_OWNERSHIP_FAILURE':
      return {
        title: 'add_ownership_failure_popup_title',
        message: 'add_ownership_failure_popup_msg',
        error: true
      };
    case 'REMOVE_OWNERSHIP':
      return {
        title: 'remove_ownership_popup_title',
        message: 'remove_ownership_popup_msg',
        error: true
      };
    case 'REMOVE_OWNERSHIP_FAILURE':
      return {
        title: 'remove_ownership_failure_popup_title',
        message: 'remove_ownership_failure_popup_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_LIMIT':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_FAILURE_BAD_DATA':
      return {
        title: 'add_device_incorrect_serial_number_title',
        message: 'add_device_incorrect_serial_number_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_FAILURE_FORBIDDEN':
      return {
        title: 'add_device_not_found_title',
        message: 'add_device_not_found_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_FAILURE_LIMIT':
      return {
        title: 'add_device_unavailable_title',
        message: 'add_device_unavailable_msg',
        error: true
      };
    case 'CREATE_OWNERSHIP_FAILURE_CODE':
      return {
        title: 'add_device_error_title',
        message: 'add_device_error_msg',
        error: true
      };
    case 'REMOVE_PROTECTED_INSTALLATION':
      return {
        title: 'remove_device_from_installation_title',
        message: 'remove_device_from_installation_msg',
        error: true
      };
    case 'REMOVE_PROTECTED_INSTALLATION_FAILURE_LIMIT':
      return {
        title: 'remove_device_from_installation_error_title',
        message: 'remove_device_from_installation_error_msg',
        error: true
      };
    case 'SAVE_INSTALLATION_DATA':
      return {
        title: 'add_device_to_installation_title',
        message: 'add_device_to_installation_msg',
        error: true
      };
    case 'SAVE_INSTALLATION_DATA_FAILURE_LIMIT':
      return {
        title: 'add_device_to_installation_already_exists_title',
        message: 'add_device_to_installation_already_exists_msg',
        error: true
      };
    case 'SAVE_INSTALLATION_DATA_FAILURE_CODE':
      return {
        title: 'add_device_to_installation_not_exist_title',
        message: 'add_device_to_installation_not_exist_msg',
        error: true
      };
    default:
      return null;
  }
}

function NotificationPopupTextContent(props) {
  var data = props.data,
      closePopup = props.closePopup;

  var popupContent = getContent(data.get('type'), data.get('message'));
  return react_default.a.createElement(Popup_SimpleNotificationPopup, NotificationPopUpTextContent__extends({}, popupContent, { onClose: closePopup }));
}
// EXTERNAL MODULE: ./src/actions/NotificationPopupActions.js
var NotificationPopupActions = __webpack_require__(940);

// CONCATENATED MODULE: ./src/components/Popup/NotificationPopUpManager.js
var NotificationPopUpManager__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NotificationPopUpManager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NotificationPopUpManager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NotificationPopUpManager__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NotificationPopUpManager__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var POPUP_TIMEOUT = 50000;

var NotificationPopUpManager_NotificationPopupsManager = function (_React$Component) {
  NotificationPopUpManager__inherits(NotificationPopupsManager, _React$Component);

  function NotificationPopupsManager() {
    var _ref;

    var _temp, _this, _ret;

    NotificationPopUpManager__classCallCheck(this, NotificationPopupsManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NotificationPopUpManager__possibleConstructorReturn(this, (_ref = NotificationPopupsManager.__proto__ || Object.getPrototypeOf(NotificationPopupsManager)).call.apply(_ref, [this].concat(args))), _this), _this.closePopup = function () {
      if (_this.timeoutHandler) {
        clearTimeout(_this.timeoutHandler);
      }
      _this.popupShown = false;
      var type = _this.props.notificationPopupData.get('type');
      _this.props.hidePopup();
    }, _temp), NotificationPopUpManager__possibleConstructorReturn(_this, _ret);
  }

  NotificationPopUpManager__createClass(NotificationPopupsManager, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closePopup();
    }
  }, {
    key: 'render',
    value: function render() {
      var notificationPopupData = this.props.notificationPopupData;
      if (!notificationPopupData.get('type') || this.popupShown) {
        return null;
      }
      this.popupShown = true;
      if (!notificationPopupData.get('noTimeout')) {
        this.timeoutHandler = setTimeout(this.closePopup, POPUP_TIMEOUT);
      }
      if (notificationPopupData.get('type') === 'SHOW_CUSTOM_POPUP') {
        return NotificationPopUpManager__jsx(NotificationPopUpCustomContent, {
          data: notificationPopupData,
          closePopup: this.closePopup,
          lang: this.props.lang
        });
      }
      return NotificationPopUpManager__jsx(NotificationPopupTextContent, {
        data: notificationPopupData,
        closePopup: this.closePopup
      });
    }
  }]);

  return NotificationPopupsManager;
}(react_default.a.Component);

var NotificationPopUpManager_mapState = function mapState(state) {
  return {
    notificationPopupData: state.notificationPopupData
  };
};

var NotificationPopUpManager_mapDispatch = function mapDispatch(dispatch) {
  return {
    hidePopup: function hidePopup() {
      return dispatch(Object(NotificationPopupActions["a" /* hidePopup */])());
    }
  };
};

/* harmony default export */ var NotificationPopUpManager = (Object(es["b" /* connect */])(NotificationPopUpManager_mapState, NotificationPopUpManager_mapDispatch)(NotificationPopUpManager_NotificationPopupsManager));
// EXTERNAL MODULE: ./src/components/Popup/PopupOverview.css
var PopupOverview = __webpack_require__(1089);
var PopupOverview_default = /*#__PURE__*/__webpack_require__.n(PopupOverview);

// CONCATENATED MODULE: ./src/components/Popup/PopupOverview.js
var PopupOverview__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var PopupOverview__ref = PopupOverview__jsx(Icon["a" /* default */], {
  iconName: "odrzuc",
  size: 20
});

function PopupOverview_PopupOverview(props) {
  var deviceType = props.deviceType;

  var PopupOverviewClose = deviceType === 'superior' ? classnames_default()(PopupOverview_default.a.PopupOverview_close, PopupOverview_default.a.close_spirotech) : classnames_default()(PopupOverview_default.a.PopupOverview_close);
  return PopupOverview__jsx('div', {
    className: PopupOverview_default.a.PopupOverview
  }, void 0, PopupOverview__jsx('div', {
    className: PopupOverview_default.a.PopupOverview_overlay,
    onClick: props.onClose
  }), PopupOverview__jsx('div', {
    className: PopupOverview_default.a.PopupOverview_content
  }, void 0, PopupOverview__jsx('button', {
    type: 'button',
    className: PopupOverviewClose,
    onClick: props.onClose
  }, void 0, PopupOverview__ref), PopupOverview__jsx('div', {
    className: classnames_default()(PopupOverview_default.a.PopupOverview_box)
  }, void 0, props.children)));
}

PopupOverview_PopupOverview.defaultProps = {
  deviceType: 'softener'
};

/* harmony default export */ var Popup_PopupOverview = (Popup_popupBehaviour(withStyles_default()(PopupOverview_default.a)(PopupOverview_PopupOverview)));
// EXTERNAL MODULE: ./src/components/HistoryEvents/HistoryEvents.css
var HistoryEvents_HistoryEvents = __webpack_require__(909);
var HistoryEvents_default = /*#__PURE__*/__webpack_require__.n(HistoryEvents_HistoryEvents);

// CONCATENATED MODULE: ./src/components/HistoryEvents/Messages.js


function HistoryEvents_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    softener_history_event_0000: {
      'id': 'softener_history_event_0000',
      'defaultMessage': 'Saved. Time 00:00:00'
    },
    softener_history_event_0001: {
      'id': 'softener_history_event_0001',
      'defaultMessage': 'Saved. Time 06:00:00'
    },
    softener_history_event_0002: {
      'id': 'softener_history_event_0002',
      'defaultMessage': 'Saved. Time 12:00:00'
    },
    softener_history_event_0003: {
      'id': 'softener_history_event_0003',
      'defaultMessage': 'Saved. Time 18:00:00'
    },
    softener_history_event_0004: {
      'id': 'softener_history_event_0004',
      'defaultMessage': 'Valve 1 mechanism fault'
    },
    softener_history_event_0005: {
      'id': 'softener_history_event_0005',
      'defaultMessage': 'Valve 2 mechanism fault'
    },
    softener_history_event_0006: {
      'id': 'softener_history_event_0006',
      'defaultMessage': 'Valve 3 mechanism fault'
    },
    softener_history_event_0007: {
      'id': 'softener_history_event_0007',
      'defaultMessage': 'Pressure sensor fault'
    },
    softener_history_event_0008: {
      'id': 'softener_history_event_0008',
      'defaultMessage': 'Power ON'
    },
    softener_history_event_0009: {
      'id': 'softener_history_event_0009',
      'defaultMessage': 'Power OFF'
    },
    softener_history_event_0010: {
      'id': 'softener_history_event_0010',
      'defaultMessage': 'Pressure below 1,5 bar (low pressure warning)'
    },
    softener_history_event_0011: {
      'id': 'softener_history_event_0011',
      'defaultMessage': 'Pressure increase by 1 bar'
    },
    softener_history_event_0012: {
      'id': 'softener_history_event_0012',
      'defaultMessage': 'Pressure decrease by 1 bar'
    },
    softener_history_event_0013: {
      'id': 'softener_history_event_0013',
      'defaultMessage': 'Pressure over 8 bar (high pressure warning)'
    },
    softener_history_event_0014: {
      'id': 'softener_history_event_0014',
      'defaultMessage': 'Controller\'s memory refreshment'
    },
    softener_history_event_0020: {
      'id': 'softener_history_event_0020',
      'defaultMessage': 'No salt detected during the regeneration'
    },
    softener_history_event_0021: {
      'id': 'softener_history_event_0021',
      'defaultMessage': 'Chlor current measurement'
    },
    softener_history_event_0022: {
      'id': 'softener_history_event_0022',
      'defaultMessage': 'No salt\' message confirmation'
    },
    softener_history_event_0030: {
      'id': 'softener_history_event_0030',
      'defaultMessage': 'Holiday mode cancel'
    },
    softener_history_event_0031: {
      'id': 'softener_history_event_0031',
      'defaultMessage': 'Holiday mode cancel from the water flow'
    },
    softener_history_event_0032: {
      'id': 'softener_history_event_0032',
      'defaultMessage': 'Holiday mode cancel by user'
    },
    softener_history_event_0040: {
      'id': 'softener_history_event_0040',
      'defaultMessage': 'Connected to LAN network'
    },
    softener_history_event_0041: {
      'id': 'softener_history_event_0041',
      'defaultMessage': 'Disconnected from LAN network'
    },
    softener_history_event_0042: {
      'id': 'softener_history_event_0042',
      'defaultMessage': 'Asigned IP address from the DHCP server'
    },
    softener_history_event_0043: {
      'id': 'softener_history_event_0043',
      'defaultMessage': 'Manually assigned network parameters'
    },
    softener_history_event_0044: {
      'id': 'softener_history_event_0044',
      'defaultMessage': 'User login through Telnet service'
    },
    softener_history_event_0045: {
      'id': 'softener_history_event_0045',
      'defaultMessage': 'Online service connection'
    },
    softener_history_event_0046: {
      'id': 'softener_history_event_0046',
      'defaultMessage': 'Direct computer connection'
    },
    softener_history_event_0047: {
      'id': 'softener_history_event_0047',
      'defaultMessage': 'Online software update'
    },
    softener_history_event_0049: {
      'id': 'softener_history_event_0049',
      'defaultMessage': 'WLAN-USB module reinitialization'
    },
    softener_history_event_0050: {
      'id': 'softener_history_event_0050',
      'defaultMessage': 'User parameters change (menu level 1)'
    },
    softener_history_event_0051: {
      'id': 'softener_history_event_0051',
      'defaultMessage': 'Service parameters change (menu level 2)'
    },
    softener_history_event_0052: {
      'id': 'softener_history_event_0052',
      'defaultMessage': 'Manufacturer parameters change (menu level 3)'
    },
    softener_history_event_0053: {
      'id': 'softener_history_event_0053',
      'defaultMessage': 'Configuration change'
    },
    softener_history_event_0054: {
      'id': 'softener_history_event_0054',
      'defaultMessage': 'RTC time change (original time)'
    },
    softener_history_event_0055: {
      'id': 'softener_history_event_0055',
      'defaultMessage': 'RTC time change (actual time)'
    },
    softener_history_event_0056: {
      'id': 'softener_history_event_0056',
      'defaultMessage': 'Time zone change'
    },
    softener_history_event_0057: {
      'id': 'softener_history_event_0057',
      'defaultMessage': 'Annual inspection reminder'
    },
    softener_history_event_0058: {
      'id': 'softener_history_event_0058',
      'defaultMessage': 'Annual inspection approved'
    },
    softener_history_event_0059: {
      'id': 'softener_history_event_0059',
      'defaultMessage': 'Communication lost with valve 2'
    },
    softener_history_event_0060: {
      'id': 'softener_history_event_0060',
      'defaultMessage': 'Communication lost with valve 3'
    },
    softener_history_event_0062: {
      'id': 'softener_history_event_0062',
      'defaultMessage': 'Return of the valve communication'
    },
    softener_history_event_1000: {
      'id': 'softener_history_event_1000',
      'defaultMessage': 'Auto regeneration start'
    },
    softener_history_event_1001: {
      'id': 'softener_history_event_1001',
      'defaultMessage': 'Immediate regeneration manual start'
    },
    softener_history_event_1002: {
      'id': 'softener_history_event_1002',
      'defaultMessage': 'Delayed regeneration manual start'
    },
    softener_history_event_1003: {
      'id': 'softener_history_event_1003',
      'defaultMessage': 'Immediate multi-regeneration manual start'
    },
    softener_history_event_1004: {
      'id': 'softener_history_event_1004',
      'defaultMessage': 'Delayed regeneration manual stop'
    },
    softener_history_event_1011: {
      'id': 'softener_history_event_1011',
      'defaultMessage': 'Decrease reserve and reporting the necessity of regeneration A cylinder'
    },
    softener_history_event_1012: {
      'id': 'softener_history_event_1012',
      'defaultMessage': 'Decrease reserve and reporting the necessity of regeneration C cylinder'
    },
    softener_history_event_1013: {
      'id': 'softener_history_event_1013',
      'defaultMessage': 'Decrease reserve and reporting the necessity of regeneration B cylinder'
    },
    softener_history_event_1020: {
      'id': 'softener_history_event_1020',
      'defaultMessage': 'Manual cycle stop (pushing the next cycle)'
    },
    softener_history_event_1021: {
      'id': 'softener_history_event_1021',
      'defaultMessage': 'Manual regeneration stop (press \'NEXT\' longer)'
    },
    softener_history_event_1030: {
      'id': 'softener_history_event_1030',
      'defaultMessage': 'Regeneration completed, calculating the reserve'
    },
    softener_history_event_1100: {
      'id': 'softener_history_event_1100',
      'defaultMessage': 'Camshaft valve \'0\' postion for cylinder A found'
    },
    softener_history_event_1200: {
      'id': 'softener_history_event_1200',
      'defaultMessage': 'Camshaft valve \'0\' postion for cylinder C found'
    },
    softener_history_event_1300: {
      'id': 'softener_history_event_1300',
      'defaultMessage': 'Camshaft valve \'0\' postion for cylinder B found'
    },
    softener_history_event_2101: {
      'id': 'softener_history_event_2101',
      'defaultMessage': 'C1 cycle for A cylinder'
    },
    softener_history_event_2102: {
      'id': 'softener_history_event_2102',
      'defaultMessage': 'C2 cycle for A cylinder'
    },
    softener_history_event_2103: {
      'id': 'softener_history_event_2103',
      'defaultMessage': 'C3 cycle for A cylinder'
    },
    softener_history_event_2104: {
      'id': 'softener_history_event_2104',
      'defaultMessage': 'C4 cycle for A cylinder'
    },
    softener_history_event_2105: {
      'id': 'softener_history_event_2105',
      'defaultMessage': 'C5 cycle for A cylinder'
    },
    softener_history_event_2106: {
      'id': 'softener_history_event_2106',
      'defaultMessage': 'C6 cycle for A cylinder'
    },
    softener_history_event_2107: {
      'id': 'softener_history_event_2107',
      'defaultMessage': 'C7 cycle for A cylinder'
    },
    softener_history_event_2108: {
      'id': 'softener_history_event_2108',
      'defaultMessage': 'C8 cycle for A cylinder'
    },
    softener_history_event_2109: {
      'id': 'softener_history_event_2109',
      'defaultMessage': 'C9 cycle for A cylinder'
    },
    softener_history_event_2110: {
      'id': 'softener_history_event_2110',
      'defaultMessage': 'C10 cycle for A cylinder'
    },
    softener_history_event_2111: {
      'id': 'softener_history_event_2111',
      'defaultMessage': 'C11 cycle for A cylinder'
    },
    softener_history_event_2112: {
      'id': 'softener_history_event_2112',
      'defaultMessage': 'C12 cycle for A cylinder'
    },
    softener_history_event_2113: {
      'id': 'softener_history_event_2113',
      'defaultMessage': 'C13 cycle for A cylinder'
    },
    softener_history_event_2114: {
      'id': 'softener_history_event_2114',
      'defaultMessage': 'C14 cycle for A cylinder'
    },
    softener_history_event_2115: {
      'id': 'softener_history_event_2115',
      'defaultMessage': 'C15 cycle for A cylinder'
    },
    softener_history_event_2201: {
      'id': 'softener_history_event_2201',
      'defaultMessage': 'C1 cycle for C cylinder'
    },
    softener_history_event_2202: {
      'id': 'softener_history_event_2202',
      'defaultMessage': 'C2 cycle for C cylinder'
    },
    softener_history_event_2203: {
      'id': 'softener_history_event_2203',
      'defaultMessage': 'C3 cycle for C cylinder'
    },
    softener_history_event_2204: {
      'id': 'softener_history_event_2204',
      'defaultMessage': 'C4 cycle for C cylinder'
    },
    softener_history_event_2205: {
      'id': 'softener_history_event_2205',
      'defaultMessage': 'C5 cycle for C cylinder'
    },
    softener_history_event_2206: {
      'id': 'softener_history_event_2206',
      'defaultMessage': 'C6 cycle for C cylinder'
    },
    softener_history_event_2207: {
      'id': 'softener_history_event_2207',
      'defaultMessage': 'C7 cycle for C cylinder'
    },
    softener_history_event_2208: {
      'id': 'softener_history_event_2208',
      'defaultMessage': 'C8 cycle for C cylinder'
    },
    softener_history_event_2209: {
      'id': 'softener_history_event_2209',
      'defaultMessage': 'C9 cycle for C cylinder'
    },
    softener_history_event_2210: {
      'id': 'softener_history_event_2210',
      'defaultMessage': 'C10 cycle for C cylinder'
    },
    softener_history_event_2211: {
      'id': 'softener_history_event_2211',
      'defaultMessage': 'C11 cycle for C cylinder'
    },
    softener_history_event_2212: {
      'id': 'softener_history_event_2212',
      'defaultMessage': 'C12 cycle for C cylinder'
    },
    softener_history_event_2213: {
      'id': 'softener_history_event_2213',
      'defaultMessage': 'C13 cycle for C cylinder'
    },
    softener_history_event_2214: {
      'id': 'softener_history_event_2214',
      'defaultMessage': 'C14 cycle for C cylinder'
    },
    softener_history_event_2215: {
      'id': 'softener_history_event_2215',
      'defaultMessage': 'C15 cycle for C cylinder'
    },
    softener_history_event_2301: {
      'id': 'softener_history_event_2301',
      'defaultMessage': 'C1 cycle for B cylinder'
    },
    softener_history_event_2302: {
      'id': 'softener_history_event_2302',
      'defaultMessage': 'C2 cycle for B cylinder'
    },
    softener_history_event_2303: {
      'id': 'softener_history_event_2303',
      'defaultMessage': 'C3 cycle for B cylinder'
    },
    softener_history_event_2304: {
      'id': 'softener_history_event_2304',
      'defaultMessage': 'C4 cycle for B cylinder'
    },
    softener_history_event_2305: {
      'id': 'softener_history_event_2305',
      'defaultMessage': 'C5 cycle for B cylinder'
    },
    softener_history_event_2306: {
      'id': 'softener_history_event_2306',
      'defaultMessage': 'C6 cycle for B cylinder'
    },
    softener_history_event_2307: {
      'id': 'softener_history_event_2307',
      'defaultMessage': 'C7 cycle for B cylinder'
    },
    softener_history_event_2308: {
      'id': 'softener_history_event_2308',
      'defaultMessage': 'C8 cycle for B cylinder'
    },
    softener_history_event_2309: {
      'id': 'softener_history_event_2309',
      'defaultMessage': 'C9 cycle for B cylinder'
    },
    softener_history_event_2310: {
      'id': 'softener_history_event_2310',
      'defaultMessage': 'C10 cycle for B cylinder'
    },
    softener_history_event_2311: {
      'id': 'softener_history_event_2311',
      'defaultMessage': 'C11 cycle for B cylinder'
    },
    softener_history_event_2312: {
      'id': 'softener_history_event_2312',
      'defaultMessage': 'C12 cycle for B cylinder'
    },
    softener_history_event_2313: {
      'id': 'softener_history_event_2313',
      'defaultMessage': 'C13 cycle for B cylinder'
    },
    softener_history_event_2314: {
      'id': 'softener_history_event_2314',
      'defaultMessage': 'C14 cycle for B cylinder'
    },
    softener_history_event_2315: {
      'id': 'softener_history_event_2315',
      'defaultMessage': 'C15 cycle for B cylinder'
    },
    softener_history_event_3101: {
      'id': 'softener_history_event_3101',
      'defaultMessage': 'CU1 cycle for A cylinder'
    },
    softener_history_event_3102: {
      'id': 'softener_history_event_3102',
      'defaultMessage': 'CU2 cycle for A cylinder'
    },
    softener_history_event_3103: {
      'id': 'softener_history_event_3103',
      'defaultMessage': 'CU3 cycle for A cylinder'
    },
    softener_history_event_3104: {
      'id': 'softener_history_event_3104',
      'defaultMessage': 'CU4 cycle for A cylinder'
    },
    softener_history_event_3105: {
      'id': 'softener_history_event_3105',
      'defaultMessage': 'CU5 cycle for A cylinder'
    },
    softener_history_event_3106: {
      'id': 'softener_history_event_3106',
      'defaultMessage': 'CU6 cycle for A cylinder'
    },
    softener_history_event_3107: {
      'id': 'softener_history_event_3107',
      'defaultMessage': 'CU7 cycle for A cylinder'
    },
    softener_history_event_3108: {
      'id': 'softener_history_event_3108',
      'defaultMessage': 'CU8 cycle for A cylinder'
    },
    softener_history_event_3109: {
      'id': 'softener_history_event_3109',
      'defaultMessage': 'CU9 cycle for A cylinder'
    },
    softener_history_event_3110: {
      'id': 'softener_history_event_3110',
      'defaultMessage': 'CU10 cycle for A cylinder'
    },
    softener_history_event_3111: {
      'id': 'softener_history_event_3111',
      'defaultMessage': 'CU11 cycle for A cylinder'
    },
    softener_history_event_3112: {
      'id': 'softener_history_event_3112',
      'defaultMessage': 'CU12 cycle for A cylinder'
    },
    softener_history_event_3113: {
      'id': 'softener_history_event_3113',
      'defaultMessage': 'CU13 cycle for A cylinder'
    },
    softener_history_event_3114: {
      'id': 'softener_history_event_3114',
      'defaultMessage': 'CU14 cycle for A cylinder'
    },
    softener_history_event_3115: {
      'id': 'softener_history_event_3115',
      'defaultMessage': 'CU15 cycle for A cylinder'
    },
    softener_history_event_3201: {
      'id': 'softener_history_event_3201',
      'defaultMessage': 'CU1 cycle for C cylinder'
    },
    softener_history_event_3202: {
      'id': 'softener_history_event_3202',
      'defaultMessage': 'CU2 cycle for C cylinder'
    },
    softener_history_event_3203: {
      'id': 'softener_history_event_3203',
      'defaultMessage': 'CU3 cycle for C cylinder'
    },
    softener_history_event_3204: {
      'id': 'softener_history_event_3204',
      'defaultMessage': 'CU4 cycle for C cylinder'
    },
    softener_history_event_3205: {
      'id': 'softener_history_event_3205',
      'defaultMessage': 'CU5 cycle for C cylinder'
    },
    softener_history_event_3206: {
      'id': 'softener_history_event_3206',
      'defaultMessage': 'CU6 cycle for C cylinder'
    },
    softener_history_event_3207: {
      'id': 'softener_history_event_3207',
      'defaultMessage': 'CU7 cycle for C cylinder'
    },
    softener_history_event_3208: {
      'id': 'softener_history_event_3208',
      'defaultMessage': 'CU8 cycle for C cylinder'
    },
    softener_history_event_3209: {
      'id': 'softener_history_event_3209',
      'defaultMessage': 'CU9 cycle for C cylinder'
    },
    softener_history_event_3210: {
      'id': 'softener_history_event_3210',
      'defaultMessage': 'CU10 cycle for C cylinder'
    },
    softener_history_event_3211: {
      'id': 'softener_history_event_3211',
      'defaultMessage': 'CU11 cycle for C cylinder'
    },
    softener_history_event_3212: {
      'id': 'softener_history_event_3212',
      'defaultMessage': 'CU12 cycle for C cylinder'
    },
    softener_history_event_3213: {
      'id': 'softener_history_event_3213',
      'defaultMessage': 'CU13 cycle for C cylinder'
    },
    softener_history_event_3214: {
      'id': 'softener_history_event_3214',
      'defaultMessage': 'CU14 cycle for C cylinder'
    },
    softener_history_event_3215: {
      'id': 'softener_history_event_3215',
      'defaultMessage': 'CU15 cycle for C cylinder'
    },
    softener_history_event_3301: {
      'id': 'softener_history_event_3301',
      'defaultMessage': 'CU1 cycle for B cylinder'
    },
    softener_history_event_3302: {
      'id': 'softener_history_event_3302',
      'defaultMessage': 'CU2 cycle for B cylinder'
    },
    softener_history_event_3303: {
      'id': 'softener_history_event_3303',
      'defaultMessage': 'CU3 cycle for B cylinder'
    },
    softener_history_event_3304: {
      'id': 'softener_history_event_3304',
      'defaultMessage': 'CU4 cycle for B cylinder'
    },
    softener_history_event_3305: {
      'id': 'softener_history_event_3305',
      'defaultMessage': 'CU5 cycle for B cylinder'
    },
    softener_history_event_3306: {
      'id': 'softener_history_event_3306',
      'defaultMessage': 'CU6 cycle for B cylinder'
    },
    softener_history_event_3307: {
      'id': 'softener_history_event_3307',
      'defaultMessage': 'CU7 cycle for B cylinder'
    },
    softener_history_event_3308: {
      'id': 'softener_history_event_3308',
      'defaultMessage': 'CU8 cycle for B cylinder'
    },
    softener_history_event_3309: {
      'id': 'softener_history_event_3309',
      'defaultMessage': 'CU9 cycle for B cylinder'
    },
    softener_history_event_3310: {
      'id': 'softener_history_event_3310',
      'defaultMessage': 'CU10 cycle for B cylinder'
    },
    softener_history_event_3311: {
      'id': 'softener_history_event_3311',
      'defaultMessage': 'CU11 cycle for B cylinder'
    },
    softener_history_event_3312: {
      'id': 'softener_history_event_3312',
      'defaultMessage': 'CU12 cycle for B cylinder'
    },
    softener_history_event_3313: {
      'id': 'softener_history_event_3313',
      'defaultMessage': 'CU13 cycle for B cylinder'
    },
    softener_history_event_3314: {
      'id': 'softener_history_event_3314',
      'defaultMessage': 'CU14 cycle for B cylinder'
    },
    softener_history_event_3315: {
      'id': 'softener_history_event_3315',
      'defaultMessage': 'CU15 cycle for B cylinder'
    },
    softener_history_event_4101: {
      'id': 'softener_history_event_4101',
      'defaultMessage': 'CM1 cycle for A cylinder'
    },
    softener_history_event_4102: {
      'id': 'softener_history_event_4102',
      'defaultMessage': 'CM2 cycle for A cylinder'
    },
    softener_history_event_4103: {
      'id': 'softener_history_event_4103',
      'defaultMessage': 'CM3 cycle for A cylinder'
    },
    softener_history_event_4104: {
      'id': 'softener_history_event_4104',
      'defaultMessage': 'CM4 cycle for A cylinder'
    },
    softener_history_event_4105: {
      'id': 'softener_history_event_4105',
      'defaultMessage': 'CM5 cycle for A cylinder'
    },
    softener_history_event_4106: {
      'id': 'softener_history_event_4106',
      'defaultMessage': 'CM6 cycle for A cylinder'
    },
    softener_history_event_4107: {
      'id': 'softener_history_event_4107',
      'defaultMessage': 'CM7 cycle for A cylinder'
    },
    softener_history_event_4108: {
      'id': 'softener_history_event_4108',
      'defaultMessage': 'CM8 cycle for A cylinder'
    },
    softener_history_event_4109: {
      'id': 'softener_history_event_4109',
      'defaultMessage': 'CM9 cycle for A cylinder'
    },
    softener_history_event_4110: {
      'id': 'softener_history_event_4110',
      'defaultMessage': 'CM10 cycle for A cylinder'
    },
    softener_history_event_4111: {
      'id': 'softener_history_event_4111',
      'defaultMessage': 'CM11 cycle for A cylinder'
    },
    softener_history_event_4112: {
      'id': 'softener_history_event_4112',
      'defaultMessage': 'CM12 cycle for A cylinder'
    },
    softener_history_event_4113: {
      'id': 'softener_history_event_4113',
      'defaultMessage': 'CM13 cycle for A cylinder'
    },
    softener_history_event_4114: {
      'id': 'softener_history_event_4114',
      'defaultMessage': 'CM14 cycle for A cylinder'
    },
    softener_history_event_4115: {
      'id': 'softener_history_event_4115',
      'defaultMessage': 'CM15 cycle for A cylinder'
    },
    softener_history_event_4201: {
      'id': 'softener_history_event_4201',
      'defaultMessage': 'CM1 cycle for C cylinder'
    },
    softener_history_event_4202: {
      'id': 'softener_history_event_4202',
      'defaultMessage': 'CM2 cycle for C cylinder'
    },
    softener_history_event_4203: {
      'id': 'softener_history_event_4203',
      'defaultMessage': 'CM3 cycle for C cylinder'
    },
    softener_history_event_4204: {
      'id': 'softener_history_event_4204',
      'defaultMessage': 'CM4 cycle for C cylinder'
    },
    softener_history_event_4205: {
      'id': 'softener_history_event_4205',
      'defaultMessage': 'CM5 cycle for C cylinder'
    },
    softener_history_event_4206: {
      'id': 'softener_history_event_4206',
      'defaultMessage': 'CM6 cycle for C cylinder'
    },
    softener_history_event_4207: {
      'id': 'softener_history_event_4207',
      'defaultMessage': 'CM7 cycle for C cylinder'
    },
    softener_history_event_4208: {
      'id': 'softener_history_event_4208',
      'defaultMessage': 'CM8 cycle for C cylinder'
    },
    softener_history_event_4209: {
      'id': 'softener_history_event_4209',
      'defaultMessage': 'CM9 cycle for C cylinder'
    },
    softener_history_event_4210: {
      'id': 'softener_history_event_4210',
      'defaultMessage': 'CM10 cycle for C cylinder'
    },
    softener_history_event_4211: {
      'id': 'softener_history_event_4211',
      'defaultMessage': 'CM11 cycle for C cylinder'
    },
    softener_history_event_4212: {
      'id': 'softener_history_event_4212',
      'defaultMessage': 'CM12 cycle for C cylinder'
    },
    softener_history_event_4213: {
      'id': 'softener_history_event_4213',
      'defaultMessage': 'CM13 cycle for C cylinder'
    },
    softener_history_event_4214: {
      'id': 'softener_history_event_4214',
      'defaultMessage': 'CM14 cycle for C cylinder'
    },
    softener_history_event_4215: {
      'id': 'softener_history_event_4215',
      'defaultMessage': 'CM15 cycle for C cylinder'
    },
    softener_history_event_4301: {
      'id': 'softener_history_event_4301',
      'defaultMessage': 'CM1 cycle for B cylinder'
    },
    softener_history_event_4302: {
      'id': 'softener_history_event_4302',
      'defaultMessage': 'CM2 cycle for B cylinder'
    },
    softener_history_event_4303: {
      'id': 'softener_history_event_4303',
      'defaultMessage': 'CM3 cycle for B cylinder'
    },
    softener_history_event_4304: {
      'id': 'softener_history_event_4304',
      'defaultMessage': 'CM4 cycle for B cylinder'
    },
    softener_history_event_4305: {
      'id': 'softener_history_event_4305',
      'defaultMessage': 'CM5 cycle for B cylinder'
    },
    softener_history_event_4306: {
      'id': 'softener_history_event_4306',
      'defaultMessage': 'CM6 cycle for B cylinder'
    },
    softener_history_event_4307: {
      'id': 'softener_history_event_4307',
      'defaultMessage': 'CM7 cycle for B cylinder'
    },
    softener_history_event_4308: {
      'id': 'softener_history_event_4308',
      'defaultMessage': 'CM8 cycle for B cylinder'
    },
    softener_history_event_4309: {
      'id': 'softener_history_event_4309',
      'defaultMessage': 'CM9 cycle for B cylinder'
    },
    softener_history_event_4310: {
      'id': 'softener_history_event_4310',
      'defaultMessage': 'CM10 cycle for B cylinder'
    },
    softener_history_event_4311: {
      'id': 'softener_history_event_4311',
      'defaultMessage': 'CM11 cycle for B cylinder'
    },
    softener_history_event_4312: {
      'id': 'softener_history_event_4312',
      'defaultMessage': 'CM12 cycle for B cylinder'
    },
    softener_history_event_4313: {
      'id': 'softener_history_event_4313',
      'defaultMessage': 'CM13 cycle for B cylinder'
    },
    softener_history_event_4314: {
      'id': 'softener_history_event_4314',
      'defaultMessage': 'CM14 cycle for B cylinder'
    },
    softener_history_event_4315: {
      'id': 'softener_history_event_4315',
      'defaultMessage': 'CM15 cycle for B cylinder'
    },
    filter_from_checboxes_history: {
      'id': 'filter_from_checboxes_history',
      'defaultMessage': 'Filter history by checked options above'
    },
    multiple_select_history: {
      'id': 'multiple_select_history',
      'defaultMessage': 'Hold down the Ctrl (windows) / Command (Mac) button to select multiple events'
    },
    reset_selection_history: {
      'id': 'reset_selection_history',
      'defaultMessage': 'Show all'
    },
    filter_select_button_history: {
      'id': 'filter_select_button_history',
      'defaultMessage': 'Filter'
    },
    clear_filter_button_history: {
      'id': 'clear_filter_button_history',
      'defaultMessage': 'Clear fiilter'
    },
    save_all_as_pdf_button_history: {
      'id': 'save_all_as_pdf_button_history',
      'defaultMessage': 'Save all record in PDF'
    },
    save_as_pdf_button_history: {
      'id': 'save_as_pdf_button_history',
      'defaultMessage': 'Save shown records in PDF'
    },
    history_events_event_filtering_header_text: {
      'id': 'history_events_event_filtering_header_text',
      'defaultMessage': 'Events filtering'
    },
    history_events_power_header_text: {
      'id': 'history_events_power_header_text',
      'defaultMessage': 'Power'
    },
    history_events_cyclic_saves_header_text: {
      'id': 'history_events_cyclic_saves_header_text',
      'defaultMessage': 'Cyclic saves'
    },
    history_events_alarms_header_text: {
      'id': 'history_events_alarms_header_text',
      'defaultMessage': 'Alarms'
    },
    no_key: {
      'id': 'no_key',
      'defaultMessage': 'Pressure'
    },
    no_key1: {
      'id': 'no_key1',
      'defaultMessage': 'Salt'
    },
    no_key2: {
      'id': 'no_key2',
      'defaultMessage': 'Network'
    },
    no_key3: {
      'id': 'no_key3',
      'defaultMessage': 'Parameters modifications'
    },
    no_key4: {
      'id': 'no_key4',
      'defaultMessage': 'Regenerations'
    },
    no_key5: {
      'id': 'no_key5',
      'defaultMessage': 'Filter'
    },
    no_key6: {
      'id': 'no_key6',
      'defaultMessage': 'Delete filter'
    },
    no_key7: {
      'id': 'no_key7',
      'defaultMessage': 'Number of events in the file'
    },
    no_key8: {
      'id': 'no_key8',
      'defaultMessage': 'Open'
    },
    history_events_header_time: {
      'id': 'history_events_header_time',
      'defaultMessage': 'Time'
    },
    history_events_header_event: {
      'id': 'history_events_header_event',
      'defaultMessage': 'Event'
    },
    history_events_header_flows: {
      'id': 'history_events_header_flows',
      'defaultMessage': 'Flows'
    },
    history_events_header_pressure: {
      'id': 'history_events_header_pressure',
      'defaultMessage': 'Pressures'
    },
    history_events_header_regenerations: {
      'id': 'history_events_header_regenerations',
      'defaultMessage': 'Regenerations'
    },
    history_events_header_cylinder_reserve: {
      'id': 'history_events_header_cylinder_reserve',
      'defaultMessage': 'Cylinder reserves'
    },
    history_events_header_network: {
      'id': 'history_events_header_network',
      'defaultMessage': 'Network'
    },
    history_events_date: {
      'id': 'history_events_date',
      'defaultMessage': 'Date'
    },
    history_events_time: {
      'id': 'history_events_time',
      'defaultMessage': 'Time'
    },
    history_events_event: {
      'id': 'history_events_event',
      'defaultMessage': 'Event'
    },
    history_events_daily_water_usage: {
      'id': 'history_events_daily_water_usage',
      'defaultMessage': 'Daily water usage [l]'
    },
    history_events_weekly_water_usage: {
      'id': 'history_events_weekly_water_usage',
      'defaultMessage': 'Weekly water usage [l]'
    },
    history_events_monthly_water_usage: {
      'id': 'history_events_monthly_water_usage',
      'defaultMessage': 'Monthly water usage [l]'
    },
    history_events_total_water_usage: {
      'id': 'history_events_total_water_usage',
      'defaultMessage': 'Total water usage [l]'
    },
    history_events_untreated_water_flow: {
      'id': 'history_events_untreated_water_flow',
      'defaultMessage': 'Untreated water flow [l]'
    },
    history_events_water_flow: {
      'id': 'history_events_water_flow',
      'defaultMessage': 'Water flow in case of the excessive water flow [l]'
    },
    history_events_water_pressure: {
      'id': 'history_events_water_pressure',
      'defaultMessage': 'Water pressure [bar]'
    },
    history_events_max_water_pressure: {
      'id': 'history_events_max_water_pressure',
      'defaultMessage': 'Maximum water pressure [bar]'
    },
    history_events_min_water_pressure: {
      'id': 'history_events_min_water_pressure',
      'defaultMessage': 'Minimum water pressure [bar]'
    },
    history_events_max_water_flow: {
      'id': 'history_events_max_water_flow',
      'defaultMessage': 'Maximum water flow [l/min]'
    },
    history_events_normal_regeneration_number: {
      'id': 'history_events_normal_regeneration_number',
      'defaultMessage': 'Normal regenerations number'
    },
    history_events_service_regeneration_number: {
      'id': 'history_events_service_regeneration_number',
      'defaultMessage': 'Service regenerations number'
    },
    history_events_incomplete_regeneration_number: {
      'id': 'history_events_incomplete_regeneration_number',
      'defaultMessage': 'Incomplete regenerations number'
    },
    history_events_holiday_regeneration_number: {
      'id': 'history_events_holiday_regeneration_number',
      'defaultMessage': 'Holiday regenerations number'
    },
    history_events_multi_regeneration_number: {
      'id': 'history_events_multi_regeneration_number',
      'defaultMessage': 'Multi-regenerations number'
    },
    history_events_b1_cylinder_reserve: {
      'id': 'history_events_b1_cylinder_reserve',
      'defaultMessage': 'B1 cylinder reserve'
    },
    history_events_b2_cylinder_reserve: {
      'id': 'history_events_b2_cylinder_reserve',
      'defaultMessage': 'B2 cylinder reserve'
    },
    history_events_b3_cylinder_reserve: {
      'id': 'history_events_b3_cylinder_reserve',
      'defaultMessage': 'B3 cylinder reserve'
    },
    history_events_a_cylinder_reserve: {
      'id': 'history_events_a_cylinder_reserve',
      'defaultMessage': 'A cylinder reserve [l]'
    },
    history_events_b_cylinder_reserve: {
      'id': 'history_events_b_cylinder_reserve',
      'defaultMessage': 'B cylinder reserve [l]'
    },
    history_events_c_cylinder_reserve: {
      'id': 'history_events_c_cylinder_reserve',
      'defaultMessage': 'C cylinder reserve [l]'
    },
    history_events_chlor_current: {
      'id': 'history_events_chlor_current',
      'defaultMessage': 'Chlor current [mA]'
    },
    history_events_ip_address: {
      'id': 'history_events_ip_address',
      'defaultMessage': 'IP address'
    },
    history_events_subnet_mask: {
      'id': 'history_events_subnet_mask',
      'defaultMessage': 'Subnet mask'
    },
    history_events_default_gateway: {
      'id': 'history_events_default_gateway',
      'defaultMessage': 'Default Gateway'
    },
    history_events_device_operator: {
      'id': 'history_events_device_operator',
      'defaultMessage': 'Device operator'
    },
    history_events_record_no: {
      'id': 'history_events_record_no',
      'defaultMessage': 'Record no.'
    },
    record_part1_text: {
      'id': 'record_part1_text',
      'defaultMessage': 'You see'
    },
    record_part2_text: {
      'id': 'record_part2_text',
      'defaultMessage': 'records'
    },
    history_parameters_superior_date: {
      'id': 'history_parameters_superior_date',
      'defaultMessage': 'Date'
    },
    history_parameters_superior_time: {
      'id': 'history_parameters_superior_time',
      'defaultMessage': 'Time'
    },
    history_parameters_superior_language: {
      'id': 'history_parameters_superior_language',
      'defaultMessage': 'Language'
    },
    history_parameters_superior_device_type: {
      'id': 'history_parameters_superior_device_type',
      'defaultMessage': 'Device type'
    },
    history_parameters_superior_auto_degass_start_1_enable: {
      'id': 'history_parameters_superior_auto_degass_start_1_enable',
      'defaultMessage': 'Auto Degass Start 1 - enable'
    },
    history_parameters_superior_auto_degass_start_1_hour: {
      'id': 'history_parameters_superior_auto_degass_start_1_hour',
      'defaultMessage': 'Auto Degass Start 1 - hour'
    },
    history_parameters_superior_auto_degass_start_1_minute: {
      'id': 'history_parameters_superior_auto_degass_start_1_minute',
      'defaultMessage': 'Auto Degass Start 1 - minute'
    },
    history_parameters_superior_auto_degass_stop_1_enable: {
      'id': 'history_parameters_superior_auto_degass_stop_1_enable',
      'defaultMessage': 'Auto Degass Stop 1 - enable'
    },
    history_parameters_superior_auto_degass_stop_1_hour: {
      'id': 'history_parameters_superior_auto_degass_stop_1_hour',
      'defaultMessage': 'Auto Degass Stop 1 - hour'
    },
    history_parameters_superior_auto_degass_stop_1_minute: {
      'id': 'history_parameters_superior_auto_degass_stop_1_minute',
      'defaultMessage': 'Auto Degass Stop 1 - minute'
    },
    history_parameters_superior_auto_degass_start_2_enable: {
      'id': 'history_parameters_superior_auto_degass_start_2_enable',
      'defaultMessage': 'Auto Degass Start 2 - enable'
    },
    history_parameters_superior_auto_degass_start_2_hour: {
      'id': 'history_parameters_superior_auto_degass_start_2_hour',
      'defaultMessage': 'Auto Degass Start 2 - hour'
    },
    history_parameters_superior_auto_degass_start_2_minute: {
      'id': 'history_parameters_superior_auto_degass_start_2_minute',
      'defaultMessage': 'Auto Degass Start 2 - minute'
    },
    history_parameters_superior_auto_degass_stop_2_enable: {
      'id': 'history_parameters_superior_auto_degass_stop_2_enable',
      'defaultMessage': 'Auto Degass Stop 2 - enable'
    },
    history_parameters_superior_auto_degass_stop_2_hour: {
      'id': 'history_parameters_superior_auto_degass_stop_2_hour',
      'defaultMessage': 'Auto Degass Stop 2 - hour'
    },
    history_parameters_superior_auto_degass_stop_2_minute: {
      'id': 'history_parameters_superior_auto_degass_stop_2_minute',
      'defaultMessage': 'Auto Degass Stop 2 - minute'
    },
    history_parameters_superior_degass_block: {
      'id': 'history_parameters_superior_degass_block',
      'defaultMessage': 'Degassing blocking weekday'
    },
    history_events_superior_header_time: {
      'id': 'history_events_superior_header_time',
      'defaultMessage': 'Time'
    },
    history_events_superior_header_event: {
      'id': 'history_events_superior_header_event',
      'defaultMessage': 'Events'
    },
    history_events_superior_header_flow: {
      'id': 'history_events_superior_header_flow',
      'defaultMessage': 'Flows'
    },
    history_events_superior_header_other: {
      'id': 'history_events_superior_header_other',
      'defaultMessage': 'Other'
    },
    history_events_superior_date: {
      'id': 'history_events_superior_date',
      'defaultMessage': 'Date'
    },
    history_events_superior_time: {
      'id': 'history_events_superior_time',
      'defaultMessage': 'Time'
    },
    history_events_superior_event: {
      'id': 'history_events_superior_event',
      'defaultMessage': 'Event'
    },
    history_events_superior_current_refill_flow: {
      'id': 'history_events_superior_current_refill_flow',
      'defaultMessage': 'Current refill flow [l]'
    },
    history_events_superior_refill_flow_rate: {
      'id': 'history_events_superior_refill_flow_rate',
      'defaultMessage': 'Refill flow rate [l/min]'
    },
    history_events_superior_total_refill_volume: {
      'id': 'history_events_superior_total_refill_volume',
      'defaultMessage': 'Total refill volume [l]'
    },
    history_events_superior_system_pressure: {
      'id': 'history_events_superior_system_pressure',
      'defaultMessage': 'System pressure [bar]'
    },
    history_events_superior_total_refill_time: {
      'id': 'history_events_superior_total_refill_time',
      'defaultMessage': 'Total refill time [min]'
    },
    history_events_superior_total_degass_time: {
      'id': 'history_events_superior_total_degass_time',
      'defaultMessage': 'Total degass time [min]'
    },
    history_events_superior_device_operator: {
      'id': 'history_events_superior_device_operator',
      'defaultMessage': 'Device operator'
    },
    history_events_superior_record_no: {
      'id': 'history_events_superior_record_no',
      'defaultMessage': 'Record no.'
    },
    history_pressures_superior_t_psys: {
      'id': 'history_pressures_superior_t_psys',
      'defaultMessage': 't[Psys]'
    },
    history_pressures_superior_psys: {
      'id': 'history_pressures_superior_psys',
      'defaultMessage': 'Psys'
    },
    history_pressures_superior_t_pmin: {
      'id': 'history_pressures_superior_t_pmin',
      'defaultMessage': 't[Pmin]'
    },
    history_pressures_superior_pmin: {
      'id': 'history_pressures_superior_pmin',
      'defaultMessage': 'Pmin'
    },
    history_pressures_superior_t_pzero: {
      'id': 'history_pressures_superior_t_pzero',
      'defaultMessage': 't[Pflushperiodstart]'
    },
    history_pressures_superior_pzero: {
      'id': 'history_pressures_superior_pzero',
      'defaultMessage': 'Pflushperiodstart'
    },
    history_pressures_superior_t_pflush: {
      'id': 'history_pressures_superior_t_pflush',
      'defaultMessage': 't[Pflush]'
    },
    history_pressures_superior_pflush: {
      'id': 'history_pressures_superior_pflush',
      'defaultMessage': 'Pflush'
    },
    superior_history_event_0001: {
      'id': 'superior_history_event_0001',
      'defaultMessage': 'Power ON'
    },
    superior_history_event_0002: {
      'id': 'superior_history_event_0002',
      'defaultMessage': 'Power OFF'
    },
    superior_history_event_0003: {
      'id': 'superior_history_event_0003',
      'defaultMessage': 'Silent reset'
    },
    superior_history_event_0004: {
      'id': 'superior_history_event_0004',
      'defaultMessage': 'Device enabled'
    },
    superior_history_event_0005: {
      'id': 'superior_history_event_0005',
      'defaultMessage': 'Device disabled'
    },
    superior_history_event_0006: {
      'id': 'superior_history_event_0006',
      'defaultMessage': 'Reboot'
    },
    superior_history_event_0010: {
      'id': 'superior_history_event_0010',
      'defaultMessage': 'Degassing started'
    },
    superior_history_event_0011: {
      'id': 'superior_history_event_0011',
      'defaultMessage': 'Degassing stopped'
    },
    superior_history_event_0012: {
      'id': 'superior_history_event_0012',
      'defaultMessage': 'Refilling started'
    },
    superior_history_event_0121: {
      'id': 'superior_history_event_0121',
      'defaultMessage': 'Ext. refilling'
    },
    superior_history_event_0122: {
      'id': 'superior_history_event_0122',
      'defaultMessage': 'BMS refilling'
    },
    superior_history_event_0013: {
      'id': 'superior_history_event_0013',
      'defaultMessage': 'Refilling stopped'
    },
    superior_history_event_0014: {
      'id': 'superior_history_event_0014',
      'defaultMessage': 'Initial filling'
    },
    superior_history_event_0015: {
      'id': 'superior_history_event_0015',
      'defaultMessage': 'System filling'
    },
    superior_history_event_0016: {
      'id': 'superior_history_event_0016',
      'defaultMessage': 'Pump test started'
    },
    superior_history_event_0018: {
      'id': 'superior_history_event_0018',
      'defaultMessage': 'Low pressure'
    },
    superior_history_event_0019: {
      'id': 'superior_history_event_0019',
      'defaultMessage': 'High pressure'
    },
    superior_history_event_0021: {
      'id': 'superior_history_event_0021',
      'defaultMessage': 'User menu modificated'
    },
    superior_history_event_0022: {
      'id': 'superior_history_event_0022',
      'defaultMessage': 'Advanced menu modificated'
    },
    superior_history_event_0023: {
      'id': 'superior_history_event_0023',
      'defaultMessage': 'Device type changed'
    },
    superior_history_event_0034: {
      'id': 'superior_history_event_0034',
      'defaultMessage': 'Clock changed - before'
    },
    superior_history_event_0035: {
      'id': 'superior_history_event_0035',
      'defaultMessage': 'Clock changed - after'
    },
    superior_history_event_0036: {
      'id': 'superior_history_event_0036',
      'defaultMessage': 'Timezone changed'
    },
    superior_history_event_0037: {
      'id': 'superior_history_event_0037',
      'defaultMessage': 'Manual work enabled'
    },
    superior_history_event_0040: {
      'id': 'superior_history_event_0040',
      'defaultMessage': 'Network connected'
    },
    superior_history_event_0041: {
      'id': 'superior_history_event_0041',
      'defaultMessage': 'Network disconnected'
    },
    superior_history_event_0042: {
      'id': 'superior_history_event_0042',
      'defaultMessage': 'DHCP address assigned'
    },
    superior_history_event_0043: {
      'id': 'superior_history_event_0043',
      'defaultMessage': 'Manual network assigned'
    },
    superior_history_event_0044: {
      'id': 'superior_history_event_0044',
      'defaultMessage': 'Connected to internet service'
    },
    superior_history_event_0045: {
      'id': 'superior_history_event_0045',
      'defaultMessage': 'Firmware upgrade request'
    },
    superior_history_event_0046: {
      'id': 'superior_history_event_0046',
      'defaultMessage': 'Factory reset'
    },
    superior_history_event_0050: {
      'id': 'superior_history_event_0050',
      'defaultMessage': 'Error clear'
    },
    superior_history_event_0051: {
      'id': 'superior_history_event_0051',
      'defaultMessage': 'Commissioning test started'
    },
    superior_history_event_0052: {
      'id': 'superior_history_event_0052',
      'defaultMessage': 'Commissioning test passed'
    },
    superior_history_event_0053: {
      'id': 'superior_history_event_0053',
      'defaultMessage': 'Commissioning test failed'
    },
    superior_history_event_0400: {
      'id': 'superior_history_event_0400',
      'defaultMessage': 'No error'
    },
    superior_history_event_0401: {
      'id': 'superior_history_event_0401',
      'defaultMessage': 'System pressure too low'
    },
    superior_history_event_0402: {
      'id': 'superior_history_event_0402',
      'defaultMessage': 'System pressure too high'
    },
    superior_history_event_0403: {
      'id': 'superior_history_event_0403',
      'defaultMessage': 'Too low water temperature'
    },
    superior_history_event_0404: {
      'id': 'superior_history_event_0404',
      'defaultMessage': 'Too high water temperature'
    },
    superior_history_event_0405: {
      'id': 'superior_history_event_0405',
      'defaultMessage': 'Input flow blocked'
    },
    superior_history_event_0406: {
      'id': 'superior_history_event_0406',
      'defaultMessage': 'Low level vessel repeatedly'
    },
    superior_history_event_0407: {
      'id': 'superior_history_event_0407',
      'defaultMessage': 'Low level vessel'
    },
    superior_history_event_0408: {
      'id': 'superior_history_event_0408',
      'defaultMessage': 'Main pump overheated'
    },
    superior_history_event_0409: {
      'id': 'superior_history_event_0409',
      'defaultMessage': 'Main pump overload'
    },
    superior_history_event_0410: {
      'id': 'superior_history_event_0410',
      'defaultMessage': 'Refill flow too low'
    },
    superior_history_event_0411: {
      'id': 'superior_history_event_0411',
      'defaultMessage': 'Refill valve open'
    },
    superior_history_event_0412: {
      'id': 'superior_history_event_0412',
      'defaultMessage': 'Unknown errror'
    },
    superior_history_event_0413: {
      'id': 'superior_history_event_0413',
      'defaultMessage': 'Refill: too often'
    },
    superior_history_event_0414: {
      'id': 'superior_history_event_0414',
      'defaultMessage': 'Refill: too long'
    },
    superior_history_event_0415: {
      'id': 'superior_history_event_0415',
      'defaultMessage': 'Refill: too much'
    },
    superior_history_event_0416: {
      'id': 'superior_history_event_0416',
      'defaultMessage': 'Unknown errror'
    },
    superior_history_event_0417: {
      'id': 'superior_history_event_0417',
      'defaultMessage': 'Wrong phase order'
    },
    superior_history_event_0418: {
      'id': 'superior_history_event_0418',
      'defaultMessage': 'Too big output pressure'
    },
    superior_history_event_0419: {
      'id': 'superior_history_event_0419',
      'defaultMessage': 'Pressure sensor fault'
    },
    superior_history_event_0420: {
      'id': 'superior_history_event_0420',
      'defaultMessage': 'Fuse 2 broken'
    },
    superior_history_event_0421: {
      'id': 'superior_history_event_0421',
      'defaultMessage': 'Fuse 3 broken'
    },
    superior_history_event_0422: {
      'id': 'superior_history_event_0422',
      'defaultMessage': 'Communication fault'
    },
    superior_history_event_0423: {
      'id': 'superior_history_event_0423',
      'defaultMessage': 'Too low expansion vessel'
    },
    superior_history_event_0424: {
      'id': 'superior_history_event_0424',
      'defaultMessage': 'Low level break tank'
    },
    superior_history_event_0425: {
      'id': 'superior_history_event_0425',
      'defaultMessage': 'Pump error'
    },
    superior_history_event_0426: {
      'id': 'superior_history_event_0426',
      'defaultMessage': 'Unknown error'
    },
    superior_history_event_0427: {
      'id': 'superior_history_event_0427',
      'defaultMessage': 'Unknown error'
    },
    superior_history_event_0428: {
      'id': 'superior_history_event_0428',
      'defaultMessage': 'Unknown error'
    },
    superior_history_event_0429: {
      'id': 'superior_history_event_0429',
      'defaultMessage': 'Unknown error'
    },
    superior_history_event_0430: {
      'id': 'superior_history_event_0430',
      'defaultMessage': 'Inlet blocked'
    },
    superior_history_event_0431: {
      'id': 'superior_history_event_0431',
      'defaultMessage': 'Fill time too long'
    },
    superior_history_event_0432: {
      'id': 'superior_history_event_0432',
      'defaultMessage': 'Pressure drop inlet too high'
    },
    superior_history_event_0433: {
      'id': 'superior_history_event_0433',
      'defaultMessage': 'Pressure drop inlet too low'
    },
    superior_history_event_0434: {
      'id': 'superior_history_event_0434',
      'defaultMessage': 'SmartSwitch broken'
    },
    superior_history_event_0435: {
      'id': 'superior_history_event_0435',
      'defaultMessage': 'Solenoid valve does not close'
    },
    superior_history_event_0436: {
      'id': 'superior_history_event_0436',
      'defaultMessage': 'Undesirable air intake'
    },
    superior_history_event_0437: {
      'id': 'superior_history_event_0437',
      'defaultMessage': 'Incompressible system'
    },
    superior_history_event_0438: {
      'id': 'superior_history_event_0438',
      'defaultMessage': 'Incompressible system'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEventRow.js
var HistoryEventRow__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryEventRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function HistoryEventRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryEventRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryEventRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var HistoryEventRow_HistoryEventRow = function (_React$Component) {
  HistoryEventRow__inherits(HistoryEventRow, _React$Component);

  function HistoryEventRow() {
    var _ref;

    var _temp, _this, _ret;

    HistoryEventRow__classCallCheck(this, HistoryEventRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryEventRow__possibleConstructorReturn(this, (_ref = HistoryEventRow.__proto__ || Object.getPrototypeOf(HistoryEventRow)).call.apply(_ref, [this].concat(args))), _this), _this.getBoxWrapStyle = function (deviceType, center) {
      var isSuperior = deviceType === 'superior';

      var wrapStyle = classnames_default()();
      if (center) {
        wrapStyle = isSuperior ? classnames_default()(HistoryEvents_default.a.spirotech_data_color, HistoryEvents_default.a.center) : classnames_default()(HistoryEvents_default.a.data_color, HistoryEvents_default.a.center);
      } else {
        wrapStyle = isSuperior ? classnames_default()(HistoryEvents_default.a.spirotech_data_color) : classnames_default()(HistoryEvents_default.a.data_color);
      }
      return wrapStyle;
    }, _this.showBox = function (element, index, messages, deviceDocument) {
      var deviceType = deviceDocument.get('deviceType');
      var screenType = deviceDocument.get('screenType');

      var visible = _this.getColumnVisibilityByIndex(index, _this.props.documentSoftenerFilter, _this.props.documentSuperiorFilter, deviceType, screenType);

      var wrappedStyle = _this.getBoxWrapStyle(deviceType);
      var wrappedStyleCenter = _this.getBoxWrapStyle(deviceType, true);
      if (visible) {
        var isArray = Object.prototype.toString.call(element) === '[object Object]';
        if (isArray) {
          var value = element.get(0);
          if (value !== '') {
            return HistoryEventRow__jsx('td', {
              className: wrappedStyle,
              onClick: _this.props.onClick
            }, index, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[value]));
          }
          return HistoryEventRow__jsx('td', {
            className: wrappedStyleCenter
          }, index, element);
        }
        return HistoryEventRow__jsx('td', {
          className: wrappedStyleCenter
        }, index, element);
      }
      return null;
    }, _this.getColumnVisibilitySoftenerItems = function (documentSoftenerFilter, screenType) {
      var values = [documentSoftenerFilter.get('date'), documentSoftenerFilter.get('time'), documentSoftenerFilter.get('event'), documentSoftenerFilter.get('daily_water_usage'), documentSoftenerFilter.get('weekly_water_usage'), documentSoftenerFilter.get('monthly_water_usage'), documentSoftenerFilter.get('total_water_usage'), documentSoftenerFilter.get('untreated_water_flow'), documentSoftenerFilter.get('water_flow'), documentSoftenerFilter.get('water_pressure'), documentSoftenerFilter.get('max_water_pressure'), documentSoftenerFilter.get('min_water_pressure'), documentSoftenerFilter.get('max_water_flow'), documentSoftenerFilter.get('normal_regeneration_number'), documentSoftenerFilter.get('service_regeneration_number'), documentSoftenerFilter.get('incomplete_regeneration_number')];

      var values2 = [documentSoftenerFilter.get('chlor_current'), documentSoftenerFilter.get('ip_address'), documentSoftenerFilter.get('subnet_mask'), documentSoftenerFilter.get('default_gateway'), documentSoftenerFilter.get('device_operator'), documentSoftenerFilter.get('record_no')];
      var retValues = [].concat(values, _toConsumableArray(_this.getReserve(documentSoftenerFilter, screenType)), values2);
      return retValues;
    }, _this.getReserve = function (documentSoftenerFilter, screenType) {
      switch (screenType) {
        case 'DOUBLEALTERNATIVE':
        case 'DOUBLEPARALLEL':
        case 'DOUBLEFILTER':
          return [documentSoftenerFilter.get('a_cylinder_reserve'), documentSoftenerFilter.get('c_cylinder_reserve'), documentSoftenerFilter.get('b_cylinder_reserve')];
        case 'TRIPLEALTERNATIVE':
        case 'TRIPLEPARALLEL':
        case 'TRIPLEFILTER':
          return [documentSoftenerFilter.get('b_cylinder_reserve'), documentSoftenerFilter.get('a_cylinder_reserve'), documentSoftenerFilter.get('c_cylinder_reserve')];
        default:
          return [documentSoftenerFilter.get('a_cylinder_reserve'), documentSoftenerFilter.get('b_cylinder_reserve'), documentSoftenerFilter.get('c_cylinder_reserve')];
      }
    }, _this.getColumnVisibilitySuperiorItems = function (documentSuperiorFilter) {
      var values = [documentSuperiorFilter.get('date'), documentSuperiorFilter.get('time'), documentSuperiorFilter.get('event'), documentSuperiorFilter.get('current_refill_flow'), documentSuperiorFilter.get('refill_flow_rate'), documentSuperiorFilter.get('total_refill_volume'), documentSuperiorFilter.get('system_pressure'), documentSuperiorFilter.get('total_refill_time'), documentSuperiorFilter.get('total_degass_time'), documentSuperiorFilter.get('device_operator'), documentSuperiorFilter.get('record_no')];
      return values;
    }, _this.getColumnVisibilityByIndex = function (index, documentSoftenerFilter, documentSuperiorFilter, deviceType, screenType) {
      var values = [];
      var ret = 0;
      switch (deviceType) {
        case 'charlie':
        case 'softener':
        case 'simplex':
          values = _this.getColumnVisibilitySoftenerItems(documentSoftenerFilter, screenType);
          ret = values[index];
          break;
        case 'superior':
          values = _this.getColumnVisibilitySuperiorItems(documentSuperiorFilter);
          ret = values[index];
          break;
        default:
          break;
      }
      return ret;
    }, _this.isRowVisible = function (eventValue) {
      if (+_this.props.filteredEvents.length !== 0) {
        if (_this.props.filteredEvents.indexOf(eventValue) < 0) {
          return false;
        }
        return true;
      }
      return true;
    }, _temp), HistoryEventRow__possibleConstructorReturn(_this, _ret);
  }

  HistoryEventRow__createClass(HistoryEventRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = HistoryEvents_Messages_Messages();
      var _props = this.props,
          row = _props.row,
          colorId = _props.colorId,
          deviceDocument = _props.deviceDocument;

      if (typeof row !== 'undefined') {
        var eventValue = row.get(2).get(1);
        var highlightedValue = colorId === eventValue;
        var wrapStyle = highlightedValue ? classnames_default()(HistoryEvents_default.a.row_container, HistoryEvents_default.a.red) : classnames_default()(HistoryEvents_default.a.row_container);
        var rowVisible = this.isRowVisible(eventValue);
        if (rowVisible) {
          return HistoryEventRow__jsx('tr', {
            className: wrapStyle
          }, void 0, row.map(function (element, ind) {
            return _this2.showBox(element, ind, messages, deviceDocument);
          }));
        }
        return null;
      }
      return null;
    }
  }]);

  return HistoryEventRow;
}(react_default.a.Component);

/* harmony default export */ var HistoryEvents_HistoryEventRow = (withStyles_default()(HistoryEvents_default.a)(HistoryEventRow_HistoryEventRow));
// EXTERNAL MODULE: ./src/components/HistoryEvents/HistoryEventsHeader.css
var HistoryEvents_HistoryEventsHeader = __webpack_require__(1092);
var HistoryEventsHeader_default = /*#__PURE__*/__webpack_require__.n(HistoryEvents_HistoryEventsHeader);

// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryHeaderRow.js
var HistoryHeaderRow__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










function HistoryHeaderRow(props) {
  var event = props.event,
      index = props.index;

  var messages = HistoryEvents_Messages_Messages();
  var value = event.get(1);
  var isSpaced = value.split(' ').length > 1;
  value = isSpaced ? value.split(' ')[1] : value;
  return HistoryHeaderRow__jsx('tr', {
    className: classnames_default()(HistoryEvents_default.a.row_container, HistoryEvents_default.a.header_color)
  }, index, HistoryHeaderRow__jsx('td', {}, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[value])));
}

/* harmony default export */ var HistoryEvents_HistoryHeaderRow = (withStyles_default()(HistoryEvents_default.a)(HistoryHeaderRow));
// EXTERNAL MODULE: ./node_modules/formsy-react/lib/index.js
var lib = __webpack_require__(880);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/components/SelectMultiple/Select.css
var SelectMultiple_Select = __webpack_require__(1094);
var Select_default = /*#__PURE__*/__webpack_require__.n(SelectMultiple_Select);

// CONCATENATED MODULE: ./src/components/SelectMultiple/Select.js
var Select__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Select__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Select__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Select__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Select__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SelectMultiple_Select_Select = function (_React$Component) {
  Select__inherits(Select, _React$Component);

  function Select(props) {
    Select__classCallCheck(this, Select);

    var _this = Select__possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.state = {
      selectTitle: '',
      canDisplayError: false
    };
    _this.changeValue = _this.changeValue.bind(_this);
    _this.displayError = _this.displayError.bind(_this);
    return _this;
  }

  Select__createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.defaultValue) {
        this.props.setValue(this.props.defaultValue);
      }
      this.isFirefox = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1; // tmp
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.state.selectTitle && nextProps.defaultValue) {
        this.props.setValue(nextProps.defaultValue);
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var _this2 = this;

      var title = null;

      if (this.props.defaultValue && this.props.options.length) {
        var defaultOption = this.props.options.find(function (option) {
          return option.value === _this2.props.defaultValue;
        });
        title = defaultOption ? defaultOption.title : title;
      }
      title = null;
      return title || this.props.title || this.props.options[0].title;
    }
  }, {
    key: 'changeValue',
    value: function changeValue(event) {
      var options = event.currentTarget.options;
      var values = [];
      for (var i = 0, l = options.length; i < l; i = i + 1) {
        if (options[i].selected) {
          values.push(options[i].value);
        }
      }
      if (this.props.onChange) {
        this.props.onChange(values);
      }
    }
  }, {
    key: 'keyDown',
    value: function keyDown(event) {
      var _this3 = this;

      if (event.keyCode === 40 || event.keyCode === 38) {
        setTimeout(function () {
          _this3.refs.select.blur();
          _this3.refs.select.focus();
        }, 0);
      }
    }
  }, {
    key: 'displayError',
    value: function displayError() {
      this.setState({
        canDisplayError: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'FormSelect';
      if (this.props.showRequired()) {
        className = classnames_default()(Select_default.a.required, Select_default.a[className]);
      } else if (this.props.showError()) {
        className = classnames_default()(Select_default.a.error, Select_default.a[className]);
      }
      var errorMessage = this.props.getErrorMessage() || (this.props.showRequired() && this.props.isFormSubmitted() ? 'field_required' : null);

      var options = this.props.options.map(function (option) {
        return Select__jsx('option', {
          value: option.value
        }, option.title + option.value, option.title);
      });

      var selectTitle = this.state.selectTitle ? this.state.selectTitle : this.getTitle();

      var selectClassNames = classnames_default()(Select_default.a.Form_field, Select_default.a.big);

      var labelClassNames = this.props.titleVisibility ? classnames_default()(Select_default.a.FormSelect__label) : classnames_default()(Select_default.a.FormSelect__label, Select_default.a.u_hidden);
      return Select__jsx('div', {
        className: className
      }, void 0, Select__jsx('label', {
        htmlFor: this.props.name,
        className: labelClassNames
      }, void 0, this.props.title), Select__jsx('div', {
        className: 'u-posRelative'
      }, void 0, selectTitle !== this.props.title ? react_default.a.createElement(
        'select',
        {
          ref: 'select',
          multiple: this.props.multiple,
          className: selectClassNames,
          name: this.props.name,
          disabled: this.props.disabled ? 'disabled' : null,
          onChange: this.changeValue,
          onKeyDown: this.isFirefox ? this.keyDown : null,
          onBlur: this.displayError,
          value: this.props.getValue() },
        options
      ) : react_default.a.createElement(
        'select',
        {
          ref: 'select',
          multiple: this.props.multiple,
          className: selectClassNames,
          name: this.props.name,
          disabled: this.props.disabled ? 'disabled' : null,
          onChange: this.changeValue,
          onKeyDown: this.isFirefox ? this.keyDown : null,
          onBlur: this.displayError,
          value: this.props.getValue() },
        Select__jsx('option', {
          className: Select_default.a.u_hidden
        }, '$selectTitle.title', ' ', selectTitle, ' '),
        options
      )), this.props.isFormSubmitted() && errorMessage ? Select__jsx('div', {
        className: 'Form-error'
      }, void 0, Select__jsx(index_es["b" /* FormattedMessage */], {
        id: errorMessage
      })) : null);
    }
  }]);

  return Select;
}(react_default.a.Component);

;

SelectMultiple_Select_Select.defaultProps = {
  large: false,
  multiple: false,
  withoutBorder: false,
  titleVisibility: false
};

/* harmony default export */ var components_SelectMultiple_Select = (Object(lib["withFormsy"])(withStyles_default()(Select_default.a)(SelectMultiple_Select_Select)));
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEventsHeader.js
var HistoryEventsHeader__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HistoryEventsHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryEventsHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryEventsHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryEventsHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryEventsHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var HistoryEventsHeader__ref2 = HistoryEventsHeader__jsx(Loader["a" /* default */], {});

var HistoryEventsHeader__ref3 = HistoryEventsHeader__jsx(Loader["a" /* default */], {});

var HistoryEventsHeader_HistoryEventsHeader = function (_React$Component) {
  HistoryEventsHeader__inherits(HistoryEventsHeader, _React$Component);

  function HistoryEventsHeader() {
    var _ref;

    var _temp, _this, _ret;

    HistoryEventsHeader__classCallCheck(this, HistoryEventsHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryEventsHeader__possibleConstructorReturn(this, (_ref = HistoryEventsHeader.__proto__ || Object.getPrototypeOf(HistoryEventsHeader)).call.apply(_ref, [this].concat(args))), _this), _this.sanitazeItemsFetched = function (deviceDocumentPaging) {
      if (deviceDocumentPaging) {
        if (deviceDocumentPaging.get('itemsCount') < deviceDocumentPaging.get('itemsPerPage')) {
          return deviceDocumentPaging.get('itemsCount');
        }
        return deviceDocumentPaging.get('numberOlderItemsFetched') * deviceDocumentPaging.get('itemsPerPage');
      }
      return 0;
    }, _temp), HistoryEventsHeader__possibleConstructorReturn(_this, _ret);
  }

  HistoryEventsHeader__createClass(HistoryEventsHeader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = HistoryEvents_Messages_Messages();
      var _props = this.props,
          events = _props.events,
          intl = _props.intl,
          deviceType = _props.deviceType,
          filteredEvents = _props.filteredEvents,
          deviceDocumentPaging = _props.deviceDocumentPaging,
          deviceSerial = _props.deviceSerial,
          deviceName = _props.deviceName;


      var eventsReady = events ? Object.entries(events).length : events;
      if (eventsReady) {
        var eventsOptions = events.toArray().map(utils["a" /* eventsParser */]).map(Object(utils["b" /* getOptionsTranslator */])(intl, messages));
        var iconSize = 41;

        var isSuperior = deviceType === 'superior';
        var colorStyled = isSuperior ? classnames_default()(HistoryEventsHeader_default.a.blackButton) : classnames_default()(HistoryEventsHeader_default.a.whiteButton);
        var dark = isSuperior ? 'dark_spirotech' : 'dark';
        var light = isSuperior ? 'light_spirotech' : 'light';
        var edytuj = isSuperior ? 'edytuj_black' : 'edytuj';
        var clearFilter = isSuperior ? 'odrzuc' : 'odrzuc_white';
        var itemsFetched = this.sanitazeItemsFetched(deviceDocumentPaging);
        var itemsCount = deviceDocumentPaging.get('itemsCount');
        var downloadingDocument = deviceDocumentPaging.get('downloadingDocument');
        return HistoryEventsHeader__jsx('section', {
          className: HistoryEventsHeader_default.a.container
        }, void 0, HistoryEventsHeader__jsx('h3', {}, void 0, deviceName, ' S/N: ', deviceSerial), HistoryEventsHeader__jsx('div', {
          className: HistoryEventsHeader_default.a.center
        }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.record_part1_text), ' ', itemsFetched, ' / ', itemsCount, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.record_part2_text)), HistoryEventsHeader__jsx('div', {
          className: HistoryEventsHeader_default.a.left
        }, void 0, HistoryEventsHeader__jsx(Form["a" /* default */], {}, void 0, HistoryEventsHeader__jsx(components_SelectMultiple_Select, {
          title: intl.formatMessage(HistoryEventsHeader__extends({}, messages.filter_select_button_history)),
          name: 'events',
          options: eventsOptions,
          onChange: this.props.onChange,
          large: true,
          multiple: true
        }))), HistoryEventsHeader__jsx('div', {
          className: HistoryEventsHeader_default.a.right
        }, void 0, HistoryEventsHeader__jsx(Button["a" /* default */], {
          onClick: function onClick() {
            if (!downloadingDocument) {
              _this2.props.onSave(_this2.props.filteredEvents, true);
            }
          },
          buttonClass: 'mainPdf',
          buttonColor: dark,
          title: intl.formatMessage(messages.save_as_pdf_button_history)
        }, void 0, HistoryEventsHeader__jsx(Icon["a" /* default */], {
          iconName: edytuj,
          size: iconSize
        }), HistoryEventsHeader__jsx('div', {
          className: colorStyled
        }, void 0, !downloadingDocument ? react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.save_as_pdf_button_history) : HistoryEventsHeader__ref2)), HistoryEventsHeader__jsx(Button["a" /* default */], {
          onClick: function onClick() {
            if (!downloadingDocument) {
              _this2.props.onSave(_this2.props.filteredEvents, false);
            }
          },
          buttonClass: 'mainPdf',
          buttonColor: dark,
          title: intl.formatMessage(messages.save_all_as_pdf_button_history)
        }, void 0, HistoryEventsHeader__jsx(Icon["a" /* default */], {
          iconName: edytuj,
          size: iconSize
        }), HistoryEventsHeader__jsx('div', {
          className: colorStyled
        }, void 0, !downloadingDocument ? react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.save_all_as_pdf_button_history) : HistoryEventsHeader__ref3)), HistoryEventsHeader__jsx(Button["a" /* default */], {
          onClick: function onClick() {
            _this2.props.onClearFilter();
            _this2.props.onChange([]);
          },
          buttonClass: 'mainPdf',
          buttonColor: light
        }, void 0, HistoryEventsHeader__jsx(Icon["a" /* default */], {
          iconName: clearFilter,
          size: iconSize
        }), HistoryEventsHeader__jsx('div', {
          className: colorStyled
        }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.clear_filter_button_history)))));
      }
      return null;
    }
  }]);

  return HistoryEventsHeader;
}(react_default.a.Component);

/* harmony default export */ var components_HistoryEvents_HistoryEventsHeader = (Object(index_es["g" /* injectIntl */])(withStyles_default()(HistoryEventsHeader_default.a)(HistoryEventsHeader_HistoryEventsHeader)));
// EXTERNAL MODULE: ./src/components/HistoryEvents/HistoryEventsFilterbox.css
var HistoryEvents_HistoryEventsFilterbox = __webpack_require__(1096);
var HistoryEventsFilterbox_default = /*#__PURE__*/__webpack_require__.n(HistoryEvents_HistoryEventsFilterbox);

// CONCATENATED MODULE: ./src/components/HistoryEvents/utils.js
function getDataFilterboxSoftener(softenerFilterDocument, messages, screenType) {
  var data = [[{
    text: messages.history_events_date,
    name: 'date'
  }, {
    text: messages.history_events_time,
    name: 'time'
  }, {
    text: messages.history_events_event,
    name: 'event'
  }], [{
    text: messages.history_events_daily_water_usage,
    name: 'daily_water_usage'
  }, {
    text: messages.history_events_weekly_water_usage,
    name: 'weekly_water_usage'
  }, {
    text: messages.history_events_monthly_water_usage,
    name: 'monthly_water_usage'
  }, {
    text: messages.history_events_total_water_usage,
    name: 'total_water_usage'
  }, {
    text: messages.history_events_untreated_water_flow,
    name: 'untreated_water_flow'
  }, {
    text: messages.history_events_water_flow,
    name: 'water_flow'
  }], [{
    text: messages.history_events_water_pressure,
    name: 'water_pressure'
  }, {
    text: messages.history_events_max_water_pressure,
    name: 'max_water_pressure'
  }, {
    text: messages.history_events_min_water_pressure,
    name: 'min_water_pressure'
  }, {
    text: messages.history_events_max_water_flow,
    name: 'max_water_flow'
  }], [{
    text: messages.history_events_normal_regeneration_number,
    name: 'normal_regeneration_number'
  }, {
    text: messages.history_events_service_regeneration_number,
    name: 'service_regeneration_number'
  }, {
    text: messages.history_events_incomplete_regeneration_number,
    name: 'incomplete_regeneration_number'
  }], getReserveData(messages, screenType), [{
    text: messages.history_events_chlor_current,
    name: 'chlor_current'
  }, {
    text: messages.history_events_ip_address,
    name: 'ip_address'
  }, {
    text: messages.history_events_subnet_mask,
    name: 'subnet_mask'
  }, {
    text: messages.history_events_default_gateway,
    name: 'default_gateway'
  }, {
    text: messages.history_events_device_operator,
    name: 'device_operator'
  }, {
    text: messages.history_events_record_no,
    name: 'record_no'
  }]];
  return data;
};

function getDataFilterboxSuperior(superiorFilterDocument, messages) {
  var data = [[{
    text: messages.history_events_superior_date,
    name: 'date'
  }, {
    text: messages.history_events_superior_time,
    name: 'time'
  }, {
    text: messages.history_events_superior_event,
    name: 'event'
  }], [{
    text: messages.history_events_superior_current_refill_flow,
    name: 'current_refill_flow'
  }, {
    text: messages.history_events_superior_refill_flow_rate,
    name: 'refill_flow_rate'
  }, {
    text: messages.history_events_superior_total_refill_volume,
    name: 'total_refill_volume'
  }, {
    text: messages.history_events_superior_system_pressure,
    name: 'system_pressure'
  }, {
    text: messages.history_events_superior_total_refill_time,
    name: 'total_refill_time'
  }, {
    text: messages.history_events_superior_total_degass_time,
    name: 'total_degass_time'
  }], [{
    text: messages.history_events_superior_device_operator,
    name: 'device_operator'
  }, {
    text: messages.history_events_superior_record_no,
    name: 'record_no'
  }]];
  return data;
};

function getReserveData(messages, screenType) {
  switch (screenType) {
    case 'DOUBLEALTERNATIVE':
    case 'DOUBLEPARALLEL':
    case 'DOUBLEFILTER':
      return [{
        text: messages.history_events_a_cylinder_reserve,
        name: 'a_cylinder_reserve'
      }, {
        text: messages.history_events_c_cylinder_reserve,
        name: 'c_cylinder_reserve'
      }];
    case 'TRIPLEALTERNATIVE':
    case 'TRIPLEPARALLEL':
    case 'TRIPLEFILTER':
      return [{
        text: messages.history_events_b_cylinder_reserve,
        name: 'b_cylinder_reserve'
      }, {
        text: messages.history_events_a_cylinder_reserve,
        name: 'a_cylinder_reserve'
      }, {
        text: messages.history_events_c_cylinder_reserve,
        name: 'c_cylinder_reserve'
      }];
    default:
      return [{
        text: messages.history_events_a_cylinder_reserve,
        name: 'a_cylinder_reserve'
      }];
  }
}
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEventsFilterboxView.js
var HistoryEventsFilterboxView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryEventsFilterboxView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryEventsFilterboxView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryEventsFilterboxView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryEventsFilterboxView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var HistoryEventsFilterboxView_HistoryEventsFilterbox = function (_React$Component) {
  HistoryEventsFilterboxView__inherits(HistoryEventsFilterbox, _React$Component);

  function HistoryEventsFilterbox() {
    var _ref;

    var _temp, _this, _ret;

    HistoryEventsFilterboxView__classCallCheck(this, HistoryEventsFilterbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryEventsFilterboxView__possibleConstructorReturn(this, (_ref = HistoryEventsFilterbox.__proto__ || Object.getPrototypeOf(HistoryEventsFilterbox)).call.apply(_ref, [this].concat(args))), _this), _this.setFilter = function (name, deviceType) {
      _this.props.setDeviceDocumentFilter('events', name, deviceType);
    }, _this.setColumnFilter = function (name, deviceType, screenType) {
      _this.props.setDeviceDocumentColumnFilter('events', name, deviceType, screenType);
    }, _this.getElement = function (item, index, deviceType, filter) {
      var value = filter.get(item.name);
      var checked = +value === 1;
      return HistoryEventsFilterboxView__jsx('div', {}, index, HistoryEventsFilterboxView__jsx('input', {
        type: 'checkbox',
        name: item.name,
        value: value,
        onChange: _this.setFilter.bind(_this, item.name, deviceType),
        checked: checked
      }), HistoryEventsFilterboxView__jsx('label', {
        htmlFor: item.name
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text)));
    }, _this.getColumn = function (column, index, deviceType, columnStyle, filter) {
      return HistoryEventsFilterboxView__jsx('td', {
        className: columnStyle
      }, index, HistoryEventsFilterboxView__jsx('span', {}, void 0, column.map(function (item, ind) {
        return _this.getElement(item, ind, deviceType, filter);
      })));
    }, _this.getColumnHeader = function (item, index, deviceType, filter, screenType) {
      var value = filter.get(item.name);
      var checked = +value === 1;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          return HistoryEventsFilterboxView__jsx('th', {
            className: classnames_default()(HistoryEventsFilterbox_default.a.header)
          }, index, HistoryEventsFilterboxView__jsx('input', {
            type: 'checkbox',
            name: item.name,
            value: value,
            onChange: _this.setColumnFilter.bind(_this, item.name, deviceType, screenType),
            checked: checked
          }), react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
        case 'superior':
          return HistoryEventsFilterboxView__jsx('th', {
            className: classnames_default()(HistoryEventsFilterbox_default.a.spirotech)
          }, index, HistoryEventsFilterboxView__jsx('input', {
            type: 'checkbox',
            name: item.name,
            value: value,
            onChange: _this.setColumnFilter.bind(_this, item.name, deviceType),
            checked: checked
          }), react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
        default:
          break;
      }
      return null;
    }, _this.getData = function (messages, deviceType, screenType) {
      var _this$props = _this.props,
          documentSoftenerFilter = _this$props.documentSoftenerFilter,
          documentSuperiorFilter = _this$props.documentSuperiorFilter;

      var data = [];
      var filter = null;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = getDataFilterboxSoftener(documentSoftenerFilter, messages, screenType);
          filter = documentSoftenerFilter;
          break;
        case 'superior':
          data = getDataFilterboxSuperior(documentSuperiorFilter, messages);
          filter = documentSuperiorFilter;
          break;
        default:
          break;
      }
      return { data: data, filter: filter };
    }, _this.getHeaderData = function (messages, deviceType) {
      var data = [];
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = [{
            text: messages.history_events_header_time,
            name: 'times'
          }, {
            text: messages.history_events_header_flows,
            name: 'flows'
          }, {
            text: messages.history_events_header_pressure,
            name: 'pressure'
          }, {
            text: messages.history_events_header_regenerations,
            name: 'regenerations'
          }, {
            text: messages.history_events_header_cylinder_reserve,
            name: 'reserve'
          }, {
            text: messages.history_events_header_network,
            name: 'network'
          }];
          break;
        case 'superior':
          data = [{
            text: messages.history_events_superior_header_time,
            name: 'times'
          }, {
            text: messages.history_events_superior_header_flow,
            name: 'flows'
          }, {
            text: messages.history_events_superior_header_other,
            name: 'other'
          }];
          break;
        default:
          break;
      }
      return data;
    }, _this.getColumnStyle = function (deviceType) {
      var columnStyle = classnames_default()();
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          columnStyle = classnames_default()(HistoryEventsFilterbox_default.a.column_softener, HistoryEventsFilterbox_default.a.table_border);
          break;
        case 'superior':
          columnStyle = classnames_default()(HistoryEventsFilterbox_default.a.column_superior, HistoryEventsFilterbox_default.a.table_border);
          break;
        default:
          break;
      }
      return columnStyle;
    }, _temp), HistoryEventsFilterboxView__possibleConstructorReturn(_this, _ret);
  }

  HistoryEventsFilterboxView__createClass(HistoryEventsFilterbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = HistoryEvents_Messages_Messages();
      var deviceDocument = this.props.deviceDocument;

      var deviceType = deviceDocument.get('deviceType');
      var screenType = deviceDocument.get('screenType');

      var _getData = this.getData(messages, deviceType, screenType),
          data = _getData.data,
          filter = _getData.filter;

      var columnStyle = this.getColumnStyle(deviceType);
      var headerData = this.getHeaderData(messages, deviceType);
      return HistoryEventsFilterboxView__jsx('table', {
        className: HistoryEventsFilterbox_default.a.Table_container
      }, void 0, HistoryEventsFilterboxView__jsx('thead', {}, void 0, HistoryEventsFilterboxView__jsx('tr', {}, void 0, headerData.map(function (item, index) {
        return _this2.getColumnHeader(item, index, deviceType, filter, screenType);
      }))), HistoryEventsFilterboxView__jsx('tbody', {}, void 0, HistoryEventsFilterboxView__jsx('tr', {}, void 0, data.map(function (item, index) {
        return _this2.getColumn(item, index, deviceType, columnStyle, filter);
      }))));
    }
  }]);

  return HistoryEventsFilterbox;
}(react_default.a.Component);

/* harmony default export */ var HistoryEventsFilterboxView = (withStyles_default()(HistoryEventsFilterbox_default.a)(HistoryEventsFilterboxView_HistoryEventsFilterbox));
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEventsFilterbox.js
var HistoryEventsFilterbox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function HistoryEventsFilterbox_HistoryEventsFilterbox(props) {
  return HistoryEventsFilterbox__jsx(HistoryEventsFilterboxView, {
    documentSoftenerFilter: props.documentSoftenerFilter,
    documentSuperiorFilter: props.documentSuperiorFilter,
    setDeviceDocumentFilter: props.setDeviceDocumentFilter,
    setDeviceDocumentColumnFilter: props.setDeviceDocumentColumnFilter,
    deviceDocument: props.deviceDocument
  });
}

var HistoryEventsFilterbox_mapDispatch = function mapDispatch(dispatch) {
  return {
    setDeviceDocumentFilter: function setDeviceDocumentFilter(documentType, name, deviceType) {
      return dispatch(documents_setDeviceDocumentFilter(documentType, name, deviceType));
    },
    setDeviceDocumentColumnFilter: function setDeviceDocumentColumnFilter(documentType, name, deviceType, screenType) {
      return dispatch(documents_setDeviceDocumentColumnFilter(documentType, name, deviceType, screenType));
    }
  };
};

/* harmony default export */ var components_HistoryEvents_HistoryEventsFilterbox = (Object(es["b" /* connect */])(null, HistoryEventsFilterbox_mapDispatch)(HistoryEventsFilterbox_HistoryEventsFilterbox));
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryMessages.js
function HistoryMessages__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




function getTableHeaderSoftenerData(screenType) {
  var messages = HistoryEvents_Messages_Messages();
  var data = [{
    text: messages.history_events_date,
    name: 'date'
  }, {
    text: messages.history_events_time,
    name: 'time'
  }, {
    text: messages.history_events_event,
    name: 'event'
  }, {
    text: messages.history_events_daily_water_usage,
    name: 'daily_water_usage'
  }, {
    text: messages.history_events_weekly_water_usage,
    name: 'weekly_water_usage'
  }, {
    text: messages.history_events_monthly_water_usage,
    name: 'monthly_water_usage'
  }, {
    text: messages.history_events_total_water_usage,
    name: 'total_water_usage'
  }, {
    text: messages.history_events_untreated_water_flow,
    name: 'untreated_water_flow'
  }, {
    text: messages.history_events_water_flow,
    name: 'water_flow'
  }, {
    text: messages.history_events_water_pressure,
    name: 'water_pressure'
  }, {
    text: messages.history_events_max_water_pressure,
    name: 'max_water_pressure'
  }, {
    text: messages.history_events_min_water_pressure,
    name: 'min_water_pressure'
  }, {
    text: messages.history_events_max_water_flow,
    name: 'max_water_flow'
  }, {
    text: messages.history_events_normal_regeneration_number,
    name: 'normal_regeneration_number'
  }, {
    text: messages.history_events_service_regeneration_number,
    name: 'service_regeneration_number'
  }, {
    text: messages.history_events_incomplete_regeneration_number,
    name: 'incomplete_regeneration_number'
  }];
  data.push.apply(data, HistoryMessages__toConsumableArray(getReserveData(messages, screenType)));
  var datab = [].concat(data, [{
    text: messages.history_events_chlor_current,
    name: 'chlor_current'
  }, {
    text: messages.history_events_ip_address,
    name: 'ip_address'
  }, {
    text: messages.history_events_subnet_mask,
    name: 'subnet_mask'
  }, {
    text: messages.history_events_default_gateway,
    name: 'default_gateway'
  }, {
    text: messages.history_events_device_operator,
    name: 'device_operator'
  }, {
    text: messages.history_events_record_no,
    name: 'record_no'
  }]);
  return datab;
};

function getTableHeaderSuperiorData() {
  var messages = HistoryEvents_Messages_Messages();
  var data = [{
    text: messages.history_events_superior_date,
    name: 'date'
  }, {
    text: messages.history_events_superior_time,
    name: 'time'
  }, {
    text: messages.history_events_superior_event,
    name: 'event'
  }, {
    text: messages.history_events_superior_current_refill_flow,
    name: 'current_refill_flow'
  }, {
    text: messages.history_events_superior_refill_flow_rate,
    name: 'refill_flow_rate'
  }, {
    text: messages.history_events_superior_total_refill_volume,
    name: 'total_refill_volume'
  }, {
    text: messages.history_events_superior_system_pressure,
    name: 'system_pressure'
  }, {
    text: messages.history_events_superior_total_refill_time,
    name: 'total_refill_time'
  }, {
    text: messages.history_events_superior_total_degass_time,
    name: 'total_degass_time'
  }, {
    text: messages.history_events_superior_device_operator,
    name: 'device_operator'
  }, {
    text: messages.history_events_superior_record_no,
    name: 'record_no'
  }];
  return data;
};
// EXTERNAL MODULE: ./src/components/InfiniteScroll/InfiniteScrollWithLoadMore.js + 1 modules
var InfiniteScrollWithLoadMore = __webpack_require__(947);

// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEventsView.js
var HistoryEventsView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryEventsView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryEventsView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryEventsView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryEventsView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var HistoryEventsView_MAX_NUMBER_OF_AUTOLOADS = 1;

var HistoryEventsView__ref = HistoryEventsView__jsx(Loader["a" /* default */], {
  block: true
});

var HistoryEventsView_HistoryEventsView = function (_React$Component) {
  HistoryEventsView__inherits(HistoryEventsView, _React$Component);

  function HistoryEventsView(props) {
    HistoryEventsView__classCallCheck(this, HistoryEventsView);

    var _this = HistoryEventsView__possibleConstructorReturn(this, (HistoryEventsView.__proto__ || Object.getPrototypeOf(HistoryEventsView)).call(this, props));

    _this.onClick = function (data, event) {
      var eventId = data.get(1);
      _this.setState({
        colorId: eventId
      });
    };

    _this.componentWillReceiveProps = function (newProps) {
      if (newProps.deviceDocument.get('serial') === null) {
        _this.onFilterEvent([]);
      }
    };

    _this.showBox = function (item, index, filter, deviceType) {
      var value = filter.get(item.name);
      var wrappedStyle = deviceType === 'superior' ? classnames_default()(HistoryEvents_default.a.row_container, HistoryEvents_default.a.spirotech_header_color) : classnames_default()(HistoryEvents_default.a.row_container, HistoryEvents_default.a.header_color);
      if (+value === 1) {
        return HistoryEventsView__jsx('th', {
          className: wrappedStyle
        }, index, react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
      }
      return null;
    };

    _this.onFilterEvent = function (values) {
      _this.setState({
        filteredEvents: values
      });
    };

    _this.getHeader = function (deviceDocument, softenerFilterDocument, superiorFilterDocument) {
      var deviceType = deviceDocument.get('deviceType');
      var screenType = deviceDocument.get('screenType');
      var data = [];
      var filter = null;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = getTableHeaderSoftenerData(screenType);
          filter = softenerFilterDocument;
          break;
        case 'superior':
          data = getTableHeaderSuperiorData();
          filter = superiorFilterDocument;
          break;
        default:
          break;
      }

      return HistoryEventsView__jsx('tr', {}, void 0, data.map(function (item, index) {
        return _this.showBox(item, index, filter, deviceType);
      }));
    };

    var colorId = '';
    _this.state = {
      colorId: colorId,
      filteredEvents: []
    };
    return _this;
  }

  HistoryEventsView__createClass(HistoryEventsView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          deviceDocument = _props.deviceDocument,
          deviceDocumentPaging = _props.deviceDocumentPaging,
          documentSoftenerFilter = _props.documentSoftenerFilter,
          documentSuperiorFilter = _props.documentSuperiorFilter,
          documentRows = _props.documentRows;

      var rowsData = documentRows;
      var events = deviceDocument && deviceDocument.get('events');
      var numberOlderItemsFetched = deviceDocumentPaging && deviceDocumentPaging.get('numberOlderItemsFetched');
      var requestInProgress = deviceDocument && deviceDocument.get('requestInProgress');

      var hasMore = deviceDocumentPaging.get('itemsPerPage') * deviceDocumentPaging.get('currentPage') < deviceDocumentPaging.get('itemsCount');

      if (deviceDocument !== 'undefined' && deviceDocument.get('serial') !== null && +deviceDocument.get('documentType') === 1) {
        if (!requestInProgress && rowsData) {
          return HistoryEventsView__jsx(Popup_PopupOverview, {
            className: HistoryEvents_default.a.Popup__editdevice,
            onClose: this.props.onClose,
            deviceType: deviceDocument.get('deviceType'),
            overrideOnClose: true
          }, void 0, HistoryEventsView__jsx(components_HistoryEvents_HistoryEventsFilterbox, {
            documentSoftenerFilter: documentSoftenerFilter,
            documentSuperiorFilter: documentSuperiorFilter,
            deviceDocument: deviceDocument
          }), HistoryEventsView__jsx(components_HistoryEvents_HistoryEventsHeader, {
            events: events,
            onChange: this.onFilterEvent,
            onSave: this.props.onSavePDF,
            filteredEvents: this.state.filteredEvents,
            onClearFilter: this.props.onClearFilter,
            deviceType: deviceDocument.get('deviceType'),
            deviceName: deviceDocument.get('deviceName'),
            deviceSerial: deviceDocument.get('serial'),
            deviceDocumentPaging: deviceDocumentPaging
          }), HistoryEventsView__jsx('table', {
            className: HistoryEvents_default.a.Table_container
          }, void 0, HistoryEventsView__jsx('thead', {}, void 0, this.getHeader(deviceDocument, documentSoftenerFilter, documentSuperiorFilter)), HistoryEventsView__jsx(InfiniteScrollWithLoadMore["a" /* default */], {
            loadMore: this.props.getNextPage,
            hasMore: hasMore,
            showLoadMore: numberOlderItemsFetched >= HistoryEventsView_MAX_NUMBER_OF_AUTOLOADS,
            className: classnames_default()(),
            table: true
          }, void 0, rowsData.map(function (row, index) {
            return HistoryEventsView__jsx(HistoryEvents_HistoryEventRow, {
              row: row,
              onClick: _this2.onClick.bind(_this2, row.get(2)),
              colorId: _this2.state.colorId,
              documentSoftenerFilter: documentSoftenerFilter,
              documentSuperiorFilter: documentSuperiorFilter,
              filteredEvents: _this2.state.filteredEvents,
              deviceDocument: deviceDocument
            }, index);
          }))));
        }
        return HistoryEventsView__jsx(Popup_PopupOverview, {
          className: HistoryEvents_default.a.Popup__editdevice,
          onClose: this.props.onClose,
          overrideOnClose: true
        }, void 0, HistoryEventsView__ref);
      }
      return null;
    }
  }]);

  return HistoryEventsView;
}(react_default.a.Component);

/* harmony default export */ var HistoryEvents_HistoryEventsView = (withStyles_default()(HistoryEvents_default.a)(HistoryEventsView_HistoryEventsView));
// CONCATENATED MODULE: ./src/components/HistoryEvents/HistoryEvents.js
var HistoryEvents__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryEvents__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryEvents__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryEvents__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryEvents__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PAGE_SIZE = 1000;

var HistoryEvents_HistoryEvents_HistoryEvents = function (_React$Component) {
  HistoryEvents__inherits(HistoryEvents, _React$Component);

  function HistoryEvents() {
    var _ref;

    var _temp, _this, _ret;

    HistoryEvents__classCallCheck(this, HistoryEvents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryEvents__possibleConstructorReturn(this, (_ref = HistoryEvents.__proto__ || Object.getPrototypeOf(HistoryEvents)).call.apply(_ref, [this].concat(args))), _this), _this.getFilter = function (deviceDocument) {
      var filter = {};
      switch (deviceDocument.get('deviceType')) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          filter = _this.props.documentSoftenerFilter;
          break;
        case 'superior':
          filter = _this.props.documentSuperiorFilter;
          break;
        default:
          break;
      }
      return filter;
    }, _this.getNextPage = function () {
      _this.props.getDeviceDocumentById(_this.props.deviceDocument.get('serial'), _this.props.deviceDocument.get('documentName'), {}, +_this.props.deviceDocumentPaging.get('currentPage') + 1, PAGE_SIZE);
    }, _this.onSavePDF = function (events, web) {
      var _this$props = _this.props,
          deviceDocument = _this$props.deviceDocument,
          deviceDocumentPaging = _this$props.deviceDocumentPaging;

      var filter = _this.getFilter(deviceDocument);
      if (web) {
        _this.props.downloadDeviceDocument(deviceDocument.get('serial'), deviceDocument.get('documentName'), JSON.stringify(filter), events, deviceDocumentPaging.get('currentPage'), deviceDocumentPaging.get('itemsPerPage'));
      } else {
        _this.props.downloadDeviceDocument(deviceDocument.get('serial'), deviceDocument.get('documentName'), JSON.stringify(filter), events);
      }
    }, _this.onClearFilter = function () {
      var deviceDocument = _this.props.deviceDocument;
      _this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
    }, _this.closePopup = function () {
      var deviceDocument = _this.props.deviceDocument;
      _this.props.clearDeviceDocument();
      _this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
    }, _temp), HistoryEvents__possibleConstructorReturn(_this, _ret);
  }

  HistoryEvents__createClass(HistoryEvents, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var deviceDocument = this.props.deviceDocument;
      if (typeof deviceDocument !== 'undefined' && deviceDocument.get('serial') !== null) {
        this.props.getDeviceDocumentById(deviceDocument.get('serial'), deviceDocument.get('documentName'), {}, 1, PAGE_SIZE);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      var isUpdatedDocument = newProps.deviceDocument.get('serial') !== this.props.deviceDocument.get('serial');
      if (isUpdatedDocument && newProps.deviceDocument.get('serial') !== null && +newProps.deviceDocument.get('documentType') === 1) {
        this.props.getDeviceDocumentById(newProps.deviceDocument.get('serial'), newProps.deviceDocument.get('documentName'), {}, +this.props.deviceDocumentPaging.get('currentPage'), PAGE_SIZE);
      }
      return true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var deviceDocument = this.props.deviceDocument;
      this.props.clearDeviceDocument();
      this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
    }
  }, {
    key: 'render',
    value: function render() {
      return HistoryEvents__jsx(HistoryEvents_HistoryEventsView, {
        documentRows: this.props.documentRows,
        deviceDocument: this.props.deviceDocument,
        deviceDocumentPaging: this.props.deviceDocumentPaging,
        documentSoftenerFilter: this.props.documentSoftenerFilter,
        documentSuperiorFilter: this.props.documentSuperiorFilter,
        getNextPage: this.getNextPage,
        onClose: this.closePopup,
        onSavePDF: this.onSavePDF,
        onClearFilter: this.onClearFilter
      });
    }
  }]);

  return HistoryEvents;
}(react_default.a.Component);

var HistoryEvents_mapState = function mapState(state) {
  return {
    deviceDocument: state.deviceDocument,
    documentRows: state.documentRows,
    deviceDocumentPaging: state.deviceDocumentPaging,
    documentSoftenerFilter: state.softenerEventFilter,
    documentSuperiorFilter: state.superiorEventFilter
  };
};

var HistoryEvents_mapDispatch = function mapDispatch(dispatch) {
  return {
    getDeviceDocumentById: function getDeviceDocumentById(serial, documentId, filterData, page, pageSize) {
      return dispatch(documents_getDeviceDocumentById(serial, documentId, filterData, page, pageSize));
    },
    clearDeviceDocument: function clearDeviceDocument() {
      return dispatch(documents_clearDeviceDocument());
    },
    downloadDeviceDocument: function downloadDeviceDocument(serial, documentId, filterData, events, page, pageSize) {
      return dispatch(documents_downloadDeviceDocument(serial, documentId, filterData, events, page, pageSize));
    },
    clearDocumentFilter: function clearDocumentFilter(deviceType, documentType) {
      return dispatch(documents_clearDocumentFilter(deviceType, documentType));
    }
  };
};

/* harmony default export */ var components_HistoryEvents_HistoryEvents = (Object(es["b" /* connect */])(HistoryEvents_mapState, HistoryEvents_mapDispatch)(HistoryEvents_HistoryEvents_HistoryEvents));
// EXTERNAL MODULE: ./src/components/HistoryParameters/HistoryParameters.css
var HistoryParameters_HistoryParameters = __webpack_require__(933);
var HistoryParameters_default = /*#__PURE__*/__webpack_require__.n(HistoryParameters_HistoryParameters);

// CONCATENATED MODULE: ./src/components/HistoryParameters/Messages.js


function HistoryParameters_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    clear_filter_button_history: {
      'id': 'clear_filter_button_history',
      'defaultMessage': 'Clear fiilter'
    },
    save_as_pdf_button_history: {
      'id': 'save_as_pdf_button_history',
      'defaultMessage': 'Save shown records in PDF'
    },
    history_parameters_language: {
      'id': 'history_parameters_language',
      'defaultMessage': 'Language - N5'
    },
    history_parameters_unit_water_hardness: {
      'id': 'history_parameters_unit_water_hardness',
      'defaultMessage': 'Unit of water hardness- N40'
    },
    history_parameters_water_pressure: {
      'id': 'history_parameters_water_pressure',
      'defaultMessage': 'Water pressure for the calculation - N16'
    },
    history_parameters_pressure_sensor: {
      'id': 'history_parameters_pressure_sensor',
      'defaultMessage': 'Pressure sensor  - N8'
    },
    history_parameters_chlorine_generator: {
      'id': 'history_parameters_chlorine_generator',
      'defaultMessage': 'Chlorine generator - N48'
    },
    history_parameters_reserve_period: {
      'id': 'history_parameters_reserve_period',
      'defaultMessage': 'Reserve period- N53'
    },
    history_parameters_reg_period: {
      'id': 'history_parameters_reg_period',
      'defaultMessage': 'Regeneration period- N38'
    },
    history_parameters_days_of_regeneration: {
      'id': 'history_parameters_days_of_regeneration',
      'defaultMessage': 'Days of regeneration - N93'
    },
    history_parameters_date: {
      'id': 'history_parameters_date',
      'defaultMessage': 'Date'
    },
    history_parameters_time: {
      'id': 'history_parameters_time',
      'defaultMessage': 'Time'
    },
    history_parameters_device_type: {
      'id': 'history_parameters_device_type',
      'defaultMessage': 'Device type'
    },
    history_parameters_outlet_water_hardness: {
      'id': 'history_parameters_outlet_water_hardness',
      'defaultMessage': 'Outlet water hardness - N46'
    },
    history_parameters_intlet_water_hardness: {
      'id': 'history_parameters_intlet_water_hardness',
      'defaultMessage': 'Inlet water hardness - N42'
    },
    history_parameters_regenerant_dose: {
      'id': 'history_parameters_regenerant_dose',
      'defaultMessage': 'Regenerant dose - N39'
    },
    history_parameters_resin_volume: {
      'id': 'history_parameters_resin_volume',
      'defaultMessage': 'Resin volume - N84'
    },
    history_parameters_reserve_type: {
      'id': 'history_parameters_reserve_type',
      'defaultMessage': 'Reserve type - N50'
    },
    history_parameters_percentage_of_reserve: {
      'id': 'history_parameters_percentage_of_reserve',
      'defaultMessage': 'Percentage of reserve - N51'
    },
    history_parameters_regeneration_time: {
      'id': 'history_parameters_regeneration_time',
      'defaultMessage': 'Regeneration time - N41'
    },
    history_parameters_average_water_used: {
      'id': 'history_parameters_average_water_used',
      'defaultMessage': 'Average water used - N7'
    },
    history_parameters_ferrum_content: {
      'id': 'history_parameters_ferrum_content',
      'defaultMessage': 'Ferumm content - N43'
    },
    history_parameters_type_of_regeneration: {
      'id': 'history_parameters_type_of_regeneration',
      'defaultMessage': 'Type of regeneration - N49'
    },
    history_parameters_cancel_vacation_mode: {
      'id': 'history_parameters_cancel_vacation_mode',
      'defaultMessage': 'Cancel vacation mode - N9'
    },
    history_parameters_backwash: {
      'id': 'history_parameters_backwash',
      'defaultMessage': 'Backwash Rinsing Time'
    },
    history_parameters_rapid_rinsing: {
      'id': 'history_parameters_rapid_rinsing',
      'defaultMessage': 'Rapid Rinsing Time'
    },
    history_parameters_dhcp_client: {
      'id': 'history_parameters_dhcp_client',
      'defaultMessage': 'DHCP client'
    },
    history_parameters_ip_address: {
      'id': 'history_parameters_ip_address',
      'defaultMessage': 'IP address'
    },
    history_parameters_subnet_mask: {
      'id': 'history_parameters_subnet_mask',
      'defaultMessage': 'Subnet mask'
    },
    history_parameters_default_gateway: {
      'id': 'history_parameters_default_gateway',
      'defaultMessage': 'Default gateway'
    },
    history_parameters_dns_server: {
      'id': 'history_parameters_dns_server',
      'defaultMessage': 'DNS server'
    },
    history_parameters_timezone: {
      'id': 'history_parameters_timezone',
      'defaultMessage': 'Timezone'
    },
    monday_info1_level1_softener: {
      'id': 'monday_info1_level1_softener',
      'defaultMessage': 'Monday'
    },
    tuesday_info1_level1_softener: {
      'id': 'tuesday_info1_level1_softener',
      'defaultMessage': 'Tuesday'
    },
    wednesday_info1_level1_softener: {
      'id': 'wednesday_info1_level1_softener',
      'defaultMessage': 'Wednesday'
    },
    thursday_info1_level1_softener: {
      'id': 'thursday_info1_level1_softener',
      'defaultMessage': 'Thursday'
    },
    friday_info1_level1_softener: {
      'id': 'friday_info1_level1_softener',
      'defaultMessage': 'Friday'
    },
    saturday_info1_level1_softener: {
      'id': 'saturday_info1_level1_softener',
      'defaultMessage': 'Saturday'
    },
    sunday_info1_level1_softener: {
      'id': 'sunday_info1_level1_softener',
      'defaultMessage': 'Sunday'
    },
    immediate_regeneration_parameters_level2_softener: {
      'id': 'immediate_regeneration_parameters_level2_softener',
      'defaultMessage': 'Immediate'
    },
    delayed_regeneration_parameters_level2_softener: {
      'id': 'delayed_regeneration_parameters_level2_softener',
      'defaultMessage': 'Delayed'
    },
    option1_chlorine_generator_parameters_level2_softener: {
      'id': 'option1_chlorine_generator_parameters_level2_softener',
      'defaultMessage': 'Chlorine Generator'
    },
    option2_chlorine_generator_parameters_level2_softener: {
      'id': 'option2_chlorine_generator_parameters_level2_softener',
      'defaultMessage': 'Salt sensor'
    },
    option3_chlorine_generator_parameters_level2_softener: {
      'id': 'option3_chlorine_generator_parameters_level2_softener',
      'defaultMessage': 'Unavailable'
    },
    salt_sensor_history_yes: {
      'id': 'salt_sensor_history_yes',
      'defaultMessage': 'Yes'
    },
    salt_sensor_history_no: {
      'id': 'salt_sensor_history_no',
      'defaultMessage': 'No'
    },
    history_parameters_check_uncheck_all: {
      'id': 'history_parameters_check_uncheck_all',
      'defaultMessage': 'Check/uncheck all'
    },
    history_parameters_superior_date: {
      'id': 'history_parameters_superior_date',
      'defaultMessage': 'Date'
    },
    history_parameters_superior_time: {
      'id': 'history_parameters_superior_time',
      'defaultMessage': 'Time'
    },
    history_parameters_superior_language: {
      'id': 'history_parameters_superior_language',
      'defaultMessage': 'Language'
    },
    history_parameters_superior_device_type: {
      'id': 'history_parameters_superior_device_type',
      'defaultMessage': 'Device type'
    },
    history_parameters_superior_auto_degass_start_1_enable: {
      'id': 'history_parameters_superior_auto_degass_start_1_enable',
      'defaultMessage': 'Auto Degass Start 1 - enable'
    },
    history_parameters_superior_auto_degass_start_1_hour: {
      'id': 'history_parameters_superior_auto_degass_start_1_hour',
      'defaultMessage': 'Auto Degass Start 1 - hour'
    },
    history_parameters_superior_auto_degass_start_1_minute: {
      'id': 'history_parameters_superior_auto_degass_start_1_minute',
      'defaultMessage': 'Auto Degass Start 1 - minute'
    },
    history_parameters_superior_auto_degass_stop_1_enable: {
      'id': 'history_parameters_superior_auto_degass_stop_1_enable',
      'defaultMessage': 'Auto Degass Stop 1 - enable'
    },
    history_parameters_superior_auto_degass_stop_1_hour: {
      'id': 'history_parameters_superior_auto_degass_stop_1_hour',
      'defaultMessage': 'Auto Degass Stop 1 - hour'
    },
    history_parameters_superior_auto_degass_stop_1_minute: {
      'id': 'history_parameters_superior_auto_degass_stop_1_minute',
      'defaultMessage': 'Auto Degass Stop 1 - minute'
    },
    history_parameters_superior_auto_degass_start_2_enable: {
      'id': 'history_parameters_superior_auto_degass_start_2_enable',
      'defaultMessage': 'Auto Degass Start 2 - enable'
    },
    history_parameters_superior_auto_degass_start_2_hour: {
      'id': 'history_parameters_superior_auto_degass_start_2_hour',
      'defaultMessage': 'Auto Degass Start 2 - hour'
    },
    history_parameters_superior_auto_degass_start_2_minute: {
      'id': 'history_parameters_superior_auto_degass_start_2_minute',
      'defaultMessage': 'Auto Degass Start 2 - minute'
    },
    history_parameters_superior_auto_degass_stop_2_enable: {
      'id': 'history_parameters_superior_auto_degass_stop_2_enable',
      'defaultMessage': 'Auto Degass Stop 2 - enable'
    },
    history_parameters_superior_auto_degass_stop_2_hour: {
      'id': 'history_parameters_superior_auto_degass_stop_2_hour',
      'defaultMessage': 'Auto Degass Stop 2 - hour'
    },
    history_parameters_superior_auto_degass_stop_2_minute: {
      'id': 'history_parameters_superior_auto_degass_stop_2_minute',
      'defaultMessage': 'Auto Degass Stop 2 - minute'
    },
    history_parameters_superior_degass_block: {
      'id': 'history_parameters_superior_degass_block',
      'defaultMessage': 'Degassing blocking weekday'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParameterRow.js
var HistoryParameterRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HistoryParameterRow__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryParameterRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryParameterRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryParameterRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryParameterRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var HistoryParameterRow_HistoryParametersRow = function (_React$Component) {
  HistoryParameterRow__inherits(HistoryParametersRow, _React$Component);

  function HistoryParametersRow() {
    var _ref;

    var _temp, _this, _ret;

    HistoryParameterRow__classCallCheck(this, HistoryParametersRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryParameterRow__possibleConstructorReturn(this, (_ref = HistoryParametersRow.__proto__ || Object.getPrototypeOf(HistoryParametersRow)).call.apply(_ref, [this].concat(args))), _this), _this.getColumnVisibilityByIndex = function (index, documentSoftenerFilter, documentSuperiorFilter, deviceType) {
      var values = [];
      var ret = 0;
      switch (deviceType) {
        case 'charlie':
        case 'softener':
        case 'simplex':
          values = [documentSoftenerFilter.get('date'), documentSoftenerFilter.get('time'), documentSoftenerFilter.get('language'), documentSoftenerFilter.get('unit_water_hardness'), documentSoftenerFilter.get('water_pressure'), documentSoftenerFilter.get('pressure_sensor'), documentSoftenerFilter.get('chlorine_generator'), documentSoftenerFilter.get('reserve_period'), documentSoftenerFilter.get('reg_period'), documentSoftenerFilter.get('days_of_regeneration'), documentSoftenerFilter.get('outlet_water_hardness'), documentSoftenerFilter.get('intlet_water_hardness'), documentSoftenerFilter.get('regenerant_dose'), documentSoftenerFilter.get('resin_volume'), documentSoftenerFilter.get('reserve_type'), documentSoftenerFilter.get('percentage_of_reserve'), documentSoftenerFilter.get('regeneration_time'), documentSoftenerFilter.get('average_water_used'), documentSoftenerFilter.get('ferrum_content'), documentSoftenerFilter.get('type_of_regeneration'), documentSoftenerFilter.get('cancel_vacation_mode'), documentSoftenerFilter.get('backwash'), documentSoftenerFilter.get('rapid_rinsing'), documentSoftenerFilter.get('dhcp_client'), documentSoftenerFilter.get('ip_address'), documentSoftenerFilter.get('subnet_mask'), documentSoftenerFilter.get('default_gateway'), documentSoftenerFilter.get('dns_server'), documentSoftenerFilter.get('timezone'), documentSoftenerFilter.get('device_type')];
          ret = values[index];
          break;
        case 'superior':
          values = [documentSuperiorFilter.get('date'), documentSuperiorFilter.get('time'), documentSuperiorFilter.get('language'), documentSuperiorFilter.get('device_type'), documentSuperiorFilter.get('auto_degass_start_1_enable'), documentSuperiorFilter.get('auto_degass_start_1_hour'), documentSuperiorFilter.get('auto_degass_start_1_minute'), documentSuperiorFilter.get('auto_degass_stop_1_enable'), documentSuperiorFilter.get('auto_degass_stop_1_hour'), documentSuperiorFilter.get('auto_degass_stop_1_minute'), documentSuperiorFilter.get('auto_degass_start_2_enable'), documentSuperiorFilter.get('auto_degass_start_2_hour'), documentSuperiorFilter.get('auto_degass_start_2_minute'), documentSuperiorFilter.get('auto_degass_stop_2_enable'), documentSuperiorFilter.get('auto_degass_stop_2_hour'), documentSuperiorFilter.get('auto_degass_stop_2_minute'), documentSuperiorFilter.get('degassblock')];
          ret = values[index];
          break;
        default:
          break;
      }
      return ret;
    }, _this.showBox = function (element, index, messages, deviceType, intl) {
      var visible = _this.getColumnVisibilityByIndex(index, _this.props.documentSoftenerFilter, _this.props.documentSuperiorFilter, deviceType);
      var value = element.get(0);
      var isChanged = element.get(1);
      var wrappedStyle = classnames_default()();
      switch (deviceType) {
        case 'charlie':
        case 'softener':
        case 'simplex':
          wrappedStyle = isChanged ? classnames_default()(HistoryParameters_default.a.red, HistoryParameters_default.a.row_container, HistoryParameters_default.a.data_color, HistoryParameters_default.a.center) : classnames_default()(HistoryParameters_default.a.row_container, HistoryParameters_default.a.data_color, HistoryParameters_default.a.center);
          break;
        case 'superior':
          wrappedStyle = isChanged ? classnames_default()(HistoryParameters_default.a.red, HistoryParameters_default.a.row_container, HistoryParameters_default.a.spirotech_data_color, HistoryParameters_default.a.center) : classnames_default()(HistoryParameters_default.a.row_container, HistoryParameters_default.a.spirotech_data_color, HistoryParameters_default.a.center);
          break;
        default:
          break;
      }
      if (visible) {
        if (deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex') {
          if (index === 5 || index === 6 || index === 19) {
            return HistoryParameterRow__jsx('td', {
              className: wrappedStyle
            }, index, HistoryParameterRow__jsx('button', {
              className: HistoryParameters_default.a.button,
              onClick: _this.props.onClick
            }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[value])));
          } else if (index === 9) {
            var retValue = '';
            if (value !== '') {
              var days = value.split(',');
              for (var i = 0; i < days.length; i += 1) {
                if (retValue === '') {
                  retValue += intl.formatMessage(HistoryParameterRow__extends({}, messages[days[i]]));
                } else {
                  retValue += ', ' + intl.formatMessage(HistoryParameterRow__extends({}, messages[days[i]]));
                }
              }
            }
            return HistoryParameterRow__jsx('td', {
              className: wrappedStyle
            }, index, HistoryParameterRow__jsx('button', {
              className: HistoryParameters_default.a.button,
              onClick: _this.props.onClick
            }, void 0, retValue));
          }
          return HistoryParameterRow__jsx('td', {
            className: wrappedStyle
          }, index, value);
        } else if (deviceType === 'superior') {
          return HistoryParameterRow__jsx('td', {
            className: wrappedStyle
          }, index, value);
        }
      }
      return null;
    }, _temp), HistoryParameterRow__possibleConstructorReturn(_this, _ret);
  }

  HistoryParameterRow__createClass(HistoryParametersRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = HistoryParameters_Messages_Messages();
      var _props = this.props,
          row = _props.row,
          deviceType = _props.deviceType,
          intl = _props.intl;

      if (typeof row !== 'undefined') {
        return HistoryParameterRow__jsx('tr', {
          className: HistoryParameters_default.a.row_container
        }, void 0, row.map(function (element, ind) {
          return _this2.showBox(element, ind, messages, deviceType, intl);
        }));
      }
      return null;
    }
  }]);

  return HistoryParametersRow;
}(react_default.a.Component);

/* harmony default export */ var HistoryParameterRow = (Object(index_es["g" /* injectIntl */])(withStyles_default()(HistoryParameters_default.a)(HistoryParameterRow_HistoryParametersRow)));
// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryMessages.js


function getDataSuperior() {
  var messages = HistoryParameters_Messages_Messages();
  var data = [{
    text: messages.history_parameters_superior_date,
    name: 'date'
  }, {
    text: messages.history_parameters_superior_time,
    name: 'time'
  }, {
    text: messages.history_parameters_superior_language,
    name: 'language'
  }, {
    text: messages.history_parameters_superior_device_type,
    name: 'device_type'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_1_enable,
    name: 'auto_degass_start_1_enable'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_1_hour,
    name: 'auto_degass_start_1_hour'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_1_minute,
    name: 'auto_degass_start_1_minute'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_1_enable,
    name: 'auto_degass_stop_1_enable'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_1_hour,
    name: 'auto_degass_stop_1_hour'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_1_minute,
    name: 'auto_degass_stop_1_minute'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_2_enable,
    name: 'auto_degass_start_2_enable'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_2_hour,
    name: 'auto_degass_start_2_hour'
  }, {
    text: messages.history_parameters_superior_auto_degass_start_2_minute,
    name: 'auto_degass_start_2_minute'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_2_enable,
    name: 'auto_degass_stop_2_enable'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_2_hour,
    name: 'auto_degass_stop_2_hour'
  }, {
    text: messages.history_parameters_superior_auto_degass_stop_2_minute,
    name: 'auto_degass_stop_2_minute'
  }, {
    text: messages.history_parameters_superior_degass_block,
    name: 'degass_block'
  }];
  return data;
}

function getDataSoftener() {
  var messages = HistoryParameters_Messages_Messages();
  var data = [{
    text: messages.history_parameters_date,
    name: 'date'
  }, {
    text: messages.history_parameters_time,
    name: 'time'
  }, {
    text: messages.history_parameters_language,
    name: 'language'
  }, {
    text: messages.history_parameters_unit_water_hardness,
    name: 'unit_water_hardness'
  }, {
    text: messages.history_parameters_water_pressure,
    name: 'water_pressure'
  }, {
    text: messages.history_parameters_pressure_sensor,
    name: 'pressure_sensor'
  }, {
    text: messages.history_parameters_chlorine_generator,
    name: 'chlorine_generator'
  }, {
    text: messages.history_parameters_reserve_period,
    name: 'reserve_period'
  }, {
    text: messages.history_parameters_reg_period,
    name: 'reg_period'
  }, {
    text: messages.history_parameters_days_of_regeneration,
    name: 'days_of_regeneration'
  }, {
    text: messages.history_parameters_outlet_water_hardness,
    name: 'outlet_water_hardness'
  }, {
    text: messages.history_parameters_intlet_water_hardness,
    name: 'intlet_water_hardness'
  }, {
    text: messages.history_parameters_regenerant_dose,
    name: 'regenerant_dose'
  }, {
    text: messages.history_parameters_resin_volume,
    name: 'resin_volume'
  }, {
    text: messages.history_parameters_reserve_type,
    name: 'reserve_type'
  }, {
    text: messages.history_parameters_percentage_of_reserve,
    name: 'percentage_of_reserve'
  }, {
    text: messages.history_parameters_regeneration_time,
    name: 'regeneration_time'
  }, {
    text: messages.history_parameters_average_water_used,
    name: 'average_water_used'
  }, {
    text: messages.history_parameters_ferrum_content,
    name: 'ferrum_content'
  }, {
    text: messages.history_parameters_type_of_regeneration,
    name: 'type_of_regeneration'
  }, {
    text: messages.history_parameters_cancel_vacation_mode,
    name: 'cancel_vacation_mode'
  }, {
    text: messages.history_parameters_backwash,
    name: 'backwash'
  }, {
    text: messages.history_parameters_rapid_rinsing,
    name: 'rapid_rinsing'
  }, {
    text: messages.history_parameters_dhcp_client,
    name: 'dhcp_client'
  }, {
    text: messages.history_parameters_ip_address,
    name: 'ip_address'
  }, {
    text: messages.history_parameters_subnet_mask,
    name: 'subnet_mask'
  }, {
    text: messages.history_parameters_default_gateway,
    name: 'default_gateway'
  }, {
    text: messages.history_parameters_dns_server,
    name: 'dns_server'
  }, {
    text: messages.history_parameters_timezone,
    name: 'timezone'
  }, {
    text: messages.history_parameters_device_type,
    name: 'device_type'
  }];
  return data;
}
// EXTERNAL MODULE: ./src/components/HistoryParameters/HistoryParametersFilterbox.css
var HistoryParameters_HistoryParametersFilterbox = __webpack_require__(1099);
var HistoryParametersFilterbox_default = /*#__PURE__*/__webpack_require__.n(HistoryParameters_HistoryParametersFilterbox);

// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParametersFilterboxView.js
var HistoryParametersFilterboxView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryParametersFilterboxView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryParametersFilterboxView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryParametersFilterboxView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryParametersFilterboxView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var HistoryParametersFilterboxView_HistoryParametersFilterbox = function (_React$Component) {
  HistoryParametersFilterboxView__inherits(HistoryParametersFilterbox, _React$Component);

  function HistoryParametersFilterbox() {
    var _ref;

    var _temp, _this, _ret;

    HistoryParametersFilterboxView__classCallCheck(this, HistoryParametersFilterbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryParametersFilterboxView__possibleConstructorReturn(this, (_ref = HistoryParametersFilterbox.__proto__ || Object.getPrototypeOf(HistoryParametersFilterbox)).call.apply(_ref, [this].concat(args))), _this), _this.setFilter = function (name, deviceType) {
      _this.props.setDeviceDocumentFilter('parameters', name, deviceType);
    }, _this.setColumnFilter = function (name, deviceType) {
      _this.props.setDeviceDocumentColumnFilter('parameters', name, deviceType);
    }, _this.getElement = function (item, index, deviceType, filter) {
      var value = filter.get(item.name);
      var checked = +value === 1;
      return HistoryParametersFilterboxView__jsx('div', {}, index, HistoryParametersFilterboxView__jsx('input', {
        type: 'checkbox',
        name: item.name,
        value: value,
        onChange: _this.setFilter.bind(_this, item.name, deviceType),
        checked: checked
      }), HistoryParametersFilterboxView__jsx('label', {
        htmlFor: item.name
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text)));
    }, _this.getColumnHeader = function (item, index, deviceType, filter) {
      var value = filter.get(item.name);
      var checked = +value === 1;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          return HistoryParametersFilterboxView__jsx('th', {
            className: classnames_default()(HistoryParametersFilterbox_default.a.header)
          }, index, HistoryParametersFilterboxView__jsx('input', {
            type: 'checkbox',
            name: item.name,
            value: value,
            onChange: _this.setColumnFilter.bind(_this, item.name, deviceType),
            checked: checked
          }), react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
        case 'superior':
          return HistoryParametersFilterboxView__jsx('th', {
            className: classnames_default()(HistoryParametersFilterbox_default.a.spirotech)
          }, index, HistoryParametersFilterboxView__jsx('input', {
            type: 'checkbox',
            name: item.name,
            value: value,
            onChange: _this.setColumnFilter.bind(_this, item.name, deviceType),
            checked: checked
          }), react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
        default:
          break;
      }
      return null;
    }, _this.getColumn = function (column, index, deviceType, columnStyle, filter) {
      return HistoryParametersFilterboxView__jsx('td', {
        className: columnStyle
      }, index, HistoryParametersFilterboxView__jsx('span', {}, void 0, column.map(function (item, ind) {
        return _this.getElement(item, ind, deviceType, filter);
      })));
    }, _this.getDataSoftener = function (softenerFilterDocument, messages) {
      var data = [[{
        text: messages.history_parameters_date,
        name: 'date'
      }, {
        text: messages.history_parameters_time,
        name: 'time'
      }, {
        text: messages.history_parameters_language,
        name: 'language'
      }, {
        text: messages.history_parameters_unit_water_hardness,
        name: 'unit_water_hardness'
      }, {
        text: messages.history_parameters_water_pressure,
        name: 'water_pressure'
      }, {
        text: messages.history_parameters_pressure_sensor,
        name: 'pressure_sensor'
      }, {
        text: messages.history_parameters_chlorine_generator,
        name: 'chlorine_generator'
      }, {
        text: messages.history_parameters_reserve_period,
        name: 'reserve_period'
      }], [{
        text: messages.history_parameters_reg_period,
        name: 'reg_period'
      }, {
        text: messages.history_parameters_days_of_regeneration,
        name: 'days_of_regeneration'
      }, {
        text: messages.history_parameters_outlet_water_hardness,
        name: 'outlet_water_hardness'
      }, {
        text: messages.history_parameters_intlet_water_hardness,
        name: 'intlet_water_hardness'
      }, {
        text: messages.history_parameters_regenerant_dose,
        name: 'regenerant_dose'
      }, {
        text: messages.history_parameters_resin_volume,
        name: 'resin_volume'
      }, {
        text: messages.history_parameters_reserve_type,
        name: 'reserve_type'
      }], [{
        text: messages.history_parameters_percentage_of_reserve,
        name: 'percentage_of_reserve'
      }, {
        text: messages.history_parameters_regeneration_time,
        name: 'regeneration_time'
      }, {
        text: messages.history_parameters_average_water_used,
        name: 'average_water_used'
      }, {
        text: messages.history_parameters_ferrum_content,
        name: 'ferrum_content'
      }, {
        text: messages.history_parameters_type_of_regeneration,
        name: 'type_of_regeneration'
      }, {
        text: messages.history_parameters_cancel_vacation_mode,
        name: 'cancel_vacation_mode'
      }], [{
        text: messages.history_parameters_backwash,
        name: 'backwash'
      }, {
        text: messages.history_parameters_rapid_rinsing,
        name: 'rapid_rinsing'
      }, {
        text: messages.history_parameters_dhcp_client,
        name: 'dhcp_client'
      }, {
        text: messages.history_parameters_ip_address,
        name: 'ip_address'
      }, {
        text: messages.history_parameters_subnet_mask,
        name: 'subnet_mask'
      }, {
        text: messages.history_parameters_default_gateway,
        name: 'default_gateway'
      }, {
        text: messages.history_parameters_dns_server,
        name: 'dns_server'
      }, {
        text: messages.history_parameters_timezone,
        name: 'timezone'
      }, {
        text: messages.history_parameters_device_type,
        name: 'device_type'
      }]];
      return data;
    }, _this.getDataSuperior = function (superiorFilterDocument, messages) {
      var data = [[{
        text: messages.history_parameters_superior_date,
        name: 'date'
      }, {
        text: messages.history_parameters_superior_time,
        name: 'time'
      }, {
        text: messages.history_parameters_superior_language,
        name: 'language'
      }, {
        text: messages.history_parameters_superior_device_type,
        name: 'device_type'
      }], [{
        text: messages.history_parameters_superior_auto_degass_start_1_enable,
        name: 'auto_degass_start_1_enable'
      }, {
        text: messages.history_parameters_superior_auto_degass_start_1_hour,
        name: 'auto_degass_start_1_hour'
      }, {
        text: messages.history_parameters_superior_auto_degass_start_1_minute,
        name: 'auto_degass_start_1_minute'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_1_enable,
        name: 'auto_degass_stop_1_enable'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_1_hour,
        name: 'auto_degass_stop_1_hour'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_1_minute,
        name: 'auto_degass_stop_1_minute'
      }], [{
        text: messages.history_parameters_superior_auto_degass_start_2_enable,
        name: 'auto_degass_start_2_enable'
      }, {
        text: messages.history_parameters_superior_auto_degass_start_2_hour,
        name: 'auto_degass_start_2_hour'
      }, {
        text: messages.history_parameters_superior_auto_degass_start_2_minute,
        name: 'auto_degass_start_2_minute'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_2_enable,
        name: 'auto_degass_stop_2_enable'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_2_hour,
        name: 'auto_degass_stop_2_hour'
      }, {
        text: messages.history_parameters_superior_auto_degass_stop_2_minute,
        name: 'auto_degass_stop_2_minute'
      }], [{
        text: messages.history_parameters_superior_degass_block,
        name: 'degass_block'
      }]];
      return data;
    }, _this.getData = function (messages, deviceType) {
      var _this$props = _this.props,
          documentSoftenerFilter = _this$props.documentSoftenerFilter,
          documentSuperiorFilter = _this$props.documentSuperiorFilter;

      var data = [];
      var filter = null;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = _this.getDataSoftener(documentSoftenerFilter, messages);
          filter = documentSoftenerFilter;
          break;
        case 'superior':
          data = _this.getDataSuperior(documentSuperiorFilter, messages);
          filter = documentSuperiorFilter;
          break;
        default:
          break;
      }
      return { data: data, filter: filter };
    }, _this.getHeaderData = function (messages, deviceType) {
      var data = [];
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = [{
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters0'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters1'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters2'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters3'
          }];
          break;
        case 'superior':
          data = [{
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters0'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters1'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters2'
          }, {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters3'
          }];
          break;
        default:
          break;
      }
      return data;
    }, _this.getColumnStyle = function (deviceType) {
      var columnStyle = classnames_default()();
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          columnStyle = classnames_default()(HistoryParametersFilterbox_default.a.column_softener, HistoryParametersFilterbox_default.a.table_border);
          break;
        case 'superior':
          columnStyle = classnames_default()(HistoryParametersFilterbox_default.a.column_superior, HistoryParametersFilterbox_default.a.table_border);
          break;
        default:
          break;
      }
      return columnStyle;
    }, _temp), HistoryParametersFilterboxView__possibleConstructorReturn(_this, _ret);
  }

  HistoryParametersFilterboxView__createClass(HistoryParametersFilterbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = HistoryParameters_Messages_Messages();
      var deviceDocument = this.props.deviceDocument;

      var deviceType = deviceDocument.get('deviceType');

      var _getData = this.getData(messages, deviceType),
          data = _getData.data,
          filter = _getData.filter;

      var columnStyle = this.getColumnStyle(deviceType);
      var headerData = this.getHeaderData(messages, deviceType);

      return HistoryParametersFilterboxView__jsx('table', {
        className: HistoryParametersFilterbox_default.a.Table_container
      }, void 0, HistoryParametersFilterboxView__jsx('thead', {}, void 0, HistoryParametersFilterboxView__jsx('tr', {}, void 0, headerData.map(function (item, index) {
        return _this2.getColumnHeader(item, index, deviceType, filter);
      }))), HistoryParametersFilterboxView__jsx('tbody', {}, void 0, HistoryParametersFilterboxView__jsx('tr', {}, void 0, data.map(function (item, index) {
        return _this2.getColumn(item, index, deviceType, columnStyle, filter);
      }))));
    }
  }]);

  return HistoryParametersFilterbox;
}(react_default.a.Component);

/* harmony default export */ var HistoryParametersFilterboxView = (withStyles_default()(HistoryParametersFilterbox_default.a)(HistoryParametersFilterboxView_HistoryParametersFilterbox));
// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParametersFilterbox.js
var HistoryParametersFilterbox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function HistoryParametersFilterbox_HistoryParametersFilterbox(props) {
  return HistoryParametersFilterbox__jsx(HistoryParametersFilterboxView, {
    documentSoftenerFilter: props.documentSoftenerFilter,
    documentSuperiorFilter: props.documentSuperiorFilter,
    setDeviceDocumentFilter: props.setDeviceDocumentFilter,
    setDeviceDocumentColumnFilter: props.setDeviceDocumentColumnFilter,
    deviceDocument: props.deviceDocument
  });
}

var HistoryParametersFilterbox_mapState = function mapState(state) {
  return {
    documentSoftenerFilter: state.softenerParametersFilter,
    documentSuperiorFilter: state.superiorParametersFilter
  };
};

var HistoryParametersFilterbox_mapDispatch = function mapDispatch(dispatch) {
  return {
    setDeviceDocumentFilter: function setDeviceDocumentFilter(documentType, name, deviceType) {
      return dispatch(documents_setDeviceDocumentFilter(documentType, name, deviceType));
    },
    setDeviceDocumentColumnFilter: function setDeviceDocumentColumnFilter(documentType, name, deviceType) {
      return dispatch(documents_setDeviceDocumentColumnFilter(documentType, name, deviceType));
    }
  };
};

/* harmony default export */ var components_HistoryParameters_HistoryParametersFilterbox = (Object(es["b" /* connect */])(HistoryParametersFilterbox_mapState, HistoryParametersFilterbox_mapDispatch)(HistoryParametersFilterbox_HistoryParametersFilterbox));
// EXTERNAL MODULE: ./src/components/HistoryParameters/HistoryParametersHeader.css
var HistoryParameters_HistoryParametersHeader = __webpack_require__(1101);
var HistoryParametersHeader_default = /*#__PURE__*/__webpack_require__.n(HistoryParameters_HistoryParametersHeader);

// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParametersHeader.js
var HistoryParametersHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryParametersHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryParametersHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryParametersHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryParametersHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var HistoryParametersHeader__ref2 = HistoryParametersHeader__jsx(Loader["a" /* default */], {});

var HistoryParametersHeader__ref3 = HistoryParametersHeader__jsx(Loader["a" /* default */], {});

var HistoryParametersHeader_HistoryParametersHeader = function (_React$Component) {
  HistoryParametersHeader__inherits(HistoryParametersHeader, _React$Component);

  function HistoryParametersHeader() {
    var _ref;

    var _temp, _this, _ret;

    HistoryParametersHeader__classCallCheck(this, HistoryParametersHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryParametersHeader__possibleConstructorReturn(this, (_ref = HistoryParametersHeader.__proto__ || Object.getPrototypeOf(HistoryParametersHeader)).call.apply(_ref, [this].concat(args))), _this), _this.getHeaderColor = function (deviceType) {
      var isSuperior = deviceType === 'superior';
      var colorStyled = isSuperior ? classnames_default()(HistoryParametersHeader_default.a.blackButton) : classnames_default()(HistoryParametersHeader_default.a.whiteButton);
      var dark = isSuperior ? "dark_spirotech" : "dark";
      var light = isSuperior ? "light_spirotech" : "light";
      var edytuj = isSuperior ? "edytuj_black" : "edytuj";
      var clearFilter = isSuperior ? 'odrzuc' : 'odrzuc_white';
      return { colorStyled: colorStyled, dark: dark, light: light, edytuj: edytuj, clearFilter: clearFilter };
    }, _temp), HistoryParametersHeader__possibleConstructorReturn(_this, _ret);
  }

  HistoryParametersHeader__createClass(HistoryParametersHeader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          deviceType = _props.deviceType,
          deviceDocumentPaging = _props.deviceDocumentPaging,
          deviceName = _props.deviceName,
          deviceSerial = _props.deviceSerial;

      var messages = HistoryParameters_Messages_Messages();
      var iconSize = 41;

      var _getHeaderColor = this.getHeaderColor(deviceType),
          colorStyled = _getHeaderColor.colorStyled,
          dark = _getHeaderColor.dark,
          light = _getHeaderColor.light,
          edytuj = _getHeaderColor.edytuj,
          clearFilter = _getHeaderColor.clearFilter;

      var downloadingDocument = deviceDocumentPaging.get('downloadingDocument');

      return HistoryParametersHeader__jsx('section', {
        className: HistoryParametersHeader_default.a.container
      }, void 0, HistoryParametersHeader__jsx('div', {
        className: HistoryParametersHeader_default.a.left
      }, void 0, HistoryParametersHeader__jsx('h3', {}, void 0, deviceName, ' S/N: ', deviceSerial)), HistoryParametersHeader__jsx('div', {
        className: HistoryParametersHeader_default.a.right
      }, void 0, HistoryParametersHeader__jsx(Button["a" /* default */], {
        onClick: function onClick() {
          if (!downloadingDocument) {
            _this2.props.onSave();
          }
        },
        buttonClass: 'mainPdf',
        buttonColor: dark
      }, void 0, HistoryParametersHeader__jsx(Icon["a" /* default */], {
        iconName: edytuj,
        size: iconSize
      }), HistoryParametersHeader__jsx('div', {
        className: colorStyled
      }, void 0, !downloadingDocument ? react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.save_as_pdf_button_history) : HistoryParametersHeader__ref2)), HistoryParametersHeader__jsx(Button["a" /* default */], {
        onClick: function onClick() {
          _this2.props.onClearFilter();
        },
        buttonClass: 'mainPdf',
        buttonColor: light
      }, void 0, HistoryParametersHeader__jsx(Icon["a" /* default */], {
        iconName: clearFilter,
        size: iconSize
      }), HistoryParametersHeader__jsx('div', {
        className: colorStyled
      }, void 0, !downloadingDocument ? react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.clear_filter_button_history) : HistoryParametersHeader__ref3))));
    }
  }]);

  return HistoryParametersHeader;
}(react_default.a.Component);

/* harmony default export */ var components_HistoryParameters_HistoryParametersHeader = (withStyles_default()(HistoryParametersHeader_default.a)(HistoryParametersHeader_HistoryParametersHeader));
// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParametersView.js
var HistoryParametersView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryParametersView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryParametersView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryParametersView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryParametersView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var HistoryParametersView__ref2 = HistoryParametersView__jsx(Loader["a" /* default */], {
  block: true
});

var HistoryParametersView_HistoryParametersView = function (_React$Component) {
  HistoryParametersView__inherits(HistoryParametersView, _React$Component);

  function HistoryParametersView() {
    var _ref;

    var _temp, _this, _ret;

    HistoryParametersView__classCallCheck(this, HistoryParametersView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryParametersView__possibleConstructorReturn(this, (_ref = HistoryParametersView.__proto__ || Object.getPrototypeOf(HistoryParametersView)).call.apply(_ref, [this].concat(args))), _this), _this.getHeader = function (deviceDocument, softenerFilterDocument, superiorFilterDocument) {
      var deviceType = deviceDocument.get('deviceType');
      var data = [];
      var filter = null;
      switch (deviceType) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          data = getDataSoftener();
          filter = softenerFilterDocument;
          break;
        case 'superior':
          data = getDataSuperior();
          filter = superiorFilterDocument;
          break;
        default:
          break;
      }

      return HistoryParametersView__jsx('tr', {}, void 0, data.map(function (item, index) {
        return _this.showBox(item, index, filter, deviceType);
      }));
    }, _this.showBox = function (item, index, filter, deviceType) {
      var value = filter.get(item.name);
      if (+value === 1) {
        switch (deviceType) {
          case 'softener':
          case 'charlie':
          case 'simplex':
            return HistoryParametersView__jsx('th', {
              className: classnames_default()(HistoryParameters_default.a.row_container, HistoryParameters_default.a.header_color)
            }, index, react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
          case 'superior':
            return HistoryParametersView__jsx('th', {
              className: classnames_default()(HistoryParameters_default.a.row_container, HistoryParameters_default.a.spirotech_header_color)
            }, index, react_default.a.createElement(index_es["b" /* FormattedMessage */], item.text));
          default:
            return null;
        }
      }
      return null;
    }, _this.onClick = function () {}, _temp), HistoryParametersView__possibleConstructorReturn(_this, _ret);
  }

  HistoryParametersView__createClass(HistoryParametersView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          deviceDocument = _props.deviceDocument,
          documentSoftenerFilter = _props.documentSoftenerFilter,
          documentSuperiorFilter = _props.documentSuperiorFilter,
          deviceDocumentPaging = _props.deviceDocumentPaging;

      var rowsData = deviceDocument && deviceDocument.get('rowsData');
      var requestInProgress = deviceDocument && deviceDocument.get('requestInProgress');
      if (deviceDocument !== 'undefined' && deviceDocument.get('serial') !== null && +deviceDocument.get('documentType') === 2) {
        if (!requestInProgress && rowsData) {
          return HistoryParametersView__jsx(Popup_PopupOverview, {
            className: HistoryParameters_default.a.Popup__editdevice,
            onClose: this.props.onClose,
            deviceType: deviceDocument.get('deviceType'),
            overrideOnClose: true
          }, void 0, HistoryParametersView__jsx(components_HistoryParameters_HistoryParametersFilterbox, {
            documentSoftenerFilter: documentSoftenerFilter,
            documentSuperiorFilter: documentSuperiorFilter,
            deviceDocument: deviceDocument
          }), HistoryParametersView__jsx(components_HistoryParameters_HistoryParametersHeader, {
            onSave: this.props.onSavePDF,
            onClearFilter: this.props.onClearFilter,
            deviceType: deviceDocument.get('deviceType'),
            deviceName: deviceDocument.get('deviceName'),
            deviceSerial: deviceDocument.get('serial'),
            deviceDocumentPaging: deviceDocumentPaging
          }), HistoryParametersView__jsx('table', {
            className: HistoryParameters_default.a.Table_container
          }, void 0, HistoryParametersView__jsx('thead', {}, void 0, this.getHeader(deviceDocument, documentSoftenerFilter, documentSuperiorFilter)), HistoryParametersView__jsx('tbody', {}, void 0, rowsData.map(function (row, index) {
            return HistoryParametersView__jsx(HistoryParameterRow, {
              row: row,
              documentSoftenerFilter: documentSoftenerFilter,
              documentSuperiorFilter: documentSuperiorFilter,
              deviceType: deviceDocument.get('deviceType'),
              onClick: _this2.onClick
            }, index);
          }))));
        }
        return HistoryParametersView__jsx(Popup_PopupOverview, {
          className: HistoryParameters_default.a.Popup__editdevice,
          onClose: this.props.onClose,
          overrideOnClose: true
        }, void 0, HistoryParametersView__ref2);
      }
      return null;
    }
  }]);

  return HistoryParametersView;
}(react_default.a.Component);

/* harmony default export */ var HistoryParameters_HistoryParametersView = (withStyles_default()(HistoryParameters_default.a)(HistoryParametersView_HistoryParametersView));
// CONCATENATED MODULE: ./src/components/HistoryParameters/HistoryParameters.js
var HistoryParameters__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HistoryParameters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HistoryParameters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HistoryParameters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HistoryParameters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var HistoryParameters_HistoryParameters_HistoryParameters = function (_React$Component) {
  HistoryParameters__inherits(HistoryParameters, _React$Component);

  function HistoryParameters() {
    var _ref;

    var _temp, _this, _ret;

    HistoryParameters__classCallCheck(this, HistoryParameters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HistoryParameters__possibleConstructorReturn(this, (_ref = HistoryParameters.__proto__ || Object.getPrototypeOf(HistoryParameters)).call.apply(_ref, [this].concat(args))), _this), _this.getFilter = function (deviceDocument) {
      var filter = {};
      switch (deviceDocument.get('deviceType')) {
        case 'softener':
        case 'charlie':
        case 'simplex':
          filter = _this.props.documentSoftenerFilter;
          break;
        case 'superior':
          filter = _this.props.documentSuperiorFilter;
          break;
        default:
          break;
      }
      return filter;
    }, _this.onSavePDF = function () {
      var deviceDocument = _this.props.deviceDocument;
      var filter = _this.getFilter(deviceDocument);
      _this.props.downloadDeviceDocument(deviceDocument.get('serial'), deviceDocument.get('documentName'), JSON.stringify(filter));
    }, _this.onClearFilter = function () {
      var deviceDocument = _this.props.deviceDocument;
      _this.props.clearDocumentFilter('parameters', deviceDocument.get('deviceType'));
    }, _this.closePopup = function () {
      var deviceDocument = _this.props.deviceDocument;
      _this.props.clearDeviceDocument();
      _this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
    }, _temp), HistoryParameters__possibleConstructorReturn(_this, _ret);
  }

  HistoryParameters__createClass(HistoryParameters, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var documentValue = this.props.deviceDocument;
      if (typeof documentValue !== 'undefined' && documentValue.get('serial') !== null) {
        this.props.getDeviceDocumentById(documentValue.get('serial'), documentValue.get('documentName'), {}, 1, 10000);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      var isUpdatedDocument = newProps.deviceDocument.get('serial') !== this.props.deviceDocument.get('serial');
      if (isUpdatedDocument && newProps.deviceDocument.get('serial') !== null && +newProps.deviceDocument.get('documentType') === 2) {
        this.props.getDeviceDocumentById(newProps.deviceDocument.get('serial'), newProps.deviceDocument.get('documentName'), {}, 1, 10000);
      }
      return true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var deviceDocument = this.props.deviceDocument;
      this.props.clearDeviceDocument();
      this.props.clearDocumentFilter('parameters', deviceDocument.get('deviceType'));
    }
  }, {
    key: 'render',
    value: function render() {
      return HistoryParameters__jsx(HistoryParameters_HistoryParametersView, {
        deviceDocument: this.props.deviceDocument,
        documentSoftenerFilter: this.props.documentSoftenerFilter,
        documentSuperiorFilter: this.props.documentSuperiorFilter,
        downloadDeviceDocument: this.props.downloadDeviceDocument,
        deviceDocumentPaging: this.props.deviceDocumentPaging,
        onClose: this.closePopup,
        onSavePDF: this.onSavePDF,
        onClearFilter: this.onClearFilter
      });
    }
  }]);

  return HistoryParameters;
}(react_default.a.Component);

var HistoryParameters_mapState = function mapState(state) {
  return {
    deviceDocument: state.deviceDocument,
    deviceDocumentPaging: state.deviceDocumentPaging,
    documentSoftenerFilter: state.softenerParametersFilter,
    documentSuperiorFilter: state.superiorParametersFilter
  };
};

var HistoryParameters_mapDispatch = function mapDispatch(dispatch) {
  return {
    getDeviceDocumentById: function getDeviceDocumentById(serial, documentId, filteData, page, pageSize) {
      return dispatch(documents_getDeviceDocumentById(serial, documentId, filteData, page, pageSize));
    },
    clearDeviceDocument: function clearDeviceDocument() {
      return dispatch(documents_clearDeviceDocument());
    },
    downloadDeviceDocument: function downloadDeviceDocument(serial, documentId, filter) {
      return dispatch(documents_downloadDeviceDocument(serial, documentId, filter));
    },
    clearDocumentFilter: function clearDocumentFilter(deviceType, documentType) {
      return dispatch(documents_clearDocumentFilter(deviceType, documentType));
    }
  };
};

/* harmony default export */ var components_HistoryParameters_HistoryParameters = (Object(es["b" /* connect */])(HistoryParameters_mapState, HistoryParameters_mapDispatch)(HistoryParameters_HistoryParameters_HistoryParameters));
// CONCATENATED MODULE: ./src/components/ConversationPopup/Messages.js


function ConversationPopup_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    messages_mark_as_read: {
      'id': 'messages_mark_as_read',
      'defaultMessage': 'Mark all new messages as read'
    },
    messages_group_title: {
      'id': 'messages_group_title',
      'defaultMessage': 'Messages'
    },
    add_message_placeholder: {
      'id': 'add_message_placeholder',
      'defaultMessage': 'Enter your message...'
    },
    send_new_message_title: {
      'id': 'send_new_message_title',
      'defaultMessage': 'You are sending a message to'
    },
    send_reply_message_title: {
      'id': 'send_reply_message_title',
      'defaultMessage': 'has sent you a message'
    },
    send_message_placeholder: {
      'id': 'send_message_placeholder',
      'defaultMessage': 'Sent message'
    },
    send_message_send: {
      'id': 'send_message_send',
      'defaultMessage': 'SEND'
    },
    send_message_skip: {
      'id': 'send_message_skip',
      'defaultMessage': 'CANCEL'
    },
    load_previous_messages: {
      'id': 'load_previous_messages',
      'defaultMessage': 'Load previous messages'
    },
    message_send_error_popup_title: {
      'id': 'message_send_error_popup_title',
      'defaultMessage': 'Send message'
    },
    message_send_error_popup_msg: {
      'id': 'message_send_error_popup_msg',
      'defaultMessage': 'Ups.. there was a problem while trying to send your message. Try again.'
    },
    message_main_title: {
      'id': 'message_main_title',
      'defaultMessage': '- messages'
    },
    message_new_info: {
      'id': 'message_new_info',
      'defaultMessage': 'NEW MESSAGE'
    }
  });
  return messages;
}
// EXTERNAL MODULE: ./src/components/ConversationPopup/ConversationPopup.css
var ConversationPopup = __webpack_require__(910);
var ConversationPopup_default = /*#__PURE__*/__webpack_require__.n(ConversationPopup);

// CONCATENATED MODULE: ./src/components/ConversationPopup/ConversationMessage.js
var ConversationMessage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









function ConversationMessage(props) {
  var message = props.message,
      isNew = props.isNew;

  var user = message.get('user');
  var sentDate = new Date(message.get('created'));
  var formattedText = message.get('text');
  var wrappedStyle = classnames_default()(ConversationPopup_default.a.ConversationMessage, ConversationPopup_default.a.ConversationMessage__new);
  var messages = ConversationPopup_Messages_Messages();
  return ConversationMessage__jsx('li', {
    className: wrappedStyle
  }, void 0, isNew && ConversationMessage__jsx('div', {
    className: ConversationPopup_default.a.ConversationMessage_info
  }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.message_new_info)), ConversationMessage__jsx('small', {
    className: 'ConversationMessage-author'
  }, void 0, user.get('full_name'), '\xA0', ConversationMessage__jsx(index_es["c" /* FormattedRelative */], {
    value: sentDate,
    initialNow: new Date()
  })), ConversationMessage__jsx('p', {
    className: ConversationPopup_default.a.ConversationMessage_text,
    dangerouslySetInnerHTML: { __html: formattedText }
  }));
}

/* harmony default export */ var ConversationPopup_ConversationMessage = (withStyles_default()(ConversationPopup_default.a)(ConversationMessage));
// CONCATENATED MODULE: ./src/components/Textarea/Textarea.js
var Textarea__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Textarea__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Textarea__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Textarea__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Textarea__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Textarea_Textarea = function (_Component) {
  Textarea__inherits(Textarea, _Component);

  function Textarea() {
    var _ref;

    var _temp, _this, _ret;

    Textarea__classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Textarea__possibleConstructorReturn(this, (_ref = Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      canDisplayError: false
    }, _this.onKeyUp = function (event) {
      var el = event.currentTarget ? event.currentTarget : event;
      el.style.height = '32px';
      el.style.height = 2 + el.scrollHeight + 'px';
    }, _this.changeValue = function (event) {
      _this.props.setValue(event.currentTarget.value);
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _this.displayError = function (event) {
      _this.setState({
        canDisplayError: true
      });
      _this.changeValue(event);
    }, _temp), Textarea__possibleConstructorReturn(_this, _ret);
  }

  Textarea__createClass(Textarea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.rows) {
        this.onKeyUp(this.textarea);
      }
      // this.textarea.style.height = (2 + this.textarea.scrollHeight) + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isRequired = this.props.showRequired();
      var className = classnames_default()('Form-textarea', {
        required: isRequired,
        error: !isRequired && this.props.showError()
      }, this.props.className);

      var errorMessage = this.props.getErrorMessage() || (isRequired && this.props.isFormSubmitted() ? 'field_required' : null);

      return Textarea__jsx('div', {
        className: className
      }, void 0, Textarea__jsx('label', {
        htmlFor: this.props.name,
        className: this.props.titleVisibility ? null : 'u-hiddenVisually'
      }, void 0, Textarea__jsx(index_es["b" /* FormattedMessage */], {
        id: this.props.title
      })), react_default.a.createElement('textarea', {
        ref: function ref(_ref2) {
          return _this2.textarea = _ref2;
        },
        className: classnames_default()('Form-field', this.props.large ? 'Form-field--large' : null),
        name: this.props.name,
        disabled: this.props.disabled ? 'disabled' : null,
        onChange: this.changeValue,
        onBlur: this.displayError,
        placeholder: this.props.intl.formatMessage({ id: this.props.title }),
        autoFocus: this.props.autofocus,
        value: this.props.getValue(),
        rows: this.props.rows,
        onKeyUp: this.onKeyUp,
        maxLength: this.props.maxLength }), (this.state.canDisplayError || this.props.isFormSubmitted()) && errorMessage ? Textarea__jsx('div', {
        className: 'Form-error'
      }, void 0, Textarea__jsx(index_es["b" /* FormattedMessage */], {
        id: errorMessage
      })) : null);
    }
  }]);

  return Textarea;
}(react["Component"]);

/* harmony default export */ var components_Textarea_Textarea = (Object(index_es["g" /* injectIntl */])(Object(lib["withFormsy"])(Textarea_Textarea), { withRef: true }));
// CONCATENATED MODULE: ./src/components/ConversationPopup/ConversationPopupView.js
var ConversationPopupView__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConversationPopupView__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConversationPopupView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConversationPopupView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConversationPopupView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ConversationPopupView__ref2 = ConversationPopupView__jsx(Icon["a" /* default */], {
  iconName: "odrzuc",
  size: 20
});

var ConversationPopupView__ref3 = ConversationPopupView__jsx(Icon["a" /* default */], {
  iconName: 'messages',
  size: 48
});

var ConversationPopupView__ref5 = ConversationPopupView__jsx(index_es["b" /* FormattedMessage */], {
  id: 'send_message_skip'
});

var _ref6 = ConversationPopupView__jsx(index_es["b" /* FormattedMessage */], {
  id: 'send_message_send'
});

var ConversationPopupView_ConversationPopupView = function (_React$Component) {
  ConversationPopupView__inherits(ConversationPopupView, _React$Component);

  function ConversationPopupView() {
    var _ref;

    var _temp, _this, _ret;

    ConversationPopupView__classCallCheck(this, ConversationPopupView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ConversationPopupView__possibleConstructorReturn(this, (_ref = ConversationPopupView.__proto__ || Object.getPrototypeOf(ConversationPopupView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      buttonDisabled: true
    }, _this.scrollToLastMessage = function () {
      if (!_this.alreadyScrolled) {
        _this.messagesBottom.scrollIntoView();
        _this.alreadyScrolled = true;
      }
    }, _this.isMessageOwner = function (message) {
      return message.getIn(['user', 'id']) === _this.props.loggedInUserId;
    }, _this.sendMessage = function (data) {
      console.log('data', data, _this.messageInput.getWrappedInstance());
      var conversationId = _this.props.conversationPaging.get('conversationId');
      if (!!conversationId) {
        _this.props.sendMessageToConversation(conversationId, data);
      } else {
        var recipient = _this.props.conversationPaging.get('recipient');
        _this.props.sendMessageToUser(recipient.get('id'), data);
      }
    }, _this.clearInput = function () {
      _this.messageInput.getWrappedInstance().setValue('');
      _this.setState({ buttonDisabled: true });
    }, _this.handleInputChange = function (event) {
      _this.setState({ buttonDisabled: !event.target.value });
    }, _this.loadPreviousMessages = function () {
      var conversationId = _this.props.conversationPaging.get('conversationId');
      _this.props.getConversation(conversationId, {
        page: +_this.props.conversationPaging.get('currentPage') + 1
      });
    }, _temp), ConversationPopupView__possibleConstructorReturn(_this, _ret);
  }

  ConversationPopupView__createClass(ConversationPopupView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var conversationId = this.props.conversationPaging.get('conversationId');
      if (!!conversationId) {
        this.props.getConversation(conversationId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.conversation.size !== this.props.conversation.size) {
        this.clearInput();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToLastMessage();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetConversation();
      this.props.resetPaging();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          producent = _props.producent,
          conversationPaging = _props.conversationPaging;

      var messages = ConversationPopup_Messages_Messages();
      var isConversation = !!conversationPaging.get('conversationId');
      var recipient = conversationPaging.get('recipient');
      var conversation = this.props.conversation;
      var hasMore = conversationPaging.get('itemsPerPage') * conversationPaging.get('currentPage') < conversationPaging.get('itemsCount');
      var fullName = recipient && recipient.get('full_name');

      var isSuperior = producent === 'spirotech';
      var conversationClose = isSuperior ? classnames_default()(ConversationPopup_default.a.ConversationPopup_close, ConversationPopup_default.a.close_spirotech) : classnames_default()(ConversationPopup_default.a.ConversationPopup_close);

      var lightColor = isSuperior ? 'light_spirotech' : 'light';
      var colorStyled = isSuperior ? classnames_default()(ConversationPopup_default.a.black_text) : classnames_default()(ConversationPopup_default.a.superior_text);

      return ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.ConversationPopup
      }, void 0, ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.ConversationPopup_overlay,
        onClick: this.props.onClose
      }), ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.ConversationPopup_content
      }, void 0, ConversationPopupView__jsx('button', {
        type: 'button',
        className: conversationClose,
        onClick: this.props.onClose
      }, void 0, ConversationPopupView__ref2), ConversationPopupView__jsx('section', {
        className: classnames_default()(ConversationPopup_default.a.Box, ConversationPopup_default.a.ConversationPopup_box)
      }, void 0, ConversationPopupView__ref3, ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.Avatar_container
      }, void 0, isConversation ? ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.Avatar_text
      }, void 0, ConversationPopupView__jsx('span', {
        className: 'Avatar-teaser ConversationPopup-teaser'
      }, void 0, ConversationPopupView__jsx('strong', {}, void 0, '\xA0', fullName, '\xA0'), react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.message_main_title))) : ConversationPopupView__jsx('div', {
        className: 'Avatar-text'
      }, void 0, ConversationPopupView__jsx('span', {
        className: 'Avatar-teaser ConversationPopup-teaser'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.send_new_message_title), ConversationPopupView__jsx('strong', {}, void 0, '\xA0', fullName, '\xA0')))), ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.ConversationPopup_message
      }, void 0, hasMore ? ConversationPopupView__jsx('div', {
        className: ConversationPopup_default.a.ConversationPopup_loadPrevious,
        onClick: this.loadPreviousMessages
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.load_previous_messages)) : null, ConversationPopupView__jsx('ul', {}, void 0, conversation.map(function (message, index) {
        return ConversationPopupView__jsx(ConversationPopup_ConversationMessage, {
          message: message,
          isNew: !_this2.isMessageOwner(message) && index === conversation.size - 1
        }, message.get('id'));
      })), react_default.a.createElement('div', { ref: function ref(el) {
          return _this2.messagesBottom = el;
        } }), ConversationPopupView__jsx(Form["a" /* default */], {
        onSubmit: this.sendMessage
      }, void 0, react_default.a.createElement(components_Textarea_Textarea, {
        name: 'text',
        title: 'add_message_placeholder',
        className: ConversationPopup_default.a.ConversationPopup_textarea,
        onChange: this.handleInputChange,
        ref: function ref(_ref4) {
          return _this2.messageInput = _ref4;
        } }), ConversationPopupView__jsx('div', {
        className: 'u-textRight'
      }, void 0, ConversationPopupView__jsx(Button["a" /* default */], {
        buttonColor: lightColor,
        type: 'button',
        onClick: this.props.onClose
      }, void 0, ConversationPopupView__jsx('div', {
        className: colorStyled
      }, void 0, ConversationPopupView__ref5)), ConversationPopupView__jsx(Button["a" /* default */], {
        disabled: this.state.buttonDisabled,
        buttonColor: lightColor,
        type: 'submit'
      }, void 0, ConversationPopupView__jsx('div', {
        className: colorStyled
      }, void 0, _ref6))))))));
    }
  }]);

  return ConversationPopupView;
}(react_default.a.Component);

ConversationPopupView_ConversationPopupView.defaultProps = {
  producent: ''
};

/* harmony default export */ var ConversationPopup_ConversationPopupView = (withStyles_default()(ConversationPopup_default.a)(ConversationPopupView_ConversationPopupView));
// EXTERNAL MODULE: ./src/actions/ConversationActions.js
var ConversationActions = __webpack_require__(943);

// CONCATENATED MODULE: ./src/components/ConversationPopup/ConversationPopup.js
var ConversationPopup__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function ConversationPopup_ConversationPopup(props) {
  var conversationPaging = props.conversationPaging,
      hideConversation = props.hideConversation,
      authentication = props.authentication; // eslint-disable-line no-shadow

  var producent = authentication.get('producent');
  if (conversationPaging.get('showConversation')) {
    return react_default.a.createElement(ConversationPopup_ConversationPopupView, ConversationPopup__extends({}, props, {
      conversationPaging: conversationPaging,
      onClose: hideConversation,
      producent: producent
    }));
  }
  return null;
}

var ConversationPopup_mapState = function mapState(state) {
  return {
    conversation: state.conversation,
    conversationPaging: state.conversationPaging,
    authentication: state.authentication
  };
};

var ConversationPopup_mapDispatch = function mapDispatch(dispatch) {
  return {
    getConversation: function getConversation(conversationId) {
      return dispatch(Object(ConversationActions["a" /* getConversation */])(conversationId));
    },
    sendMessageToConversation: function sendMessageToConversation(conversationId, data) {
      return dispatch(Object(ConversationActions["e" /* sendMessageToConversation */])(conversationId, data));
    },
    sendMessageToUser: function sendMessageToUser(userId, data) {
      return dispatch(Object(ConversationActions["f" /* sendMessageToUser */])(userId, data));
    },
    resetPaging: function resetPaging() {
      return dispatch(Object(ConversationActions["d" /* resetPaging */])());
    },
    resetConversation: function resetConversation() {
      return dispatch(Object(ConversationActions["c" /* resetConversation */])());
    },
    hideConversation: function hideConversation() {
      return dispatch(Object(ConversationActions["b" /* hideConversation */])());
    }
  };
};

/* harmony default export */ var components_ConversationPopup_ConversationPopup = (Object(redux_es["compose"])(withStyles_default()(ConversationPopup_default.a), Object(es["b" /* connect */])(ConversationPopup_mapState, ConversationPopup_mapDispatch))(ConversationPopup_ConversationPopup));
// EXTERNAL MODULE: ./src/components/BasicHeader/Header.css
var Header = __webpack_require__(1104);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header);

// EXTERNAL MODULE: ./src/components/BasicNavigation/Navigation.css
var BasicNavigation_Navigation = __webpack_require__(1106);
var Navigation_default = /*#__PURE__*/__webpack_require__.n(BasicNavigation_Navigation);

// CONCATENATED MODULE: ./src/components/BasicNavigation/Messages.js


function BasicNavigation_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    profile_settings_header_text: {
      'id': 'profile_settings_header_text',
      'defaultMessage': 'Profile settings'
    },
    device_list_header_text: {
      'id': 'device_list_header_text',
      'defaultMessage': 'Devices list'
    },
    logout_header_text: {
      'id': 'logout_header_text',
      'defaultMessage': 'Logout'
    },
    add_new_device_submit_main_screen_text: {
      'id': 'add_new_device_submit_main_screen_text',
      'defaultMessage': 'Add'
    },
    basic_navigation_notifications: {
      'id': 'basic_navigation_notifications',
      'defaultMessage': 'Notifications'
    },
    basic_navigation_messages: {
      'id': 'basic_navigation_messages',
      'defaultMessage': 'Messages'
    }
  });
  return messages;
}
// EXTERNAL MODULE: ./src/components/NavigationButton/NavigationButton.css
var NavigationButton = __webpack_require__(1108);
var NavigationButton_default = /*#__PURE__*/__webpack_require__.n(NavigationButton);

// EXTERNAL MODULE: ./src/components/Badge/Badge.js
var Badge = __webpack_require__(913);

// EXTERNAL MODULE: ./src/constants/roles.js
var roles = __webpack_require__(912);

// CONCATENATED MODULE: ./src/core/navigationHelper.js


function getProfileNumber(personalData, userRole) {
  if (userRole === +roles["a" /* default */].installer) {
    if (personalData.get('address') !== '' && personalData.get('company') !== '' && personalData.get('vat') !== '' && personalData.get('citycode')) {
      return 1;
    }
  }
  return 0;
};

function getNumberToBadge(link, alertsCount, profileNumber) {
  var ret = 0;
  if (link === '/messages') {
    ret = alertsCount.get('unseenMessages');
  } else if (link === '/notifications') {
    ret = alertsCount.get('unseenAlerts');
  } else if (link.startsWith('/profile')) {
    ret = profileNumber;
  }
  return ret;
};
// CONCATENATED MODULE: ./src/components/NavigationButton/NavigationButton.js
var NavigationButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */













function NavigationButton_NavigationButton(props) {
  var iconSize = 41;
  var link = props.link,
      message = props.message,
      iconName = props.iconName,
      alertsCount = props.alertsCount,
      profileNumber = props.profileNumber;

  if (link === '/logout') {
    return NavigationButton__jsx('div', {
      className: NavigationButton_default.a.button
    }, void 0, NavigationButton__jsx('a', {
      className: NavigationButton_default.a.link,
      href: '/logout'
    }, void 0, NavigationButton__jsx(Icon["a" /* default */], {
      iconName: iconName,
      className: 'Icon--block',
      size: iconSize
    }), NavigationButton__jsx('span', {
      className: NavigationButton_default.a.below
    }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], message))));
  } else if (link === '/messages' || link === '/notifications' || link.startsWith('/profile')) {
    var numberToBadge = getNumberToBadge(link, alertsCount, profileNumber);
    return NavigationButton__jsx('div', {
      className: NavigationButton_default.a.button
    }, void 0, NavigationButton__jsx(Link["a" /* default */], {
      className: NavigationButton_default.a.link,
      to: link
    }, void 0, NavigationButton__jsx(Icon["a" /* default */], {
      iconName: iconName,
      className: 'Icon--block',
      size: iconSize
    }, void 0, NavigationButton__jsx(Badge["a" /* default */], {
      number: numberToBadge
    })), NavigationButton__jsx('span', {
      className: NavigationButton_default.a.below
    }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], message))));
  }
  return NavigationButton__jsx('div', {
    className: NavigationButton_default.a.button
  }, void 0, NavigationButton__jsx(Link["a" /* default */], {
    className: NavigationButton_default.a.link,
    to: link
  }, void 0, NavigationButton__jsx(Icon["a" /* default */], {
    iconName: iconName,
    className: 'Icon--block',
    size: iconSize
  }), NavigationButton__jsx('span', {
    className: NavigationButton_default.a.below
  }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], message))));
}

/* harmony default export */ var components_NavigationButton_NavigationButton = (withStyles_default()(NavigationButton_default.a)(NavigationButton_NavigationButton));
// EXTERNAL MODULE: ./src/components/NavigationSmallButton/NavigationSmallButton.css
var NavigationSmallButton_NavigationSmallButton = __webpack_require__(1110);
var NavigationSmallButton_default = /*#__PURE__*/__webpack_require__.n(NavigationSmallButton_NavigationSmallButton);

// CONCATENATED MODULE: ./src/components/NavigationSmallButton/NavigationSmallButton.js
var NavigationSmallButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NavigationSmallButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NavigationSmallButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NavigationSmallButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NavigationSmallButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NavigationSmallButton_NavigationSmallButton_NavigationSmallButton = function (_React$Component) {
  NavigationSmallButton__inherits(NavigationSmallButton, _React$Component);

  function NavigationSmallButton() {
    var _ref;

    var _temp, _this, _ret;

    NavigationSmallButton__classCallCheck(this, NavigationSmallButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NavigationSmallButton__possibleConstructorReturn(this, (_ref = NavigationSmallButton.__proto__ || Object.getPrototypeOf(NavigationSmallButton)).call.apply(_ref, [this].concat(args))), _this), _this.getButtonWrapper = function (_isPriviliged, isSuperior, ownershipCount) {
      var buttonWrapper = isSuperior ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.spirotech, NavigationSmallButton_default.a.nodevice) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.nodevice);
      if (+ownershipCount > 0) {
        var buttonWrapperPriviligedSpirotech = _isPriviliged ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.spirotech, NavigationSmallButton_default.a.priviliged) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.spirotech);

        var buttonWrapperPriviliged = _isPriviliged ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.priviliged) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton);

        buttonWrapper = isSuperior ? buttonWrapperPriviligedSpirotech : buttonWrapperPriviliged;
      }
      return buttonWrapper;
    }, _this.getButtonWrapperActive = function (_isPriviliged, isSuperior, ownershipCount) {
      var buttonWrapperActive = isSuperior ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active, NavigationSmallButton_default.a.spirotech, NavigationSmallButton_default.a.nodevice) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active, NavigationSmallButton_default.a.nodevice);
      if (+ownershipCount > 0) {
        var buttonWrapperActivePriviligedSpirotech = _isPriviliged ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active, NavigationSmallButton_default.a.spirotechActive, NavigationSmallButton_default.a.priviliged) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active, NavigationSmallButton_default.a.spirotechActive);

        var buttonWrapperActivePriviliged = _isPriviliged ? classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active, NavigationSmallButton_default.a.priviliged) : classnames_default()(NavigationSmallButton_default.a.smallMenuButton, NavigationSmallButton_default.a.active);

        buttonWrapperActive = isSuperior ? buttonWrapperActivePriviligedSpirotech : buttonWrapperActivePriviliged;
      }

      return buttonWrapperActive;
    }, _temp), NavigationSmallButton__possibleConstructorReturn(_this, _ret);
  }

  NavigationSmallButton__createClass(NavigationSmallButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          producent = _props.producent,
          active = _props.active,
          alertsCount = _props.alertsCount,
          userRole = _props.userRole,
          ownershipCount = _props.ownershipCount,
          profileNumber = _props.profileNumber;
      var iconName = item.iconName,
          link = item.link,
          text = item.text;

      var isSuperior = producent === 'spirotech';
      var isPriviligedValue = Object(deviceHelper["i" /* isPriviliged */])(userRole);

      var buttonWrapper = this.getButtonWrapper(isPriviligedValue, isSuperior, ownershipCount);
      var buttonWrapperActive = this.getButtonWrapperActive(isPriviligedValue, isSuperior, ownershipCount);

      var iconSize = 26;
      var buttonClassName = active === text ? buttonWrapperActive : buttonWrapper;

      if (link === '/messages' || link === '/notifications' || link.startsWith('/profile')) {
        var numberToBadge = getNumberToBadge(link, alertsCount, profileNumber);
        return NavigationSmallButton__jsx('div', {
          role: 'button',
          className: buttonClassName,
          onClick: function onClick() {
            _this2.props.setTextValue(text);
          },
          tabIndex: '0'
        }, void 0, NavigationSmallButton__jsx(Link["a" /* default */], {
          className: NavigationSmallButton_default.a.link,
          to: link
        }, void 0, NavigationSmallButton__jsx(Icon["a" /* default */], {
          iconName: iconName,
          className: 'Icon--block',
          size: iconSize
        }, void 0, NavigationSmallButton__jsx(Badge["a" /* default */], {
          number: numberToBadge
        }))));
      } else if (link === '/logout') {
        return NavigationSmallButton__jsx('div', {
          role: 'button',
          className: buttonClassName,
          tabIndex: '0'
        }, void 0, NavigationSmallButton__jsx('a', {
          className: NavigationSmallButton_default.a.link,
          href: '/logout'
        }, void 0, NavigationSmallButton__jsx(Icon["a" /* default */], {
          iconName: iconName,
          className: 'Icon--block',
          size: iconSize
        })));
      }
      return NavigationSmallButton__jsx('div', {
        role: 'button',
        className: buttonClassName,
        onClick: function onClick() {
          _this2.props.setTextValue(text);
        },
        tabIndex: '0'
      }, void 0, NavigationSmallButton__jsx(Link["a" /* default */], {
        className: NavigationSmallButton_default.a.link,
        to: link
      }, void 0, NavigationSmallButton__jsx(Icon["a" /* default */], {
        iconName: iconName,
        className: 'Icon--block',
        size: iconSize
      })));
    }
  }]);

  return NavigationSmallButton;
}(react_default.a.Component);

/* harmony default export */ var components_NavigationSmallButton_NavigationSmallButton = (withStyles_default()(NavigationSmallButton_default.a)(NavigationSmallButton_NavigationSmallButton_NavigationSmallButton));
// CONCATENATED MODULE: ./src/components/BasicNavigation/NavigationButtonsValues.js
function getCommonButtons(small, producent, gotDevice) {
  var isSuperior = producent === 'spirotech';
  var isBlack = !small || isSuperior;
  var commonButtons = [{
    iconName: isBlack ? 'settings' : 'settings_white',
    text: 'profile_settings_header_text',
    link: '/profile/notifications'
  }, {
    iconName: isBlack ? 'messages' : 'messages_white',
    text: 'basic_navigation_messages',
    link: '/messages'
  }, {
    iconName: isBlack ? 'logout' : 'logout_white',
    text: 'logout_header_text',
    link: '/logout'
  }];
  if (gotDevice) {
    commonButtons = [{
      iconName: isBlack ? 'settings' : 'settings_white',
      text: 'profile_settings_header_text',
      link: '/profile/notifications'
    }, {
      iconName: isBlack ? 'messages' : 'messages_white',
      text: 'basic_navigation_messages',
      link: '/messages'
    }, {
      iconName: isBlack ? 'notifications' : 'notifications_white',
      text: 'basic_navigation_notifications',
      link: '/notifications'
    }, {
      iconName: isBlack ? 'logout' : 'logout_white',
      text: 'logout_header_text',
      link: '/logout'
    }];
  }
  return commonButtons;
}

function getAdminButtons(small, producent, ownershipCount) {
  var gotDevice = +ownershipCount > 0;
  var isSuperior = producent === 'spirotech';
  var isBlack = !small || isSuperior;
  var adminButtons = gotDevice ? [{
    iconName: isBlack ? 'devices' : 'devices_white',
    text: 'device_list_header_text',
    link: '/'
  }] : [{
    iconName: isBlack ? 'add' : 'add_white',
    text: 'add_new_device_submit_main_screen_text',
    link: '/newdevice'
  }];
  return adminButtons.concat(getCommonButtons(small, producent, gotDevice));
}

function getUserButtons(small, producent, ownershipCount) {
  var gotDevice = +ownershipCount > 0;
  var isSuperior = producent === 'spirotech';
  var isBlack = !small || isSuperior;
  var deviceListButton = gotDevice ? [{
    iconName: isBlack ? 'devices' : 'devices_white',
    text: 'device_list_header_text',
    link: '/'
  }] : [];
  var userButtons = deviceListButton.concat([{
    iconName: isBlack ? 'add' : 'add_white',
    text: 'add_new_device_submit_main_screen_text',
    link: '/newdevice'
  }]);

  return userButtons.concat(getCommonButtons(small, producent, gotDevice));
}
// CONCATENATED MODULE: ./src/components/BasicNavigation/Navigation.js
var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Navigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



















var ALERTS_NUMBER_CHECK_INTERVAL = 30 * 1000; //  50 * 1000; 

var Navigation_Navigation = function (_React$Component) {
  Navigation__inherits(Navigation, _React$Component);

  function Navigation(props) {
    Navigation__classCallCheck(this, Navigation);

    var _this = Navigation__possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _initialiseProps.call(_this);

    var value = 'device_list_header_text';
    var pathname = _this.props.pathname;
    if (pathname === '/profile') {
      value = 'profile_settings_header_text';
    } else if (pathname === '/messages') {
      value = 'basic_navigation_messages';
    } else if (pathname === '/notifications') {
      value = 'basic_navigation_messages';
    } else if (pathname === '/newdevice') {
      value = 'add_new_device_submit_main_screen_text';
    }
    _this.state = {
      value: value
    };
    return _this;
  }

  Navigation__createClass(Navigation, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      var alertsCount = this.props.alertsCount;
      var newAlertsCount = newProps.alertsCount;
      if (alertsCount.get('unseenMessages') < newAlertsCount.get('unseenMessages') || alertsCount.get('unseenAlerts') < newAlertsCount.get('unseenAlerts')) {}
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCheckingNewAlerts();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopCheckingNewAlerts();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = BasicNavigation_Messages_Messages();
      var _props = this.props,
          userRole = _props.userRole,
          producent = _props.producent,
          ownershipCount = _props.ownershipCount,
          personalData = _props.personalData;

      var isSuperior = producent === 'spirotech';
      var titleWrapper = isSuperior ? classnames_default()(Navigation_default.a.headerText, Navigation_default.a.spirotech) : classnames_default()(Navigation_default.a.headerText);
      var buttons = Object(deviceHelper["i" /* isPriviliged */])(userRole) ? getAdminButtons(false, producent, ownershipCount) : getUserButtons(false, producent, ownershipCount);
      var buttonsSmall = Object(deviceHelper["i" /* isPriviliged */])(userRole) ? getAdminButtons(true, producent, ownershipCount) : getUserButtons(true, producent, ownershipCount);
      var profileNumber = getProfileNumber(personalData);
      if (userRole !== null) {
        return Navigation__jsx('div', {}, void 0, Navigation__jsx('div', {
          className: Navigation_default.a.root
        }, void 0, buttons.map(function (item, index) {
          return Navigation__jsx(components_NavigationButton_NavigationButton, {
            iconName: item.iconName,
            message: messages[item.text],
            alertsCount: _this2.props.alertsCount,
            link: item.link,
            profileNumber: profileNumber
          }, item.text);
        })), Navigation__jsx('div', {
          className: Navigation_default.a.rootSmall
        }, void 0, buttonsSmall.map(function (item, index) {
          return Navigation__jsx(components_NavigationSmallButton_NavigationSmallButton, {
            item: item,
            alertsCount: _this2.props.alertsCount,
            active: _this2.state.value,
            producent: producent,
            setTextValue: _this2.setTextValue,
            userRole: userRole,
            ownershipCount: ownershipCount,
            profileNumber: profileNumber
          }, item.text);
        }), Navigation__jsx('div', {
          className: titleWrapper
        }, void 0, Navigation__jsx('span', {
          className: Navigation_default.a.center
        }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages[this.state.value])))));
      }
      return null;
    }
  }]);

  return Navigation;
}(react_default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setTextValue = function (value) {
    _this3.setState({
      value: value
    });
  };

  this.checkForNewAlerts = function () {
    if (_this3.props.alertsCount.get('requestInProgress') === false) {
      _this3.props.getAlertsCount();
    }
  };

  this.startCheckingNewAlerts = function () {
    if (_this3.intervalId) {
      return;
    }
    _this3.checkForNewAlerts();
    _this3.intervalId = window.setInterval(_this3.checkForNewAlerts, ALERTS_NUMBER_CHECK_INTERVAL);
  };

  this.stopCheckingNewAlerts = function () {
    window.clearInterval(_this3.intervalId);
    _this3.intervalId = null;
  };
};

var Navigation_mapState = function mapState(state) {
  return {
    alertsCount: state.alertsCount,
    personalData: state.profilePersonalData,
    alertsPaging: state.alertsPaging
  };
};

Navigation_Navigation.defaultProps = {
  userRole: null
};

var Navigation_mapDispatch = function mapDispatch(dispatch) {
  return {
    getAlertsCount: function getAlertsCount() {
      return dispatch(Object(AlertsActions["b" /* getAlertsCount */])());
    }
  };
};

/* harmony default export */ var components_BasicNavigation_Navigation = (Object(redux_es["compose"])(withStyles_default()(Navigation_default.a), Object(es["b" /* connect */])(Navigation_mapState, Navigation_mapDispatch))(Navigation_Navigation));
// EXTERNAL MODULE: ./src/actions/authentication.js
var actions_authentication = __webpack_require__(942);

// EXTERNAL MODULE: ./src/components/BasicHeader/new_saocal_20.png
var new_saocal_20 = __webpack_require__(1112);
var new_saocal_20_default = /*#__PURE__*/__webpack_require__.n(new_saocal_20);

// EXTERNAL MODULE: ./src/components/BasicHeader/spirotech_new_logo.png
var spirotech_new_logo = __webpack_require__(1113);
var spirotech_new_logo_default = /*#__PURE__*/__webpack_require__.n(spirotech_new_logo);

// EXTERNAL MODULE: ./src/components/BasicHeader/SYR_OCEANIC_Logo.png
var SYR_OCEANIC_Logo = __webpack_require__(1114);
var SYR_OCEANIC_Logo_default = /*#__PURE__*/__webpack_require__.n(SYR_OCEANIC_Logo);

// CONCATENATED MODULE: ./src/components/BasicHeader/Header.js
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */















var Header__ref2 = Header__jsx('img', {
  src: new_saocal_20_default.a,
  alt: 'Saocal'
});

var Header__ref3 = Header__jsx('img', {
  src: SYR_OCEANIC_Logo_default.a,
  alt: 'Syr'
});

var _ref4 = Header__jsx('img', {
  src: SYR_OCEANIC_Logo_default.a,
  alt: 'Oceanic'
});

var Header__ref5 = Header__jsx('img', {
  src: spirotech_new_logo_default.a,
  alt: 'Spirotech'
});

var Header_BasicHeader = function (_React$Component) {
  Header__inherits(BasicHeader, _React$Component);

  function BasicHeader() {
    var _ref;

    var _temp, _this, _ret;

    Header__classCallCheck(this, BasicHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Header__possibleConstructorReturn(this, (_ref = BasicHeader.__proto__ || Object.getPrototypeOf(BasicHeader)).call.apply(_ref, [this].concat(args))), _this), _this.getLogo = function (producent) {
      switch (producent) {
        case 'husty':
          return Header__jsx(Link["a" /* default */], {
            className: classnames_default()(Header_default.a.brand, Header_default.a.Header_logo),
            to: '/'
          }, void 0, Header__ref2);
        case 'syr':
          return Header__jsx(Link["a" /* default */], {
            className: classnames_default()(Header_default.a.brand, Header_default.a.Header_logo),
            to: '/'
          }, void 0, Header__ref3);
        case 'oceanic':
          return Header__jsx(Link["a" /* default */], {
            className: classnames_default()(Header_default.a.brand, Header_default.a.Header_logo),
            to: '/'
          }, void 0, _ref4);
        case 'spirotech':
          return Header__jsx(Link["a" /* default */], {
            className: classnames_default()(Header_default.a.brand, Header_default.a.Header_logo),
            to: '/'
          }, void 0, Header__ref5);
        case 'vanmarcke':
          return null;
        default:
          return null;
      }
    }, _temp), Header__possibleConstructorReturn(_this, _ret);
  }

  Header__createClass(BasicHeader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getUserPriviliges();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          pathname = _props.pathname,
          authentication = _props.authentication;

      var userRole = authentication.get('userRole');
      var producent = authentication.get('producent');
      var ownershipCount = authentication.get('ownershipCount');
      return Header__jsx('div', {
        className: Header_default.a.root
      }, void 0, Header__jsx('div', {
        className: classnames_default()(Header_default.a.container, Header_default.a.root)
      }, void 0, Header__jsx('div', {
        className: classnames_default()(Header_default.a.Header_inner, Header_default.a.u_cf)
      }, void 0, Header__jsx(components_BasicNavigation_Navigation, {
        userRole: userRole,
        producent: producent,
        ownershipCount: ownershipCount,
        pathname: pathname
      }), this.getLogo(producent))));
    }
  }]);

  return BasicHeader;
}(react_default.a.Component);

var Header_mapState = function mapState(state) {
  return {
    authentication: state.authentication
  };
};

var Header_mapDispatch = function mapDispatch(dispatch) {
  return {
    getUserPriviliges: function getUserPriviliges() {
      return dispatch(Object(actions_authentication["b" /* getUserPriviliges */])());
    }
  };
};

/* harmony default export */ var BasicHeader_Header = (Object(redux_es["compose"])(withStyles_default()(Header_default.a), Object(es["b" /* connect */])(Header_mapState, Header_mapDispatch))(Header_BasicHeader));
// EXTERNAL MODULE: ./src/components/Footer/Footer.css
var Footer_Footer = __webpack_require__(1115);
var Footer_default = /*#__PURE__*/__webpack_require__.n(Footer_Footer);

// EXTERNAL MODULE: ./src/constants/websites.js
var websites = __webpack_require__(935);

// CONCATENATED MODULE: ./src/components/Footer/Messages.js


function Footer_Messages_Messages() {
  var messages = Object(index_es["f" /* defineMessages */])({
    privacy_footer_text: {
      'id': 'privacy_footer_text',
      'defaultMessage': 'Privacy'
    },
    cookies_footer_text: {
      'id': 'cookies_footer_text',
      'defaultMessage': 'Cookies'
    }
  });
  return messages;
}
// CONCATENATED MODULE: ./src/components/Footer/Footer.js
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Footer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */













var Footer_Footer_Footer = function (_React$Component) {
  Footer__inherits(Footer, _React$Component);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    Footer__classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Footer__possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.getIsSpirotech = function (producent, runtime) {
      var host = runtime.host;
      var hostname = runtime.hostname;
      // const host = SPIROTECH_URL;
      // const hostname = SPIROTECH_URL;
      return producent === 'spirotech' || hostname === websites["b" /* SPIROTECH_URL */] || hostname === websites["c" /* TEST_SPIROTECH_URL */];
    }, _temp), Footer__possibleConstructorReturn(_this, _ret);
  }

  Footer__createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          runtime = _props.runtime,
          authentication = _props.authentication;

      var messages = Footer_Messages_Messages();
      var producent = authentication.get('producent');
      var isSpirotech = this.getIsSpirotech(producent, runtime);
      var wrappedStyle = isSpirotech ? classnames_default()(Footer_default.a.root, Footer_default.a.spirotech) : classnames_default()(Footer_default.a.root);
      var linkStyle = isSpirotech ? classnames_default()(Footer_default.a.link_spirotech, Footer_default.a.link) : classnames_default()(Footer_default.a.link);
      return Footer__jsx('div', {
        className: wrappedStyle
      }, void 0, Footer__jsx('div', {
        className: Footer_default.a.container
      }, void 0, Footer__jsx(Link["a" /* default */], {
        className: linkStyle,
        to: '/'
      }, void 0, 'Start'), Footer__jsx('span', {
        className: Footer_default.a.spacer
      }, void 0, '\xB7'), Footer__jsx(Link["a" /* default */], {
        className: linkStyle,
        to: '/privacy/cookies'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.cookies_footer_text)), Footer__jsx('span', {
        className: Footer_default.a.spacer
      }, void 0, '\xB7'), Footer__jsx(Link["a" /* default */], {
        className: linkStyle,
        to: '/privacy/gdpr'
      }, void 0, react_default.a.createElement(index_es["b" /* FormattedMessage */], messages.privacy_footer_text))));
    }
  }]);

  return Footer;
}(react_default.a.Component);

var Footer_mapState = function mapState(state) {
  return {
    authentication: state.authentication,
    runtime: state.runtime
  };
};

/* harmony default export */ var components_Footer_Footer = (Object(index_es["g" /* injectIntl */])(Object(redux_es["compose"])(withStyles_default()(Footer_default.a), Object(es["b" /* connect */])(Footer_mapState, null))(Footer_Footer_Footer)));
// CONCATENATED MODULE: ./src/components/Layout/Layout.js
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





// external-global styles must be imported in your JS.









var Layout__ref = Layout__jsx(NotificationPopUpManager, {
  lang: 'en'
});

var Layout__ref2 = Layout__jsx(components_Footer_Footer, {});

var Layout__ref3 = Layout__jsx(NotificationPopUpManager, {
  lang: 'en'
});

var Layout__ref4 = Layout__jsx(components_HistoryEvents_HistoryEvents, {});

var Layout__ref5 = Layout__jsx(components_HistoryParameters_HistoryParameters, {});

var Layout__ref6 = Layout__jsx(components_ConversationPopup_ConversationPopup, {});

var _ref7 = Layout__jsx(components_Footer_Footer, {});

function Layout_Layout(props) {
  var loggedOut = props.loggedOut;

  if (loggedOut) {
    return Layout__jsx('div', {
      className: Layout_default.a.box
    }, void 0, props.children, Layout__ref, Layout__ref2);
  }
  return Layout__jsx('div', {}, void 0, Layout__jsx(BasicHeader_Header, {
    pathname: props.pathname
  }), props.children, Layout__ref3, Layout__ref4, Layout__ref5, Layout__ref6, _ref7);
}

Layout_Layout.defaultProps = {
  loggedOut: false,
  pathname: ''
};

/* harmony default export */ var components_Layout_Layout = __webpack_exports__["a"] = (withStyles_default()(normalize_default.a, Layout_default.a)(Layout_Layout));

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(950), __esModule: true };

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(951);
module.exports = __webpack_require__(864).Object.getPrototypeOf;


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(916);
var $getPrototypeOf = __webpack_require__(917);

__webpack_require__(952)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(875);
var core = __webpack_require__(864);
var fails = __webpack_require__(881);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 953:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(956);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(957), __esModule: true };

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(958);
var $Object = __webpack_require__(864).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(875);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(871), 'Object', { defineProperty: __webpack_require__(870).f });


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(921);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(961), __esModule: true };

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(896);
__webpack_require__(904);
module.exports = __webpack_require__(905).f('iterator');


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(897);
var defined = __webpack_require__(892);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(899);
var descriptor = __webpack_require__(888);
var setToStringTag = __webpack_require__(903);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(876)(IteratorPrototype, __webpack_require__(866)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(870);
var anObject = __webpack_require__(877);
var getKeys = __webpack_require__(900);

module.exports = __webpack_require__(871) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(901);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(879);
var toLength = __webpack_require__(967);
var toAbsoluteIndex = __webpack_require__(968);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(897);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(897);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(868).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(971);
var step = __webpack_require__(972);
var Iterators = __webpack_require__(882);
var toIObject = __webpack_require__(879);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(922)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(974), __esModule: true };

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(975);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
module.exports = __webpack_require__(864).Symbol;


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(868);
var has = __webpack_require__(869);
var DESCRIPTORS = __webpack_require__(871);
var $export = __webpack_require__(875);
var redefine = __webpack_require__(923);
var META = __webpack_require__(976).KEY;
var $fails = __webpack_require__(881);
var shared = __webpack_require__(894);
var setToStringTag = __webpack_require__(903);
var uid = __webpack_require__(887);
var wks = __webpack_require__(866);
var wksExt = __webpack_require__(905);
var wksDefine = __webpack_require__(906);
var enumKeys = __webpack_require__(977);
var isArray = __webpack_require__(978);
var anObject = __webpack_require__(877);
var isObject = __webpack_require__(878);
var toIObject = __webpack_require__(879);
var toPrimitive = __webpack_require__(895);
var createDesc = __webpack_require__(888);
var _create = __webpack_require__(899);
var gOPNExt = __webpack_require__(979);
var $GOPD = __webpack_require__(927);
var $DP = __webpack_require__(870);
var $keys = __webpack_require__(900);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(926).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(907).f = $propertyIsEnumerable;
  __webpack_require__(925).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(898)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(876)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(887)('meta');
var isObject = __webpack_require__(878);
var has = __webpack_require__(869);
var setDesc = __webpack_require__(870).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(881)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(900);
var gOPS = __webpack_require__(925);
var pIE = __webpack_require__(907);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(901);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(879);
var gOPN = __webpack_require__(926).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 980:
/***/ (function(module, exports) {



/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(906)('asyncIterator');


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(906)('observable');


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(984);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(988);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(921);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(985), __esModule: true };

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(986);
module.exports = __webpack_require__(864).Object.setPrototypeOf;


/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(875);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(987).set });


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(878);
var anObject = __webpack_require__(877);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(918)(Function.call, __webpack_require__(927).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(989), __esModule: true };

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(990);
var $Object = __webpack_require__(864).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(875);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(899) });


/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(992), __esModule: true };

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(864);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(994);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(997);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(995), __esModule: true };

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(904);
__webpack_require__(896);
module.exports = __webpack_require__(996);


/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(928);
var ITERATOR = __webpack_require__(866)('iterator');
var Iterators = __webpack_require__(882);
module.exports = __webpack_require__(864).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(998), __esModule: true };

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(904);
__webpack_require__(896);
module.exports = __webpack_require__(999);


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(877);
var get = __webpack_require__(1000);
module.exports = __webpack_require__(864).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ })

});


// WEBPACK FOOTER //
// gdpr.7c87dfd2.chunk.js